// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/BebasNeue-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/BebasNeue-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/roboto-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/roboto-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/seadog-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/seadog-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/seadog.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/poppins/pxiEyp8kv8JHgFVrJJbecmNE.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/poppins/pxiEyp8kv8JHgFVrJJnecmNE.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/poppins/pxiEyp8kv8JHgFVrJJfecg.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134, 182.5, 254%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("bootstrap-icons/font/fonts/bootstrap-icons.woff2?24e3eb84d0bcaf83d77f904c78ac1f47", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("bootstrap-icons/font/fonts/bootstrap-icons.woff?24e3eb84d0bcaf83d77f904c78ac1f47", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Globals */
@font-face {
  font-family: "bebasNeueRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "robotoRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "sea-dogregular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2");
  unicode-range: U+0900-097F, U+1CD0-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FF;
}
/* latin-ext */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/*!
 * Bootstrap  v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.05, 93.5, 215.05);
  --bs-btn-hover-border-color: rgb(10.4, 88, 202.4);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(10.4, 88, 202.4);
  --bs-btn-active-border-color: rgb(9.75, 82.5, 189.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(21.25, 114.75, 71.4);
  --bs-btn-hover-border-color: rgb(20, 108, 67.2);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(20, 108, 67.2);
  --bs-btn-active-border-color: rgb(18.75, 101.25, 63);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(49.3, 209.95, 242.25);
  --bs-btn-hover-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(61.4, 212.6, 243);
  --bs-btn-active-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 202.3, 44.2);
  --bs-btn-hover-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 205.4, 56.6);
  --bs-btn-active-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(187, 45.05, 58.65);
  --bs-btn-hover-border-color: rgb(176, 42.4, 55.2);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(176, 42.4, 55.2);
  --bs-btn-active-border-color: rgb(165, 39.75, 51.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(210.8, 211.65, 212.5);
  --bs-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(198.4, 199.2, 200);
  --bs-btn-active-border-color: rgb(186, 186.75, 187.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --bs-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --bs-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * Bootstrap Icons v1.13.1 (https://icons.getbootstrap.com/)
 * Copyright 2019-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/icons/blob/main/LICENSE)
 */
@font-face {
  font-display: block;
  font-family: "bootstrap-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff");
}
.bi::before,
[class^=bi-]::before,
[class*=" bi-"]::before {
  display: inline-block;
  font-family: "bootstrap-icons" !important;
  font-style: normal;
  font-weight: normal !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bi-123::before {
  content: "\\f67f";
}

.bi-alarm-fill::before {
  content: "\\f101";
}

.bi-alarm::before {
  content: "\\f102";
}

.bi-align-bottom::before {
  content: "\\f103";
}

.bi-align-center::before {
  content: "\\f104";
}

.bi-align-end::before {
  content: "\\f105";
}

.bi-align-middle::before {
  content: "\\f106";
}

.bi-align-start::before {
  content: "\\f107";
}

.bi-align-top::before {
  content: "\\f108";
}

.bi-alt::before {
  content: "\\f109";
}

.bi-app-indicator::before {
  content: "\\f10a";
}

.bi-app::before {
  content: "\\f10b";
}

.bi-archive-fill::before {
  content: "\\f10c";
}

.bi-archive::before {
  content: "\\f10d";
}

.bi-arrow-90deg-down::before {
  content: "\\f10e";
}

.bi-arrow-90deg-left::before {
  content: "\\f10f";
}

.bi-arrow-90deg-right::before {
  content: "\\f110";
}

.bi-arrow-90deg-up::before {
  content: "\\f111";
}

.bi-arrow-bar-down::before {
  content: "\\f112";
}

.bi-arrow-bar-left::before {
  content: "\\f113";
}

.bi-arrow-bar-right::before {
  content: "\\f114";
}

.bi-arrow-bar-up::before {
  content: "\\f115";
}

.bi-arrow-clockwise::before {
  content: "\\f116";
}

.bi-arrow-counterclockwise::before {
  content: "\\f117";
}

.bi-arrow-down-circle-fill::before {
  content: "\\f118";
}

.bi-arrow-down-circle::before {
  content: "\\f119";
}

.bi-arrow-down-left-circle-fill::before {
  content: "\\f11a";
}

.bi-arrow-down-left-circle::before {
  content: "\\f11b";
}

.bi-arrow-down-left-square-fill::before {
  content: "\\f11c";
}

.bi-arrow-down-left-square::before {
  content: "\\f11d";
}

.bi-arrow-down-left::before {
  content: "\\f11e";
}

.bi-arrow-down-right-circle-fill::before {
  content: "\\f11f";
}

.bi-arrow-down-right-circle::before {
  content: "\\f120";
}

.bi-arrow-down-right-square-fill::before {
  content: "\\f121";
}

.bi-arrow-down-right-square::before {
  content: "\\f122";
}

.bi-arrow-down-right::before {
  content: "\\f123";
}

.bi-arrow-down-short::before {
  content: "\\f124";
}

.bi-arrow-down-square-fill::before {
  content: "\\f125";
}

.bi-arrow-down-square::before {
  content: "\\f126";
}

.bi-arrow-down-up::before {
  content: "\\f127";
}

.bi-arrow-down::before {
  content: "\\f128";
}

.bi-arrow-left-circle-fill::before {
  content: "\\f129";
}

.bi-arrow-left-circle::before {
  content: "\\f12a";
}

.bi-arrow-left-right::before {
  content: "\\f12b";
}

.bi-arrow-left-short::before {
  content: "\\f12c";
}

.bi-arrow-left-square-fill::before {
  content: "\\f12d";
}

.bi-arrow-left-square::before {
  content: "\\f12e";
}

.bi-arrow-left::before {
  content: "\\f12f";
}

.bi-arrow-repeat::before {
  content: "\\f130";
}

.bi-arrow-return-left::before {
  content: "\\f131";
}

.bi-arrow-return-right::before {
  content: "\\f132";
}

.bi-arrow-right-circle-fill::before {
  content: "\\f133";
}

.bi-arrow-right-circle::before {
  content: "\\f134";
}

.bi-arrow-right-short::before {
  content: "\\f135";
}

.bi-arrow-right-square-fill::before {
  content: "\\f136";
}

.bi-arrow-right-square::before {
  content: "\\f137";
}

.bi-arrow-right::before {
  content: "\\f138";
}

.bi-arrow-up-circle-fill::before {
  content: "\\f139";
}

.bi-arrow-up-circle::before {
  content: "\\f13a";
}

.bi-arrow-up-left-circle-fill::before {
  content: "\\f13b";
}

.bi-arrow-up-left-circle::before {
  content: "\\f13c";
}

.bi-arrow-up-left-square-fill::before {
  content: "\\f13d";
}

.bi-arrow-up-left-square::before {
  content: "\\f13e";
}

.bi-arrow-up-left::before {
  content: "\\f13f";
}

.bi-arrow-up-right-circle-fill::before {
  content: "\\f140";
}

.bi-arrow-up-right-circle::before {
  content: "\\f141";
}

.bi-arrow-up-right-square-fill::before {
  content: "\\f142";
}

.bi-arrow-up-right-square::before {
  content: "\\f143";
}

.bi-arrow-up-right::before {
  content: "\\f144";
}

.bi-arrow-up-short::before {
  content: "\\f145";
}

.bi-arrow-up-square-fill::before {
  content: "\\f146";
}

.bi-arrow-up-square::before {
  content: "\\f147";
}

.bi-arrow-up::before {
  content: "\\f148";
}

.bi-arrows-angle-contract::before {
  content: "\\f149";
}

.bi-arrows-angle-expand::before {
  content: "\\f14a";
}

.bi-arrows-collapse::before {
  content: "\\f14b";
}

.bi-arrows-expand::before {
  content: "\\f14c";
}

.bi-arrows-fullscreen::before {
  content: "\\f14d";
}

.bi-arrows-move::before {
  content: "\\f14e";
}

.bi-aspect-ratio-fill::before {
  content: "\\f14f";
}

.bi-aspect-ratio::before {
  content: "\\f150";
}

.bi-asterisk::before {
  content: "\\f151";
}

.bi-at::before {
  content: "\\f152";
}

.bi-award-fill::before {
  content: "\\f153";
}

.bi-award::before {
  content: "\\f154";
}

.bi-back::before {
  content: "\\f155";
}

.bi-backspace-fill::before {
  content: "\\f156";
}

.bi-backspace-reverse-fill::before {
  content: "\\f157";
}

.bi-backspace-reverse::before {
  content: "\\f158";
}

.bi-backspace::before {
  content: "\\f159";
}

.bi-badge-3d-fill::before {
  content: "\\f15a";
}

.bi-badge-3d::before {
  content: "\\f15b";
}

.bi-badge-4k-fill::before {
  content: "\\f15c";
}

.bi-badge-4k::before {
  content: "\\f15d";
}

.bi-badge-8k-fill::before {
  content: "\\f15e";
}

.bi-badge-8k::before {
  content: "\\f15f";
}

.bi-badge-ad-fill::before {
  content: "\\f160";
}

.bi-badge-ad::before {
  content: "\\f161";
}

.bi-badge-ar-fill::before {
  content: "\\f162";
}

.bi-badge-ar::before {
  content: "\\f163";
}

.bi-badge-cc-fill::before {
  content: "\\f164";
}

.bi-badge-cc::before {
  content: "\\f165";
}

.bi-badge-hd-fill::before {
  content: "\\f166";
}

.bi-badge-hd::before {
  content: "\\f167";
}

.bi-badge-tm-fill::before {
  content: "\\f168";
}

.bi-badge-tm::before {
  content: "\\f169";
}

.bi-badge-vo-fill::before {
  content: "\\f16a";
}

.bi-badge-vo::before {
  content: "\\f16b";
}

.bi-badge-vr-fill::before {
  content: "\\f16c";
}

.bi-badge-vr::before {
  content: "\\f16d";
}

.bi-badge-wc-fill::before {
  content: "\\f16e";
}

.bi-badge-wc::before {
  content: "\\f16f";
}

.bi-bag-check-fill::before {
  content: "\\f170";
}

.bi-bag-check::before {
  content: "\\f171";
}

.bi-bag-dash-fill::before {
  content: "\\f172";
}

.bi-bag-dash::before {
  content: "\\f173";
}

.bi-bag-fill::before {
  content: "\\f174";
}

.bi-bag-plus-fill::before {
  content: "\\f175";
}

.bi-bag-plus::before {
  content: "\\f176";
}

.bi-bag-x-fill::before {
  content: "\\f177";
}

.bi-bag-x::before {
  content: "\\f178";
}

.bi-bag::before {
  content: "\\f179";
}

.bi-bar-chart-fill::before {
  content: "\\f17a";
}

.bi-bar-chart-line-fill::before {
  content: "\\f17b";
}

.bi-bar-chart-line::before {
  content: "\\f17c";
}

.bi-bar-chart-steps::before {
  content: "\\f17d";
}

.bi-bar-chart::before {
  content: "\\f17e";
}

.bi-basket-fill::before {
  content: "\\f17f";
}

.bi-basket::before {
  content: "\\f180";
}

.bi-basket2-fill::before {
  content: "\\f181";
}

.bi-basket2::before {
  content: "\\f182";
}

.bi-basket3-fill::before {
  content: "\\f183";
}

.bi-basket3::before {
  content: "\\f184";
}

.bi-battery-charging::before {
  content: "\\f185";
}

.bi-battery-full::before {
  content: "\\f186";
}

.bi-battery-half::before {
  content: "\\f187";
}

.bi-battery::before {
  content: "\\f188";
}

.bi-bell-fill::before {
  content: "\\f189";
}

.bi-bell::before {
  content: "\\f18a";
}

.bi-bezier::before {
  content: "\\f18b";
}

.bi-bezier2::before {
  content: "\\f18c";
}

.bi-bicycle::before {
  content: "\\f18d";
}

.bi-binoculars-fill::before {
  content: "\\f18e";
}

.bi-binoculars::before {
  content: "\\f18f";
}

.bi-blockquote-left::before {
  content: "\\f190";
}

.bi-blockquote-right::before {
  content: "\\f191";
}

.bi-book-fill::before {
  content: "\\f192";
}

.bi-book-half::before {
  content: "\\f193";
}

.bi-book::before {
  content: "\\f194";
}

.bi-bookmark-check-fill::before {
  content: "\\f195";
}

.bi-bookmark-check::before {
  content: "\\f196";
}

.bi-bookmark-dash-fill::before {
  content: "\\f197";
}

.bi-bookmark-dash::before {
  content: "\\f198";
}

.bi-bookmark-fill::before {
  content: "\\f199";
}

.bi-bookmark-heart-fill::before {
  content: "\\f19a";
}

.bi-bookmark-heart::before {
  content: "\\f19b";
}

.bi-bookmark-plus-fill::before {
  content: "\\f19c";
}

.bi-bookmark-plus::before {
  content: "\\f19d";
}

.bi-bookmark-star-fill::before {
  content: "\\f19e";
}

.bi-bookmark-star::before {
  content: "\\f19f";
}

.bi-bookmark-x-fill::before {
  content: "\\f1a0";
}

.bi-bookmark-x::before {
  content: "\\f1a1";
}

.bi-bookmark::before {
  content: "\\f1a2";
}

.bi-bookmarks-fill::before {
  content: "\\f1a3";
}

.bi-bookmarks::before {
  content: "\\f1a4";
}

.bi-bookshelf::before {
  content: "\\f1a5";
}

.bi-bootstrap-fill::before {
  content: "\\f1a6";
}

.bi-bootstrap-reboot::before {
  content: "\\f1a7";
}

.bi-bootstrap::before {
  content: "\\f1a8";
}

.bi-border-all::before {
  content: "\\f1a9";
}

.bi-border-bottom::before {
  content: "\\f1aa";
}

.bi-border-center::before {
  content: "\\f1ab";
}

.bi-border-inner::before {
  content: "\\f1ac";
}

.bi-border-left::before {
  content: "\\f1ad";
}

.bi-border-middle::before {
  content: "\\f1ae";
}

.bi-border-outer::before {
  content: "\\f1af";
}

.bi-border-right::before {
  content: "\\f1b0";
}

.bi-border-style::before {
  content: "\\f1b1";
}

.bi-border-top::before {
  content: "\\f1b2";
}

.bi-border-width::before {
  content: "\\f1b3";
}

.bi-border::before {
  content: "\\f1b4";
}

.bi-bounding-box-circles::before {
  content: "\\f1b5";
}

.bi-bounding-box::before {
  content: "\\f1b6";
}

.bi-box-arrow-down-left::before {
  content: "\\f1b7";
}

.bi-box-arrow-down-right::before {
  content: "\\f1b8";
}

.bi-box-arrow-down::before {
  content: "\\f1b9";
}

.bi-box-arrow-in-down-left::before {
  content: "\\f1ba";
}

.bi-box-arrow-in-down-right::before {
  content: "\\f1bb";
}

.bi-box-arrow-in-down::before {
  content: "\\f1bc";
}

.bi-box-arrow-in-left::before {
  content: "\\f1bd";
}

.bi-box-arrow-in-right::before {
  content: "\\f1be";
}

.bi-box-arrow-in-up-left::before {
  content: "\\f1bf";
}

.bi-box-arrow-in-up-right::before {
  content: "\\f1c0";
}

.bi-box-arrow-in-up::before {
  content: "\\f1c1";
}

.bi-box-arrow-left::before {
  content: "\\f1c2";
}

.bi-box-arrow-right::before {
  content: "\\f1c3";
}

.bi-box-arrow-up-left::before {
  content: "\\f1c4";
}

.bi-box-arrow-up-right::before {
  content: "\\f1c5";
}

.bi-box-arrow-up::before {
  content: "\\f1c6";
}

.bi-box-seam::before {
  content: "\\f1c7";
}

.bi-box::before {
  content: "\\f1c8";
}

.bi-braces::before {
  content: "\\f1c9";
}

.bi-bricks::before {
  content: "\\f1ca";
}

.bi-briefcase-fill::before {
  content: "\\f1cb";
}

.bi-briefcase::before {
  content: "\\f1cc";
}

.bi-brightness-alt-high-fill::before {
  content: "\\f1cd";
}

.bi-brightness-alt-high::before {
  content: "\\f1ce";
}

.bi-brightness-alt-low-fill::before {
  content: "\\f1cf";
}

.bi-brightness-alt-low::before {
  content: "\\f1d0";
}

.bi-brightness-high-fill::before {
  content: "\\f1d1";
}

.bi-brightness-high::before {
  content: "\\f1d2";
}

.bi-brightness-low-fill::before {
  content: "\\f1d3";
}

.bi-brightness-low::before {
  content: "\\f1d4";
}

.bi-broadcast-pin::before {
  content: "\\f1d5";
}

.bi-broadcast::before {
  content: "\\f1d6";
}

.bi-brush-fill::before {
  content: "\\f1d7";
}

.bi-brush::before {
  content: "\\f1d8";
}

.bi-bucket-fill::before {
  content: "\\f1d9";
}

.bi-bucket::before {
  content: "\\f1da";
}

.bi-bug-fill::before {
  content: "\\f1db";
}

.bi-bug::before {
  content: "\\f1dc";
}

.bi-building::before {
  content: "\\f1dd";
}

.bi-bullseye::before {
  content: "\\f1de";
}

.bi-calculator-fill::before {
  content: "\\f1df";
}

.bi-calculator::before {
  content: "\\f1e0";
}

.bi-calendar-check-fill::before {
  content: "\\f1e1";
}

.bi-calendar-check::before {
  content: "\\f1e2";
}

.bi-calendar-date-fill::before {
  content: "\\f1e3";
}

.bi-calendar-date::before {
  content: "\\f1e4";
}

.bi-calendar-day-fill::before {
  content: "\\f1e5";
}

.bi-calendar-day::before {
  content: "\\f1e6";
}

.bi-calendar-event-fill::before {
  content: "\\f1e7";
}

.bi-calendar-event::before {
  content: "\\f1e8";
}

.bi-calendar-fill::before {
  content: "\\f1e9";
}

.bi-calendar-minus-fill::before {
  content: "\\f1ea";
}

.bi-calendar-minus::before {
  content: "\\f1eb";
}

.bi-calendar-month-fill::before {
  content: "\\f1ec";
}

.bi-calendar-month::before {
  content: "\\f1ed";
}

.bi-calendar-plus-fill::before {
  content: "\\f1ee";
}

.bi-calendar-plus::before {
  content: "\\f1ef";
}

.bi-calendar-range-fill::before {
  content: "\\f1f0";
}

.bi-calendar-range::before {
  content: "\\f1f1";
}

.bi-calendar-week-fill::before {
  content: "\\f1f2";
}

.bi-calendar-week::before {
  content: "\\f1f3";
}

.bi-calendar-x-fill::before {
  content: "\\f1f4";
}

.bi-calendar-x::before {
  content: "\\f1f5";
}

.bi-calendar::before {
  content: "\\f1f6";
}

.bi-calendar2-check-fill::before {
  content: "\\f1f7";
}

.bi-calendar2-check::before {
  content: "\\f1f8";
}

.bi-calendar2-date-fill::before {
  content: "\\f1f9";
}

.bi-calendar2-date::before {
  content: "\\f1fa";
}

.bi-calendar2-day-fill::before {
  content: "\\f1fb";
}

.bi-calendar2-day::before {
  content: "\\f1fc";
}

.bi-calendar2-event-fill::before {
  content: "\\f1fd";
}

.bi-calendar2-event::before {
  content: "\\f1fe";
}

.bi-calendar2-fill::before {
  content: "\\f1ff";
}

.bi-calendar2-minus-fill::before {
  content: "\\f200";
}

.bi-calendar2-minus::before {
  content: "\\f201";
}

.bi-calendar2-month-fill::before {
  content: "\\f202";
}

.bi-calendar2-month::before {
  content: "\\f203";
}

.bi-calendar2-plus-fill::before {
  content: "\\f204";
}

.bi-calendar2-plus::before {
  content: "\\f205";
}

.bi-calendar2-range-fill::before {
  content: "\\f206";
}

.bi-calendar2-range::before {
  content: "\\f207";
}

.bi-calendar2-week-fill::before {
  content: "\\f208";
}

.bi-calendar2-week::before {
  content: "\\f209";
}

.bi-calendar2-x-fill::before {
  content: "\\f20a";
}

.bi-calendar2-x::before {
  content: "\\f20b";
}

.bi-calendar2::before {
  content: "\\f20c";
}

.bi-calendar3-event-fill::before {
  content: "\\f20d";
}

.bi-calendar3-event::before {
  content: "\\f20e";
}

.bi-calendar3-fill::before {
  content: "\\f20f";
}

.bi-calendar3-range-fill::before {
  content: "\\f210";
}

.bi-calendar3-range::before {
  content: "\\f211";
}

.bi-calendar3-week-fill::before {
  content: "\\f212";
}

.bi-calendar3-week::before {
  content: "\\f213";
}

.bi-calendar3::before {
  content: "\\f214";
}

.bi-calendar4-event::before {
  content: "\\f215";
}

.bi-calendar4-range::before {
  content: "\\f216";
}

.bi-calendar4-week::before {
  content: "\\f217";
}

.bi-calendar4::before {
  content: "\\f218";
}

.bi-camera-fill::before {
  content: "\\f219";
}

.bi-camera-reels-fill::before {
  content: "\\f21a";
}

.bi-camera-reels::before {
  content: "\\f21b";
}

.bi-camera-video-fill::before {
  content: "\\f21c";
}

.bi-camera-video-off-fill::before {
  content: "\\f21d";
}

.bi-camera-video-off::before {
  content: "\\f21e";
}

.bi-camera-video::before {
  content: "\\f21f";
}

.bi-camera::before {
  content: "\\f220";
}

.bi-camera2::before {
  content: "\\f221";
}

.bi-capslock-fill::before {
  content: "\\f222";
}

.bi-capslock::before {
  content: "\\f223";
}

.bi-card-checklist::before {
  content: "\\f224";
}

.bi-card-heading::before {
  content: "\\f225";
}

.bi-card-image::before {
  content: "\\f226";
}

.bi-card-list::before {
  content: "\\f227";
}

.bi-card-text::before {
  content: "\\f228";
}

.bi-caret-down-fill::before {
  content: "\\f229";
}

.bi-caret-down-square-fill::before {
  content: "\\f22a";
}

.bi-caret-down-square::before {
  content: "\\f22b";
}

.bi-caret-down::before {
  content: "\\f22c";
}

.bi-caret-left-fill::before {
  content: "\\f22d";
}

.bi-caret-left-square-fill::before {
  content: "\\f22e";
}

.bi-caret-left-square::before {
  content: "\\f22f";
}

.bi-caret-left::before {
  content: "\\f230";
}

.bi-caret-right-fill::before {
  content: "\\f231";
}

.bi-caret-right-square-fill::before {
  content: "\\f232";
}

.bi-caret-right-square::before {
  content: "\\f233";
}

.bi-caret-right::before {
  content: "\\f234";
}

.bi-caret-up-fill::before {
  content: "\\f235";
}

.bi-caret-up-square-fill::before {
  content: "\\f236";
}

.bi-caret-up-square::before {
  content: "\\f237";
}

.bi-caret-up::before {
  content: "\\f238";
}

.bi-cart-check-fill::before {
  content: "\\f239";
}

.bi-cart-check::before {
  content: "\\f23a";
}

.bi-cart-dash-fill::before {
  content: "\\f23b";
}

.bi-cart-dash::before {
  content: "\\f23c";
}

.bi-cart-fill::before {
  content: "\\f23d";
}

.bi-cart-plus-fill::before {
  content: "\\f23e";
}

.bi-cart-plus::before {
  content: "\\f23f";
}

.bi-cart-x-fill::before {
  content: "\\f240";
}

.bi-cart-x::before {
  content: "\\f241";
}

.bi-cart::before {
  content: "\\f242";
}

.bi-cart2::before {
  content: "\\f243";
}

.bi-cart3::before {
  content: "\\f244";
}

.bi-cart4::before {
  content: "\\f245";
}

.bi-cash-stack::before {
  content: "\\f246";
}

.bi-cash::before {
  content: "\\f247";
}

.bi-cast::before {
  content: "\\f248";
}

.bi-chat-dots-fill::before {
  content: "\\f249";
}

.bi-chat-dots::before {
  content: "\\f24a";
}

.bi-chat-fill::before {
  content: "\\f24b";
}

.bi-chat-left-dots-fill::before {
  content: "\\f24c";
}

.bi-chat-left-dots::before {
  content: "\\f24d";
}

.bi-chat-left-fill::before {
  content: "\\f24e";
}

.bi-chat-left-quote-fill::before {
  content: "\\f24f";
}

.bi-chat-left-quote::before {
  content: "\\f250";
}

.bi-chat-left-text-fill::before {
  content: "\\f251";
}

.bi-chat-left-text::before {
  content: "\\f252";
}

.bi-chat-left::before {
  content: "\\f253";
}

.bi-chat-quote-fill::before {
  content: "\\f254";
}

.bi-chat-quote::before {
  content: "\\f255";
}

.bi-chat-right-dots-fill::before {
  content: "\\f256";
}

.bi-chat-right-dots::before {
  content: "\\f257";
}

.bi-chat-right-fill::before {
  content: "\\f258";
}

.bi-chat-right-quote-fill::before {
  content: "\\f259";
}

.bi-chat-right-quote::before {
  content: "\\f25a";
}

.bi-chat-right-text-fill::before {
  content: "\\f25b";
}

.bi-chat-right-text::before {
  content: "\\f25c";
}

.bi-chat-right::before {
  content: "\\f25d";
}

.bi-chat-square-dots-fill::before {
  content: "\\f25e";
}

.bi-chat-square-dots::before {
  content: "\\f25f";
}

.bi-chat-square-fill::before {
  content: "\\f260";
}

.bi-chat-square-quote-fill::before {
  content: "\\f261";
}

.bi-chat-square-quote::before {
  content: "\\f262";
}

.bi-chat-square-text-fill::before {
  content: "\\f263";
}

.bi-chat-square-text::before {
  content: "\\f264";
}

.bi-chat-square::before {
  content: "\\f265";
}

.bi-chat-text-fill::before {
  content: "\\f266";
}

.bi-chat-text::before {
  content: "\\f267";
}

.bi-chat::before {
  content: "\\f268";
}

.bi-check-all::before {
  content: "\\f269";
}

.bi-check-circle-fill::before {
  content: "\\f26a";
}

.bi-check-circle::before {
  content: "\\f26b";
}

.bi-check-square-fill::before {
  content: "\\f26c";
}

.bi-check-square::before {
  content: "\\f26d";
}

.bi-check::before {
  content: "\\f26e";
}

.bi-check2-all::before {
  content: "\\f26f";
}

.bi-check2-circle::before {
  content: "\\f270";
}

.bi-check2-square::before {
  content: "\\f271";
}

.bi-check2::before {
  content: "\\f272";
}

.bi-chevron-bar-contract::before {
  content: "\\f273";
}

.bi-chevron-bar-down::before {
  content: "\\f274";
}

.bi-chevron-bar-expand::before {
  content: "\\f275";
}

.bi-chevron-bar-left::before {
  content: "\\f276";
}

.bi-chevron-bar-right::before {
  content: "\\f277";
}

.bi-chevron-bar-up::before {
  content: "\\f278";
}

.bi-chevron-compact-down::before {
  content: "\\f279";
}

.bi-chevron-compact-left::before {
  content: "\\f27a";
}

.bi-chevron-compact-right::before {
  content: "\\f27b";
}

.bi-chevron-compact-up::before {
  content: "\\f27c";
}

.bi-chevron-contract::before {
  content: "\\f27d";
}

.bi-chevron-double-down::before {
  content: "\\f27e";
}

.bi-chevron-double-left::before {
  content: "\\f27f";
}

.bi-chevron-double-right::before {
  content: "\\f280";
}

.bi-chevron-double-up::before {
  content: "\\f281";
}

.bi-chevron-down::before {
  content: "\\f282";
}

.bi-chevron-expand::before {
  content: "\\f283";
}

.bi-chevron-left::before {
  content: "\\f284";
}

.bi-chevron-right::before {
  content: "\\f285";
}

.bi-chevron-up::before {
  content: "\\f286";
}

.bi-circle-fill::before {
  content: "\\f287";
}

.bi-circle-half::before {
  content: "\\f288";
}

.bi-circle-square::before {
  content: "\\f289";
}

.bi-circle::before {
  content: "\\f28a";
}

.bi-clipboard-check::before {
  content: "\\f28b";
}

.bi-clipboard-data::before {
  content: "\\f28c";
}

.bi-clipboard-minus::before {
  content: "\\f28d";
}

.bi-clipboard-plus::before {
  content: "\\f28e";
}

.bi-clipboard-x::before {
  content: "\\f28f";
}

.bi-clipboard::before {
  content: "\\f290";
}

.bi-clock-fill::before {
  content: "\\f291";
}

.bi-clock-history::before {
  content: "\\f292";
}

.bi-clock::before {
  content: "\\f293";
}

.bi-cloud-arrow-down-fill::before {
  content: "\\f294";
}

.bi-cloud-arrow-down::before {
  content: "\\f295";
}

.bi-cloud-arrow-up-fill::before {
  content: "\\f296";
}

.bi-cloud-arrow-up::before {
  content: "\\f297";
}

.bi-cloud-check-fill::before {
  content: "\\f298";
}

.bi-cloud-check::before {
  content: "\\f299";
}

.bi-cloud-download-fill::before {
  content: "\\f29a";
}

.bi-cloud-download::before {
  content: "\\f29b";
}

.bi-cloud-drizzle-fill::before {
  content: "\\f29c";
}

.bi-cloud-drizzle::before {
  content: "\\f29d";
}

.bi-cloud-fill::before {
  content: "\\f29e";
}

.bi-cloud-fog-fill::before {
  content: "\\f29f";
}

.bi-cloud-fog::before {
  content: "\\f2a0";
}

.bi-cloud-fog2-fill::before {
  content: "\\f2a1";
}

.bi-cloud-fog2::before {
  content: "\\f2a2";
}

.bi-cloud-hail-fill::before {
  content: "\\f2a3";
}

.bi-cloud-hail::before {
  content: "\\f2a4";
}

.bi-cloud-haze-fill::before {
  content: "\\f2a6";
}

.bi-cloud-haze::before {
  content: "\\f2a7";
}

.bi-cloud-haze2-fill::before {
  content: "\\f2a8";
}

.bi-cloud-lightning-fill::before {
  content: "\\f2a9";
}

.bi-cloud-lightning-rain-fill::before {
  content: "\\f2aa";
}

.bi-cloud-lightning-rain::before {
  content: "\\f2ab";
}

.bi-cloud-lightning::before {
  content: "\\f2ac";
}

.bi-cloud-minus-fill::before {
  content: "\\f2ad";
}

.bi-cloud-minus::before {
  content: "\\f2ae";
}

.bi-cloud-moon-fill::before {
  content: "\\f2af";
}

.bi-cloud-moon::before {
  content: "\\f2b0";
}

.bi-cloud-plus-fill::before {
  content: "\\f2b1";
}

.bi-cloud-plus::before {
  content: "\\f2b2";
}

.bi-cloud-rain-fill::before {
  content: "\\f2b3";
}

.bi-cloud-rain-heavy-fill::before {
  content: "\\f2b4";
}

.bi-cloud-rain-heavy::before {
  content: "\\f2b5";
}

.bi-cloud-rain::before {
  content: "\\f2b6";
}

.bi-cloud-slash-fill::before {
  content: "\\f2b7";
}

.bi-cloud-slash::before {
  content: "\\f2b8";
}

.bi-cloud-sleet-fill::before {
  content: "\\f2b9";
}

.bi-cloud-sleet::before {
  content: "\\f2ba";
}

.bi-cloud-snow-fill::before {
  content: "\\f2bb";
}

.bi-cloud-snow::before {
  content: "\\f2bc";
}

.bi-cloud-sun-fill::before {
  content: "\\f2bd";
}

.bi-cloud-sun::before {
  content: "\\f2be";
}

.bi-cloud-upload-fill::before {
  content: "\\f2bf";
}

.bi-cloud-upload::before {
  content: "\\f2c0";
}

.bi-cloud::before {
  content: "\\f2c1";
}

.bi-clouds-fill::before {
  content: "\\f2c2";
}

.bi-clouds::before {
  content: "\\f2c3";
}

.bi-cloudy-fill::before {
  content: "\\f2c4";
}

.bi-cloudy::before {
  content: "\\f2c5";
}

.bi-code-slash::before {
  content: "\\f2c6";
}

.bi-code-square::before {
  content: "\\f2c7";
}

.bi-code::before {
  content: "\\f2c8";
}

.bi-collection-fill::before {
  content: "\\f2c9";
}

.bi-collection-play-fill::before {
  content: "\\f2ca";
}

.bi-collection-play::before {
  content: "\\f2cb";
}

.bi-collection::before {
  content: "\\f2cc";
}

.bi-columns-gap::before {
  content: "\\f2cd";
}

.bi-columns::before {
  content: "\\f2ce";
}

.bi-command::before {
  content: "\\f2cf";
}

.bi-compass-fill::before {
  content: "\\f2d0";
}

.bi-compass::before {
  content: "\\f2d1";
}

.bi-cone-striped::before {
  content: "\\f2d2";
}

.bi-cone::before {
  content: "\\f2d3";
}

.bi-controller::before {
  content: "\\f2d4";
}

.bi-cpu-fill::before {
  content: "\\f2d5";
}

.bi-cpu::before {
  content: "\\f2d6";
}

.bi-credit-card-2-back-fill::before {
  content: "\\f2d7";
}

.bi-credit-card-2-back::before {
  content: "\\f2d8";
}

.bi-credit-card-2-front-fill::before {
  content: "\\f2d9";
}

.bi-credit-card-2-front::before {
  content: "\\f2da";
}

.bi-credit-card-fill::before {
  content: "\\f2db";
}

.bi-credit-card::before {
  content: "\\f2dc";
}

.bi-crop::before {
  content: "\\f2dd";
}

.bi-cup-fill::before {
  content: "\\f2de";
}

.bi-cup-straw::before {
  content: "\\f2df";
}

.bi-cup::before {
  content: "\\f2e0";
}

.bi-cursor-fill::before {
  content: "\\f2e1";
}

.bi-cursor-text::before {
  content: "\\f2e2";
}

.bi-cursor::before {
  content: "\\f2e3";
}

.bi-dash-circle-dotted::before {
  content: "\\f2e4";
}

.bi-dash-circle-fill::before {
  content: "\\f2e5";
}

.bi-dash-circle::before {
  content: "\\f2e6";
}

.bi-dash-square-dotted::before {
  content: "\\f2e7";
}

.bi-dash-square-fill::before {
  content: "\\f2e8";
}

.bi-dash-square::before {
  content: "\\f2e9";
}

.bi-dash::before {
  content: "\\f2ea";
}

.bi-diagram-2-fill::before {
  content: "\\f2eb";
}

.bi-diagram-2::before {
  content: "\\f2ec";
}

.bi-diagram-3-fill::before {
  content: "\\f2ed";
}

.bi-diagram-3::before {
  content: "\\f2ee";
}

.bi-diamond-fill::before {
  content: "\\f2ef";
}

.bi-diamond-half::before {
  content: "\\f2f0";
}

.bi-diamond::before {
  content: "\\f2f1";
}

.bi-dice-1-fill::before {
  content: "\\f2f2";
}

.bi-dice-1::before {
  content: "\\f2f3";
}

.bi-dice-2-fill::before {
  content: "\\f2f4";
}

.bi-dice-2::before {
  content: "\\f2f5";
}

.bi-dice-3-fill::before {
  content: "\\f2f6";
}

.bi-dice-3::before {
  content: "\\f2f7";
}

.bi-dice-4-fill::before {
  content: "\\f2f8";
}

.bi-dice-4::before {
  content: "\\f2f9";
}

.bi-dice-5-fill::before {
  content: "\\f2fa";
}

.bi-dice-5::before {
  content: "\\f2fb";
}

.bi-dice-6-fill::before {
  content: "\\f2fc";
}

.bi-dice-6::before {
  content: "\\f2fd";
}

.bi-disc-fill::before {
  content: "\\f2fe";
}

.bi-disc::before {
  content: "\\f2ff";
}

.bi-discord::before {
  content: "\\f300";
}

.bi-display-fill::before {
  content: "\\f301";
}

.bi-display::before {
  content: "\\f302";
}

.bi-distribute-horizontal::before {
  content: "\\f303";
}

.bi-distribute-vertical::before {
  content: "\\f304";
}

.bi-door-closed-fill::before {
  content: "\\f305";
}

.bi-door-closed::before {
  content: "\\f306";
}

.bi-door-open-fill::before {
  content: "\\f307";
}

.bi-door-open::before {
  content: "\\f308";
}

.bi-dot::before {
  content: "\\f309";
}

.bi-download::before {
  content: "\\f30a";
}

.bi-droplet-fill::before {
  content: "\\f30b";
}

.bi-droplet-half::before {
  content: "\\f30c";
}

.bi-droplet::before {
  content: "\\f30d";
}

.bi-earbuds::before {
  content: "\\f30e";
}

.bi-easel-fill::before {
  content: "\\f30f";
}

.bi-easel::before {
  content: "\\f310";
}

.bi-egg-fill::before {
  content: "\\f311";
}

.bi-egg-fried::before {
  content: "\\f312";
}

.bi-egg::before {
  content: "\\f313";
}

.bi-eject-fill::before {
  content: "\\f314";
}

.bi-eject::before {
  content: "\\f315";
}

.bi-emoji-angry-fill::before {
  content: "\\f316";
}

.bi-emoji-angry::before {
  content: "\\f317";
}

.bi-emoji-dizzy-fill::before {
  content: "\\f318";
}

.bi-emoji-dizzy::before {
  content: "\\f319";
}

.bi-emoji-expressionless-fill::before {
  content: "\\f31a";
}

.bi-emoji-expressionless::before {
  content: "\\f31b";
}

.bi-emoji-frown-fill::before {
  content: "\\f31c";
}

.bi-emoji-frown::before {
  content: "\\f31d";
}

.bi-emoji-heart-eyes-fill::before {
  content: "\\f31e";
}

.bi-emoji-heart-eyes::before {
  content: "\\f31f";
}

.bi-emoji-laughing-fill::before {
  content: "\\f320";
}

.bi-emoji-laughing::before {
  content: "\\f321";
}

.bi-emoji-neutral-fill::before {
  content: "\\f322";
}

.bi-emoji-neutral::before {
  content: "\\f323";
}

.bi-emoji-smile-fill::before {
  content: "\\f324";
}

.bi-emoji-smile-upside-down-fill::before {
  content: "\\f325";
}

.bi-emoji-smile-upside-down::before {
  content: "\\f326";
}

.bi-emoji-smile::before {
  content: "\\f327";
}

.bi-emoji-sunglasses-fill::before {
  content: "\\f328";
}

.bi-emoji-sunglasses::before {
  content: "\\f329";
}

.bi-emoji-wink-fill::before {
  content: "\\f32a";
}

.bi-emoji-wink::before {
  content: "\\f32b";
}

.bi-envelope-fill::before {
  content: "\\f32c";
}

.bi-envelope-open-fill::before {
  content: "\\f32d";
}

.bi-envelope-open::before {
  content: "\\f32e";
}

.bi-envelope::before {
  content: "\\f32f";
}

.bi-eraser-fill::before {
  content: "\\f330";
}

.bi-eraser::before {
  content: "\\f331";
}

.bi-exclamation-circle-fill::before {
  content: "\\f332";
}

.bi-exclamation-circle::before {
  content: "\\f333";
}

.bi-exclamation-diamond-fill::before {
  content: "\\f334";
}

.bi-exclamation-diamond::before {
  content: "\\f335";
}

.bi-exclamation-octagon-fill::before {
  content: "\\f336";
}

.bi-exclamation-octagon::before {
  content: "\\f337";
}

.bi-exclamation-square-fill::before {
  content: "\\f338";
}

.bi-exclamation-square::before {
  content: "\\f339";
}

.bi-exclamation-triangle-fill::before {
  content: "\\f33a";
}

.bi-exclamation-triangle::before {
  content: "\\f33b";
}

.bi-exclamation::before {
  content: "\\f33c";
}

.bi-exclude::before {
  content: "\\f33d";
}

.bi-eye-fill::before {
  content: "\\f33e";
}

.bi-eye-slash-fill::before {
  content: "\\f33f";
}

.bi-eye-slash::before {
  content: "\\f340";
}

.bi-eye::before {
  content: "\\f341";
}

.bi-eyedropper::before {
  content: "\\f342";
}

.bi-eyeglasses::before {
  content: "\\f343";
}

.bi-facebook::before {
  content: "\\f344";
}

.bi-file-arrow-down-fill::before {
  content: "\\f345";
}

.bi-file-arrow-down::before {
  content: "\\f346";
}

.bi-file-arrow-up-fill::before {
  content: "\\f347";
}

.bi-file-arrow-up::before {
  content: "\\f348";
}

.bi-file-bar-graph-fill::before {
  content: "\\f349";
}

.bi-file-bar-graph::before {
  content: "\\f34a";
}

.bi-file-binary-fill::before {
  content: "\\f34b";
}

.bi-file-binary::before {
  content: "\\f34c";
}

.bi-file-break-fill::before {
  content: "\\f34d";
}

.bi-file-break::before {
  content: "\\f34e";
}

.bi-file-check-fill::before {
  content: "\\f34f";
}

.bi-file-check::before {
  content: "\\f350";
}

.bi-file-code-fill::before {
  content: "\\f351";
}

.bi-file-code::before {
  content: "\\f352";
}

.bi-file-diff-fill::before {
  content: "\\f353";
}

.bi-file-diff::before {
  content: "\\f354";
}

.bi-file-earmark-arrow-down-fill::before {
  content: "\\f355";
}

.bi-file-earmark-arrow-down::before {
  content: "\\f356";
}

.bi-file-earmark-arrow-up-fill::before {
  content: "\\f357";
}

.bi-file-earmark-arrow-up::before {
  content: "\\f358";
}

.bi-file-earmark-bar-graph-fill::before {
  content: "\\f359";
}

.bi-file-earmark-bar-graph::before {
  content: "\\f35a";
}

.bi-file-earmark-binary-fill::before {
  content: "\\f35b";
}

.bi-file-earmark-binary::before {
  content: "\\f35c";
}

.bi-file-earmark-break-fill::before {
  content: "\\f35d";
}

.bi-file-earmark-break::before {
  content: "\\f35e";
}

.bi-file-earmark-check-fill::before {
  content: "\\f35f";
}

.bi-file-earmark-check::before {
  content: "\\f360";
}

.bi-file-earmark-code-fill::before {
  content: "\\f361";
}

.bi-file-earmark-code::before {
  content: "\\f362";
}

.bi-file-earmark-diff-fill::before {
  content: "\\f363";
}

.bi-file-earmark-diff::before {
  content: "\\f364";
}

.bi-file-earmark-easel-fill::before {
  content: "\\f365";
}

.bi-file-earmark-easel::before {
  content: "\\f366";
}

.bi-file-earmark-excel-fill::before {
  content: "\\f367";
}

.bi-file-earmark-excel::before {
  content: "\\f368";
}

.bi-file-earmark-fill::before {
  content: "\\f369";
}

.bi-file-earmark-font-fill::before {
  content: "\\f36a";
}

.bi-file-earmark-font::before {
  content: "\\f36b";
}

.bi-file-earmark-image-fill::before {
  content: "\\f36c";
}

.bi-file-earmark-image::before {
  content: "\\f36d";
}

.bi-file-earmark-lock-fill::before {
  content: "\\f36e";
}

.bi-file-earmark-lock::before {
  content: "\\f36f";
}

.bi-file-earmark-lock2-fill::before {
  content: "\\f370";
}

.bi-file-earmark-lock2::before {
  content: "\\f371";
}

.bi-file-earmark-medical-fill::before {
  content: "\\f372";
}

.bi-file-earmark-medical::before {
  content: "\\f373";
}

.bi-file-earmark-minus-fill::before {
  content: "\\f374";
}

.bi-file-earmark-minus::before {
  content: "\\f375";
}

.bi-file-earmark-music-fill::before {
  content: "\\f376";
}

.bi-file-earmark-music::before {
  content: "\\f377";
}

.bi-file-earmark-person-fill::before {
  content: "\\f378";
}

.bi-file-earmark-person::before {
  content: "\\f379";
}

.bi-file-earmark-play-fill::before {
  content: "\\f37a";
}

.bi-file-earmark-play::before {
  content: "\\f37b";
}

.bi-file-earmark-plus-fill::before {
  content: "\\f37c";
}

.bi-file-earmark-plus::before {
  content: "\\f37d";
}

.bi-file-earmark-post-fill::before {
  content: "\\f37e";
}

.bi-file-earmark-post::before {
  content: "\\f37f";
}

.bi-file-earmark-ppt-fill::before {
  content: "\\f380";
}

.bi-file-earmark-ppt::before {
  content: "\\f381";
}

.bi-file-earmark-richtext-fill::before {
  content: "\\f382";
}

.bi-file-earmark-richtext::before {
  content: "\\f383";
}

.bi-file-earmark-ruled-fill::before {
  content: "\\f384";
}

.bi-file-earmark-ruled::before {
  content: "\\f385";
}

.bi-file-earmark-slides-fill::before {
  content: "\\f386";
}

.bi-file-earmark-slides::before {
  content: "\\f387";
}

.bi-file-earmark-spreadsheet-fill::before {
  content: "\\f388";
}

.bi-file-earmark-spreadsheet::before {
  content: "\\f389";
}

.bi-file-earmark-text-fill::before {
  content: "\\f38a";
}

.bi-file-earmark-text::before {
  content: "\\f38b";
}

.bi-file-earmark-word-fill::before {
  content: "\\f38c";
}

.bi-file-earmark-word::before {
  content: "\\f38d";
}

.bi-file-earmark-x-fill::before {
  content: "\\f38e";
}

.bi-file-earmark-x::before {
  content: "\\f38f";
}

.bi-file-earmark-zip-fill::before {
  content: "\\f390";
}

.bi-file-earmark-zip::before {
  content: "\\f391";
}

.bi-file-earmark::before {
  content: "\\f392";
}

.bi-file-easel-fill::before {
  content: "\\f393";
}

.bi-file-easel::before {
  content: "\\f394";
}

.bi-file-excel-fill::before {
  content: "\\f395";
}

.bi-file-excel::before {
  content: "\\f396";
}

.bi-file-fill::before {
  content: "\\f397";
}

.bi-file-font-fill::before {
  content: "\\f398";
}

.bi-file-font::before {
  content: "\\f399";
}

.bi-file-image-fill::before {
  content: "\\f39a";
}

.bi-file-image::before {
  content: "\\f39b";
}

.bi-file-lock-fill::before {
  content: "\\f39c";
}

.bi-file-lock::before {
  content: "\\f39d";
}

.bi-file-lock2-fill::before {
  content: "\\f39e";
}

.bi-file-lock2::before {
  content: "\\f39f";
}

.bi-file-medical-fill::before {
  content: "\\f3a0";
}

.bi-file-medical::before {
  content: "\\f3a1";
}

.bi-file-minus-fill::before {
  content: "\\f3a2";
}

.bi-file-minus::before {
  content: "\\f3a3";
}

.bi-file-music-fill::before {
  content: "\\f3a4";
}

.bi-file-music::before {
  content: "\\f3a5";
}

.bi-file-person-fill::before {
  content: "\\f3a6";
}

.bi-file-person::before {
  content: "\\f3a7";
}

.bi-file-play-fill::before {
  content: "\\f3a8";
}

.bi-file-play::before {
  content: "\\f3a9";
}

.bi-file-plus-fill::before {
  content: "\\f3aa";
}

.bi-file-plus::before {
  content: "\\f3ab";
}

.bi-file-post-fill::before {
  content: "\\f3ac";
}

.bi-file-post::before {
  content: "\\f3ad";
}

.bi-file-ppt-fill::before {
  content: "\\f3ae";
}

.bi-file-ppt::before {
  content: "\\f3af";
}

.bi-file-richtext-fill::before {
  content: "\\f3b0";
}

.bi-file-richtext::before {
  content: "\\f3b1";
}

.bi-file-ruled-fill::before {
  content: "\\f3b2";
}

.bi-file-ruled::before {
  content: "\\f3b3";
}

.bi-file-slides-fill::before {
  content: "\\f3b4";
}

.bi-file-slides::before {
  content: "\\f3b5";
}

.bi-file-spreadsheet-fill::before {
  content: "\\f3b6";
}

.bi-file-spreadsheet::before {
  content: "\\f3b7";
}

.bi-file-text-fill::before {
  content: "\\f3b8";
}

.bi-file-text::before {
  content: "\\f3b9";
}

.bi-file-word-fill::before {
  content: "\\f3ba";
}

.bi-file-word::before {
  content: "\\f3bb";
}

.bi-file-x-fill::before {
  content: "\\f3bc";
}

.bi-file-x::before {
  content: "\\f3bd";
}

.bi-file-zip-fill::before {
  content: "\\f3be";
}

.bi-file-zip::before {
  content: "\\f3bf";
}

.bi-file::before {
  content: "\\f3c0";
}

.bi-files-alt::before {
  content: "\\f3c1";
}

.bi-files::before {
  content: "\\f3c2";
}

.bi-film::before {
  content: "\\f3c3";
}

.bi-filter-circle-fill::before {
  content: "\\f3c4";
}

.bi-filter-circle::before {
  content: "\\f3c5";
}

.bi-filter-left::before {
  content: "\\f3c6";
}

.bi-filter-right::before {
  content: "\\f3c7";
}

.bi-filter-square-fill::before {
  content: "\\f3c8";
}

.bi-filter-square::before {
  content: "\\f3c9";
}

.bi-filter::before {
  content: "\\f3ca";
}

.bi-flag-fill::before {
  content: "\\f3cb";
}

.bi-flag::before {
  content: "\\f3cc";
}

.bi-flower1::before {
  content: "\\f3cd";
}

.bi-flower2::before {
  content: "\\f3ce";
}

.bi-flower3::before {
  content: "\\f3cf";
}

.bi-folder-check::before {
  content: "\\f3d0";
}

.bi-folder-fill::before {
  content: "\\f3d1";
}

.bi-folder-minus::before {
  content: "\\f3d2";
}

.bi-folder-plus::before {
  content: "\\f3d3";
}

.bi-folder-symlink-fill::before {
  content: "\\f3d4";
}

.bi-folder-symlink::before {
  content: "\\f3d5";
}

.bi-folder-x::before {
  content: "\\f3d6";
}

.bi-folder::before {
  content: "\\f3d7";
}

.bi-folder2-open::before {
  content: "\\f3d8";
}

.bi-folder2::before {
  content: "\\f3d9";
}

.bi-fonts::before {
  content: "\\f3da";
}

.bi-forward-fill::before {
  content: "\\f3db";
}

.bi-forward::before {
  content: "\\f3dc";
}

.bi-front::before {
  content: "\\f3dd";
}

.bi-fullscreen-exit::before {
  content: "\\f3de";
}

.bi-fullscreen::before {
  content: "\\f3df";
}

.bi-funnel-fill::before {
  content: "\\f3e0";
}

.bi-funnel::before {
  content: "\\f3e1";
}

.bi-gear-fill::before {
  content: "\\f3e2";
}

.bi-gear-wide-connected::before {
  content: "\\f3e3";
}

.bi-gear-wide::before {
  content: "\\f3e4";
}

.bi-gear::before {
  content: "\\f3e5";
}

.bi-gem::before {
  content: "\\f3e6";
}

.bi-geo-alt-fill::before {
  content: "\\f3e7";
}

.bi-geo-alt::before {
  content: "\\f3e8";
}

.bi-geo-fill::before {
  content: "\\f3e9";
}

.bi-geo::before {
  content: "\\f3ea";
}

.bi-gift-fill::before {
  content: "\\f3eb";
}

.bi-gift::before {
  content: "\\f3ec";
}

.bi-github::before {
  content: "\\f3ed";
}

.bi-globe::before {
  content: "\\f3ee";
}

.bi-globe2::before {
  content: "\\f3ef";
}

.bi-google::before {
  content: "\\f3f0";
}

.bi-graph-down::before {
  content: "\\f3f1";
}

.bi-graph-up::before {
  content: "\\f3f2";
}

.bi-grid-1x2-fill::before {
  content: "\\f3f3";
}

.bi-grid-1x2::before {
  content: "\\f3f4";
}

.bi-grid-3x2-gap-fill::before {
  content: "\\f3f5";
}

.bi-grid-3x2-gap::before {
  content: "\\f3f6";
}

.bi-grid-3x2::before {
  content: "\\f3f7";
}

.bi-grid-3x3-gap-fill::before {
  content: "\\f3f8";
}

.bi-grid-3x3-gap::before {
  content: "\\f3f9";
}

.bi-grid-3x3::before {
  content: "\\f3fa";
}

.bi-grid-fill::before {
  content: "\\f3fb";
}

.bi-grid::before {
  content: "\\f3fc";
}

.bi-grip-horizontal::before {
  content: "\\f3fd";
}

.bi-grip-vertical::before {
  content: "\\f3fe";
}

.bi-hammer::before {
  content: "\\f3ff";
}

.bi-hand-index-fill::before {
  content: "\\f400";
}

.bi-hand-index-thumb-fill::before {
  content: "\\f401";
}

.bi-hand-index-thumb::before {
  content: "\\f402";
}

.bi-hand-index::before {
  content: "\\f403";
}

.bi-hand-thumbs-down-fill::before {
  content: "\\f404";
}

.bi-hand-thumbs-down::before {
  content: "\\f405";
}

.bi-hand-thumbs-up-fill::before {
  content: "\\f406";
}

.bi-hand-thumbs-up::before {
  content: "\\f407";
}

.bi-handbag-fill::before {
  content: "\\f408";
}

.bi-handbag::before {
  content: "\\f409";
}

.bi-hash::before {
  content: "\\f40a";
}

.bi-hdd-fill::before {
  content: "\\f40b";
}

.bi-hdd-network-fill::before {
  content: "\\f40c";
}

.bi-hdd-network::before {
  content: "\\f40d";
}

.bi-hdd-rack-fill::before {
  content: "\\f40e";
}

.bi-hdd-rack::before {
  content: "\\f40f";
}

.bi-hdd-stack-fill::before {
  content: "\\f410";
}

.bi-hdd-stack::before {
  content: "\\f411";
}

.bi-hdd::before {
  content: "\\f412";
}

.bi-headphones::before {
  content: "\\f413";
}

.bi-headset::before {
  content: "\\f414";
}

.bi-heart-fill::before {
  content: "\\f415";
}

.bi-heart-half::before {
  content: "\\f416";
}

.bi-heart::before {
  content: "\\f417";
}

.bi-heptagon-fill::before {
  content: "\\f418";
}

.bi-heptagon-half::before {
  content: "\\f419";
}

.bi-heptagon::before {
  content: "\\f41a";
}

.bi-hexagon-fill::before {
  content: "\\f41b";
}

.bi-hexagon-half::before {
  content: "\\f41c";
}

.bi-hexagon::before {
  content: "\\f41d";
}

.bi-hourglass-bottom::before {
  content: "\\f41e";
}

.bi-hourglass-split::before {
  content: "\\f41f";
}

.bi-hourglass-top::before {
  content: "\\f420";
}

.bi-hourglass::before {
  content: "\\f421";
}

.bi-house-door-fill::before {
  content: "\\f422";
}

.bi-house-door::before {
  content: "\\f423";
}

.bi-house-fill::before {
  content: "\\f424";
}

.bi-house::before {
  content: "\\f425";
}

.bi-hr::before {
  content: "\\f426";
}

.bi-hurricane::before {
  content: "\\f427";
}

.bi-image-alt::before {
  content: "\\f428";
}

.bi-image-fill::before {
  content: "\\f429";
}

.bi-image::before {
  content: "\\f42a";
}

.bi-images::before {
  content: "\\f42b";
}

.bi-inbox-fill::before {
  content: "\\f42c";
}

.bi-inbox::before {
  content: "\\f42d";
}

.bi-inboxes-fill::before {
  content: "\\f42e";
}

.bi-inboxes::before {
  content: "\\f42f";
}

.bi-info-circle-fill::before {
  content: "\\f430";
}

.bi-info-circle::before {
  content: "\\f431";
}

.bi-info-square-fill::before {
  content: "\\f432";
}

.bi-info-square::before {
  content: "\\f433";
}

.bi-info::before {
  content: "\\f434";
}

.bi-input-cursor-text::before {
  content: "\\f435";
}

.bi-input-cursor::before {
  content: "\\f436";
}

.bi-instagram::before {
  content: "\\f437";
}

.bi-intersect::before {
  content: "\\f438";
}

.bi-journal-album::before {
  content: "\\f439";
}

.bi-journal-arrow-down::before {
  content: "\\f43a";
}

.bi-journal-arrow-up::before {
  content: "\\f43b";
}

.bi-journal-bookmark-fill::before {
  content: "\\f43c";
}

.bi-journal-bookmark::before {
  content: "\\f43d";
}

.bi-journal-check::before {
  content: "\\f43e";
}

.bi-journal-code::before {
  content: "\\f43f";
}

.bi-journal-medical::before {
  content: "\\f440";
}

.bi-journal-minus::before {
  content: "\\f441";
}

.bi-journal-plus::before {
  content: "\\f442";
}

.bi-journal-richtext::before {
  content: "\\f443";
}

.bi-journal-text::before {
  content: "\\f444";
}

.bi-journal-x::before {
  content: "\\f445";
}

.bi-journal::before {
  content: "\\f446";
}

.bi-journals::before {
  content: "\\f447";
}

.bi-joystick::before {
  content: "\\f448";
}

.bi-justify-left::before {
  content: "\\f449";
}

.bi-justify-right::before {
  content: "\\f44a";
}

.bi-justify::before {
  content: "\\f44b";
}

.bi-kanban-fill::before {
  content: "\\f44c";
}

.bi-kanban::before {
  content: "\\f44d";
}

.bi-key-fill::before {
  content: "\\f44e";
}

.bi-key::before {
  content: "\\f44f";
}

.bi-keyboard-fill::before {
  content: "\\f450";
}

.bi-keyboard::before {
  content: "\\f451";
}

.bi-ladder::before {
  content: "\\f452";
}

.bi-lamp-fill::before {
  content: "\\f453";
}

.bi-lamp::before {
  content: "\\f454";
}

.bi-laptop-fill::before {
  content: "\\f455";
}

.bi-laptop::before {
  content: "\\f456";
}

.bi-layer-backward::before {
  content: "\\f457";
}

.bi-layer-forward::before {
  content: "\\f458";
}

.bi-layers-fill::before {
  content: "\\f459";
}

.bi-layers-half::before {
  content: "\\f45a";
}

.bi-layers::before {
  content: "\\f45b";
}

.bi-layout-sidebar-inset-reverse::before {
  content: "\\f45c";
}

.bi-layout-sidebar-inset::before {
  content: "\\f45d";
}

.bi-layout-sidebar-reverse::before {
  content: "\\f45e";
}

.bi-layout-sidebar::before {
  content: "\\f45f";
}

.bi-layout-split::before {
  content: "\\f460";
}

.bi-layout-text-sidebar-reverse::before {
  content: "\\f461";
}

.bi-layout-text-sidebar::before {
  content: "\\f462";
}

.bi-layout-text-window-reverse::before {
  content: "\\f463";
}

.bi-layout-text-window::before {
  content: "\\f464";
}

.bi-layout-three-columns::before {
  content: "\\f465";
}

.bi-layout-wtf::before {
  content: "\\f466";
}

.bi-life-preserver::before {
  content: "\\f467";
}

.bi-lightbulb-fill::before {
  content: "\\f468";
}

.bi-lightbulb-off-fill::before {
  content: "\\f469";
}

.bi-lightbulb-off::before {
  content: "\\f46a";
}

.bi-lightbulb::before {
  content: "\\f46b";
}

.bi-lightning-charge-fill::before {
  content: "\\f46c";
}

.bi-lightning-charge::before {
  content: "\\f46d";
}

.bi-lightning-fill::before {
  content: "\\f46e";
}

.bi-lightning::before {
  content: "\\f46f";
}

.bi-link-45deg::before {
  content: "\\f470";
}

.bi-link::before {
  content: "\\f471";
}

.bi-linkedin::before {
  content: "\\f472";
}

.bi-list-check::before {
  content: "\\f473";
}

.bi-list-nested::before {
  content: "\\f474";
}

.bi-list-ol::before {
  content: "\\f475";
}

.bi-list-stars::before {
  content: "\\f476";
}

.bi-list-task::before {
  content: "\\f477";
}

.bi-list-ul::before {
  content: "\\f478";
}

.bi-list::before {
  content: "\\f479";
}

.bi-lock-fill::before {
  content: "\\f47a";
}

.bi-lock::before {
  content: "\\f47b";
}

.bi-mailbox::before {
  content: "\\f47c";
}

.bi-mailbox2::before {
  content: "\\f47d";
}

.bi-map-fill::before {
  content: "\\f47e";
}

.bi-map::before {
  content: "\\f47f";
}

.bi-markdown-fill::before {
  content: "\\f480";
}

.bi-markdown::before {
  content: "\\f481";
}

.bi-mask::before {
  content: "\\f482";
}

.bi-megaphone-fill::before {
  content: "\\f483";
}

.bi-megaphone::before {
  content: "\\f484";
}

.bi-menu-app-fill::before {
  content: "\\f485";
}

.bi-menu-app::before {
  content: "\\f486";
}

.bi-menu-button-fill::before {
  content: "\\f487";
}

.bi-menu-button-wide-fill::before {
  content: "\\f488";
}

.bi-menu-button-wide::before {
  content: "\\f489";
}

.bi-menu-button::before {
  content: "\\f48a";
}

.bi-menu-down::before {
  content: "\\f48b";
}

.bi-menu-up::before {
  content: "\\f48c";
}

.bi-mic-fill::before {
  content: "\\f48d";
}

.bi-mic-mute-fill::before {
  content: "\\f48e";
}

.bi-mic-mute::before {
  content: "\\f48f";
}

.bi-mic::before {
  content: "\\f490";
}

.bi-minecart-loaded::before {
  content: "\\f491";
}

.bi-minecart::before {
  content: "\\f492";
}

.bi-moisture::before {
  content: "\\f493";
}

.bi-moon-fill::before {
  content: "\\f494";
}

.bi-moon-stars-fill::before {
  content: "\\f495";
}

.bi-moon-stars::before {
  content: "\\f496";
}

.bi-moon::before {
  content: "\\f497";
}

.bi-mouse-fill::before {
  content: "\\f498";
}

.bi-mouse::before {
  content: "\\f499";
}

.bi-mouse2-fill::before {
  content: "\\f49a";
}

.bi-mouse2::before {
  content: "\\f49b";
}

.bi-mouse3-fill::before {
  content: "\\f49c";
}

.bi-mouse3::before {
  content: "\\f49d";
}

.bi-music-note-beamed::before {
  content: "\\f49e";
}

.bi-music-note-list::before {
  content: "\\f49f";
}

.bi-music-note::before {
  content: "\\f4a0";
}

.bi-music-player-fill::before {
  content: "\\f4a1";
}

.bi-music-player::before {
  content: "\\f4a2";
}

.bi-newspaper::before {
  content: "\\f4a3";
}

.bi-node-minus-fill::before {
  content: "\\f4a4";
}

.bi-node-minus::before {
  content: "\\f4a5";
}

.bi-node-plus-fill::before {
  content: "\\f4a6";
}

.bi-node-plus::before {
  content: "\\f4a7";
}

.bi-nut-fill::before {
  content: "\\f4a8";
}

.bi-nut::before {
  content: "\\f4a9";
}

.bi-octagon-fill::before {
  content: "\\f4aa";
}

.bi-octagon-half::before {
  content: "\\f4ab";
}

.bi-octagon::before {
  content: "\\f4ac";
}

.bi-option::before {
  content: "\\f4ad";
}

.bi-outlet::before {
  content: "\\f4ae";
}

.bi-paint-bucket::before {
  content: "\\f4af";
}

.bi-palette-fill::before {
  content: "\\f4b0";
}

.bi-palette::before {
  content: "\\f4b1";
}

.bi-palette2::before {
  content: "\\f4b2";
}

.bi-paperclip::before {
  content: "\\f4b3";
}

.bi-paragraph::before {
  content: "\\f4b4";
}

.bi-patch-check-fill::before {
  content: "\\f4b5";
}

.bi-patch-check::before {
  content: "\\f4b6";
}

.bi-patch-exclamation-fill::before {
  content: "\\f4b7";
}

.bi-patch-exclamation::before {
  content: "\\f4b8";
}

.bi-patch-minus-fill::before {
  content: "\\f4b9";
}

.bi-patch-minus::before {
  content: "\\f4ba";
}

.bi-patch-plus-fill::before {
  content: "\\f4bb";
}

.bi-patch-plus::before {
  content: "\\f4bc";
}

.bi-patch-question-fill::before {
  content: "\\f4bd";
}

.bi-patch-question::before {
  content: "\\f4be";
}

.bi-pause-btn-fill::before {
  content: "\\f4bf";
}

.bi-pause-btn::before {
  content: "\\f4c0";
}

.bi-pause-circle-fill::before {
  content: "\\f4c1";
}

.bi-pause-circle::before {
  content: "\\f4c2";
}

.bi-pause-fill::before {
  content: "\\f4c3";
}

.bi-pause::before {
  content: "\\f4c4";
}

.bi-peace-fill::before {
  content: "\\f4c5";
}

.bi-peace::before {
  content: "\\f4c6";
}

.bi-pen-fill::before {
  content: "\\f4c7";
}

.bi-pen::before {
  content: "\\f4c8";
}

.bi-pencil-fill::before {
  content: "\\f4c9";
}

.bi-pencil-square::before {
  content: "\\f4ca";
}

.bi-pencil::before {
  content: "\\f4cb";
}

.bi-pentagon-fill::before {
  content: "\\f4cc";
}

.bi-pentagon-half::before {
  content: "\\f4cd";
}

.bi-pentagon::before {
  content: "\\f4ce";
}

.bi-people-fill::before {
  content: "\\f4cf";
}

.bi-people::before {
  content: "\\f4d0";
}

.bi-percent::before {
  content: "\\f4d1";
}

.bi-person-badge-fill::before {
  content: "\\f4d2";
}

.bi-person-badge::before {
  content: "\\f4d3";
}

.bi-person-bounding-box::before {
  content: "\\f4d4";
}

.bi-person-check-fill::before {
  content: "\\f4d5";
}

.bi-person-check::before {
  content: "\\f4d6";
}

.bi-person-circle::before {
  content: "\\f4d7";
}

.bi-person-dash-fill::before {
  content: "\\f4d8";
}

.bi-person-dash::before {
  content: "\\f4d9";
}

.bi-person-fill::before {
  content: "\\f4da";
}

.bi-person-lines-fill::before {
  content: "\\f4db";
}

.bi-person-plus-fill::before {
  content: "\\f4dc";
}

.bi-person-plus::before {
  content: "\\f4dd";
}

.bi-person-square::before {
  content: "\\f4de";
}

.bi-person-x-fill::before {
  content: "\\f4df";
}

.bi-person-x::before {
  content: "\\f4e0";
}

.bi-person::before {
  content: "\\f4e1";
}

.bi-phone-fill::before {
  content: "\\f4e2";
}

.bi-phone-landscape-fill::before {
  content: "\\f4e3";
}

.bi-phone-landscape::before {
  content: "\\f4e4";
}

.bi-phone-vibrate-fill::before {
  content: "\\f4e5";
}

.bi-phone-vibrate::before {
  content: "\\f4e6";
}

.bi-phone::before {
  content: "\\f4e7";
}

.bi-pie-chart-fill::before {
  content: "\\f4e8";
}

.bi-pie-chart::before {
  content: "\\f4e9";
}

.bi-pin-angle-fill::before {
  content: "\\f4ea";
}

.bi-pin-angle::before {
  content: "\\f4eb";
}

.bi-pin-fill::before {
  content: "\\f4ec";
}

.bi-pin::before {
  content: "\\f4ed";
}

.bi-pip-fill::before {
  content: "\\f4ee";
}

.bi-pip::before {
  content: "\\f4ef";
}

.bi-play-btn-fill::before {
  content: "\\f4f0";
}

.bi-play-btn::before {
  content: "\\f4f1";
}

.bi-play-circle-fill::before {
  content: "\\f4f2";
}

.bi-play-circle::before {
  content: "\\f4f3";
}

.bi-play-fill::before {
  content: "\\f4f4";
}

.bi-play::before {
  content: "\\f4f5";
}

.bi-plug-fill::before {
  content: "\\f4f6";
}

.bi-plug::before {
  content: "\\f4f7";
}

.bi-plus-circle-dotted::before {
  content: "\\f4f8";
}

.bi-plus-circle-fill::before {
  content: "\\f4f9";
}

.bi-plus-circle::before {
  content: "\\f4fa";
}

.bi-plus-square-dotted::before {
  content: "\\f4fb";
}

.bi-plus-square-fill::before {
  content: "\\f4fc";
}

.bi-plus-square::before {
  content: "\\f4fd";
}

.bi-plus::before {
  content: "\\f4fe";
}

.bi-power::before {
  content: "\\f4ff";
}

.bi-printer-fill::before {
  content: "\\f500";
}

.bi-printer::before {
  content: "\\f501";
}

.bi-puzzle-fill::before {
  content: "\\f502";
}

.bi-puzzle::before {
  content: "\\f503";
}

.bi-question-circle-fill::before {
  content: "\\f504";
}

.bi-question-circle::before {
  content: "\\f505";
}

.bi-question-diamond-fill::before {
  content: "\\f506";
}

.bi-question-diamond::before {
  content: "\\f507";
}

.bi-question-octagon-fill::before {
  content: "\\f508";
}

.bi-question-octagon::before {
  content: "\\f509";
}

.bi-question-square-fill::before {
  content: "\\f50a";
}

.bi-question-square::before {
  content: "\\f50b";
}

.bi-question::before {
  content: "\\f50c";
}

.bi-rainbow::before {
  content: "\\f50d";
}

.bi-receipt-cutoff::before {
  content: "\\f50e";
}

.bi-receipt::before {
  content: "\\f50f";
}

.bi-reception-0::before {
  content: "\\f510";
}

.bi-reception-1::before {
  content: "\\f511";
}

.bi-reception-2::before {
  content: "\\f512";
}

.bi-reception-3::before {
  content: "\\f513";
}

.bi-reception-4::before {
  content: "\\f514";
}

.bi-record-btn-fill::before {
  content: "\\f515";
}

.bi-record-btn::before {
  content: "\\f516";
}

.bi-record-circle-fill::before {
  content: "\\f517";
}

.bi-record-circle::before {
  content: "\\f518";
}

.bi-record-fill::before {
  content: "\\f519";
}

.bi-record::before {
  content: "\\f51a";
}

.bi-record2-fill::before {
  content: "\\f51b";
}

.bi-record2::before {
  content: "\\f51c";
}

.bi-reply-all-fill::before {
  content: "\\f51d";
}

.bi-reply-all::before {
  content: "\\f51e";
}

.bi-reply-fill::before {
  content: "\\f51f";
}

.bi-reply::before {
  content: "\\f520";
}

.bi-rss-fill::before {
  content: "\\f521";
}

.bi-rss::before {
  content: "\\f522";
}

.bi-rulers::before {
  content: "\\f523";
}

.bi-save-fill::before {
  content: "\\f524";
}

.bi-save::before {
  content: "\\f525";
}

.bi-save2-fill::before {
  content: "\\f526";
}

.bi-save2::before {
  content: "\\f527";
}

.bi-scissors::before {
  content: "\\f528";
}

.bi-screwdriver::before {
  content: "\\f529";
}

.bi-search::before {
  content: "\\f52a";
}

.bi-segmented-nav::before {
  content: "\\f52b";
}

.bi-server::before {
  content: "\\f52c";
}

.bi-share-fill::before {
  content: "\\f52d";
}

.bi-share::before {
  content: "\\f52e";
}

.bi-shield-check::before {
  content: "\\f52f";
}

.bi-shield-exclamation::before {
  content: "\\f530";
}

.bi-shield-fill-check::before {
  content: "\\f531";
}

.bi-shield-fill-exclamation::before {
  content: "\\f532";
}

.bi-shield-fill-minus::before {
  content: "\\f533";
}

.bi-shield-fill-plus::before {
  content: "\\f534";
}

.bi-shield-fill-x::before {
  content: "\\f535";
}

.bi-shield-fill::before {
  content: "\\f536";
}

.bi-shield-lock-fill::before {
  content: "\\f537";
}

.bi-shield-lock::before {
  content: "\\f538";
}

.bi-shield-minus::before {
  content: "\\f539";
}

.bi-shield-plus::before {
  content: "\\f53a";
}

.bi-shield-shaded::before {
  content: "\\f53b";
}

.bi-shield-slash-fill::before {
  content: "\\f53c";
}

.bi-shield-slash::before {
  content: "\\f53d";
}

.bi-shield-x::before {
  content: "\\f53e";
}

.bi-shield::before {
  content: "\\f53f";
}

.bi-shift-fill::before {
  content: "\\f540";
}

.bi-shift::before {
  content: "\\f541";
}

.bi-shop-window::before {
  content: "\\f542";
}

.bi-shop::before {
  content: "\\f543";
}

.bi-shuffle::before {
  content: "\\f544";
}

.bi-signpost-2-fill::before {
  content: "\\f545";
}

.bi-signpost-2::before {
  content: "\\f546";
}

.bi-signpost-fill::before {
  content: "\\f547";
}

.bi-signpost-split-fill::before {
  content: "\\f548";
}

.bi-signpost-split::before {
  content: "\\f549";
}

.bi-signpost::before {
  content: "\\f54a";
}

.bi-sim-fill::before {
  content: "\\f54b";
}

.bi-sim::before {
  content: "\\f54c";
}

.bi-skip-backward-btn-fill::before {
  content: "\\f54d";
}

.bi-skip-backward-btn::before {
  content: "\\f54e";
}

.bi-skip-backward-circle-fill::before {
  content: "\\f54f";
}

.bi-skip-backward-circle::before {
  content: "\\f550";
}

.bi-skip-backward-fill::before {
  content: "\\f551";
}

.bi-skip-backward::before {
  content: "\\f552";
}

.bi-skip-end-btn-fill::before {
  content: "\\f553";
}

.bi-skip-end-btn::before {
  content: "\\f554";
}

.bi-skip-end-circle-fill::before {
  content: "\\f555";
}

.bi-skip-end-circle::before {
  content: "\\f556";
}

.bi-skip-end-fill::before {
  content: "\\f557";
}

.bi-skip-end::before {
  content: "\\f558";
}

.bi-skip-forward-btn-fill::before {
  content: "\\f559";
}

.bi-skip-forward-btn::before {
  content: "\\f55a";
}

.bi-skip-forward-circle-fill::before {
  content: "\\f55b";
}

.bi-skip-forward-circle::before {
  content: "\\f55c";
}

.bi-skip-forward-fill::before {
  content: "\\f55d";
}

.bi-skip-forward::before {
  content: "\\f55e";
}

.bi-skip-start-btn-fill::before {
  content: "\\f55f";
}

.bi-skip-start-btn::before {
  content: "\\f560";
}

.bi-skip-start-circle-fill::before {
  content: "\\f561";
}

.bi-skip-start-circle::before {
  content: "\\f562";
}

.bi-skip-start-fill::before {
  content: "\\f563";
}

.bi-skip-start::before {
  content: "\\f564";
}

.bi-slack::before {
  content: "\\f565";
}

.bi-slash-circle-fill::before {
  content: "\\f566";
}

.bi-slash-circle::before {
  content: "\\f567";
}

.bi-slash-square-fill::before {
  content: "\\f568";
}

.bi-slash-square::before {
  content: "\\f569";
}

.bi-slash::before {
  content: "\\f56a";
}

.bi-sliders::before {
  content: "\\f56b";
}

.bi-smartwatch::before {
  content: "\\f56c";
}

.bi-snow::before {
  content: "\\f56d";
}

.bi-snow2::before {
  content: "\\f56e";
}

.bi-snow3::before {
  content: "\\f56f";
}

.bi-sort-alpha-down-alt::before {
  content: "\\f570";
}

.bi-sort-alpha-down::before {
  content: "\\f571";
}

.bi-sort-alpha-up-alt::before {
  content: "\\f572";
}

.bi-sort-alpha-up::before {
  content: "\\f573";
}

.bi-sort-down-alt::before {
  content: "\\f574";
}

.bi-sort-down::before {
  content: "\\f575";
}

.bi-sort-numeric-down-alt::before {
  content: "\\f576";
}

.bi-sort-numeric-down::before {
  content: "\\f577";
}

.bi-sort-numeric-up-alt::before {
  content: "\\f578";
}

.bi-sort-numeric-up::before {
  content: "\\f579";
}

.bi-sort-up-alt::before {
  content: "\\f57a";
}

.bi-sort-up::before {
  content: "\\f57b";
}

.bi-soundwave::before {
  content: "\\f57c";
}

.bi-speaker-fill::before {
  content: "\\f57d";
}

.bi-speaker::before {
  content: "\\f57e";
}

.bi-speedometer::before {
  content: "\\f57f";
}

.bi-speedometer2::before {
  content: "\\f580";
}

.bi-spellcheck::before {
  content: "\\f581";
}

.bi-square-fill::before {
  content: "\\f582";
}

.bi-square-half::before {
  content: "\\f583";
}

.bi-square::before {
  content: "\\f584";
}

.bi-stack::before {
  content: "\\f585";
}

.bi-star-fill::before {
  content: "\\f586";
}

.bi-star-half::before {
  content: "\\f587";
}

.bi-star::before {
  content: "\\f588";
}

.bi-stars::before {
  content: "\\f589";
}

.bi-stickies-fill::before {
  content: "\\f58a";
}

.bi-stickies::before {
  content: "\\f58b";
}

.bi-sticky-fill::before {
  content: "\\f58c";
}

.bi-sticky::before {
  content: "\\f58d";
}

.bi-stop-btn-fill::before {
  content: "\\f58e";
}

.bi-stop-btn::before {
  content: "\\f58f";
}

.bi-stop-circle-fill::before {
  content: "\\f590";
}

.bi-stop-circle::before {
  content: "\\f591";
}

.bi-stop-fill::before {
  content: "\\f592";
}

.bi-stop::before {
  content: "\\f593";
}

.bi-stoplights-fill::before {
  content: "\\f594";
}

.bi-stoplights::before {
  content: "\\f595";
}

.bi-stopwatch-fill::before {
  content: "\\f596";
}

.bi-stopwatch::before {
  content: "\\f597";
}

.bi-subtract::before {
  content: "\\f598";
}

.bi-suit-club-fill::before {
  content: "\\f599";
}

.bi-suit-club::before {
  content: "\\f59a";
}

.bi-suit-diamond-fill::before {
  content: "\\f59b";
}

.bi-suit-diamond::before {
  content: "\\f59c";
}

.bi-suit-heart-fill::before {
  content: "\\f59d";
}

.bi-suit-heart::before {
  content: "\\f59e";
}

.bi-suit-spade-fill::before {
  content: "\\f59f";
}

.bi-suit-spade::before {
  content: "\\f5a0";
}

.bi-sun-fill::before {
  content: "\\f5a1";
}

.bi-sun::before {
  content: "\\f5a2";
}

.bi-sunglasses::before {
  content: "\\f5a3";
}

.bi-sunrise-fill::before {
  content: "\\f5a4";
}

.bi-sunrise::before {
  content: "\\f5a5";
}

.bi-sunset-fill::before {
  content: "\\f5a6";
}

.bi-sunset::before {
  content: "\\f5a7";
}

.bi-symmetry-horizontal::before {
  content: "\\f5a8";
}

.bi-symmetry-vertical::before {
  content: "\\f5a9";
}

.bi-table::before {
  content: "\\f5aa";
}

.bi-tablet-fill::before {
  content: "\\f5ab";
}

.bi-tablet-landscape-fill::before {
  content: "\\f5ac";
}

.bi-tablet-landscape::before {
  content: "\\f5ad";
}

.bi-tablet::before {
  content: "\\f5ae";
}

.bi-tag-fill::before {
  content: "\\f5af";
}

.bi-tag::before {
  content: "\\f5b0";
}

.bi-tags-fill::before {
  content: "\\f5b1";
}

.bi-tags::before {
  content: "\\f5b2";
}

.bi-telegram::before {
  content: "\\f5b3";
}

.bi-telephone-fill::before {
  content: "\\f5b4";
}

.bi-telephone-forward-fill::before {
  content: "\\f5b5";
}

.bi-telephone-forward::before {
  content: "\\f5b6";
}

.bi-telephone-inbound-fill::before {
  content: "\\f5b7";
}

.bi-telephone-inbound::before {
  content: "\\f5b8";
}

.bi-telephone-minus-fill::before {
  content: "\\f5b9";
}

.bi-telephone-minus::before {
  content: "\\f5ba";
}

.bi-telephone-outbound-fill::before {
  content: "\\f5bb";
}

.bi-telephone-outbound::before {
  content: "\\f5bc";
}

.bi-telephone-plus-fill::before {
  content: "\\f5bd";
}

.bi-telephone-plus::before {
  content: "\\f5be";
}

.bi-telephone-x-fill::before {
  content: "\\f5bf";
}

.bi-telephone-x::before {
  content: "\\f5c0";
}

.bi-telephone::before {
  content: "\\f5c1";
}

.bi-terminal-fill::before {
  content: "\\f5c2";
}

.bi-terminal::before {
  content: "\\f5c3";
}

.bi-text-center::before {
  content: "\\f5c4";
}

.bi-text-indent-left::before {
  content: "\\f5c5";
}

.bi-text-indent-right::before {
  content: "\\f5c6";
}

.bi-text-left::before {
  content: "\\f5c7";
}

.bi-text-paragraph::before {
  content: "\\f5c8";
}

.bi-text-right::before {
  content: "\\f5c9";
}

.bi-textarea-resize::before {
  content: "\\f5ca";
}

.bi-textarea-t::before {
  content: "\\f5cb";
}

.bi-textarea::before {
  content: "\\f5cc";
}

.bi-thermometer-half::before {
  content: "\\f5cd";
}

.bi-thermometer-high::before {
  content: "\\f5ce";
}

.bi-thermometer-low::before {
  content: "\\f5cf";
}

.bi-thermometer-snow::before {
  content: "\\f5d0";
}

.bi-thermometer-sun::before {
  content: "\\f5d1";
}

.bi-thermometer::before {
  content: "\\f5d2";
}

.bi-three-dots-vertical::before {
  content: "\\f5d3";
}

.bi-three-dots::before {
  content: "\\f5d4";
}

.bi-toggle-off::before {
  content: "\\f5d5";
}

.bi-toggle-on::before {
  content: "\\f5d6";
}

.bi-toggle2-off::before {
  content: "\\f5d7";
}

.bi-toggle2-on::before {
  content: "\\f5d8";
}

.bi-toggles::before {
  content: "\\f5d9";
}

.bi-toggles2::before {
  content: "\\f5da";
}

.bi-tools::before {
  content: "\\f5db";
}

.bi-tornado::before {
  content: "\\f5dc";
}

.bi-trash-fill::before {
  content: "\\f5dd";
}

.bi-trash::before {
  content: "\\f5de";
}

.bi-trash2-fill::before {
  content: "\\f5df";
}

.bi-trash2::before {
  content: "\\f5e0";
}

.bi-tree-fill::before {
  content: "\\f5e1";
}

.bi-tree::before {
  content: "\\f5e2";
}

.bi-triangle-fill::before {
  content: "\\f5e3";
}

.bi-triangle-half::before {
  content: "\\f5e4";
}

.bi-triangle::before {
  content: "\\f5e5";
}

.bi-trophy-fill::before {
  content: "\\f5e6";
}

.bi-trophy::before {
  content: "\\f5e7";
}

.bi-tropical-storm::before {
  content: "\\f5e8";
}

.bi-truck-flatbed::before {
  content: "\\f5e9";
}

.bi-truck::before {
  content: "\\f5ea";
}

.bi-tsunami::before {
  content: "\\f5eb";
}

.bi-tv-fill::before {
  content: "\\f5ec";
}

.bi-tv::before {
  content: "\\f5ed";
}

.bi-twitch::before {
  content: "\\f5ee";
}

.bi-twitter::before {
  content: "\\f5ef";
}

.bi-type-bold::before {
  content: "\\f5f0";
}

.bi-type-h1::before {
  content: "\\f5f1";
}

.bi-type-h2::before {
  content: "\\f5f2";
}

.bi-type-h3::before {
  content: "\\f5f3";
}

.bi-type-italic::before {
  content: "\\f5f4";
}

.bi-type-strikethrough::before {
  content: "\\f5f5";
}

.bi-type-underline::before {
  content: "\\f5f6";
}

.bi-type::before {
  content: "\\f5f7";
}

.bi-ui-checks-grid::before {
  content: "\\f5f8";
}

.bi-ui-checks::before {
  content: "\\f5f9";
}

.bi-ui-radios-grid::before {
  content: "\\f5fa";
}

.bi-ui-radios::before {
  content: "\\f5fb";
}

.bi-umbrella-fill::before {
  content: "\\f5fc";
}

.bi-umbrella::before {
  content: "\\f5fd";
}

.bi-union::before {
  content: "\\f5fe";
}

.bi-unlock-fill::before {
  content: "\\f5ff";
}

.bi-unlock::before {
  content: "\\f600";
}

.bi-upc-scan::before {
  content: "\\f601";
}

.bi-upc::before {
  content: "\\f602";
}

.bi-upload::before {
  content: "\\f603";
}

.bi-vector-pen::before {
  content: "\\f604";
}

.bi-view-list::before {
  content: "\\f605";
}

.bi-view-stacked::before {
  content: "\\f606";
}

.bi-vinyl-fill::before {
  content: "\\f607";
}

.bi-vinyl::before {
  content: "\\f608";
}

.bi-voicemail::before {
  content: "\\f609";
}

.bi-volume-down-fill::before {
  content: "\\f60a";
}

.bi-volume-down::before {
  content: "\\f60b";
}

.bi-volume-mute-fill::before {
  content: "\\f60c";
}

.bi-volume-mute::before {
  content: "\\f60d";
}

.bi-volume-off-fill::before {
  content: "\\f60e";
}

.bi-volume-off::before {
  content: "\\f60f";
}

.bi-volume-up-fill::before {
  content: "\\f610";
}

.bi-volume-up::before {
  content: "\\f611";
}

.bi-vr::before {
  content: "\\f612";
}

.bi-wallet-fill::before {
  content: "\\f613";
}

.bi-wallet::before {
  content: "\\f614";
}

.bi-wallet2::before {
  content: "\\f615";
}

.bi-watch::before {
  content: "\\f616";
}

.bi-water::before {
  content: "\\f617";
}

.bi-whatsapp::before {
  content: "\\f618";
}

.bi-wifi-1::before {
  content: "\\f619";
}

.bi-wifi-2::before {
  content: "\\f61a";
}

.bi-wifi-off::before {
  content: "\\f61b";
}

.bi-wifi::before {
  content: "\\f61c";
}

.bi-wind::before {
  content: "\\f61d";
}

.bi-window-dock::before {
  content: "\\f61e";
}

.bi-window-sidebar::before {
  content: "\\f61f";
}

.bi-window::before {
  content: "\\f620";
}

.bi-wrench::before {
  content: "\\f621";
}

.bi-x-circle-fill::before {
  content: "\\f622";
}

.bi-x-circle::before {
  content: "\\f623";
}

.bi-x-diamond-fill::before {
  content: "\\f624";
}

.bi-x-diamond::before {
  content: "\\f625";
}

.bi-x-octagon-fill::before {
  content: "\\f626";
}

.bi-x-octagon::before {
  content: "\\f627";
}

.bi-x-square-fill::before {
  content: "\\f628";
}

.bi-x-square::before {
  content: "\\f629";
}

.bi-x::before {
  content: "\\f62a";
}

.bi-youtube::before {
  content: "\\f62b";
}

.bi-zoom-in::before {
  content: "\\f62c";
}

.bi-zoom-out::before {
  content: "\\f62d";
}

.bi-bank::before {
  content: "\\f62e";
}

.bi-bank2::before {
  content: "\\f62f";
}

.bi-bell-slash-fill::before {
  content: "\\f630";
}

.bi-bell-slash::before {
  content: "\\f631";
}

.bi-cash-coin::before {
  content: "\\f632";
}

.bi-check-lg::before {
  content: "\\f633";
}

.bi-coin::before {
  content: "\\f634";
}

.bi-currency-bitcoin::before {
  content: "\\f635";
}

.bi-currency-dollar::before {
  content: "\\f636";
}

.bi-currency-euro::before {
  content: "\\f637";
}

.bi-currency-exchange::before {
  content: "\\f638";
}

.bi-currency-pound::before {
  content: "\\f639";
}

.bi-currency-yen::before {
  content: "\\f63a";
}

.bi-dash-lg::before {
  content: "\\f63b";
}

.bi-exclamation-lg::before {
  content: "\\f63c";
}

.bi-file-earmark-pdf-fill::before {
  content: "\\f63d";
}

.bi-file-earmark-pdf::before {
  content: "\\f63e";
}

.bi-file-pdf-fill::before {
  content: "\\f63f";
}

.bi-file-pdf::before {
  content: "\\f640";
}

.bi-gender-ambiguous::before {
  content: "\\f641";
}

.bi-gender-female::before {
  content: "\\f642";
}

.bi-gender-male::before {
  content: "\\f643";
}

.bi-gender-trans::before {
  content: "\\f644";
}

.bi-headset-vr::before {
  content: "\\f645";
}

.bi-info-lg::before {
  content: "\\f646";
}

.bi-mastodon::before {
  content: "\\f647";
}

.bi-messenger::before {
  content: "\\f648";
}

.bi-piggy-bank-fill::before {
  content: "\\f649";
}

.bi-piggy-bank::before {
  content: "\\f64a";
}

.bi-pin-map-fill::before {
  content: "\\f64b";
}

.bi-pin-map::before {
  content: "\\f64c";
}

.bi-plus-lg::before {
  content: "\\f64d";
}

.bi-question-lg::before {
  content: "\\f64e";
}

.bi-recycle::before {
  content: "\\f64f";
}

.bi-reddit::before {
  content: "\\f650";
}

.bi-safe-fill::before {
  content: "\\f651";
}

.bi-safe2-fill::before {
  content: "\\f652";
}

.bi-safe2::before {
  content: "\\f653";
}

.bi-sd-card-fill::before {
  content: "\\f654";
}

.bi-sd-card::before {
  content: "\\f655";
}

.bi-skype::before {
  content: "\\f656";
}

.bi-slash-lg::before {
  content: "\\f657";
}

.bi-translate::before {
  content: "\\f658";
}

.bi-x-lg::before {
  content: "\\f659";
}

.bi-safe::before {
  content: "\\f65a";
}

.bi-apple::before {
  content: "\\f65b";
}

.bi-microsoft::before {
  content: "\\f65d";
}

.bi-windows::before {
  content: "\\f65e";
}

.bi-behance::before {
  content: "\\f65c";
}

.bi-dribbble::before {
  content: "\\f65f";
}

.bi-line::before {
  content: "\\f660";
}

.bi-medium::before {
  content: "\\f661";
}

.bi-paypal::before {
  content: "\\f662";
}

.bi-pinterest::before {
  content: "\\f663";
}

.bi-signal::before {
  content: "\\f664";
}

.bi-snapchat::before {
  content: "\\f665";
}

.bi-spotify::before {
  content: "\\f666";
}

.bi-stack-overflow::before {
  content: "\\f667";
}

.bi-strava::before {
  content: "\\f668";
}

.bi-wordpress::before {
  content: "\\f669";
}

.bi-vimeo::before {
  content: "\\f66a";
}

.bi-activity::before {
  content: "\\f66b";
}

.bi-easel2-fill::before {
  content: "\\f66c";
}

.bi-easel2::before {
  content: "\\f66d";
}

.bi-easel3-fill::before {
  content: "\\f66e";
}

.bi-easel3::before {
  content: "\\f66f";
}

.bi-fan::before {
  content: "\\f670";
}

.bi-fingerprint::before {
  content: "\\f671";
}

.bi-graph-down-arrow::before {
  content: "\\f672";
}

.bi-graph-up-arrow::before {
  content: "\\f673";
}

.bi-hypnotize::before {
  content: "\\f674";
}

.bi-magic::before {
  content: "\\f675";
}

.bi-person-rolodex::before {
  content: "\\f676";
}

.bi-person-video::before {
  content: "\\f677";
}

.bi-person-video2::before {
  content: "\\f678";
}

.bi-person-video3::before {
  content: "\\f679";
}

.bi-person-workspace::before {
  content: "\\f67a";
}

.bi-radioactive::before {
  content: "\\f67b";
}

.bi-webcam-fill::before {
  content: "\\f67c";
}

.bi-webcam::before {
  content: "\\f67d";
}

.bi-yin-yang::before {
  content: "\\f67e";
}

.bi-bandaid-fill::before {
  content: "\\f680";
}

.bi-bandaid::before {
  content: "\\f681";
}

.bi-bluetooth::before {
  content: "\\f682";
}

.bi-body-text::before {
  content: "\\f683";
}

.bi-boombox::before {
  content: "\\f684";
}

.bi-boxes::before {
  content: "\\f685";
}

.bi-dpad-fill::before {
  content: "\\f686";
}

.bi-dpad::before {
  content: "\\f687";
}

.bi-ear-fill::before {
  content: "\\f688";
}

.bi-ear::before {
  content: "\\f689";
}

.bi-envelope-check-fill::before {
  content: "\\f68b";
}

.bi-envelope-check::before {
  content: "\\f68c";
}

.bi-envelope-dash-fill::before {
  content: "\\f68e";
}

.bi-envelope-dash::before {
  content: "\\f68f";
}

.bi-envelope-exclamation-fill::before {
  content: "\\f691";
}

.bi-envelope-exclamation::before {
  content: "\\f692";
}

.bi-envelope-plus-fill::before {
  content: "\\f693";
}

.bi-envelope-plus::before {
  content: "\\f694";
}

.bi-envelope-slash-fill::before {
  content: "\\f696";
}

.bi-envelope-slash::before {
  content: "\\f697";
}

.bi-envelope-x-fill::before {
  content: "\\f699";
}

.bi-envelope-x::before {
  content: "\\f69a";
}

.bi-explicit-fill::before {
  content: "\\f69b";
}

.bi-explicit::before {
  content: "\\f69c";
}

.bi-git::before {
  content: "\\f69d";
}

.bi-infinity::before {
  content: "\\f69e";
}

.bi-list-columns-reverse::before {
  content: "\\f69f";
}

.bi-list-columns::before {
  content: "\\f6a0";
}

.bi-meta::before {
  content: "\\f6a1";
}

.bi-nintendo-switch::before {
  content: "\\f6a4";
}

.bi-pc-display-horizontal::before {
  content: "\\f6a5";
}

.bi-pc-display::before {
  content: "\\f6a6";
}

.bi-pc-horizontal::before {
  content: "\\f6a7";
}

.bi-pc::before {
  content: "\\f6a8";
}

.bi-playstation::before {
  content: "\\f6a9";
}

.bi-plus-slash-minus::before {
  content: "\\f6aa";
}

.bi-projector-fill::before {
  content: "\\f6ab";
}

.bi-projector::before {
  content: "\\f6ac";
}

.bi-qr-code-scan::before {
  content: "\\f6ad";
}

.bi-qr-code::before {
  content: "\\f6ae";
}

.bi-quora::before {
  content: "\\f6af";
}

.bi-quote::before {
  content: "\\f6b0";
}

.bi-robot::before {
  content: "\\f6b1";
}

.bi-send-check-fill::before {
  content: "\\f6b2";
}

.bi-send-check::before {
  content: "\\f6b3";
}

.bi-send-dash-fill::before {
  content: "\\f6b4";
}

.bi-send-dash::before {
  content: "\\f6b5";
}

.bi-send-exclamation-fill::before {
  content: "\\f6b7";
}

.bi-send-exclamation::before {
  content: "\\f6b8";
}

.bi-send-fill::before {
  content: "\\f6b9";
}

.bi-send-plus-fill::before {
  content: "\\f6ba";
}

.bi-send-plus::before {
  content: "\\f6bb";
}

.bi-send-slash-fill::before {
  content: "\\f6bc";
}

.bi-send-slash::before {
  content: "\\f6bd";
}

.bi-send-x-fill::before {
  content: "\\f6be";
}

.bi-send-x::before {
  content: "\\f6bf";
}

.bi-send::before {
  content: "\\f6c0";
}

.bi-steam::before {
  content: "\\f6c1";
}

.bi-terminal-dash::before {
  content: "\\f6c3";
}

.bi-terminal-plus::before {
  content: "\\f6c4";
}

.bi-terminal-split::before {
  content: "\\f6c5";
}

.bi-ticket-detailed-fill::before {
  content: "\\f6c6";
}

.bi-ticket-detailed::before {
  content: "\\f6c7";
}

.bi-ticket-fill::before {
  content: "\\f6c8";
}

.bi-ticket-perforated-fill::before {
  content: "\\f6c9";
}

.bi-ticket-perforated::before {
  content: "\\f6ca";
}

.bi-ticket::before {
  content: "\\f6cb";
}

.bi-tiktok::before {
  content: "\\f6cc";
}

.bi-window-dash::before {
  content: "\\f6cd";
}

.bi-window-desktop::before {
  content: "\\f6ce";
}

.bi-window-fullscreen::before {
  content: "\\f6cf";
}

.bi-window-plus::before {
  content: "\\f6d0";
}

.bi-window-split::before {
  content: "\\f6d1";
}

.bi-window-stack::before {
  content: "\\f6d2";
}

.bi-window-x::before {
  content: "\\f6d3";
}

.bi-xbox::before {
  content: "\\f6d4";
}

.bi-ethernet::before {
  content: "\\f6d5";
}

.bi-hdmi-fill::before {
  content: "\\f6d6";
}

.bi-hdmi::before {
  content: "\\f6d7";
}

.bi-usb-c-fill::before {
  content: "\\f6d8";
}

.bi-usb-c::before {
  content: "\\f6d9";
}

.bi-usb-fill::before {
  content: "\\f6da";
}

.bi-usb-plug-fill::before {
  content: "\\f6db";
}

.bi-usb-plug::before {
  content: "\\f6dc";
}

.bi-usb-symbol::before {
  content: "\\f6dd";
}

.bi-usb::before {
  content: "\\f6de";
}

.bi-boombox-fill::before {
  content: "\\f6df";
}

.bi-displayport::before {
  content: "\\f6e1";
}

.bi-gpu-card::before {
  content: "\\f6e2";
}

.bi-memory::before {
  content: "\\f6e3";
}

.bi-modem-fill::before {
  content: "\\f6e4";
}

.bi-modem::before {
  content: "\\f6e5";
}

.bi-motherboard-fill::before {
  content: "\\f6e6";
}

.bi-motherboard::before {
  content: "\\f6e7";
}

.bi-optical-audio-fill::before {
  content: "\\f6e8";
}

.bi-optical-audio::before {
  content: "\\f6e9";
}

.bi-pci-card::before {
  content: "\\f6ea";
}

.bi-router-fill::before {
  content: "\\f6eb";
}

.bi-router::before {
  content: "\\f6ec";
}

.bi-thunderbolt-fill::before {
  content: "\\f6ef";
}

.bi-thunderbolt::before {
  content: "\\f6f0";
}

.bi-usb-drive-fill::before {
  content: "\\f6f1";
}

.bi-usb-drive::before {
  content: "\\f6f2";
}

.bi-usb-micro-fill::before {
  content: "\\f6f3";
}

.bi-usb-micro::before {
  content: "\\f6f4";
}

.bi-usb-mini-fill::before {
  content: "\\f6f5";
}

.bi-usb-mini::before {
  content: "\\f6f6";
}

.bi-cloud-haze2::before {
  content: "\\f6f7";
}

.bi-device-hdd-fill::before {
  content: "\\f6f8";
}

.bi-device-hdd::before {
  content: "\\f6f9";
}

.bi-device-ssd-fill::before {
  content: "\\f6fa";
}

.bi-device-ssd::before {
  content: "\\f6fb";
}

.bi-displayport-fill::before {
  content: "\\f6fc";
}

.bi-mortarboard-fill::before {
  content: "\\f6fd";
}

.bi-mortarboard::before {
  content: "\\f6fe";
}

.bi-terminal-x::before {
  content: "\\f6ff";
}

.bi-arrow-through-heart-fill::before {
  content: "\\f700";
}

.bi-arrow-through-heart::before {
  content: "\\f701";
}

.bi-badge-sd-fill::before {
  content: "\\f702";
}

.bi-badge-sd::before {
  content: "\\f703";
}

.bi-bag-heart-fill::before {
  content: "\\f704";
}

.bi-bag-heart::before {
  content: "\\f705";
}

.bi-balloon-fill::before {
  content: "\\f706";
}

.bi-balloon-heart-fill::before {
  content: "\\f707";
}

.bi-balloon-heart::before {
  content: "\\f708";
}

.bi-balloon::before {
  content: "\\f709";
}

.bi-box2-fill::before {
  content: "\\f70a";
}

.bi-box2-heart-fill::before {
  content: "\\f70b";
}

.bi-box2-heart::before {
  content: "\\f70c";
}

.bi-box2::before {
  content: "\\f70d";
}

.bi-braces-asterisk::before {
  content: "\\f70e";
}

.bi-calendar-heart-fill::before {
  content: "\\f70f";
}

.bi-calendar-heart::before {
  content: "\\f710";
}

.bi-calendar2-heart-fill::before {
  content: "\\f711";
}

.bi-calendar2-heart::before {
  content: "\\f712";
}

.bi-chat-heart-fill::before {
  content: "\\f713";
}

.bi-chat-heart::before {
  content: "\\f714";
}

.bi-chat-left-heart-fill::before {
  content: "\\f715";
}

.bi-chat-left-heart::before {
  content: "\\f716";
}

.bi-chat-right-heart-fill::before {
  content: "\\f717";
}

.bi-chat-right-heart::before {
  content: "\\f718";
}

.bi-chat-square-heart-fill::before {
  content: "\\f719";
}

.bi-chat-square-heart::before {
  content: "\\f71a";
}

.bi-clipboard-check-fill::before {
  content: "\\f71b";
}

.bi-clipboard-data-fill::before {
  content: "\\f71c";
}

.bi-clipboard-fill::before {
  content: "\\f71d";
}

.bi-clipboard-heart-fill::before {
  content: "\\f71e";
}

.bi-clipboard-heart::before {
  content: "\\f71f";
}

.bi-clipboard-minus-fill::before {
  content: "\\f720";
}

.bi-clipboard-plus-fill::before {
  content: "\\f721";
}

.bi-clipboard-pulse::before {
  content: "\\f722";
}

.bi-clipboard-x-fill::before {
  content: "\\f723";
}

.bi-clipboard2-check-fill::before {
  content: "\\f724";
}

.bi-clipboard2-check::before {
  content: "\\f725";
}

.bi-clipboard2-data-fill::before {
  content: "\\f726";
}

.bi-clipboard2-data::before {
  content: "\\f727";
}

.bi-clipboard2-fill::before {
  content: "\\f728";
}

.bi-clipboard2-heart-fill::before {
  content: "\\f729";
}

.bi-clipboard2-heart::before {
  content: "\\f72a";
}

.bi-clipboard2-minus-fill::before {
  content: "\\f72b";
}

.bi-clipboard2-minus::before {
  content: "\\f72c";
}

.bi-clipboard2-plus-fill::before {
  content: "\\f72d";
}

.bi-clipboard2-plus::before {
  content: "\\f72e";
}

.bi-clipboard2-pulse-fill::before {
  content: "\\f72f";
}

.bi-clipboard2-pulse::before {
  content: "\\f730";
}

.bi-clipboard2-x-fill::before {
  content: "\\f731";
}

.bi-clipboard2-x::before {
  content: "\\f732";
}

.bi-clipboard2::before {
  content: "\\f733";
}

.bi-emoji-kiss-fill::before {
  content: "\\f734";
}

.bi-emoji-kiss::before {
  content: "\\f735";
}

.bi-envelope-heart-fill::before {
  content: "\\f736";
}

.bi-envelope-heart::before {
  content: "\\f737";
}

.bi-envelope-open-heart-fill::before {
  content: "\\f738";
}

.bi-envelope-open-heart::before {
  content: "\\f739";
}

.bi-envelope-paper-fill::before {
  content: "\\f73a";
}

.bi-envelope-paper-heart-fill::before {
  content: "\\f73b";
}

.bi-envelope-paper-heart::before {
  content: "\\f73c";
}

.bi-envelope-paper::before {
  content: "\\f73d";
}

.bi-filetype-aac::before {
  content: "\\f73e";
}

.bi-filetype-ai::before {
  content: "\\f73f";
}

.bi-filetype-bmp::before {
  content: "\\f740";
}

.bi-filetype-cs::before {
  content: "\\f741";
}

.bi-filetype-css::before {
  content: "\\f742";
}

.bi-filetype-csv::before {
  content: "\\f743";
}

.bi-filetype-doc::before {
  content: "\\f744";
}

.bi-filetype-docx::before {
  content: "\\f745";
}

.bi-filetype-exe::before {
  content: "\\f746";
}

.bi-filetype-gif::before {
  content: "\\f747";
}

.bi-filetype-heic::before {
  content: "\\f748";
}

.bi-filetype-html::before {
  content: "\\f749";
}

.bi-filetype-java::before {
  content: "\\f74a";
}

.bi-filetype-jpg::before {
  content: "\\f74b";
}

.bi-filetype-js::before {
  content: "\\f74c";
}

.bi-filetype-jsx::before {
  content: "\\f74d";
}

.bi-filetype-key::before {
  content: "\\f74e";
}

.bi-filetype-m4p::before {
  content: "\\f74f";
}

.bi-filetype-md::before {
  content: "\\f750";
}

.bi-filetype-mdx::before {
  content: "\\f751";
}

.bi-filetype-mov::before {
  content: "\\f752";
}

.bi-filetype-mp3::before {
  content: "\\f753";
}

.bi-filetype-mp4::before {
  content: "\\f754";
}

.bi-filetype-otf::before {
  content: "\\f755";
}

.bi-filetype-pdf::before {
  content: "\\f756";
}

.bi-filetype-php::before {
  content: "\\f757";
}

.bi-filetype-png::before {
  content: "\\f758";
}

.bi-filetype-ppt::before {
  content: "\\f75a";
}

.bi-filetype-psd::before {
  content: "\\f75b";
}

.bi-filetype-py::before {
  content: "\\f75c";
}

.bi-filetype-raw::before {
  content: "\\f75d";
}

.bi-filetype-rb::before {
  content: "\\f75e";
}

.bi-filetype-sass::before {
  content: "\\f75f";
}

.bi-filetype-scss::before {
  content: "\\f760";
}

.bi-filetype-sh::before {
  content: "\\f761";
}

.bi-filetype-svg::before {
  content: "\\f762";
}

.bi-filetype-tiff::before {
  content: "\\f763";
}

.bi-filetype-tsx::before {
  content: "\\f764";
}

.bi-filetype-ttf::before {
  content: "\\f765";
}

.bi-filetype-txt::before {
  content: "\\f766";
}

.bi-filetype-wav::before {
  content: "\\f767";
}

.bi-filetype-woff::before {
  content: "\\f768";
}

.bi-filetype-xls::before {
  content: "\\f76a";
}

.bi-filetype-xml::before {
  content: "\\f76b";
}

.bi-filetype-yml::before {
  content: "\\f76c";
}

.bi-heart-arrow::before {
  content: "\\f76d";
}

.bi-heart-pulse-fill::before {
  content: "\\f76e";
}

.bi-heart-pulse::before {
  content: "\\f76f";
}

.bi-heartbreak-fill::before {
  content: "\\f770";
}

.bi-heartbreak::before {
  content: "\\f771";
}

.bi-hearts::before {
  content: "\\f772";
}

.bi-hospital-fill::before {
  content: "\\f773";
}

.bi-hospital::before {
  content: "\\f774";
}

.bi-house-heart-fill::before {
  content: "\\f775";
}

.bi-house-heart::before {
  content: "\\f776";
}

.bi-incognito::before {
  content: "\\f777";
}

.bi-magnet-fill::before {
  content: "\\f778";
}

.bi-magnet::before {
  content: "\\f779";
}

.bi-person-heart::before {
  content: "\\f77a";
}

.bi-person-hearts::before {
  content: "\\f77b";
}

.bi-phone-flip::before {
  content: "\\f77c";
}

.bi-plugin::before {
  content: "\\f77d";
}

.bi-postage-fill::before {
  content: "\\f77e";
}

.bi-postage-heart-fill::before {
  content: "\\f77f";
}

.bi-postage-heart::before {
  content: "\\f780";
}

.bi-postage::before {
  content: "\\f781";
}

.bi-postcard-fill::before {
  content: "\\f782";
}

.bi-postcard-heart-fill::before {
  content: "\\f783";
}

.bi-postcard-heart::before {
  content: "\\f784";
}

.bi-postcard::before {
  content: "\\f785";
}

.bi-search-heart-fill::before {
  content: "\\f786";
}

.bi-search-heart::before {
  content: "\\f787";
}

.bi-sliders2-vertical::before {
  content: "\\f788";
}

.bi-sliders2::before {
  content: "\\f789";
}

.bi-trash3-fill::before {
  content: "\\f78a";
}

.bi-trash3::before {
  content: "\\f78b";
}

.bi-valentine::before {
  content: "\\f78c";
}

.bi-valentine2::before {
  content: "\\f78d";
}

.bi-wrench-adjustable-circle-fill::before {
  content: "\\f78e";
}

.bi-wrench-adjustable-circle::before {
  content: "\\f78f";
}

.bi-wrench-adjustable::before {
  content: "\\f790";
}

.bi-filetype-json::before {
  content: "\\f791";
}

.bi-filetype-pptx::before {
  content: "\\f792";
}

.bi-filetype-xlsx::before {
  content: "\\f793";
}

.bi-1-circle-fill::before {
  content: "\\f796";
}

.bi-1-circle::before {
  content: "\\f797";
}

.bi-1-square-fill::before {
  content: "\\f798";
}

.bi-1-square::before {
  content: "\\f799";
}

.bi-2-circle-fill::before {
  content: "\\f79c";
}

.bi-2-circle::before {
  content: "\\f79d";
}

.bi-2-square-fill::before {
  content: "\\f79e";
}

.bi-2-square::before {
  content: "\\f79f";
}

.bi-3-circle-fill::before {
  content: "\\f7a2";
}

.bi-3-circle::before {
  content: "\\f7a3";
}

.bi-3-square-fill::before {
  content: "\\f7a4";
}

.bi-3-square::before {
  content: "\\f7a5";
}

.bi-4-circle-fill::before {
  content: "\\f7a8";
}

.bi-4-circle::before {
  content: "\\f7a9";
}

.bi-4-square-fill::before {
  content: "\\f7aa";
}

.bi-4-square::before {
  content: "\\f7ab";
}

.bi-5-circle-fill::before {
  content: "\\f7ae";
}

.bi-5-circle::before {
  content: "\\f7af";
}

.bi-5-square-fill::before {
  content: "\\f7b0";
}

.bi-5-square::before {
  content: "\\f7b1";
}

.bi-6-circle-fill::before {
  content: "\\f7b4";
}

.bi-6-circle::before {
  content: "\\f7b5";
}

.bi-6-square-fill::before {
  content: "\\f7b6";
}

.bi-6-square::before {
  content: "\\f7b7";
}

.bi-7-circle-fill::before {
  content: "\\f7ba";
}

.bi-7-circle::before {
  content: "\\f7bb";
}

.bi-7-square-fill::before {
  content: "\\f7bc";
}

.bi-7-square::before {
  content: "\\f7bd";
}

.bi-8-circle-fill::before {
  content: "\\f7c0";
}

.bi-8-circle::before {
  content: "\\f7c1";
}

.bi-8-square-fill::before {
  content: "\\f7c2";
}

.bi-8-square::before {
  content: "\\f7c3";
}

.bi-9-circle-fill::before {
  content: "\\f7c6";
}

.bi-9-circle::before {
  content: "\\f7c7";
}

.bi-9-square-fill::before {
  content: "\\f7c8";
}

.bi-9-square::before {
  content: "\\f7c9";
}

.bi-airplane-engines-fill::before {
  content: "\\f7ca";
}

.bi-airplane-engines::before {
  content: "\\f7cb";
}

.bi-airplane-fill::before {
  content: "\\f7cc";
}

.bi-airplane::before {
  content: "\\f7cd";
}

.bi-alexa::before {
  content: "\\f7ce";
}

.bi-alipay::before {
  content: "\\f7cf";
}

.bi-android::before {
  content: "\\f7d0";
}

.bi-android2::before {
  content: "\\f7d1";
}

.bi-box-fill::before {
  content: "\\f7d2";
}

.bi-box-seam-fill::before {
  content: "\\f7d3";
}

.bi-browser-chrome::before {
  content: "\\f7d4";
}

.bi-browser-edge::before {
  content: "\\f7d5";
}

.bi-browser-firefox::before {
  content: "\\f7d6";
}

.bi-browser-safari::before {
  content: "\\f7d7";
}

.bi-c-circle-fill::before {
  content: "\\f7da";
}

.bi-c-circle::before {
  content: "\\f7db";
}

.bi-c-square-fill::before {
  content: "\\f7dc";
}

.bi-c-square::before {
  content: "\\f7dd";
}

.bi-capsule-pill::before {
  content: "\\f7de";
}

.bi-capsule::before {
  content: "\\f7df";
}

.bi-car-front-fill::before {
  content: "\\f7e0";
}

.bi-car-front::before {
  content: "\\f7e1";
}

.bi-cassette-fill::before {
  content: "\\f7e2";
}

.bi-cassette::before {
  content: "\\f7e3";
}

.bi-cc-circle-fill::before {
  content: "\\f7e6";
}

.bi-cc-circle::before {
  content: "\\f7e7";
}

.bi-cc-square-fill::before {
  content: "\\f7e8";
}

.bi-cc-square::before {
  content: "\\f7e9";
}

.bi-cup-hot-fill::before {
  content: "\\f7ea";
}

.bi-cup-hot::before {
  content: "\\f7eb";
}

.bi-currency-rupee::before {
  content: "\\f7ec";
}

.bi-dropbox::before {
  content: "\\f7ed";
}

.bi-escape::before {
  content: "\\f7ee";
}

.bi-fast-forward-btn-fill::before {
  content: "\\f7ef";
}

.bi-fast-forward-btn::before {
  content: "\\f7f0";
}

.bi-fast-forward-circle-fill::before {
  content: "\\f7f1";
}

.bi-fast-forward-circle::before {
  content: "\\f7f2";
}

.bi-fast-forward-fill::before {
  content: "\\f7f3";
}

.bi-fast-forward::before {
  content: "\\f7f4";
}

.bi-filetype-sql::before {
  content: "\\f7f5";
}

.bi-fire::before {
  content: "\\f7f6";
}

.bi-google-play::before {
  content: "\\f7f7";
}

.bi-h-circle-fill::before {
  content: "\\f7fa";
}

.bi-h-circle::before {
  content: "\\f7fb";
}

.bi-h-square-fill::before {
  content: "\\f7fc";
}

.bi-h-square::before {
  content: "\\f7fd";
}

.bi-indent::before {
  content: "\\f7fe";
}

.bi-lungs-fill::before {
  content: "\\f7ff";
}

.bi-lungs::before {
  content: "\\f800";
}

.bi-microsoft-teams::before {
  content: "\\f801";
}

.bi-p-circle-fill::before {
  content: "\\f804";
}

.bi-p-circle::before {
  content: "\\f805";
}

.bi-p-square-fill::before {
  content: "\\f806";
}

.bi-p-square::before {
  content: "\\f807";
}

.bi-pass-fill::before {
  content: "\\f808";
}

.bi-pass::before {
  content: "\\f809";
}

.bi-prescription::before {
  content: "\\f80a";
}

.bi-prescription2::before {
  content: "\\f80b";
}

.bi-r-circle-fill::before {
  content: "\\f80e";
}

.bi-r-circle::before {
  content: "\\f80f";
}

.bi-r-square-fill::before {
  content: "\\f810";
}

.bi-r-square::before {
  content: "\\f811";
}

.bi-repeat-1::before {
  content: "\\f812";
}

.bi-repeat::before {
  content: "\\f813";
}

.bi-rewind-btn-fill::before {
  content: "\\f814";
}

.bi-rewind-btn::before {
  content: "\\f815";
}

.bi-rewind-circle-fill::before {
  content: "\\f816";
}

.bi-rewind-circle::before {
  content: "\\f817";
}

.bi-rewind-fill::before {
  content: "\\f818";
}

.bi-rewind::before {
  content: "\\f819";
}

.bi-train-freight-front-fill::before {
  content: "\\f81a";
}

.bi-train-freight-front::before {
  content: "\\f81b";
}

.bi-train-front-fill::before {
  content: "\\f81c";
}

.bi-train-front::before {
  content: "\\f81d";
}

.bi-train-lightrail-front-fill::before {
  content: "\\f81e";
}

.bi-train-lightrail-front::before {
  content: "\\f81f";
}

.bi-truck-front-fill::before {
  content: "\\f820";
}

.bi-truck-front::before {
  content: "\\f821";
}

.bi-ubuntu::before {
  content: "\\f822";
}

.bi-unindent::before {
  content: "\\f823";
}

.bi-unity::before {
  content: "\\f824";
}

.bi-universal-access-circle::before {
  content: "\\f825";
}

.bi-universal-access::before {
  content: "\\f826";
}

.bi-virus::before {
  content: "\\f827";
}

.bi-virus2::before {
  content: "\\f828";
}

.bi-wechat::before {
  content: "\\f829";
}

.bi-yelp::before {
  content: "\\f82a";
}

.bi-sign-stop-fill::before {
  content: "\\f82b";
}

.bi-sign-stop-lights-fill::before {
  content: "\\f82c";
}

.bi-sign-stop-lights::before {
  content: "\\f82d";
}

.bi-sign-stop::before {
  content: "\\f82e";
}

.bi-sign-turn-left-fill::before {
  content: "\\f82f";
}

.bi-sign-turn-left::before {
  content: "\\f830";
}

.bi-sign-turn-right-fill::before {
  content: "\\f831";
}

.bi-sign-turn-right::before {
  content: "\\f832";
}

.bi-sign-turn-slight-left-fill::before {
  content: "\\f833";
}

.bi-sign-turn-slight-left::before {
  content: "\\f834";
}

.bi-sign-turn-slight-right-fill::before {
  content: "\\f835";
}

.bi-sign-turn-slight-right::before {
  content: "\\f836";
}

.bi-sign-yield-fill::before {
  content: "\\f837";
}

.bi-sign-yield::before {
  content: "\\f838";
}

.bi-ev-station-fill::before {
  content: "\\f839";
}

.bi-ev-station::before {
  content: "\\f83a";
}

.bi-fuel-pump-diesel-fill::before {
  content: "\\f83b";
}

.bi-fuel-pump-diesel::before {
  content: "\\f83c";
}

.bi-fuel-pump-fill::before {
  content: "\\f83d";
}

.bi-fuel-pump::before {
  content: "\\f83e";
}

.bi-0-circle-fill::before {
  content: "\\f83f";
}

.bi-0-circle::before {
  content: "\\f840";
}

.bi-0-square-fill::before {
  content: "\\f841";
}

.bi-0-square::before {
  content: "\\f842";
}

.bi-rocket-fill::before {
  content: "\\f843";
}

.bi-rocket-takeoff-fill::before {
  content: "\\f844";
}

.bi-rocket-takeoff::before {
  content: "\\f845";
}

.bi-rocket::before {
  content: "\\f846";
}

.bi-stripe::before {
  content: "\\f847";
}

.bi-subscript::before {
  content: "\\f848";
}

.bi-superscript::before {
  content: "\\f849";
}

.bi-trello::before {
  content: "\\f84a";
}

.bi-envelope-at-fill::before {
  content: "\\f84b";
}

.bi-envelope-at::before {
  content: "\\f84c";
}

.bi-regex::before {
  content: "\\f84d";
}

.bi-text-wrap::before {
  content: "\\f84e";
}

.bi-sign-dead-end-fill::before {
  content: "\\f84f";
}

.bi-sign-dead-end::before {
  content: "\\f850";
}

.bi-sign-do-not-enter-fill::before {
  content: "\\f851";
}

.bi-sign-do-not-enter::before {
  content: "\\f852";
}

.bi-sign-intersection-fill::before {
  content: "\\f853";
}

.bi-sign-intersection-side-fill::before {
  content: "\\f854";
}

.bi-sign-intersection-side::before {
  content: "\\f855";
}

.bi-sign-intersection-t-fill::before {
  content: "\\f856";
}

.bi-sign-intersection-t::before {
  content: "\\f857";
}

.bi-sign-intersection-y-fill::before {
  content: "\\f858";
}

.bi-sign-intersection-y::before {
  content: "\\f859";
}

.bi-sign-intersection::before {
  content: "\\f85a";
}

.bi-sign-merge-left-fill::before {
  content: "\\f85b";
}

.bi-sign-merge-left::before {
  content: "\\f85c";
}

.bi-sign-merge-right-fill::before {
  content: "\\f85d";
}

.bi-sign-merge-right::before {
  content: "\\f85e";
}

.bi-sign-no-left-turn-fill::before {
  content: "\\f85f";
}

.bi-sign-no-left-turn::before {
  content: "\\f860";
}

.bi-sign-no-parking-fill::before {
  content: "\\f861";
}

.bi-sign-no-parking::before {
  content: "\\f862";
}

.bi-sign-no-right-turn-fill::before {
  content: "\\f863";
}

.bi-sign-no-right-turn::before {
  content: "\\f864";
}

.bi-sign-railroad-fill::before {
  content: "\\f865";
}

.bi-sign-railroad::before {
  content: "\\f866";
}

.bi-building-add::before {
  content: "\\f867";
}

.bi-building-check::before {
  content: "\\f868";
}

.bi-building-dash::before {
  content: "\\f869";
}

.bi-building-down::before {
  content: "\\f86a";
}

.bi-building-exclamation::before {
  content: "\\f86b";
}

.bi-building-fill-add::before {
  content: "\\f86c";
}

.bi-building-fill-check::before {
  content: "\\f86d";
}

.bi-building-fill-dash::before {
  content: "\\f86e";
}

.bi-building-fill-down::before {
  content: "\\f86f";
}

.bi-building-fill-exclamation::before {
  content: "\\f870";
}

.bi-building-fill-gear::before {
  content: "\\f871";
}

.bi-building-fill-lock::before {
  content: "\\f872";
}

.bi-building-fill-slash::before {
  content: "\\f873";
}

.bi-building-fill-up::before {
  content: "\\f874";
}

.bi-building-fill-x::before {
  content: "\\f875";
}

.bi-building-fill::before {
  content: "\\f876";
}

.bi-building-gear::before {
  content: "\\f877";
}

.bi-building-lock::before {
  content: "\\f878";
}

.bi-building-slash::before {
  content: "\\f879";
}

.bi-building-up::before {
  content: "\\f87a";
}

.bi-building-x::before {
  content: "\\f87b";
}

.bi-buildings-fill::before {
  content: "\\f87c";
}

.bi-buildings::before {
  content: "\\f87d";
}

.bi-bus-front-fill::before {
  content: "\\f87e";
}

.bi-bus-front::before {
  content: "\\f87f";
}

.bi-ev-front-fill::before {
  content: "\\f880";
}

.bi-ev-front::before {
  content: "\\f881";
}

.bi-globe-americas::before {
  content: "\\f882";
}

.bi-globe-asia-australia::before {
  content: "\\f883";
}

.bi-globe-central-south-asia::before {
  content: "\\f884";
}

.bi-globe-europe-africa::before {
  content: "\\f885";
}

.bi-house-add-fill::before {
  content: "\\f886";
}

.bi-house-add::before {
  content: "\\f887";
}

.bi-house-check-fill::before {
  content: "\\f888";
}

.bi-house-check::before {
  content: "\\f889";
}

.bi-house-dash-fill::before {
  content: "\\f88a";
}

.bi-house-dash::before {
  content: "\\f88b";
}

.bi-house-down-fill::before {
  content: "\\f88c";
}

.bi-house-down::before {
  content: "\\f88d";
}

.bi-house-exclamation-fill::before {
  content: "\\f88e";
}

.bi-house-exclamation::before {
  content: "\\f88f";
}

.bi-house-gear-fill::before {
  content: "\\f890";
}

.bi-house-gear::before {
  content: "\\f891";
}

.bi-house-lock-fill::before {
  content: "\\f892";
}

.bi-house-lock::before {
  content: "\\f893";
}

.bi-house-slash-fill::before {
  content: "\\f894";
}

.bi-house-slash::before {
  content: "\\f895";
}

.bi-house-up-fill::before {
  content: "\\f896";
}

.bi-house-up::before {
  content: "\\f897";
}

.bi-house-x-fill::before {
  content: "\\f898";
}

.bi-house-x::before {
  content: "\\f899";
}

.bi-person-add::before {
  content: "\\f89a";
}

.bi-person-down::before {
  content: "\\f89b";
}

.bi-person-exclamation::before {
  content: "\\f89c";
}

.bi-person-fill-add::before {
  content: "\\f89d";
}

.bi-person-fill-check::before {
  content: "\\f89e";
}

.bi-person-fill-dash::before {
  content: "\\f89f";
}

.bi-person-fill-down::before {
  content: "\\f8a0";
}

.bi-person-fill-exclamation::before {
  content: "\\f8a1";
}

.bi-person-fill-gear::before {
  content: "\\f8a2";
}

.bi-person-fill-lock::before {
  content: "\\f8a3";
}

.bi-person-fill-slash::before {
  content: "\\f8a4";
}

.bi-person-fill-up::before {
  content: "\\f8a5";
}

.bi-person-fill-x::before {
  content: "\\f8a6";
}

.bi-person-gear::before {
  content: "\\f8a7";
}

.bi-person-lock::before {
  content: "\\f8a8";
}

.bi-person-slash::before {
  content: "\\f8a9";
}

.bi-person-up::before {
  content: "\\f8aa";
}

.bi-scooter::before {
  content: "\\f8ab";
}

.bi-taxi-front-fill::before {
  content: "\\f8ac";
}

.bi-taxi-front::before {
  content: "\\f8ad";
}

.bi-amd::before {
  content: "\\f8ae";
}

.bi-database-add::before {
  content: "\\f8af";
}

.bi-database-check::before {
  content: "\\f8b0";
}

.bi-database-dash::before {
  content: "\\f8b1";
}

.bi-database-down::before {
  content: "\\f8b2";
}

.bi-database-exclamation::before {
  content: "\\f8b3";
}

.bi-database-fill-add::before {
  content: "\\f8b4";
}

.bi-database-fill-check::before {
  content: "\\f8b5";
}

.bi-database-fill-dash::before {
  content: "\\f8b6";
}

.bi-database-fill-down::before {
  content: "\\f8b7";
}

.bi-database-fill-exclamation::before {
  content: "\\f8b8";
}

.bi-database-fill-gear::before {
  content: "\\f8b9";
}

.bi-database-fill-lock::before {
  content: "\\f8ba";
}

.bi-database-fill-slash::before {
  content: "\\f8bb";
}

.bi-database-fill-up::before {
  content: "\\f8bc";
}

.bi-database-fill-x::before {
  content: "\\f8bd";
}

.bi-database-fill::before {
  content: "\\f8be";
}

.bi-database-gear::before {
  content: "\\f8bf";
}

.bi-database-lock::before {
  content: "\\f8c0";
}

.bi-database-slash::before {
  content: "\\f8c1";
}

.bi-database-up::before {
  content: "\\f8c2";
}

.bi-database-x::before {
  content: "\\f8c3";
}

.bi-database::before {
  content: "\\f8c4";
}

.bi-houses-fill::before {
  content: "\\f8c5";
}

.bi-houses::before {
  content: "\\f8c6";
}

.bi-nvidia::before {
  content: "\\f8c7";
}

.bi-person-vcard-fill::before {
  content: "\\f8c8";
}

.bi-person-vcard::before {
  content: "\\f8c9";
}

.bi-sina-weibo::before {
  content: "\\f8ca";
}

.bi-tencent-qq::before {
  content: "\\f8cb";
}

.bi-wikipedia::before {
  content: "\\f8cc";
}

.bi-alphabet-uppercase::before {
  content: "\\f2a5";
}

.bi-alphabet::before {
  content: "\\f68a";
}

.bi-amazon::before {
  content: "\\f68d";
}

.bi-arrows-collapse-vertical::before {
  content: "\\f690";
}

.bi-arrows-expand-vertical::before {
  content: "\\f695";
}

.bi-arrows-vertical::before {
  content: "\\f698";
}

.bi-arrows::before {
  content: "\\f6a2";
}

.bi-ban-fill::before {
  content: "\\f6a3";
}

.bi-ban::before {
  content: "\\f6b6";
}

.bi-bing::before {
  content: "\\f6c2";
}

.bi-cake::before {
  content: "\\f6e0";
}

.bi-cake2::before {
  content: "\\f6ed";
}

.bi-cookie::before {
  content: "\\f6ee";
}

.bi-copy::before {
  content: "\\f759";
}

.bi-crosshair::before {
  content: "\\f769";
}

.bi-crosshair2::before {
  content: "\\f794";
}

.bi-emoji-astonished-fill::before {
  content: "\\f795";
}

.bi-emoji-astonished::before {
  content: "\\f79a";
}

.bi-emoji-grimace-fill::before {
  content: "\\f79b";
}

.bi-emoji-grimace::before {
  content: "\\f7a0";
}

.bi-emoji-grin-fill::before {
  content: "\\f7a1";
}

.bi-emoji-grin::before {
  content: "\\f7a6";
}

.bi-emoji-surprise-fill::before {
  content: "\\f7a7";
}

.bi-emoji-surprise::before {
  content: "\\f7ac";
}

.bi-emoji-tear-fill::before {
  content: "\\f7ad";
}

.bi-emoji-tear::before {
  content: "\\f7b2";
}

.bi-envelope-arrow-down-fill::before {
  content: "\\f7b3";
}

.bi-envelope-arrow-down::before {
  content: "\\f7b8";
}

.bi-envelope-arrow-up-fill::before {
  content: "\\f7b9";
}

.bi-envelope-arrow-up::before {
  content: "\\f7be";
}

.bi-feather::before {
  content: "\\f7bf";
}

.bi-feather2::before {
  content: "\\f7c4";
}

.bi-floppy-fill::before {
  content: "\\f7c5";
}

.bi-floppy::before {
  content: "\\f7d8";
}

.bi-floppy2-fill::before {
  content: "\\f7d9";
}

.bi-floppy2::before {
  content: "\\f7e4";
}

.bi-gitlab::before {
  content: "\\f7e5";
}

.bi-highlighter::before {
  content: "\\f7f8";
}

.bi-marker-tip::before {
  content: "\\f802";
}

.bi-nvme-fill::before {
  content: "\\f803";
}

.bi-nvme::before {
  content: "\\f80c";
}

.bi-opencollective::before {
  content: "\\f80d";
}

.bi-pci-card-network::before {
  content: "\\f8cd";
}

.bi-pci-card-sound::before {
  content: "\\f8ce";
}

.bi-radar::before {
  content: "\\f8cf";
}

.bi-send-arrow-down-fill::before {
  content: "\\f8d0";
}

.bi-send-arrow-down::before {
  content: "\\f8d1";
}

.bi-send-arrow-up-fill::before {
  content: "\\f8d2";
}

.bi-send-arrow-up::before {
  content: "\\f8d3";
}

.bi-sim-slash-fill::before {
  content: "\\f8d4";
}

.bi-sim-slash::before {
  content: "\\f8d5";
}

.bi-sourceforge::before {
  content: "\\f8d6";
}

.bi-substack::before {
  content: "\\f8d7";
}

.bi-threads-fill::before {
  content: "\\f8d8";
}

.bi-threads::before {
  content: "\\f8d9";
}

.bi-transparency::before {
  content: "\\f8da";
}

.bi-twitter-x::before {
  content: "\\f8db";
}

.bi-type-h4::before {
  content: "\\f8dc";
}

.bi-type-h5::before {
  content: "\\f8dd";
}

.bi-type-h6::before {
  content: "\\f8de";
}

.bi-backpack-fill::before {
  content: "\\f8df";
}

.bi-backpack::before {
  content: "\\f8e0";
}

.bi-backpack2-fill::before {
  content: "\\f8e1";
}

.bi-backpack2::before {
  content: "\\f8e2";
}

.bi-backpack3-fill::before {
  content: "\\f8e3";
}

.bi-backpack3::before {
  content: "\\f8e4";
}

.bi-backpack4-fill::before {
  content: "\\f8e5";
}

.bi-backpack4::before {
  content: "\\f8e6";
}

.bi-brilliance::before {
  content: "\\f8e7";
}

.bi-cake-fill::before {
  content: "\\f8e8";
}

.bi-cake2-fill::before {
  content: "\\f8e9";
}

.bi-duffle-fill::before {
  content: "\\f8ea";
}

.bi-duffle::before {
  content: "\\f8eb";
}

.bi-exposure::before {
  content: "\\f8ec";
}

.bi-gender-neuter::before {
  content: "\\f8ed";
}

.bi-highlights::before {
  content: "\\f8ee";
}

.bi-luggage-fill::before {
  content: "\\f8ef";
}

.bi-luggage::before {
  content: "\\f8f0";
}

.bi-mailbox-flag::before {
  content: "\\f8f1";
}

.bi-mailbox2-flag::before {
  content: "\\f8f2";
}

.bi-noise-reduction::before {
  content: "\\f8f3";
}

.bi-passport-fill::before {
  content: "\\f8f4";
}

.bi-passport::before {
  content: "\\f8f5";
}

.bi-person-arms-up::before {
  content: "\\f8f6";
}

.bi-person-raised-hand::before {
  content: "\\f8f7";
}

.bi-person-standing-dress::before {
  content: "\\f8f8";
}

.bi-person-standing::before {
  content: "\\f8f9";
}

.bi-person-walking::before {
  content: "\\f8fa";
}

.bi-person-wheelchair::before {
  content: "\\f8fb";
}

.bi-shadows::before {
  content: "\\f8fc";
}

.bi-suitcase-fill::before {
  content: "\\f8fd";
}

.bi-suitcase-lg-fill::before {
  content: "\\f8fe";
}

.bi-suitcase-lg::before {
  content: "\\f8ff";
}

.bi-suitcase::before {
  content: "豈";
}

.bi-suitcase2-fill::before {
  content: "更";
}

.bi-suitcase2::before {
  content: "車";
}

.bi-vignette::before {
  content: "賈";
}

.bi-bluesky::before {
  content: "\\f7f9";
}

.bi-tux::before {
  content: "滑";
}

.bi-beaker-fill::before {
  content: "串";
}

.bi-beaker::before {
  content: "句";
}

.bi-flask-fill::before {
  content: "龜";
}

.bi-flask-florence-fill::before {
  content: "龜";
}

.bi-flask-florence::before {
  content: "契";
}

.bi-flask::before {
  content: "金";
}

.bi-leaf-fill::before {
  content: "喇";
}

.bi-leaf::before {
  content: "奈";
}

.bi-measuring-cup-fill::before {
  content: "懶";
}

.bi-measuring-cup::before {
  content: "癩";
}

.bi-unlock2-fill::before {
  content: "羅";
}

.bi-unlock2::before {
  content: "蘿";
}

.bi-battery-low::before {
  content: "螺";
}

.bi-anthropic::before {
  content: "裸";
}

.bi-apple-music::before {
  content: "邏";
}

.bi-claude::before {
  content: "樂";
}

.bi-openai::before {
  content: "洛";
}

.bi-perplexity::before {
  content: "烙";
}

.bi-css::before {
  content: "珞";
}

.bi-javascript::before {
  content: "落";
}

.bi-typescript::before {
  content: "酪";
}

.bi-fork-knife::before {
  content: "駱";
}

.bi-globe-americas-fill::before {
  content: "亂";
}

.bi-globe-asia-australia-fill::before {
  content: "卵";
}

.bi-globe-central-south-asia-fill::before {
  content: "欄";
}

.bi-globe-europe-africa-fill::before {
  content: "爛";
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 0px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}

.custom_main_font {
  font-family: "fira_sansregular";
}

#buy_now_button {
  font-family: "sea-dogregular";
}

#buy_now_button:hover {
  cursor: pointer;
}

#about_container {
  font-family: "Poppins";
}

#showcase_container {
  font-family: "Poppins";
}

#outlets_container {
  font-family: "Poppins";
}

#contactus_container {
  font-family: "Poppins";
}

#customer_support_container {
  font-family: "Poppins";
}

#navmenu {
  font-family: "Poppins";
}

/* End Globals */
/* top Navbar */
.topnav {
  overflow: hidden;
  background-color: #333;
  margin-bottom: 5px;
  font-family: "fira_sansregular";
  display: flex;
  flex-direction: row;
}

.topnav a {
  float: left;
  color: #f2f2f2;
  text-align: center;
  padding: 16px 14px 16px 16px;
  text-decoration: none;
  font-size: 17px;
}

.topnav a:hover {
  background-color: #ddd;
  color: black;
}

.topnav a.active {
  background-color: #4CAF50;
  color: white;
}

#firm_title {
  font-family: "sea-dogregular";
}

#firm_main_logo {
  height: 40px;
}

.pp-blue {
  color: #076691;
}

/*End Top Navbar */
/* Form Page */
.loginInput::-webkit-input-placeholder {
  font-family: "fira_sansregular";
}

.loginInput:-ms-input-placeholder {
  font-family: "fira_sansregular";
}

.loginInput:-moz-placeholder {
  font-family: "fira_sansregular";
}

.loginInput::-moz-placeholder {
  font-family: "fira_sansregular";
}

* {
  box-sizing: border-box;
}

input[type=text], select, textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  font-family: "fira_sansregular";
}

label {
  padding: 12px 12px 12px 0;
  display: inline-block;
}

input[type=submit] {
  background-color: #4CAF50;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  float: right;
  margin: 5px;
  font-family: "fira_sansregular";
}

input[type=submit]:hover {
  background-color: #45a049;
}

input[type=button] {
  background-color: #4CAF50;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  float: right;
  margin: 5px;
  font-family: "fira_sansregular";
}

input[type=button]:hover {
  background-color: #45a049;
}

.custom_container {
  border-radius: 5px;
  max-width: 500px;
  background-color: #f2f2f2;
  padding: 20px;
  margin: 20px;
  margin: auto;
  font-family: "fira_sansregular";
}

.col-25 {
  float: left;
  width: 25%;
  margin-top: 6px;
  font-family: "fira_sansregular";
}

.col-75 {
  float: left;
  width: 75%;
  margin-top: 6px;
  font-family: "fira_sansregular";
}

.col-75 select {
  font-family: "fira_sansregular";
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

#menu_items_toggle_button {
  float: right;
  display: none;
}

#menu_item_expanded_list {
  display: none;
}

/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 770px) {
  .col-25, .col-75, input[type=submit] {
    width: 100%;
    margin-top: 0;
  }
  .menu_items {
    display: none;
  }
  #menu_item_expanded_list {
    background-color: #333;
    position: fixed;
    top: 0px;
    left: 0px;
    display: none;
  }
  #menu_item_expanded_list a {
    width: 100vw;
    text-align: left;
    border-bottom: 1px solid #f2f2f2;
  }
  #menu_item_expanded_list a:hover {
    background-color: #f2f2f2;
  }
  #menu_items_toggle_button {
    float: right;
    display: block;
  }
}
/* End of Form Page */
/* Snack Bar */
#snackbar {
  font-family: "fira_sansregular";
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}
@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}
@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
/* End of Snack Bar */
/* Commons */
.custom_font {
  font-family: "fira_sansregular";
}

.background_color_green {
  background-color: #4CAF50;
}

.background_color_violet {
  background-color: #9900e6;
}

.step_card {
  width: 200px;
  height: 250px;
  padding: 2px;
  margin: 3px;
  display: inline-block;
}

.no_bullets_list {
  list-style-type: none;
}

/* End of commons */
/* Contact Us Page */
.contact_us_main_container {
  padding: 20px;
}

.button {
  background-color: #008CBA;
  border: none;
  border-radius: 8px;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  font-family: "fira_sansregular";
}

/* End of Contact Us Page */
/* Pricing Page */
.pricing_container {
  padding: 20px;
  font-family: "fira_sansregular";
  overflow: auto;
}

#pricing_table {
  margin: auto;
}

#pricing_table th {
  padding: 10px 10px 10px 10px;
  background-color: #ff6666;
  color: white;
}

#pricing_table td {
  padding: 10px 10px 10px 10px;
}

/* Visitor Container */
.visitor_container {
  padding: 10px 10px 10px 10px;
  margin-bottom: 5px;
}

/* End of Pricing Page */
/* Services Page */
.services_main_div {
  padding: 20px;
  font-family: "fira_sansregular";
  overflow: auto;
}

.service_item {
  border: solid 1px;
  border-radius: 5px;
  width: 250px;
  height: 400px;
  text-align: center;
  box-shadow: 5px 2px 2px #000000;
  background-color: white;
  display: inline-block;
  overflow: hidden;
  padding: 25px;
  margin: 5px;
}

.service_item:hover {
  box-shadow: 5px 5px 5px #000000;
  display: inline-block;
}

/* End of services page */
/* Blog page */
.blog_main_div {
  padding: 20px;
  font-family: "fira_sansregular";
}

.blog_display_area {
  border: solid 1px;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  display: inline-block;
  padding: 25px;
  margin-top: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}

.title_area {
  border: solid 1px;
  border-radius: 5px;
  width: 100%;
  height: 200px;
  background-color: white;
  padding: 5px;
}

.blog_title_item {
  width: 22%;
  border: solid 1px;
  padding: 5px;
  box-shadow: 5px 2px 2px #000000;
  display: inline-block;
  margin: 6px;
}

.meta_data_area {
  border: solid 0px;
  padding: 2px;
  margin: 2px;
}

.scroll {
  overflow: auto;
}

.scroll::-webkit-scrollbar {
  width: 5px;
}

.scroll::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

date {
  border: solid 0px;
}

view {
  border: solid 0px;
}

view_count {
  border: solid 0px;
}

like {
  border: solid 0px;
}

like_count {
  border: solid 0px;
}

comment {
  border: solid 0px;
}

comment_count {
  border: solid 0px;
}

interaction {
  float: right;
}

.blog {
  border: solid 1px;
  width: 60%;
  margin-left: 50px;
  display: inline-block;
}

blog_title_image {
  padding: 5px;
  margin-top: 5px;
}

.additional_blog_sections {
  border: solid 1px;
  display: inline-block;
  width: 29%;
  height: 1000px;
}

.social_media_widget {
  border: solid 1px;
  width: 40px;
  text-align: center;
  margin-top: 2px;
  padding: 2px;
  margin-bottom: 2px;
  display: inline-block;
  opacity: 0.8;
  transform: translateY(-500px);
}

/* End of blog page */
/*Dev Page*/
#dev_main_container {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.dev_title_item {
  width: 60%;
  border: solid 1px;
  padding: 5px;
  box-shadow: 5px 2px 2px #000000;
  display: inline-block;
  margin: 6px;
  background-color: #ffffff;
}

.dev_title_item p {
  text-indent: 20px;
}

/*End of dev page*/
/* Home Page */
.home_main_container {
  border-radius: 2px;
  /*background-color:  #2eb82e;*/
  padding: 20px;
  height: 100vh;
  overflow: auto;
  margin: auto;
  font-family: "fira_sansregular";
}

.steps_items {
  /*float:right;*/
  position: relative;
  display: inline-block;
}

.home_main_anim {
  /*border: solid black;*/
  height: 200px;
  width: 500px;
  display: inline-block;
}

.step_sub_block {
  position: relative;
  display: inline-block;
}

/* End of Home Page */
/* Footer Section */
.footer {
  width: 100%;
  margin-top: 2px;
  background-color: #333;
  color: white;
  text-align: center;
  font-family: "fira_sansregular";
  padding: 10px;
}

/* End of Footer */
/* Subscription Form */
.subscription_form {
  margin: auto;
  font-family: "fira_sansregular";
}

.subscription_form[input] {
  font-family: "fira_sansregular";
}

/* End of Subscription Form */
#loader_wrapper {
  position: fixed;
  z-index: 1;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.loading {
  display: block;
  height: 100%;
  width: 100%;
  background: linear-gradient(120deg, #7bc6cc, #be93c5);
  padding: 4em 0;
  font-size: 84px;
  font-family: "sea-dog";
  font-weight: 800;
  text-align: center;
}
.loading span {
  display: inline-block;
  margin: 0 -0.05em;
}

.loading02 span {
  animation: loading02 1.2s infinite alternate;
}
.loading02 span:nth-child(2) {
  animation-delay: 0.2s;
}
.loading02 span:nth-child(3) {
  animation-delay: 0.4s;
}
.loading02 span:nth-child(4) {
  animation-delay: 0.6s;
}
.loading02 span:nth-child(5) {
  animation-delay: 0.8s;
}
.loading02 span:nth-child(6) {
  animation-delay: 1s;
}
.loading02 span:nth-child(7) {
  animation-delay: 1.2s;
}

@keyframes loading02 {
  0% {
    filter: blur(0);
    opacity: 1;
  }
  100% {
    filter: blur(5px);
    opacity: 0.2;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/custom.scss","webpack://./src/styles/font-faces.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./node_modules/bootstrap-icons/font/bootstrap-icons.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,YAAA;ACAA;EACC,+BAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;ADED;ACCA;EACC,4BAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;ADAD;ACGA;EACI,6BAAA;EACA,gLAAA;EAGA,mBAAA;EACA,kBAAA;ADHJ;ACQA;EACC,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA;EACA,sGAAA;ADND;ACSA,cAAA;AACA;EACC,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA;EACA,gJAAA;ADPD;ACUA,UAAA;AACA;EACC,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA;EACA,iMAAA;ADRD;AEzCE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AHwCF;;AKxJI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AHwCJ;;AMhNA;;;EAGE,sBAAA;ANmNF;;AMpMI;EANJ;IAOM,uBAAA;ENwMJ;AACF;;AM3LA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AN8LF;;AMrLA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;APjc9B;;AM9KA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;AN+KF;;AM5KA;EFuMQ,iCAAA;AJvBR;AIrII;EE3CJ;IF8MQ,iBAAA;EJ1BN;AACF;;AMhLA;EFkMQ,iCAAA;AJdR;AI9II;EEtCJ;IFyMQ,eAAA;EJjBN;AACF;;AMpLA;EF6LQ,+BAAA;AJLR;AIvJI;EEjCJ;IFoMQ,kBAAA;EJRN;AACF;;AMxLA;EFwLQ,iCAAA;AJIR;AIhKI;EE5BJ;IF+LQ,iBAAA;EJCN;AACF;;AM5LA;EF+KM,kBALI;AJsBV;;AM3LA;EF0KM,eALI;AJ0BV;;AMpLA;EACE,aAAA;EACA,mBCwV0B;APjK5B;;AM7KA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;ANgLF;;AM1KA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AN6KF;;AMvKA;;EAEE,kBAAA;AN0KF;;AMvKA;;;EAGE,aAAA;EACA,mBAAA;AN0KF;;AMvKA;;;;EAIE,gBAAA;AN0KF;;AMvKA;EACE,gBC6b4B;APnR9B;;AMrKA;EACE,qBAAA;EACA,cAAA;ANwKF;;AMlKA;EACE,gBAAA;ANqKF;;AM7JA;;EAEE,mBCsa4B;APtQ9B;;AMxJA;EF6EM,kBALI;AJoFV;;AMrJA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;ANwJF;;AM/IA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ANkJF;;AM/IA;EAAM,eAAA;ANmJN;;AMlJA;EAAM,WAAA;ANsJN;;AMjJA;EACE,gEAAA;EACA,0BCgNwC;AP5D1C;AMlJE;EACE,mDAAA;ANoJJ;;AMzIE;EAEE,cAAA;EACA,qBAAA;AN2IJ;;AMpIA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AJ+HV;;AMhIA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AJuIV;AM/HE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ANiIJ;;AM7HA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ANgIF;AM7HE;EACE,cAAA;AN+HJ;;AM3HA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;ARoaJ;AM5HE;EACE,UAAA;EF7BE,cALI;AJiKV;;AMpHA;EACE,gBAAA;ANuHF;;AMjHA;;EAEE,sBAAA;ANoHF;;AM5GA;EACE,oBAAA;EACA,yBAAA;AN+GF;;AM5GA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;AN+GF;;AMxGA;EAEE,mBAAA;EACA,gCAAA;AN0GF;;AMvGA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AN0GF;;AMlGA;EACE,qBAAA;ANqGF;;AM/FA;EAEE,gBAAA;ANiGF;;AMzFA;EACE,UAAA;AN4FF;;AMvFA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AN0FF;;AMtFA;;EAEE,oBAAA;ANyFF;;AMpFA;EACE,eAAA;ANuFF;;AMpFA;EAGE,iBAAA;ANqFF;AMlFE;EACE,UAAA;ANoFJ;;AM7EA;EACE,wBAAA;ANgFF;;AMxEA;;;;EAIE,0BAAA;AN2EF;AMxEI;;;;EACE,eAAA;AN6EN;;AMtEA;EACE,UAAA;EACA,kBAAA;ANyEF;;AMpEA;EACE,gBAAA;ANuEF;;AM7DA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ANgEF;;AMxDA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AJ8QR;AI1aI;EEyWJ;IFtMQ,iBAAA;EJ2QN;AACF;AM7DE;EACE,WAAA;AN+DJ;;AMxDA;;;;;;;EAOE,UAAA;AN2DF;;AMxDA;EACE,YAAA;AN2DF;;AMlDA;EACE,6BAAA;EACA,oBAAA;ANqDF;AMlDE;EACE,eAAA;EACA,oBAAA;ANoDJ;;AM3CA;;;;;;;CAAA;AAWA;EACE,wBAAA;AN2CF;;AMtCA;EACE,UAAA;ANyCF;;AMlCA;EACE,aAAA;EACA,0BAAA;ANqCF;;AMhCA;EACE,qBAAA;ANmCF;;AM9BA;EACE,SAAA;ANiCF;;AM1BA;EACE,kBAAA;EACA,eAAA;AN6BF;;AMrBA;EACE,wBAAA;ANwBF;;AMhBA;EACE,wBAAA;ANmBF;;AS9lBA;ELmQM,kBALI;EK5PR,gBFwoB4B;APvC9B;;AS5lBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJkWR;AI9fI;EKpGF;ILuQM,eAAA;EJ+VN;AACF;;ASvmBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJ6WR;AIzgBI;EKpGF;ILuQM,iBAAA;EJ0WN;AACF;;ASlnBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJwXR;AIphBI;EKpGF;ILuQM,eAAA;EJqXN;AACF;;AS7nBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJmYR;AI/hBI;EKpGF;ILuQM,iBAAA;EJgYN;AACF;;ASxoBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJ8YR;AI1iBI;EKpGF;ILuQM,eAAA;EJ2YN;AACF;;ASnpBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJyZR;AIrjBI;EKpGF;ILuQM,iBAAA;EJsZN;AACF;;AStoBA;ECvDE,eAAA;EACA,gBAAA;AVisBF;;AStoBA;EC5DE,eAAA;EACA,gBAAA;AVssBF;;ASxoBA;EACE,qBAAA;AT2oBF;ASzoBE;EACE,oBFsoB0B;APK9B;;ASjoBA;EL8MM,kBALI;EKvMR,yBAAA;ATooBF;;AShoBA;EACE,mBFiUO;EH1HH,kBALI;AJkcV;ASjoBE;EACE,gBAAA;ATmoBJ;;AS/nBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;APwtBX;AShoBE;EACE,aAAA;ATkoBJ;;AWluBA;ECIE,eAAA;EAGA,YAAA;AZguBF;;AWjuBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AZyuBF;;AW3tBA;EAEE,qBAAA;AX6tBF;;AW1tBA;EACE,qBAAA;EACA,cAAA;AX6tBF;;AW1tBA;EPyPM,kBALI;EOlPR,gCJkjDkC;APr1BpC;;Aa/vBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Ad4wBF;;AettBI;EF5CE;IACE,gBNkee;EPoSrB;AACF;Ae5tBI;EF5CE;IACE,gBNkee;EPySrB;AACF;AejuBI;EF5CE;IACE,gBNkee;EP8SrB;AACF;AetuBI;EF5CE;IACE,iBNkee;EPmTrB;AACF;Ae3uBI;EF5CE;IACE,iBNkee;EPwTrB;AACF;AgB3yBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AhBizBJ;;AgB5yBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AjBqzBF;AgBnzBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AjB+yBF;;AiBhwBM;EACE,WAAA;AjBmwBR;;AiBhwBM;EApCJ,cAAA;EACA,WAAA;AjBwyBF;;AiB1xBE;EACE,cAAA;EACA,WAAA;AjB6xBJ;;AiB/xBE;EACE,cAAA;EACA,UAAA;AjBkyBJ;;AiBpyBE;EACE,cAAA;EACA,mBAAA;AjBuyBJ;;AiBzyBE;EACE,cAAA;EACA,UAAA;AjB4yBJ;;AiB9yBE;EACE,cAAA;EACA,UAAA;AjBizBJ;;AiBnzBE;EACE,cAAA;EACA,mBAAA;AjBszBJ;;AiBvxBM;EAhDJ,cAAA;EACA,WAAA;AjB20BF;;AiBtxBU;EAhEN,cAAA;EACA,kBAAA;AjB01BJ;;AiB3xBU;EAhEN,cAAA;EACA,mBAAA;AjB+1BJ;;AiBhyBU;EAhEN,cAAA;EACA,UAAA;AjBo2BJ;;AiBryBU;EAhEN,cAAA;EACA,mBAAA;AjBy2BJ;;AiB1yBU;EAhEN,cAAA;EACA,mBAAA;AjB82BJ;;AiB/yBU;EAhEN,cAAA;EACA,UAAA;AjBm3BJ;;AiBpzBU;EAhEN,cAAA;EACA,mBAAA;AjBw3BJ;;AiBzzBU;EAhEN,cAAA;EACA,mBAAA;AjB63BJ;;AiB9zBU;EAhEN,cAAA;EACA,UAAA;AjBk4BJ;;AiBn0BU;EAhEN,cAAA;EACA,mBAAA;AjBu4BJ;;AiBx0BU;EAhEN,cAAA;EACA,mBAAA;AjB44BJ;;AiB70BU;EAhEN,cAAA;EACA,WAAA;AjBi5BJ;;AiB10BY;EAxDV,wBAAA;AjBs4BF;;AiB90BY;EAxDV,yBAAA;AjB04BF;;AiBl1BY;EAxDV,gBAAA;AjB84BF;;AiBt1BY;EAxDV,yBAAA;AjBk5BF;;AiB11BY;EAxDV,yBAAA;AjBs5BF;;AiB91BY;EAxDV,gBAAA;AjB05BF;;AiBl2BY;EAxDV,yBAAA;AjB85BF;;AiBt2BY;EAxDV,yBAAA;AjBk6BF;;AiB12BY;EAxDV,gBAAA;AjBs6BF;;AiB92BY;EAxDV,yBAAA;AjB06BF;;AiBl3BY;EAxDV,yBAAA;AjB86BF;;AiB32BQ;;EAEE,gBAAA;AjB82BV;;AiB32BQ;;EAEE,gBAAA;AjB82BV;;AiBr3BQ;;EAEE,sBAAA;AjBw3BV;;AiBr3BQ;;EAEE,sBAAA;AjBw3BV;;AiB/3BQ;;EAEE,qBAAA;AjBk4BV;;AiB/3BQ;;EAEE,qBAAA;AjBk4BV;;AiBz4BQ;;EAEE,mBAAA;AjB44BV;;AiBz4BQ;;EAEE,mBAAA;AjB44BV;;AiBn5BQ;;EAEE,qBAAA;AjBs5BV;;AiBn5BQ;;EAEE,qBAAA;AjBs5BV;;AiB75BQ;;EAEE,mBAAA;AjBg6BV;;AiB75BQ;;EAEE,mBAAA;AjBg6BV;;Ae19BI;EEUE;IACE,WAAA;EjBo9BN;EiBj9BI;IApCJ,cAAA;IACA,WAAA;EjBw/BA;EiB1+BA;IACE,cAAA;IACA,WAAA;EjB4+BF;EiB9+BA;IACE,cAAA;IACA,UAAA;EjBg/BF;EiBl/BA;IACE,cAAA;IACA,mBAAA;EjBo/BF;EiBt/BA;IACE,cAAA;IACA,UAAA;EjBw/BF;EiB1/BA;IACE,cAAA;IACA,UAAA;EjB4/BF;EiB9/BA;IACE,cAAA;IACA,mBAAA;EjBggCF;EiBj+BI;IAhDJ,cAAA;IACA,WAAA;EjBohCA;EiB/9BQ;IAhEN,cAAA;IACA,kBAAA;EjBkiCF;EiBn+BQ;IAhEN,cAAA;IACA,mBAAA;EjBsiCF;EiBv+BQ;IAhEN,cAAA;IACA,UAAA;EjB0iCF;EiB3+BQ;IAhEN,cAAA;IACA,mBAAA;EjB8iCF;EiB/+BQ;IAhEN,cAAA;IACA,mBAAA;EjBkjCF;EiBn/BQ;IAhEN,cAAA;IACA,UAAA;EjBsjCF;EiBv/BQ;IAhEN,cAAA;IACA,mBAAA;EjB0jCF;EiB3/BQ;IAhEN,cAAA;IACA,mBAAA;EjB8jCF;EiB//BQ;IAhEN,cAAA;IACA,UAAA;EjBkkCF;EiBngCQ;IAhEN,cAAA;IACA,mBAAA;EjBskCF;EiBvgCQ;IAhEN,cAAA;IACA,mBAAA;EjB0kCF;EiB3gCQ;IAhEN,cAAA;IACA,WAAA;EjB8kCF;EiBvgCU;IAxDV,cAAA;EjBkkCA;EiB1gCU;IAxDV,wBAAA;EjBqkCA;EiB7gCU;IAxDV,yBAAA;EjBwkCA;EiBhhCU;IAxDV,gBAAA;EjB2kCA;EiBnhCU;IAxDV,yBAAA;EjB8kCA;EiBthCU;IAxDV,yBAAA;EjBilCA;EiBzhCU;IAxDV,gBAAA;EjBolCA;EiB5hCU;IAxDV,yBAAA;EjBulCA;EiB/hCU;IAxDV,yBAAA;EjB0lCA;EiBliCU;IAxDV,gBAAA;EjB6lCA;EiBriCU;IAxDV,yBAAA;EjBgmCA;EiBxiCU;IAxDV,yBAAA;EjBmmCA;EiBhiCM;;IAEE,gBAAA;EjBkiCR;EiB/hCM;;IAEE,gBAAA;EjBiiCR;EiBxiCM;;IAEE,sBAAA;EjB0iCR;EiBviCM;;IAEE,sBAAA;EjByiCR;EiBhjCM;;IAEE,qBAAA;EjBkjCR;EiB/iCM;;IAEE,qBAAA;EjBijCR;EiBxjCM;;IAEE,mBAAA;EjB0jCR;EiBvjCM;;IAEE,mBAAA;EjByjCR;EiBhkCM;;IAEE,qBAAA;EjBkkCR;EiB/jCM;;IAEE,qBAAA;EjBikCR;EiBxkCM;;IAEE,mBAAA;EjB0kCR;EiBvkCM;;IAEE,mBAAA;EjBykCR;AACF;AepoCI;EEUE;IACE,WAAA;EjB6nCN;EiB1nCI;IApCJ,cAAA;IACA,WAAA;EjBiqCA;EiBnpCA;IACE,cAAA;IACA,WAAA;EjBqpCF;EiBvpCA;IACE,cAAA;IACA,UAAA;EjBypCF;EiB3pCA;IACE,cAAA;IACA,mBAAA;EjB6pCF;EiB/pCA;IACE,cAAA;IACA,UAAA;EjBiqCF;EiBnqCA;IACE,cAAA;IACA,UAAA;EjBqqCF;EiBvqCA;IACE,cAAA;IACA,mBAAA;EjByqCF;EiB1oCI;IAhDJ,cAAA;IACA,WAAA;EjB6rCA;EiBxoCQ;IAhEN,cAAA;IACA,kBAAA;EjB2sCF;EiB5oCQ;IAhEN,cAAA;IACA,mBAAA;EjB+sCF;EiBhpCQ;IAhEN,cAAA;IACA,UAAA;EjBmtCF;EiBppCQ;IAhEN,cAAA;IACA,mBAAA;EjButCF;EiBxpCQ;IAhEN,cAAA;IACA,mBAAA;EjB2tCF;EiB5pCQ;IAhEN,cAAA;IACA,UAAA;EjB+tCF;EiBhqCQ;IAhEN,cAAA;IACA,mBAAA;EjBmuCF;EiBpqCQ;IAhEN,cAAA;IACA,mBAAA;EjBuuCF;EiBxqCQ;IAhEN,cAAA;IACA,UAAA;EjB2uCF;EiB5qCQ;IAhEN,cAAA;IACA,mBAAA;EjB+uCF;EiBhrCQ;IAhEN,cAAA;IACA,mBAAA;EjBmvCF;EiBprCQ;IAhEN,cAAA;IACA,WAAA;EjBuvCF;EiBhrCU;IAxDV,cAAA;EjB2uCA;EiBnrCU;IAxDV,wBAAA;EjB8uCA;EiBtrCU;IAxDV,yBAAA;EjBivCA;EiBzrCU;IAxDV,gBAAA;EjBovCA;EiB5rCU;IAxDV,yBAAA;EjBuvCA;EiB/rCU;IAxDV,yBAAA;EjB0vCA;EiBlsCU;IAxDV,gBAAA;EjB6vCA;EiBrsCU;IAxDV,yBAAA;EjBgwCA;EiBxsCU;IAxDV,yBAAA;EjBmwCA;EiB3sCU;IAxDV,gBAAA;EjBswCA;EiB9sCU;IAxDV,yBAAA;EjBywCA;EiBjtCU;IAxDV,yBAAA;EjB4wCA;EiBzsCM;;IAEE,gBAAA;EjB2sCR;EiBxsCM;;IAEE,gBAAA;EjB0sCR;EiBjtCM;;IAEE,sBAAA;EjBmtCR;EiBhtCM;;IAEE,sBAAA;EjBktCR;EiBztCM;;IAEE,qBAAA;EjB2tCR;EiBxtCM;;IAEE,qBAAA;EjB0tCR;EiBjuCM;;IAEE,mBAAA;EjBmuCR;EiBhuCM;;IAEE,mBAAA;EjBkuCR;EiBzuCM;;IAEE,qBAAA;EjB2uCR;EiBxuCM;;IAEE,qBAAA;EjB0uCR;EiBjvCM;;IAEE,mBAAA;EjBmvCR;EiBhvCM;;IAEE,mBAAA;EjBkvCR;AACF;Ae7yCI;EEUE;IACE,WAAA;EjBsyCN;EiBnyCI;IApCJ,cAAA;IACA,WAAA;EjB00CA;EiB5zCA;IACE,cAAA;IACA,WAAA;EjB8zCF;EiBh0CA;IACE,cAAA;IACA,UAAA;EjBk0CF;EiBp0CA;IACE,cAAA;IACA,mBAAA;EjBs0CF;EiBx0CA;IACE,cAAA;IACA,UAAA;EjB00CF;EiB50CA;IACE,cAAA;IACA,UAAA;EjB80CF;EiBh1CA;IACE,cAAA;IACA,mBAAA;EjBk1CF;EiBnzCI;IAhDJ,cAAA;IACA,WAAA;EjBs2CA;EiBjzCQ;IAhEN,cAAA;IACA,kBAAA;EjBo3CF;EiBrzCQ;IAhEN,cAAA;IACA,mBAAA;EjBw3CF;EiBzzCQ;IAhEN,cAAA;IACA,UAAA;EjB43CF;EiB7zCQ;IAhEN,cAAA;IACA,mBAAA;EjBg4CF;EiBj0CQ;IAhEN,cAAA;IACA,mBAAA;EjBo4CF;EiBr0CQ;IAhEN,cAAA;IACA,UAAA;EjBw4CF;EiBz0CQ;IAhEN,cAAA;IACA,mBAAA;EjB44CF;EiB70CQ;IAhEN,cAAA;IACA,mBAAA;EjBg5CF;EiBj1CQ;IAhEN,cAAA;IACA,UAAA;EjBo5CF;EiBr1CQ;IAhEN,cAAA;IACA,mBAAA;EjBw5CF;EiBz1CQ;IAhEN,cAAA;IACA,mBAAA;EjB45CF;EiB71CQ;IAhEN,cAAA;IACA,WAAA;EjBg6CF;EiBz1CU;IAxDV,cAAA;EjBo5CA;EiB51CU;IAxDV,wBAAA;EjBu5CA;EiB/1CU;IAxDV,yBAAA;EjB05CA;EiBl2CU;IAxDV,gBAAA;EjB65CA;EiBr2CU;IAxDV,yBAAA;EjBg6CA;EiBx2CU;IAxDV,yBAAA;EjBm6CA;EiB32CU;IAxDV,gBAAA;EjBs6CA;EiB92CU;IAxDV,yBAAA;EjBy6CA;EiBj3CU;IAxDV,yBAAA;EjB46CA;EiBp3CU;IAxDV,gBAAA;EjB+6CA;EiBv3CU;IAxDV,yBAAA;EjBk7CA;EiB13CU;IAxDV,yBAAA;EjBq7CA;EiBl3CM;;IAEE,gBAAA;EjBo3CR;EiBj3CM;;IAEE,gBAAA;EjBm3CR;EiB13CM;;IAEE,sBAAA;EjB43CR;EiBz3CM;;IAEE,sBAAA;EjB23CR;EiBl4CM;;IAEE,qBAAA;EjBo4CR;EiBj4CM;;IAEE,qBAAA;EjBm4CR;EiB14CM;;IAEE,mBAAA;EjB44CR;EiBz4CM;;IAEE,mBAAA;EjB24CR;EiBl5CM;;IAEE,qBAAA;EjBo5CR;EiBj5CM;;IAEE,qBAAA;EjBm5CR;EiB15CM;;IAEE,mBAAA;EjB45CR;EiBz5CM;;IAEE,mBAAA;EjB25CR;AACF;Aet9CI;EEUE;IACE,WAAA;EjB+8CN;EiB58CI;IApCJ,cAAA;IACA,WAAA;EjBm/CA;EiBr+CA;IACE,cAAA;IACA,WAAA;EjBu+CF;EiBz+CA;IACE,cAAA;IACA,UAAA;EjB2+CF;EiB7+CA;IACE,cAAA;IACA,mBAAA;EjB++CF;EiBj/CA;IACE,cAAA;IACA,UAAA;EjBm/CF;EiBr/CA;IACE,cAAA;IACA,UAAA;EjBu/CF;EiBz/CA;IACE,cAAA;IACA,mBAAA;EjB2/CF;EiB59CI;IAhDJ,cAAA;IACA,WAAA;EjB+gDA;EiB19CQ;IAhEN,cAAA;IACA,kBAAA;EjB6hDF;EiB99CQ;IAhEN,cAAA;IACA,mBAAA;EjBiiDF;EiBl+CQ;IAhEN,cAAA;IACA,UAAA;EjBqiDF;EiBt+CQ;IAhEN,cAAA;IACA,mBAAA;EjByiDF;EiB1+CQ;IAhEN,cAAA;IACA,mBAAA;EjB6iDF;EiB9+CQ;IAhEN,cAAA;IACA,UAAA;EjBijDF;EiBl/CQ;IAhEN,cAAA;IACA,mBAAA;EjBqjDF;EiBt/CQ;IAhEN,cAAA;IACA,mBAAA;EjByjDF;EiB1/CQ;IAhEN,cAAA;IACA,UAAA;EjB6jDF;EiB9/CQ;IAhEN,cAAA;IACA,mBAAA;EjBikDF;EiBlgDQ;IAhEN,cAAA;IACA,mBAAA;EjBqkDF;EiBtgDQ;IAhEN,cAAA;IACA,WAAA;EjBykDF;EiBlgDU;IAxDV,cAAA;EjB6jDA;EiBrgDU;IAxDV,wBAAA;EjBgkDA;EiBxgDU;IAxDV,yBAAA;EjBmkDA;EiB3gDU;IAxDV,gBAAA;EjBskDA;EiB9gDU;IAxDV,yBAAA;EjBykDA;EiBjhDU;IAxDV,yBAAA;EjB4kDA;EiBphDU;IAxDV,gBAAA;EjB+kDA;EiBvhDU;IAxDV,yBAAA;EjBklDA;EiB1hDU;IAxDV,yBAAA;EjBqlDA;EiB7hDU;IAxDV,gBAAA;EjBwlDA;EiBhiDU;IAxDV,yBAAA;EjB2lDA;EiBniDU;IAxDV,yBAAA;EjB8lDA;EiB3hDM;;IAEE,gBAAA;EjB6hDR;EiB1hDM;;IAEE,gBAAA;EjB4hDR;EiBniDM;;IAEE,sBAAA;EjBqiDR;EiBliDM;;IAEE,sBAAA;EjBoiDR;EiB3iDM;;IAEE,qBAAA;EjB6iDR;EiB1iDM;;IAEE,qBAAA;EjB4iDR;EiBnjDM;;IAEE,mBAAA;EjBqjDR;EiBljDM;;IAEE,mBAAA;EjBojDR;EiB3jDM;;IAEE,qBAAA;EjB6jDR;EiB1jDM;;IAEE,qBAAA;EjB4jDR;EiBnkDM;;IAEE,mBAAA;EjBqkDR;EiBlkDM;;IAEE,mBAAA;EjBokDR;AACF;Ae/nDI;EEUE;IACE,WAAA;EjBwnDN;EiBrnDI;IApCJ,cAAA;IACA,WAAA;EjB4pDA;EiB9oDA;IACE,cAAA;IACA,WAAA;EjBgpDF;EiBlpDA;IACE,cAAA;IACA,UAAA;EjBopDF;EiBtpDA;IACE,cAAA;IACA,mBAAA;EjBwpDF;EiB1pDA;IACE,cAAA;IACA,UAAA;EjB4pDF;EiB9pDA;IACE,cAAA;IACA,UAAA;EjBgqDF;EiBlqDA;IACE,cAAA;IACA,mBAAA;EjBoqDF;EiBroDI;IAhDJ,cAAA;IACA,WAAA;EjBwrDA;EiBnoDQ;IAhEN,cAAA;IACA,kBAAA;EjBssDF;EiBvoDQ;IAhEN,cAAA;IACA,mBAAA;EjB0sDF;EiB3oDQ;IAhEN,cAAA;IACA,UAAA;EjB8sDF;EiB/oDQ;IAhEN,cAAA;IACA,mBAAA;EjBktDF;EiBnpDQ;IAhEN,cAAA;IACA,mBAAA;EjBstDF;EiBvpDQ;IAhEN,cAAA;IACA,UAAA;EjB0tDF;EiB3pDQ;IAhEN,cAAA;IACA,mBAAA;EjB8tDF;EiB/pDQ;IAhEN,cAAA;IACA,mBAAA;EjBkuDF;EiBnqDQ;IAhEN,cAAA;IACA,UAAA;EjBsuDF;EiBvqDQ;IAhEN,cAAA;IACA,mBAAA;EjB0uDF;EiB3qDQ;IAhEN,cAAA;IACA,mBAAA;EjB8uDF;EiB/qDQ;IAhEN,cAAA;IACA,WAAA;EjBkvDF;EiB3qDU;IAxDV,cAAA;EjBsuDA;EiB9qDU;IAxDV,wBAAA;EjByuDA;EiBjrDU;IAxDV,yBAAA;EjB4uDA;EiBprDU;IAxDV,gBAAA;EjB+uDA;EiBvrDU;IAxDV,yBAAA;EjBkvDA;EiB1rDU;IAxDV,yBAAA;EjBqvDA;EiB7rDU;IAxDV,gBAAA;EjBwvDA;EiBhsDU;IAxDV,yBAAA;EjB2vDA;EiBnsDU;IAxDV,yBAAA;EjB8vDA;EiBtsDU;IAxDV,gBAAA;EjBiwDA;EiBzsDU;IAxDV,yBAAA;EjBowDA;EiB5sDU;IAxDV,yBAAA;EjBuwDA;EiBpsDM;;IAEE,gBAAA;EjBssDR;EiBnsDM;;IAEE,gBAAA;EjBqsDR;EiB5sDM;;IAEE,sBAAA;EjB8sDR;EiB3sDM;;IAEE,sBAAA;EjB6sDR;EiBptDM;;IAEE,qBAAA;EjBstDR;EiBntDM;;IAEE,qBAAA;EjBqtDR;EiB5tDM;;IAEE,mBAAA;EjB8tDR;EiB3tDM;;IAEE,mBAAA;EjB6tDR;EiBpuDM;;IAEE,qBAAA;EjBsuDR;EiBnuDM;;IAEE,qBAAA;EjBquDR;EiB5uDM;;IAEE,mBAAA;EjB8uDR;EiB3uDM;;IAEE,mBAAA;EjB6uDR;AACF;AkBn2DA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AlBk2DF;AkB31DE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AlB41DJ;AkBz1DE;EACE,uBAAA;AlB21DJ;AkBx1DE;EACE,sBAAA;AlB01DJ;;AkBt1DA;EACE,+DAAA;AlBy1DF;;AkBl1DA;EACE,iBAAA;AlBq1DF;;AkB30DE;EACE,wBAAA;AlB80DJ;;AkB/zDE;EACE,sCAAA;AlBk0DJ;AkB/zDI;EACE,sCAAA;AlBi0DN;;AkB1zDE;EACE,sBAAA;AlB6zDJ;AkB1zDE;EACE,mBAAA;AlB4zDJ;;AkBlzDE;EACE,oDAAA;EACA,8CAAA;AlBqzDJ;;AkB/yDE;EACE,oDAAA;EACA,8CAAA;AlBkzDJ;;AkB1yDA;EACE,oDAAA;EACA,8CAAA;AlB6yDF;;AkBryDE;EACE,mDAAA;EACA,6CAAA;AlBwyDJ;;AmBp7DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBg7DJ;;AmBl8DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB87DJ;;AmBh9DE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB48DJ;;AmB99DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB09DJ;;AmB5+DE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBw+DJ;;AmB1/DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBs/DJ;;AmBxgEE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBogEJ;;AmBthEE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBkhEJ;;AkBj4DI;EACE,gBAAA;EACA,iCAAA;AlBo4DN;;Ae/9DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB04DJ;AACF;Aet+DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBg5DJ;AACF;Ae5+DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBs5DJ;AACF;Ael/DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB45DJ;AACF;Aex/DI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBk6DJ;AACF;AoBtkEA;EACE,qBbu2BsC;APiuCxC;;AoB/jEA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;APi+C9B;;AoB5jEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AJi0DV;;AoB5jEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AJu0DV;;AqB7lEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;AP+vCxC;;AsBnmEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;AtBimEF;AuBnmEM;EDhBN;ICiBQ,gBAAA;EvBsmEN;AACF;AsBpmEE;EACE,gBAAA;AtBsmEJ;AsBpmEI;EACE,eAAA;AtBsmEN;AsBjmEE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,kCf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;AP6kDxB;AsB3lEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AtB+kEJ;AsB1kEE;EACE,cAAA;EACA,UAAA;AtB4kEJ;AsBxkEE;EACE,gCf40BoC;Ee10BpC,UAAA;AtBykEJ;AsBjkEE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;AtBgkEJ;AsB5jEE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;AtB8jEJ;AuBppEM;ED0EJ;ICzEM,gBAAA;EvBupEN;AACF;AsBhkEE;EACE,wCf47B8B;APsoClC;;AsBzjEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AtB4jEF;AsB1jEE;EACE,UAAA;AtB4jEJ;AsBzjEE;EAEE,gBAAA;EACA,eAAA;AtB0jEJ;;AsB/iEA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;ARurEJ;AsBhjEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;AP86C9B;;AsB9iEA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;ARmsEJ;AsB/iEE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;APs7C9B;;AsBziEE;EACE,oEf6uBoC;AP+zCxC;AsBziEE;EACE,mEf0uBoC;APi0CxC;AsBxiEE;EACE,iEfuuBoC;APm0CxC;;AsBriEA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;APu9C9B;AsBtiEE;EACE,eAAA;AtBwiEJ;AsBriEE;EACE,oBAAA;EdvLA,sCAAA;AR+tEJ;AsBpiEE;EACE,oBAAA;Ed5LA,sCAAA;ARmuEJ;AsBniEE;EAAoB,+Df8sBkB;APw1CxC;AsBriEE;EAAoB,6Df8sBkB;AP01CxC;;AyBvvEA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AzBuvEF;AuB5vEM;EEfN;IFgBQ,gBAAA;EvB+vEN;AACF;AyB1vEE;EACE,kClBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;APuxClC;AyBpvEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AzBqvEJ;AyBlvEE;EAEE,wClBu1BoC;AP45CxC;AyB9uEE;EACE,kBAAA;EACA,uCAAA;AzBgvEJ;;AyB5uEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AR0xEJ;;AyB5uEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;ARkyEJ;;AyB1uEI;EACE,iEAAA;AzB6uEN;;A0BrzEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;APm5C1C;A0BtzEE;EACE,WAAA;EACA,mBAAA;A1BwzEJ;;A0BpzEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;A1BuzEF;A0BrzEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A1BuzEJ;;A0BnzEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;A1BqzEF;A0BlzEE;ElB3BE,qBAAA;ARg1EJ;A0BjzEE;EAEE,kBnBm4BsC;AP+6C1C;A0B/yEE;EACE,uBnB03BsC;APu7C1C;A0B9yEE;EACE,kCnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;APkzDxB;A0B7yEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;AP40EV;A0B7yEI;EAII,kEAAA;A1B4yER;A0BxyEI;EAII,kEAAA;A1BuyER;A0BlyEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,kEAAA;A1BgyEN;A0B5xEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AP47C3C;A0BvxEI;EACE,eAAA;EACA,YnBy1BqC;APg8C3C;;A0B3wEA;EACE,mBnBo1BgC;AP07ClC;A0B5wEE;EACE,6DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A1B6wEJ;AuB/3EM;EG0GJ;IHzGM,gBAAA;EvBk4EN;AACF;A0BhxEI;EACE,6DAAA;A1BkxEN;A0B/wEI;EACE,iCnB60B4B;EmBx0B1B,6DAAA;A1B6wER;A0BxwEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;A1B0wEJ;A0BxwEI;EACE,oBAAA;EACA,cAAA;A1B0wEN;;A0BrwEA;EACE,qBAAA;EACA,kBnBsyBgC;APk+ClC;;A0BrwEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1BwwEF;A0BpwEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;APgnD9B;;A0B/vEI;EACE,6DAAA;A1BkwEN;;A2Br7EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A3Bw7EF;A2Bt7EE;EACE,UAAA;A3Bw7EJ;A2Bp7EI;EAA0B,kEpB8gCa;APy6C3C;A2Bt7EI;EAA0B,kEpB6gCa;AP46C3C;A2Bt7EE;EACE,SAAA;A3Bw7EJ;A2Br7EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,4GImBF;A3Bs7EJ;AuBr8EM;EIMJ;IJLM,gBAAA;EvBw8EN;AACF;A2Bz7EI;EHjCF,0CjB8hCyC;AP+7C3C;A2Bv7EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;ARu9EJ;A2Br7EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,4GI6CF;A3Bs7EJ;AuB/9EM;EIiCJ;IJhCM,gBAAA;EvBk+EN;AACF;A2Bz7EI;EH3DF,0CjB8hCyC;APy9C3C;A2Bv7EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;ARi/EJ;A2Br7EE;EACE,oBAAA;A3Bu7EJ;A2Br7EI;EACE,2CpBg9BqC;APu+C3C;A2Bp7EI;EACE,2CpB48BqC;AP0+C3C;;A4B7gFA;EACE,kBAAA;A5BghFF;A4B9gFE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;APy+CxC;A4B7gFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A5B+gFJ;AuBthFM;EKTJ;ILUM,gBAAA;EvByhFN;AACF;A4BjhFE;;EAEE,qBAAA;A5BmhFJ;A4BjhFI;;EACE,kBAAA;A5BohFN;A4BjhFI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;AP0gDxC;A4BjhFI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;AP+gDxC;A4BhhFE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;APkzD9B;A4B3gFI;;;;EACE,8DrBy/BkC;APuhDxC;A4B3gFI;EACE,8DrBm/BkC;AP0hDxC;A4BxgFI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,sCAAA;ARukFJ;A4BxgFE;EACE,wCrBkzBoC;APwtDxC;A4BtgFI;EACE,sCAAA;A5BwgFN;A4BpgFE;;EAEE,crBhFO;APslFX;;A6BhmFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7BmmFF;A6BjmFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7BmmFJ;A6B/lFE;;;EAGE,UAAA;A7BimFJ;A6B3lFE;EACE,kBAAA;EACA,UAAA;A7B6lFJ;A6B3lFI;EACE,UAAA;A7B6lFN;;A6BllFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;AR4nFJ;;A6B5kFA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;ARqoFJ;;A6B5kFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;AR8oFJ;;A6B5kFA;;EAEE,mBAAA;A7B+kFF;;A6BlkFI;;;;ErBjEA,0BAAA;EACA,6BAAA;AR0oFJ;A6BjkFI;;;;ErB1EA,0BAAA;EACA,6BAAA;ARipFJ;A6B3jFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;ARwoFJ;A6B3jFE;;ErB9EE,yBAAA;EACA,4BAAA;AR6oFJ;;A8BrqFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;APqnDzB;;A8BpqFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;ARksFJ;;A8BlqFI;;;;EAEE,cAAA;A9BuqFN;;A8BttFI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9BmqFR;A8BhqFM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;APupDzB;;A8BnuFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A9BwpFR;;A8BxuFI;EAuFE,+CvBq/BmB;APgqDzB;A8BlpFQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A9BmpFV;A8B/oFM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;AP0qDzB;;A8BtvFI;EAkHI,yCAAA;A9BwoFR;;A8B1vFI;EAyHE,+CvBm9BmB;APkrDzB;A8BnoFM;EACE,4CvBg9BiB;APqrDzB;A8BloFM;EACE,2DvB48BiB;APwrDzB;A8BjoFM;EACE,iCvBw8BiB;AP2rDzB;;A8B9nFI;EACE,kBAAA;A9BioFN;;A8B3wFI;;;;;EAoJM,UAAA;A9B+nFV;;A8B/vFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;AP+sDzB;;A8B9vFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;AR4xFJ;;A8B5vFI;;;;EAEE,cAAA;A9BiwFN;;A8BhzFI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9B6vFR;A8B1vFM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;APivDzB;;A8B7zFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A9BkvFR;;A8Bl0FI;EAuFE,iDvBq/BmB;AP0vDzB;A8B5uFQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A9B6uFV;A8BzuFM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;APowDzB;;A8Bh1FI;EAkHI,yCAAA;A9BkuFR;;A8Bp1FI;EAyHE,iDvBm9BmB;AP4wDzB;A8B7tFM;EACE,8CvBg9BiB;AP+wDzB;A8B5tFM;EACE,0DvB48BiB;APkxDzB;A8B3tFM;EACE,mCvBw8BiB;APqxDzB;;A8BxtFI;EACE,kBAAA;A9B2tFN;;A8Br2FI;;;;;EAsJM,UAAA;A9ButFV;;A+B/2FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A/B62FF;AuBj4FM;EQhBN;IRiBQ,gBAAA;EvBo4FN;AACF;A+Bh3FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A/Bi3FJ;A+B92FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/B+2FJ;A+B52FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A/B02FN;A+Bt2FE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A/Bo2FN;A+Bh2FE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A/B41FJ;A+Bz1FI;EAKI,0CAAA;A/Bu1FR;A+Bl1FE;EAKI,0CAAA;A/Bg1FN;A+B50FE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A/B20FJ;;A+B/zFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCk7FF;;A+Bh1FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCm8FF;;A+Bj2FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,+CAAA;EACA,uCAAA;EACA,2BAAA;EACA,sCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCo9FF;;A+Bl3FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCq+FF;;A+Bn4FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCs/FF;;A+Bp5FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCugGF;;A+Br6FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCwhGF;;A+Bt7FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCyiGF;;A+B76FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCiiGF;;A+B97FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCkjGF;;A+B/8FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCmkGF;;A+Bh+FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhColGF;;A+Bj/FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCqmGF;;A+BlgGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCsnGF;;A+BnhGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCuoGF;;A+BpiGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCwpGF;;A+BziGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;AP6xF1C;A+BjiGE;EACE,0BAAA;A/BmiGJ;A+BhiGE;EACE,gCAAA;A/BkiGJ;;A+BvhGA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;AhC4qGF;;A+B1hGA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;AhCmrGF;;AiCtvGA;EVgBM,gCUfJ;AjCyvGF;AuBtuGM;EUpBN;IVqBQ,gBAAA;EvByuGN;AACF;AiC5vGE;EACE,UAAA;AjC8vGJ;;AiCxvGE;EACE,aAAA;AjC2vGJ;;AiCvvGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AjC0vGF;AuBxvGM;EULN;IVMQ,gBAAA;EvB2vGN;AACF;AiC7vGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AjC+vGJ;AuBlwGM;EUAJ;IVCM,gBAAA;EvBqwGN;AACF;;AkC1xGA;;;;;;EAME,kBAAA;AlC6xGF;;AkC1xGA;EACE,mBAAA;AlC6xGF;AmCrwGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnC6yGF;AmCnvGI;EACE,cAAA;AnCqvGN;;AkCnyGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AR60GJ;AkChyGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AlCkyGJ;;AkC1wGI;EACE,oBAAA;AlC6wGN;AkC3wGM;EACE,WAAA;EACA,OAAA;AlC6wGR;;AkCzwGI;EACE,kBAAA;AlC4wGN;AkC1wGM;EACE,QAAA;EACA,UAAA;AlC4wGR;;AetzGI;EmB4BA;IACE,oBAAA;ElC8xGJ;EkC5xGI;IACE,WAAA;IACA,OAAA;ElC8xGN;EkC1xGE;IACE,kBAAA;ElC4xGJ;EkC1xGI;IACE,QAAA;IACA,UAAA;ElC4xGN;AACF;Aev0GI;EmB4BA;IACE,oBAAA;ElC8yGJ;EkC5yGI;IACE,WAAA;IACA,OAAA;ElC8yGN;EkC1yGE;IACE,kBAAA;ElC4yGJ;EkC1yGI;IACE,QAAA;IACA,UAAA;ElC4yGN;AACF;Aev1GI;EmB4BA;IACE,oBAAA;ElC8zGJ;EkC5zGI;IACE,WAAA;IACA,OAAA;ElC8zGN;EkC1zGE;IACE,kBAAA;ElC4zGJ;EkC1zGI;IACE,QAAA;IACA,UAAA;ElC4zGN;AACF;Aev2GI;EmB4BA;IACE,oBAAA;ElC80GJ;EkC50GI;IACE,WAAA;IACA,OAAA;ElC80GN;EkC10GE;IACE,kBAAA;ElC40GJ;EkC10GI;IACE,QAAA;IACA,UAAA;ElC40GN;AACF;Aev3GI;EmB4BA;IACE,oBAAA;ElC81GJ;EkC51GI;IACE,WAAA;IACA,OAAA;ElC81GN;EkC11GE;IACE,kBAAA;ElC41GJ;EkC11GI;IACE,QAAA;IACA,UAAA;ElC41GN;AACF;AkCn1GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlCq1GJ;AmCz6GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnC08GF;AmCv5GI;EACE,cAAA;AnCy5GN;;AkCz1GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AlC41GJ;AmC97GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AnCw9GF;AmC56GI;EACE,cAAA;AnC86GN;AkCp2GI;EACE,iBAAA;AlCs2GN;;AkCh2GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AlCm2GJ;AmCt9GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AnCw9GN;AmC78GM;EACE,aAAA;AnC+8GR;AmC58GM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AnCk/GF;AmC58GI;EACE,cAAA;AnC88GN;AkCn3GI;EACE,iBAAA;AlCq3GN;;AkC92GA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlCi3GF;;AkC32GA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;ARqhHJ;AkC52GE;EAEE,0CAAA;EV1LF,kDU4LuB;AlC42GzB;AkCz2GE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AlC02GzB;AkCv2GE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlCw2GJ;;AkCl2GA;EACE,cAAA;AlCq2GF;;AkCj2GA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AlCo2GF;;AkCh2GA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlCm2GF;;AkC/1GA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AlCi2GF;;AoCvlHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApC0lHF;AoCxlHE;;EACE,kBAAA;EACA,cAAA;ApC2lHJ;AoCtlHE;;;;;;;;;;;;EAME,UAAA;ApC8lHJ;;AoCzlHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApC4lHF;AoC1lHE;EACE,WAAA;ApC4lHJ;;AoCxlHA;E5BhBI,sCAAA;AR4mHJ;AoCxlHE;;EAEE,8CAAA;ApC0lHJ;AoCtlHE;;;E5BVE,0BAAA;EACA,6BAAA;ARqmHJ;AoCllHE;;;E5BNE,yBAAA;EACA,4BAAA;AR6lHJ;;AoCrkHA;EACE,wBAAA;EACA,uBAAA;ApCwkHF;AoCtkHE;EAGE,cAAA;ApCskHJ;AoCnkHE;EACE,eAAA;ApCqkHJ;;AoCjkHA;EACE,uBAAA;EACA,sBAAA;ApCokHF;;AoCjkHA;EACE,sBAAA;EACA,qBAAA;ApCokHF;;AoChjHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApCmjHF;AoCjjHE;;EAEE,WAAA;ApCmjHJ;AoChjHE;;EAEE,6CAAA;ApCkjHJ;AoC9iHE;;E5B1FE,6BAAA;EACA,4BAAA;AR4oHJ;AoC1iHE;;;E5BjHE,yBAAA;EACA,0BAAA;ARgqHJ;;AqCxrHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCurHF;;AqCprHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ArCurHF;AuBnsHM;EcGN;IdFQ,gBAAA;EvBssHN;AACF;AqC1rHE;EAEE,qCAAA;ArC2rHJ;AqCvrHE;EACE,UAAA;EACA,kD9BkhBoB;APuqGxB;AqCrrHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ArCsrHJ;;AqC9qHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ArC8qHF;AqC5qHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AR4tHJ;AqC7qHI;EAGE,kBAAA;EACA,wDAAA;ArC6qHN;AqCzqHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ArC2qHJ;AqCxqHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AR2uHJ;;AqChqHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ArCkqHF;AqC/pHE;E7B5FE,gDAAA;AR8vHJ;AqC9pHE;;EAEE,4CAAA;EbjHF,oDakHuB;ArCgqHzB;;AqCvpHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ArCupHF;AqCrpHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ArCupHJ;AqCrpHI;EAEE,iCAAA;ArCspHN;AqClpHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ArCopHJ;;AqC1oHE;;EAEE,cAAA;EACA,kBAAA;ArC6oHJ;;AqCxoHE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ArC2oHJ;;AqCroHE;;EACE,WAAA;ArCyoHJ;;AqC/nHE;EACE,aAAA;ArCkoHJ;AqChoHE;EACE,cAAA;ArCkoHJ;;AsC/zHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AtC+zHF;AsCzzHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtCi0HJ;AsC7yHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AtC+yHF;AsC7yHE;EAEE,yCAAA;AtC8yHJ;;AsCpyHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtCmyHF;AsChyHI;EAEE,oCAAA;AtCiyHN;AsC7xHE;EACE,gBAAA;AtC+xHJ;;AsCtxHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;AtCyxHF;AsCvxHE;;;EAGE,oCAAA;AtCyxHJ;;AsC5wHA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;AtC6wHF;;AsCzwHA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AtC4wHF;AuBr5HM;EeiIN;IfhIQ,gBAAA;EvBw5HN;AACF;AsC/wHE;EACE,qBAAA;AtCixHJ;AsC9wHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AtCgxHJ;;AsC1wHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtC6wHF;;AsC1wHA;EACE,yCAAA;EACA,gBAAA;AtC6wHF;;Aev4HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCowHN;EsClwHM;IACE,mBAAA;EtCowHR;EsClwHQ;IACE,kBAAA;EtCowHV;EsCjwHQ;IACE,kDAAA;IACA,iDAAA;EtCmwHV;EsC/vHM;IACE,iBAAA;EtCiwHR;EsC9vHM;IACE,wBAAA;IACA,gBAAA;EtCgwHR;EsC7vHM;IACE,aAAA;EtC+vHR;EsC5vHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtC4vHR;EsCzvHQ;IACE,aAAA;EtC2vHV;EsCxvHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC0vHV;AACF;Aev7HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCmzHN;EsCjzHM;IACE,mBAAA;EtCmzHR;EsCjzHQ;IACE,kBAAA;EtCmzHV;EsChzHQ;IACE,kDAAA;IACA,iDAAA;EtCkzHV;EsC9yHM;IACE,iBAAA;EtCgzHR;EsC7yHM;IACE,wBAAA;IACA,gBAAA;EtC+yHR;EsC5yHM;IACE,aAAA;EtC8yHR;EsC3yHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtC2yHR;EsCxyHQ;IACE,aAAA;EtC0yHV;EsCvyHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCyyHV;AACF;Aet+HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCk2HN;EsCh2HM;IACE,mBAAA;EtCk2HR;EsCh2HQ;IACE,kBAAA;EtCk2HV;EsC/1HQ;IACE,kDAAA;IACA,iDAAA;EtCi2HV;EsC71HM;IACE,iBAAA;EtC+1HR;EsC51HM;IACE,wBAAA;IACA,gBAAA;EtC81HR;EsC31HM;IACE,aAAA;EtC61HR;EsC11HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtC01HR;EsCv1HQ;IACE,aAAA;EtCy1HV;EsCt1HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCw1HV;AACF;AerhII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCi5HN;EsC/4HM;IACE,mBAAA;EtCi5HR;EsC/4HQ;IACE,kBAAA;EtCi5HV;EsC94HQ;IACE,kDAAA;IACA,iDAAA;EtCg5HV;EsC54HM;IACE,iBAAA;EtC84HR;EsC34HM;IACE,wBAAA;IACA,gBAAA;EtC64HR;EsC14HM;IACE,aAAA;EtC44HR;EsCz4HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCy4HR;EsCt4HQ;IACE,aAAA;EtCw4HV;EsCr4HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCu4HV;AACF;AepkII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCg8HN;EsC97HM;IACE,mBAAA;EtCg8HR;EsC97HQ;IACE,kBAAA;EtCg8HV;EsC77HQ;IACE,kDAAA;IACA,iDAAA;EtC+7HV;EsC37HM;IACE,iBAAA;EtC67HR;EsC17HM;IACE,wBAAA;IACA,gBAAA;EtC47HR;EsCz7HM;IACE,aAAA;EtC27HR;EsCx7HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCw7HR;EsCr7HQ;IACE,aAAA;EtCu7HV;EsCp7HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCs7HV;AACF;AsC7+HI;EAEI,iBAAA;EACA,2BAAA;AtC8+HR;AsC5+HQ;EACE,mBAAA;AtC8+HV;AsC5+HU;EACE,kBAAA;AtC8+HZ;AsC3+HU;EACE,kDAAA;EACA,iDAAA;AtC6+HZ;AsCz+HQ;EACE,iBAAA;AtC2+HV;AsCx+HQ;EACE,wBAAA;EACA,gBAAA;AtC0+HV;AsCv+HQ;EACE,aAAA;AtCy+HV;AsCt+HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AtCs+HV;AsCn+HU;EACE,aAAA;AtCq+HZ;AsCl+HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtCo+HZ;;AsCn9HA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AtCq9HF;;AsC/8HI;EACE,qEAAA;AtCk9HN;;AuC3uIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AR6vIJ;AuCxuIE;EACE,eAAA;EACA,cAAA;AvC0uIJ;AuCvuIE;EACE,mBAAA;EACA,sBAAA;AvCyuIJ;AuCvuII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;ARgwIJ;AuCvuII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;ARuvIJ;AuCpuIE;;EAEE,aAAA;AvCsuIJ;;AuCluIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AvCmuIF;;AuChuIA;EACE,4CAAA;EACA,iCAAA;AvCmuIF;;AuChuIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AvCmuIF;;AuChuIA;EACE,gBAAA;AvCmuIF;;AuC3tIE;EACE,oCAAA;AvC8tIJ;;AuCttIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AvCytIF;AuCvtIE;E/B7FE,wFAAA;ARuzIJ;;AuCrtIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AvCwtIF;AuCttIE;E/BxGE,wFAAA;ARi0IJ;;AuC/sIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AvCktIF;AuChtIE;EACE,mCAAA;EACA,sCAAA;AvCktIJ;;AuC9sIA;EACE,uDAAA;EACA,sDAAA;AvCitIF;;AuC7sIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AR21IJ;;AuC7sIA;;;EAGE,WAAA;AvCgtIF;;AuC7sIA;;E/B3II,0DAAA;EACA,2DAAA;AR61IJ;;AuC9sIA;;E/BlII,8DAAA;EACA,6DAAA;ARq1IJ;;AuCvsIE;EACE,0CAAA;AvC0sIJ;Aer0II;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EvC0sIF;EuCvsIE;IACE,WAAA;IACA,gBAAA;EvCysIJ;EuCvsII;IACE,cAAA;IACA,cAAA;EvCysIN;EuCpsIM;I/B1KJ,0BAAA;IACA,6BAAA;ERi3IF;EuCrsIQ;;IAGE,0BAAA;EvCssIV;EuCpsIQ;;IAGE,6BAAA;EvCqsIV;EuCjsIM;I/B3KJ,yBAAA;IACA,4BAAA;ER+2IF;EuClsIQ;;IAGE,yBAAA;EvCmsIV;EuCjsIQ;;IAGE,4BAAA;EvCksIV;AACF;;AwCt6IA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AxCw6IF;;AwCp6IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AxCu6IF;AuB97IM;EiBUN;IjBTQ,gBAAA;EvBi8IN;AACF;AwC16IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AxC46IJ;AwC16II;EACE,qDAAA;EACA,iDAAA;AxC46IN;AwCv6IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AxCy6IJ;AuBv9IM;EiBqCJ;IjBpCM,gBAAA;EvB09IN;AACF;AwC36IE;EACE,UAAA;AxC66IJ;AwC16IE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AxC46IJ;;AwCx6IA;EACE,gBAAA;AxC26IF;;AwCx6IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AxC26IF;AwCz6IE;EhC7DE,yDAAA;EACA,0DAAA;ARy+IJ;AwC16II;EhChEA,+DAAA;EACA,gEAAA;AR6+IJ;AwCz6IE;EACE,aAAA;AxC26IJ;AwCv6IE;EhC5DE,6DAAA;EACA,4DAAA;ARs+IJ;AwCv6IM;EhChEF,mEAAA;EACA,kEAAA;AR0+IJ;AwCt6II;EhCrEA,6DAAA;EACA,4DAAA;AR8+IJ;;AwCp6IA;EACE,8EAAA;AxCu6IF;;AwC95IE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;ARghJJ;AwC/5II;EAAgB,aAAA;AxCk6IpB;AwCj6II;EAAe,gBAAA;AxCo6InB;AwCj6II;;;EhCrHA,gBAAA;AR2hJJ;;AwC35II;EACE,iEAAA;EACA,wEAAA;AxC85IN;;AyCnjJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;ARmjJJ;;AyC7iJE;EACE,iDAAA;AzCgjJJ;AyC9iJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AzCgjJN;AyC5iJE;EACE,6CAAA;AzC8iJJ;;A0CnlJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AVwmJF;;A0CjlJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A1ColJF;AuBrmJM;EmBQN;InBPQ,gBAAA;EvBwmJN;AACF;A0CvlJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A1CwlJJ;A0CrlJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;A1CulJJ;A0CplJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A1CqlJJ;A0CllJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A1CmlJJ;;A0C9kJE;EACE,8CnC8sCgC;APm4GpC;A0C5kJM;ElC9BF,0DAAA;EACA,6DAAA;AR6mJJ;A0C1kJM;ElClDF,2DAAA;EACA,8DAAA;AR+nJJ;;A0C7jJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A3CmqJF;;A0ChkJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A3C0qJF;;A4C5qJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;ARirJJ;A4CxqJE;EACE,aAAA;A5C0qJJ;;A4CrqJA;EACE,kBAAA;EACA,SAAA;A5CwqJF;;A6CxsJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AR4sJJ;;A6CpsJA;EAEE,cAAA;A7CssJF;;A6ClsJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A7CqsJF;;A6C7rJA;EACE,mBtCs+C8B;AP0tGhC;A6C7rJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A7C+rJJ;;A6CvrJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7C0rJJ;;A6C9rJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7CisJJ;;A6CrsJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CwsJJ;;A6C5sJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7C+sJJ;;A6CntJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CstJJ;;A6C1tJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7C6tJJ;;A6CjuJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A7CouJJ;;A6CxuJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7C2uJJ;;A8CvyJE;EACE;IAAK,gDAAA;E9C2yJP;AACF;A8CvyJA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AR+yJJ;;A8ClyJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A9CqyJF;AuB1zJM;EuBYN;IvBXQ,gBAAA;EvB6zJN;AACF;;A8CvyJA;EtBAE,qMAAA;EsBEA,oEAAA;A9C0yJF;;A8CvyJA;EACE,iBAAA;A9C0yJF;;A8CvyJA;EACE,WAAA;A9C0yJF;;A8CtyJE;EACE,kDAAA;A9CyyJJ;A8CtyJM;EAJJ;IAKM,eAAA;E9CyyJN;AACF;;A+Cr2JA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AR+2JJ;;A+Ch2JA;EACE,qBAAA;EACA,sBAAA;A/Cm2JF;A+Cj2JE;EAEE,oCAAA;EACA,0BAAA;A/Ck2JJ;;A+C11JA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A/C61JF;A+C31JE;EvC9BE,+BAAA;EACA,gCAAA;AR43JJ;A+C31JE;EvCpBE,mCAAA;EACA,kCAAA;ARk3JJ;A+C31JE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A/C41JJ;A+Cx1JE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A/C01JJ;A+Ct1JE;EACE,mBAAA;A/Cw1JJ;A+Ct1JI;EACE,wDAAA;EACA,mDAAA;A/Cw1JN;;A+C90JA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A/Ci1JF;A+C70JI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A/C80JN;A+C30JI;EACE,+CAAA;EACA,uDAAA;A/C60JN;;A+Ch0JI;EACE,mBAAA;A/Cm0JN;A+Ch0JQ;EvCzDJ,6DAAA;EAZA,0BAAA;ARy4JJ;A+C/zJQ;EvC1EJ,2DAAA;EAYA,4BAAA;ARi4JJ;A+C9zJQ;EACE,aAAA;A/Cg0JV;A+C7zJQ;EACE,mDAAA;EACA,oBAAA;A/C+zJV;A+C7zJU;EACE,yDAAA;EACA,oDAAA;A/C+zJZ;;Aev5JI;EgCgEA;IACE,mBAAA;E/C21JJ;E+Cx1JM;IvCzDJ,6DAAA;IAZA,0BAAA;ERi6JF;E+Cv1JM;IvC1EJ,2DAAA;IAYA,4BAAA;ERy5JF;E+Ct1JM;IACE,aAAA;E/Cw1JR;E+Cr1JM;IACE,mDAAA;IACA,oBAAA;E/Cu1JR;E+Cr1JQ;IACE,yDAAA;IACA,oDAAA;E/Cu1JV;AACF;Aeh7JI;EgCgEA;IACE,mBAAA;E/Cm3JJ;E+Ch3JM;IvCzDJ,6DAAA;IAZA,0BAAA;ERy7JF;E+C/2JM;IvC1EJ,2DAAA;IAYA,4BAAA;ERi7JF;E+C92JM;IACE,aAAA;E/Cg3JR;E+C72JM;IACE,mDAAA;IACA,oBAAA;E/C+2JR;E+C72JQ;IACE,yDAAA;IACA,oDAAA;E/C+2JV;AACF;Aex8JI;EgCgEA;IACE,mBAAA;E/C24JJ;E+Cx4JM;IvCzDJ,6DAAA;IAZA,0BAAA;ERi9JF;E+Cv4JM;IvC1EJ,2DAAA;IAYA,4BAAA;ERy8JF;E+Ct4JM;IACE,aAAA;E/Cw4JR;E+Cr4JM;IACE,mDAAA;IACA,oBAAA;E/Cu4JR;E+Cr4JQ;IACE,yDAAA;IACA,oDAAA;E/Cu4JV;AACF;Aeh+JI;EgCgEA;IACE,mBAAA;E/Cm6JJ;E+Ch6JM;IvCzDJ,6DAAA;IAZA,0BAAA;ERy+JF;E+C/5JM;IvC1EJ,2DAAA;IAYA,4BAAA;ERi+JF;E+C95JM;IACE,aAAA;E/Cg6JR;E+C75JM;IACE,mDAAA;IACA,oBAAA;E/C+5JR;E+C75JQ;IACE,yDAAA;IACA,oDAAA;E/C+5JV;AACF;Aex/JI;EgCgEA;IACE,mBAAA;E/C27JJ;E+Cx7JM;IvCzDJ,6DAAA;IAZA,0BAAA;ERigKF;E+Cv7JM;IvC1EJ,2DAAA;IAYA,4BAAA;ERy/JF;E+Ct7JM;IACE,aAAA;E/Cw7JR;E+Cr7JM;IACE,mDAAA;IACA,oBAAA;E/Cu7JR;E+Cr7JQ;IACE,yDAAA;IACA,oDAAA;E/Cu7JV;AACF;A+C16JA;EvClJI,gBAAA;AR+jKJ;A+C16JE;EACE,mDAAA;A/C46JJ;A+C16JI;EACE,sBAAA;A/C46JN;;A+C/5JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/Ck6JJ;;A+C56JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/C+6JJ;;A+Cz7JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/C47JJ;;A+Ct8JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/Cy8JJ;;A+Cn9JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/Cs9JJ;;A+Ch+JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/Cm+JJ;;A+C7+JE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A/Cg/JJ;;A+C1/JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/C6/JJ;;AgD3rKA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;AhD2rKF;AgDxrKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AhD0rKJ;AgDvrKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AhDyrKJ;AgDtrKE;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;AhDurKJ;;AgD/qKA;EAHE,iEAAA;AhDsrKF;;AgD/qKA;;EAEE,uBAAA;AhDkrKF;;AK7tKI;E2CkCF,iEAAA;AhD+rKF;;AiDhvKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;ARyvKJ;AiD9uKE;EACE,UAAA;AjDgvKJ;AiD7uKE;EACE,aAAA;AjD+uKJ;;AiD3uKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AjD6uKF;AiD3uKE;EACE,sCAAA;AjD6uKJ;;AiDzuKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AR6wKJ;AiD3uKE;EACE,oDAAA;EACA,sCAAA;AjD6uKJ;;AiDzuKA;EACE,kCAAA;EACA,qBAAA;AjD4uKF;;AkD1yKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlDwyKF;;AkDjyKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AlDmyKF;AkDhyKE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AlDkyKJ;AuB50KM;E2BwCJ;I3BvCM,gBAAA;EvB+0KN;AACF;AkDryKE;EACE,e3Cg8CgC;APu2HpC;AkDnyKE;EACE,sB3C67CgC;APw2HpC;;AkDjyKA;EACE,+CAAA;AlDoyKF;AkDlyKE;EACE,gBAAA;EACA,gBAAA;AlDoyKJ;AkDjyKE;EACE,gBAAA;AlDmyKJ;;AkD/xKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AlDkyKF;;AkD9xKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AlD8xKF;;AkD1xKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AlDgyK9D;AmD54KE;EAAS,UAAA;AnD+4KX;AmD94KE;EAAS,mCD2GiF;AlDsyK5F;;AkDjyKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AR04KJ;AkDnyKE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AlDoyKJ;;AkD/xKA;EACE,gBAAA;EACA,8CAAA;AlDkyKF;;AkD7xKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AlD8xKF;;AkD1xKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;AR25KJ;AkDzxKE;EACE,8CAAA;AlD2xKJ;;Ae14KI;EmCqHF;IACE,0BAAA;IACA,2CAAA;ElDyxKF;EkDrxKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ElDuxKF;EkDpxKA;IACE,uBAAA;ElDsxKF;AACF;Aez5KI;EmCuIF;;IAEE,uBAAA;ElDqxKF;AACF;Ae/5KI;EmC8IF;IACE,wBAAA;ElDoxKF;AACF;AkD3wKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlD6wKN;AkD3wKM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;AR29KJ;AkD1wKM;;E1CjNF,gBAAA;AR+9KJ;AkDzwKM;EACE,gBAAA;AlD2wKR;;Aez6KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDiyKJ;EkD/xKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ER++KF;EkD9xKI;;I1CjNF,gBAAA;ERm/KF;EkD7xKI;IACE,gBAAA;ElD+xKN;AACF;Ae97KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDqzKJ;EkDnzKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ERmgLF;EkDlzKI;;I1CjNF,gBAAA;ERugLF;EkDjzKI;IACE,gBAAA;ElDmzKN;AACF;Ael9KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDy0KJ;EkDv0KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ERuhLF;EkDt0KI;;I1CjNF,gBAAA;ER2hLF;EkDr0KI;IACE,gBAAA;ElDu0KN;AACF;Aet+KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD61KJ;EkD31KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ER2iLF;EkD11KI;;I1CjNF,gBAAA;ER+iLF;EkDz1KI;IACE,gBAAA;ElD21KN;AACF;Ae1/KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDi3KJ;EkD/2KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ER+jLF;EkD92KI;;I1CjNF,gBAAA;ERmkLF;EkD72KI;IACE,gBAAA;ElD+2KN;AACF;AoDzlLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;ApDimLF;AoD/lLE;EAAS,kCAAA;ApDkmLX;AoDhmLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApDkmLJ;AoDhmLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDkmLN;;AoD7lLA;EACE,iDAAA;ApDgmLF;AoD9lLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ApDgmLJ;;AoD5lLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ApD+lLF;AoD7lLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ApD+lLJ;;AoD3lLA,mBAAA;AAEA;EACE,8CAAA;ApD6lLF;AoD3lLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ApD6lLJ;;AoDzlLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ApD4lLF;AoD1lLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ApD4lLJ;;AoDxlLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;AR4qLJ;;AsD/rLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;AR0tLJ;AsDtsLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtDwsLJ;AsDtsLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtDusLN;;AsDjsLE;EACE,oFAAA;AtDosLJ;AsDlsLI;EAEE,wFAAA;AtDmsLN;AsDhsLI;EACE,SAAA;EACA,gDAAA;AtDksLN;AsD/rLI;EACE,sCAAA;EACA,sCAAA;AtDisLN;;AsD5rLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AtD8rLJ;AsD5rLI;EAEE,kIAAA;AtD6rLN;AsD1rLI;EACE,OAAA;EACA,kDAAA;AtD4rLN;AsDzrLI;EACE,oCAAA;EACA,wCAAA;AtD2rLN;;AsDtrLA,mBAAA;AAGE;EACE,iFAAA;AtDurLJ;AsDrrLI;EAEE,wFAAA;AtDsrLN;AsDnrLI;EACE,MAAA;EACA,mDAAA;AtDqrLN;AsDlrLI;EACE,mCAAA;EACA,yCAAA;AtDorLN;AsD/qLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AtDirLJ;;AsD7qLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AtD+qLJ;AsD7qLI;EAEE,kIAAA;AtD8qLN;AsD3qLI;EACE,QAAA;EACA,iDAAA;AtD6qLN;AsD1qLI;EACE,qCAAA;EACA,uCAAA;AtD4qLN;;AsDvqLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;ARszLJ;AsDxpLE;EACE,aAAA;AtD0pLJ;;AsDtpLA;EACE,0EAAA;EACA,mCAAA;AtDypLF;;AuD90LA;EACE,kBAAA;AvDi1LF;;AuD90LA;EACE,mBAAA;AvDi1LF;;AuD90LA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvDi1LF;AwDv2LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxDy2LJ;;AuDl1LA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AvDq1LF;AuBp2LM;EgCQN;IhCPQ,gBAAA;EvBu2LN;AACF;;AuDv1LA;;;EAGE,cAAA;AvD01LF;;AuDv1LA;;EAEE,2BAAA;AvD01LF;;AuDv1LA;;EAEE,4BAAA;AvD01LF;;AuDj1LE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvDo1LJ;AuDj1LE;;;EAGE,UAAA;EACA,UAAA;AvDm1LJ;AuDh1LE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AvDk1LJ;AuB34LM;EgCqDJ;;IhCpDM,gBAAA;EvB+4LN;AACF;;AuD/0LA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AvDi1LF;AuBr6LM;EgCkEN;;IhCjEQ,gBAAA;EvBy6LN;AACF;AuDp1LE;;;EAEE,WhDrGO;EgDsGP,qBAAA;EACA,UAAA;EACA,YhDogDiC;APm1IrC;;AuDp1LA;EACE,OAAA;AvDu1LF;;AuDp1LA;EACE,QAAA;AvDu1LF;;AuDl1LA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AvDq1LF;;AuDl1LA;EACE,0TAAA;AvDq1LF;;AuDn1LA;EACE,yTAAA;AvDs1LF;;AuD90LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;AP63IrC;AuD90LE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AvD+0LJ;AuB7+LM;EgC6IJ;IhC5IM,gBAAA;EvBg/LN;AACF;AuDj1LE;EACE,UhDw8CiC;AP24IrC;;AuD10LA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;AvD60LF;;AuDl0LA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AvD20LF;;AuDp0LA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AvDu0LF;;AKlhMI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AvDw1LF;;AyDniMA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzDqiMF;;AyDjiMA;EACE;IAAK,0CAAA;EzDqiML;AACF;AyDliMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AzDiiMF;;AyD9hMA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AzDgiMF;;AyDvhMA;EACE;IACE,mBAAA;EzD0hMF;EyDxhMA;IACE,UAAA;IACA,eAAA;EzD0hMF;AACF;AyDthMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzDqhMF;;AyDlhMA;EACE,wBAAA;EACA,yBAAA;AzDqhMF;;AyDjhME;EACE;;IAEE,kCAAA;EzDohMJ;AACF;A0DrmMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;A1DsmMF;;AeziMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DulMJ;AACF;AuBlnMM;EmCYJ;InCXM,gBAAA;EvBqnMN;AACF;Ae/jMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D8lMN;E0D3lMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D6lMN;E0D1lMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D4lMN;E0DzlMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D2lMN;E0DxlMI;IAEE,eAAA;E1DylMN;E0DtlMI;IAGE,mBAAA;E1DslMN;AACF;AennMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DqlMN;E0DnlMM;IACE,aAAA;E1DqlMR;E0DllMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DmlMR;AACF;;AevnMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DqqMJ;AACF;AuBhsMM;EmCYJ;InCXM,gBAAA;EvBmsMN;AACF;Ae7oMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D4qMN;E0DzqMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D2qMN;E0DxqMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D0qMN;E0DvqMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DyqMN;E0DtqMI;IAEE,eAAA;E1DuqMN;E0DpqMI;IAGE,mBAAA;E1DoqMN;AACF;AejsMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DmqMN;E0DjqMM;IACE,aAAA;E1DmqMR;E0DhqMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DiqMR;AACF;;AersMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DmvMJ;AACF;AuB9wMM;EmCYJ;InCXM,gBAAA;EvBixMN;AACF;Ae3tMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D0vMN;E0DvvMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1DyvMN;E0DtvMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DwvMN;E0DrvMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DuvMN;E0DpvMI;IAEE,eAAA;E1DqvMN;E0DlvMI;IAGE,mBAAA;E1DkvMN;AACF;Ae/wMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DivMN;E0D/uMM;IACE,aAAA;E1DivMR;E0D9uMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D+uMR;AACF;;AenxMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1Di0MJ;AACF;AuB51MM;EmCYJ;InCXM,gBAAA;EvB+1MN;AACF;AezyMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1Dw0MN;E0Dr0MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1Du0MN;E0Dp0MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Ds0MN;E0Dn0MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Dq0MN;E0Dl0MI;IAEE,eAAA;E1Dm0MN;E0Dh0MI;IAGE,mBAAA;E1Dg0MN;AACF;Ae71MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D+zMN;E0D7zMM;IACE,aAAA;E1D+zMR;E0D5zMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D6zMR;AACF;;Aej2MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1D+4MJ;AACF;AuB16MM;EmCYJ;InCXM,gBAAA;EvB66MN;AACF;Aev3MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1Ds5MN;E0Dn5MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1Dq5MN;E0Dl5MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Do5MN;E0Dj5MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Dm5MN;E0Dh5MI;IAEE,eAAA;E1Di5MN;E0D94MI;IAGE,mBAAA;E1D84MN;AACF;Ae36MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D64MN;E0D34MM;IACE,aAAA;E1D64MR;E0D14MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D24MR;AACF;;A0D39ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A1D49MN;AuBt/MM;EmCYJ;InCXM,gBAAA;EvBy/MN;AACF;A0D/9MM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A1Di+MR;A0D99MM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A1Dg+MR;A0D79MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A1D+9MR;A0D59MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A1D89MR;A0D39MM;EAEE,eAAA;A1D49MR;A0Dz9MM;EAGE,mBAAA;A1Dy9MR;;A0D97MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;AP4iNX;AmDnjNE;EAAS,UAAA;AnDsjNX;AmDrjNE;EAAS,Y5Cm+CyB;APqlKpC;;A0D18MA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A1D68MF;A0D38ME;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;A1D48MJ;;A0Dx8MA;EACE,gBAAA;EACA,kDAAA;A1D28MF;;A0Dx8MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A1D28MF;;A2D5lNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;AP+yKpC;A2D7lNE;EACE,qBAAA;EACA,WAAA;A3D+lNJ;;A2D1lNA;EACE,iBAAA;A3D6lNF;;A2D1lNA;EACE,iBAAA;A3D6lNF;;A2D1lNA;EACE,iBAAA;A3D6lNF;;A2DxlNE;EACE,mDAAA;A3D2lNJ;;A2DvlNA;EACE;IACE,YpDmxCgC;EPu0KlC;AACF;A2DvlNA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A3DylNF;;A2DtlNA;EACE;IACE,uBAAA;E3DylNF;AACF;AwDxoNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD0oNJ;;A4D7oNE;EACE,sBAAA;EACA,iFAAA;A5DgpNJ;;A4DlpNE;EACE,sBAAA;EACA,mFAAA;A5DqpNJ;;A4DvpNE;EACE,sBAAA;EACA,iFAAA;A5D0pNJ;;A4D5pNE;EACE,sBAAA;EACA,8EAAA;A5D+pNJ;;A4DjqNE;EACE,sBAAA;EACA,iFAAA;A5DoqNJ;;A4DtqNE;EACE,sBAAA;EACA,gFAAA;A5DyqNJ;;A4D3qNE;EACE,sBAAA;EACA,+EAAA;A5D8qNJ;;A4DhrNE;EACE,sBAAA;EACA,8EAAA;A5DmrNJ;;A6DrrNE;EACE,wEAAA;EACA,kGAAA;A7DwrNJ;A6DrrNM;EAGE,8DAAA;EACA,wFAAA;A7DqrNR;;A6D9rNE;EACE,0EAAA;EACA,oGAAA;A7DisNJ;A6D9rNM;EAGE,8DAAA;EACA,wFAAA;A7D8rNR;;A6DvsNE;EACE,wEAAA;EACA,kGAAA;A7D0sNJ;A6DvsNM;EAGE,8DAAA;EACA,wFAAA;A7DusNR;;A6DhtNE;EACE,qEAAA;EACA,+FAAA;A7DmtNJ;A6DhtNM;EAGE,+DAAA;EACA,yFAAA;A7DgtNR;;A6DztNE;EACE,wEAAA;EACA,kGAAA;A7D4tNJ;A6DztNM;EAGE,+DAAA;EACA,yFAAA;A7DytNR;;A6DluNE;EACE,uEAAA;EACA,iGAAA;A7DquNJ;A6DluNM;EAGE,8DAAA;EACA,wFAAA;A7DkuNR;;A6D3uNE;EACE,sEAAA;EACA,gGAAA;A7D8uNJ;A6D3uNM;EAGE,gEAAA;EACA,0FAAA;A7D2uNR;;A6DpvNE;EACE,qEAAA;EACA,+FAAA;A7DuvNJ;A6DpvNM;EAGE,6DAAA;EACA,uFAAA;A7DovNR;;A6D7uNA;EACE,+EAAA;EACA,yGAAA;A7DgvNF;A6D7uNI;EAEE,kFAAA;EACA,4GAAA;A7D8uNN;;A8DxwNA;EACE,UAAA;EAEA,kJAAA;A9D0wNF;;A+D7wNA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A/DgxNF;A+D9wNE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A/DgxNJ;AuBzwNM;EwCZJ;IxCaM,gBAAA;EvB4wNN;AACF;;A+D9wNI;EACE,mEAAA;A/DixNN;;AgEpyNA;EACE,kBAAA;EACA,WAAA;AhEuyNF;AgEryNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AhEuyNJ;AgEpyNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhEsyNJ;;AgEjyNE;EACE,uBAAA;AhEoyNJ;;AgEryNE;EACE,sBAAA;AhEwyNJ;;AgEzyNE;EACE,yBAAA;AhE4yNJ;;AgE7yNE;EACE,iCAAA;AhEgzNJ;;AiEr0NA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;APiuLpC;;AiEr0NA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;APyuLpC;;AiEh0NI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;APgvLpC;;AiEh0NI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;APsvLpC;;AepyNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP6vLlC;EiE70NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPkwLlC;AACF;AejzNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EPywLlC;EiEz1NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EP8wLlC;AACF;Ae7zNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EPqxLlC;EiEr2NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EP0xLlC;AACF;Aez0NI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EPiyLlC;EiEj3NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPsyLlC;AACF;Aer1NI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP6yLlC;EiE73NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPkzLlC;AACF;AkE/5NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlEi6NF;;AkE95NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AlEi6NF;;AmEz6NA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ApE06NF;AoEv6NE;;EACE,6BAAA;ApE06NJ;AoEt6NE;;EACE,2BAAA;ApEy6NJ;;AqE57NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ArE+7NJ;;AsEv8NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AvE28NF;;AwEj9NA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;APyxM9B;;AyEx5NQ;EAOI,mCAAA;AzEq5NZ;;AyE55NQ;EAOI,8BAAA;AzEy5NZ;;AyEh6NQ;EAOI,iCAAA;AzE65NZ;;AyEp6NQ;EAOI,iCAAA;AzEi6NZ;;AyEx6NQ;EAOI,sCAAA;AzEq6NZ;;AyE56NQ;EAOI,mCAAA;AzEy6NZ;;AyEh7NQ;EAOI,sBAAA;AzE66NZ;;AyEp7NQ;EAOI,uBAAA;AzEi7NZ;;AyEx7NQ;EAOI,sBAAA;AzEq7NZ;;AyE57NQ;EAOI,8BAAA;AzEy7NZ;;AyEh8NQ;EAOI,4BAAA;AzE67NZ;;AyEp8NQ;EAOI,2BAAA;AzEi8NZ;;AyEx8NQ;EAOI,iCAAA;AzEq8NZ;;AyE58NQ;EAOI,2BAAA;AzEy8NZ;;AyEh9NQ;EAOI,qBAAA;AzE68NZ;;AyEp9NQ;EAOI,wBAAA;AzEi9NZ;;AyEx9NQ;EAOI,uBAAA;AzEq9NZ;;AyE59NQ;EAOI,wBAAA;AzEy9NZ;;AyEh+NQ;EAOI,qBAAA;AzE69NZ;;AyEp+NQ;EAOI,yBAAA;AzEi+NZ;;AyEx+NQ;EAOI,2BAAA;AzEq+NZ;;AyE5+NQ;EAOI,4BAAA;AzEy+NZ;;AyEh/NQ;EAOI,2BAAA;AzE6+NZ;;AyEp/NQ;EAOI,2BAAA;AzEi/NZ;;AyEx/NQ;EAOI,6BAAA;AzEq/NZ;;AyE5/NQ;EAOI,8BAAA;AzEy/NZ;;AyEhgOQ;EAOI,6BAAA;AzE6/NZ;;AyEpgOQ;EAOI,2BAAA;AzEigOZ;;AyExgOQ;EAOI,6BAAA;AzEqgOZ;;AyE5gOQ;EAOI,8BAAA;AzEygOZ;;AyEhhOQ;EAOI,6BAAA;AzE6gOZ;;AyEphOQ;EAOI,0BAAA;AzEihOZ;;AyExhOQ;EAOI,gCAAA;AzEqhOZ;;AyE5hOQ;EAOI,yBAAA;AzEyhOZ;;AyEhiOQ;EAOI,wBAAA;AzE6hOZ;;AyEpiOQ;EAOI,+BAAA;AzEiiOZ;;AyExiOQ;EAOI,yBAAA;AzEqiOZ;;AyE5iOQ;EAOI,6BAAA;AzEyiOZ;;AyEhjOQ;EAOI,8BAAA;AzE6iOZ;;AyEpjOQ;EAOI,wBAAA;AzEijOZ;;AyExjOQ;EAOI,+BAAA;AzEqjOZ;;AyE5jOQ;EAOI,wBAAA;AzEyjOZ;;AyEhkOQ;EAOI,2CAAA;AzE6jOZ;;AyEpkOQ;EAOI,8CAAA;AzEikOZ;;AyExkOQ;EAOI,8CAAA;AzEqkOZ;;AyE5kOQ;EAOI,2BAAA;AzEykOZ;;AyE1lOQ;EACE,gFAAA;AzE6lOV;;AyE9lOQ;EACE,kFAAA;AzEimOV;;AyElmOQ;EACE,gFAAA;AzEqmOV;;AyEtmOQ;EACE,6EAAA;AzEymOV;;AyE1mOQ;EACE,gFAAA;AzE6mOV;;AyE9mOQ;EACE,+EAAA;AzEinOV;;AyElnOQ;EACE,8EAAA;AzEqnOV;;AyEtnOQ;EACE,6EAAA;AzEynOV;;AyEhnOQ;EAOI,2BAAA;AzE6mOZ;;AyEpnOQ;EAOI,6BAAA;AzEinOZ;;AyExnOQ;EAOI,6BAAA;AzEqnOZ;;AyE5nOQ;EAOI,0BAAA;AzEynOZ;;AyEhoOQ;EAOI,2BAAA;AzE6nOZ;;AyEpoOQ;EAOI,iBAAA;AzEioOZ;;AyExoOQ;EAOI,mBAAA;AzEqoOZ;;AyE5oOQ;EAOI,oBAAA;AzEyoOZ;;AyEhpOQ;EAOI,oBAAA;AzE6oOZ;;AyEppOQ;EAOI,sBAAA;AzEipOZ;;AyExpOQ;EAOI,uBAAA;AzEqpOZ;;AyE5pOQ;EAOI,kBAAA;AzEypOZ;;AyEhqOQ;EAOI,oBAAA;AzE6pOZ;;AyEpqOQ;EAOI,qBAAA;AzEiqOZ;;AyExqOQ;EAOI,mBAAA;AzEqqOZ;;AyE5qOQ;EAOI,qBAAA;AzEyqOZ;;AyEhrOQ;EAOI,sBAAA;AzE6qOZ;;AyEprOQ;EAOI,2CAAA;AzEirOZ;;AyExrOQ;EAOI,sCAAA;AzEqrOZ;;AyE5rOQ;EAOI,sCAAA;AzEyrOZ;;AyEhsOQ;EAOI,uFAAA;AzE6rOZ;;AyEpsOQ;EAOI,oBAAA;AzEisOZ;;AyExsOQ;EAOI,2FAAA;AzEqsOZ;;AyE5sOQ;EAOI,wBAAA;AzEysOZ;;AyEhtOQ;EAOI,6FAAA;AzE6sOZ;;AyEptOQ;EAOI,0BAAA;AzEitOZ;;AyExtOQ;EAOI,8FAAA;AzEqtOZ;;AyE5tOQ;EAOI,2BAAA;AzEytOZ;;AyEhuOQ;EAOI,4FAAA;AzE6tOZ;;AyEpuOQ;EAOI,yBAAA;AzEiuOZ;;AyExuOQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEsuOZ;;AyE7uOQ;EAIQ,sBAAA;EAGJ,gFAAA;AzE2uOZ;;AyElvOQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEgvOZ;;AyEvvOQ;EAIQ,sBAAA;EAGJ,2EAAA;AzEqvOZ;;AyE5vOQ;EAIQ,sBAAA;EAGJ,8EAAA;AzE0vOZ;;AyEjwOQ;EAIQ,sBAAA;EAGJ,6EAAA;AzE+vOZ;;AyEtwOQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEowOZ;;AyE3wOQ;EAIQ,sBAAA;EAGJ,2EAAA;AzEywOZ;;AyEhxOQ;EAIQ,sBAAA;EAGJ,4EAAA;AzE8wOZ;;AyErxOQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEmxOZ;;AyE1xOQ;EAOI,wDAAA;AzEuxOZ;;AyE9xOQ;EAOI,0DAAA;AzE2xOZ;;AyElyOQ;EAOI,wDAAA;AzE+xOZ;;AyEtyOQ;EAOI,qDAAA;AzEmyOZ;;AyE1yOQ;EAOI,wDAAA;AzEuyOZ;;AyE9yOQ;EAOI,uDAAA;AzE2yOZ;;AyElzOQ;EAOI,sDAAA;AzE+yOZ;;AyEtzOQ;EAOI,qDAAA;AzEmzOZ;;AyE1zOQ;EAOI,4BAAA;AzEuzOZ;;AyE9zOQ;EAOI,4BAAA;AzE2zOZ;;AyEl0OQ;EAOI,4BAAA;AzE+zOZ;;AyEt0OQ;EAOI,4BAAA;AzEm0OZ;;AyE10OQ;EAOI,4BAAA;AzEu0OZ;;AyEx1OQ;EACE,wBAAA;AzE21OV;;AyE51OQ;EACE,yBAAA;AzE+1OV;;AyEh2OQ;EACE,wBAAA;AzEm2OV;;AyEp2OQ;EACE,yBAAA;AzEu2OV;;AyEx2OQ;EACE,sBAAA;AzE22OV;;AyEl2OQ;EAOI,qBAAA;AzE+1OZ;;AyEt2OQ;EAOI,qBAAA;AzEm2OZ;;AyE12OQ;EAOI,qBAAA;AzEu2OZ;;AyE92OQ;EAOI,sBAAA;AzE22OZ;;AyEl3OQ;EAOI,sBAAA;AzE+2OZ;;AyEt3OQ;EAOI,0BAAA;AzEm3OZ;;AyE13OQ;EAOI,uBAAA;AzEu3OZ;;AyE93OQ;EAOI,2BAAA;AzE23OZ;;AyEl4OQ;EAOI,sBAAA;AzE+3OZ;;AyEt4OQ;EAOI,sBAAA;AzEm4OZ;;AyE14OQ;EAOI,sBAAA;AzEu4OZ;;AyE94OQ;EAOI,uBAAA;AzE24OZ;;AyEl5OQ;EAOI,uBAAA;AzE+4OZ;;AyEt5OQ;EAOI,2BAAA;AzEm5OZ;;AyE15OQ;EAOI,wBAAA;AzEu5OZ;;AyE95OQ;EAOI,4BAAA;AzE25OZ;;AyEl6OQ;EAOI,yBAAA;AzE+5OZ;;AyEt6OQ;EAOI,8BAAA;AzEm6OZ;;AyE16OQ;EAOI,iCAAA;AzEu6OZ;;AyE96OQ;EAOI,sCAAA;AzE26OZ;;AyEl7OQ;EAOI,yCAAA;AzE+6OZ;;AyEt7OQ;EAOI,uBAAA;AzEm7OZ;;AyE17OQ;EAOI,uBAAA;AzEu7OZ;;AyE97OQ;EAOI,yBAAA;AzE27OZ;;AyEl8OQ;EAOI,yBAAA;AzE+7OZ;;AyEt8OQ;EAOI,0BAAA;AzEm8OZ;;AyE18OQ;EAOI,4BAAA;AzEu8OZ;;AyE98OQ;EAOI,kCAAA;AzE28OZ;;AyEl9OQ;EAOI,sCAAA;AzE+8OZ;;AyEt9OQ;EAOI,oCAAA;AzEm9OZ;;AyE19OQ;EAOI,kCAAA;AzEu9OZ;;AyE99OQ;EAOI,yCAAA;AzE29OZ;;AyEl+OQ;EAOI,wCAAA;AzE+9OZ;;AyEt+OQ;EAOI,wCAAA;AzEm+OZ;;AyE1+OQ;EAOI,kCAAA;AzEu+OZ;;AyE9+OQ;EAOI,gCAAA;AzE2+OZ;;AyEl/OQ;EAOI,8BAAA;AzE++OZ;;AyEt/OQ;EAOI,gCAAA;AzEm/OZ;;AyE1/OQ;EAOI,+BAAA;AzEu/OZ;;AyE9/OQ;EAOI,oCAAA;AzE2/OZ;;AyElgPQ;EAOI,kCAAA;AzE+/OZ;;AyEtgPQ;EAOI,gCAAA;AzEmgPZ;;AyE1gPQ;EAOI,uCAAA;AzEugPZ;;AyE9gPQ;EAOI,sCAAA;AzE2gPZ;;AyElhPQ;EAOI,iCAAA;AzE+gPZ;;AyEthPQ;EAOI,2BAAA;AzEmhPZ;;AyE1hPQ;EAOI,iCAAA;AzEuhPZ;;AyE9hPQ;EAOI,+BAAA;AzE2hPZ;;AyEliPQ;EAOI,6BAAA;AzE+hPZ;;AyEtiPQ;EAOI,+BAAA;AzEmiPZ;;AyE1iPQ;EAOI,8BAAA;AzEuiPZ;;AyE9iPQ;EAOI,oBAAA;AzE2iPZ;;AyEljPQ;EAOI,mBAAA;AzE+iPZ;;AyEtjPQ;EAOI,mBAAA;AzEmjPZ;;AyE1jPQ;EAOI,mBAAA;AzEujPZ;;AyE9jPQ;EAOI,mBAAA;AzE2jPZ;;AyElkPQ;EAOI,mBAAA;AzE+jPZ;;AyEtkPQ;EAOI,mBAAA;AzEmkPZ;;AyE1kPQ;EAOI,mBAAA;AzEukPZ;;AyE9kPQ;EAOI,oBAAA;AzE2kPZ;;AyEllPQ;EAOI,0BAAA;AzE+kPZ;;AyEtlPQ;EAOI,yBAAA;AzEmlPZ;;AyE1lPQ;EAOI,uBAAA;AzEulPZ;;AyE9lPQ;EAOI,yBAAA;AzE2lPZ;;AyElmPQ;EAOI,uBAAA;AzE+lPZ;;AyEtmPQ;EAOI,uBAAA;AzEmmPZ;;AyE1mPQ;EAOI,0BAAA;EAAA,yBAAA;AzEwmPZ;;AyE/mPQ;EAOI,gCAAA;EAAA,+BAAA;AzE6mPZ;;AyEpnPQ;EAOI,+BAAA;EAAA,8BAAA;AzEknPZ;;AyEznPQ;EAOI,6BAAA;EAAA,4BAAA;AzEunPZ;;AyE9nPQ;EAOI,+BAAA;EAAA,8BAAA;AzE4nPZ;;AyEnoPQ;EAOI,6BAAA;EAAA,4BAAA;AzEioPZ;;AyExoPQ;EAOI,6BAAA;EAAA,4BAAA;AzEsoPZ;;AyE7oPQ;EAOI,wBAAA;EAAA,2BAAA;AzE2oPZ;;AyElpPQ;EAOI,8BAAA;EAAA,iCAAA;AzEgpPZ;;AyEvpPQ;EAOI,6BAAA;EAAA,gCAAA;AzEqpPZ;;AyE5pPQ;EAOI,2BAAA;EAAA,8BAAA;AzE0pPZ;;AyEjqPQ;EAOI,6BAAA;EAAA,gCAAA;AzE+pPZ;;AyEtqPQ;EAOI,2BAAA;EAAA,8BAAA;AzEoqPZ;;AyE3qPQ;EAOI,2BAAA;EAAA,8BAAA;AzEyqPZ;;AyEhrPQ;EAOI,wBAAA;AzE6qPZ;;AyEprPQ;EAOI,8BAAA;AzEirPZ;;AyExrPQ;EAOI,6BAAA;AzEqrPZ;;AyE5rPQ;EAOI,2BAAA;AzEyrPZ;;AyEhsPQ;EAOI,6BAAA;AzE6rPZ;;AyEpsPQ;EAOI,2BAAA;AzEisPZ;;AyExsPQ;EAOI,2BAAA;AzEqsPZ;;AyE5sPQ;EAOI,0BAAA;AzEysPZ;;AyEhtPQ;EAOI,gCAAA;AzE6sPZ;;AyEptPQ;EAOI,+BAAA;AzEitPZ;;AyExtPQ;EAOI,6BAAA;AzEqtPZ;;AyE5tPQ;EAOI,+BAAA;AzEytPZ;;AyEhuPQ;EAOI,6BAAA;AzE6tPZ;;AyEpuPQ;EAOI,6BAAA;AzEiuPZ;;AyExuPQ;EAOI,2BAAA;AzEquPZ;;AyE5uPQ;EAOI,iCAAA;AzEyuPZ;;AyEhvPQ;EAOI,gCAAA;AzE6uPZ;;AyEpvPQ;EAOI,8BAAA;AzEivPZ;;AyExvPQ;EAOI,gCAAA;AzEqvPZ;;AyE5vPQ;EAOI,8BAAA;AzEyvPZ;;AyEhwPQ;EAOI,8BAAA;AzE6vPZ;;AyEpwPQ;EAOI,yBAAA;AzEiwPZ;;AyExwPQ;EAOI,+BAAA;AzEqwPZ;;AyE5wPQ;EAOI,8BAAA;AzEywPZ;;AyEhxPQ;EAOI,4BAAA;AzE6wPZ;;AyEpxPQ;EAOI,8BAAA;AzEixPZ;;AyExxPQ;EAOI,4BAAA;AzEqxPZ;;AyE5xPQ;EAOI,4BAAA;AzEyxPZ;;AyEhyPQ;EAOI,qBAAA;AzE6xPZ;;AyEpyPQ;EAOI,2BAAA;AzEiyPZ;;AyExyPQ;EAOI,0BAAA;AzEqyPZ;;AyE5yPQ;EAOI,wBAAA;AzEyyPZ;;AyEhzPQ;EAOI,0BAAA;AzE6yPZ;;AyEpzPQ;EAOI,wBAAA;AzEizPZ;;AyExzPQ;EAOI,2BAAA;EAAA,0BAAA;AzEszPZ;;AyE7zPQ;EAOI,iCAAA;EAAA,gCAAA;AzE2zPZ;;AyEl0PQ;EAOI,gCAAA;EAAA,+BAAA;AzEg0PZ;;AyEv0PQ;EAOI,8BAAA;EAAA,6BAAA;AzEq0PZ;;AyE50PQ;EAOI,gCAAA;EAAA,+BAAA;AzE00PZ;;AyEj1PQ;EAOI,8BAAA;EAAA,6BAAA;AzE+0PZ;;AyEt1PQ;EAOI,yBAAA;EAAA,4BAAA;AzEo1PZ;;AyE31PQ;EAOI,+BAAA;EAAA,kCAAA;AzEy1PZ;;AyEh2PQ;EAOI,8BAAA;EAAA,iCAAA;AzE81PZ;;AyEr2PQ;EAOI,4BAAA;EAAA,+BAAA;AzEm2PZ;;AyE12PQ;EAOI,8BAAA;EAAA,iCAAA;AzEw2PZ;;AyE/2PQ;EAOI,4BAAA;EAAA,+BAAA;AzE62PZ;;AyEp3PQ;EAOI,yBAAA;AzEi3PZ;;AyEx3PQ;EAOI,+BAAA;AzEq3PZ;;AyE53PQ;EAOI,8BAAA;AzEy3PZ;;AyEh4PQ;EAOI,4BAAA;AzE63PZ;;AyEp4PQ;EAOI,8BAAA;AzEi4PZ;;AyEx4PQ;EAOI,4BAAA;AzEq4PZ;;AyE54PQ;EAOI,2BAAA;AzEy4PZ;;AyEh5PQ;EAOI,iCAAA;AzE64PZ;;AyEp5PQ;EAOI,gCAAA;AzEi5PZ;;AyEx5PQ;EAOI,8BAAA;AzEq5PZ;;AyE55PQ;EAOI,gCAAA;AzEy5PZ;;AyEh6PQ;EAOI,8BAAA;AzE65PZ;;AyEp6PQ;EAOI,4BAAA;AzEi6PZ;;AyEx6PQ;EAOI,kCAAA;AzEq6PZ;;AyE56PQ;EAOI,iCAAA;AzEy6PZ;;AyEh7PQ;EAOI,+BAAA;AzE66PZ;;AyEp7PQ;EAOI,iCAAA;AzEi7PZ;;AyEx7PQ;EAOI,+BAAA;AzEq7PZ;;AyE57PQ;EAOI,0BAAA;AzEy7PZ;;AyEh8PQ;EAOI,gCAAA;AzE67PZ;;AyEp8PQ;EAOI,+BAAA;AzEi8PZ;;AyEx8PQ;EAOI,6BAAA;AzEq8PZ;;AyE58PQ;EAOI,+BAAA;AzEy8PZ;;AyEh9PQ;EAOI,6BAAA;AzE68PZ;;AyEp9PQ;EAOI,iBAAA;AzEi9PZ;;AyEx9PQ;EAOI,uBAAA;AzEq9PZ;;AyE59PQ;EAOI,sBAAA;AzEy9PZ;;AyEh+PQ;EAOI,oBAAA;AzE69PZ;;AyEp+PQ;EAOI,sBAAA;AzEi+PZ;;AyEx+PQ;EAOI,oBAAA;AzEq+PZ;;AyE5+PQ;EAOI,qBAAA;AzEy+PZ;;AyEh/PQ;EAOI,2BAAA;AzE6+PZ;;AyEp/PQ;EAOI,0BAAA;AzEi/PZ;;AyEx/PQ;EAOI,wBAAA;AzEq/PZ;;AyE5/PQ;EAOI,0BAAA;AzEy/PZ;;AyEhgQQ;EAOI,wBAAA;AzE6/PZ;;AyEpgQQ;EAOI,wBAAA;AzEigQZ;;AyExgQQ;EAOI,8BAAA;AzEqgQZ;;AyE5gQQ;EAOI,6BAAA;AzEygQZ;;AyEhhQQ;EAOI,2BAAA;AzE6gQZ;;AyEphQQ;EAOI,6BAAA;AzEihQZ;;AyExhQQ;EAOI,2BAAA;AzEqhQZ;;AyE5hQQ;EAOI,gDAAA;AzEyhQZ;;AyEhiQQ;EAOI,4CAAA;AzE6hQZ;;AyEpiQQ;EAOI,4CAAA;AzEiiQZ;;AyExiQQ;EAOI,0CAAA;AzEqiQZ;;AyE5iQQ;EAOI,4CAAA;AzEyiQZ;;AyEhjQQ;EAOI,6BAAA;AzE6iQZ;;AyEpjQQ;EAOI,0BAAA;AzEijQZ;;AyExjQQ;EAOI,6BAAA;AzEqjQZ;;AyE5jQQ;EAOI,6BAAA;AzEyjQZ;;AyEhkQQ;EAOI,+BAAA;AzE6jQZ;;AyEpkQQ;EAOI,2BAAA;AzEikQZ;;AyExkQQ;EAOI,2BAAA;AzEqkQZ;;AyE5kQQ;EAOI,2BAAA;AzEykQZ;;AyEhlQQ;EAOI,2BAAA;AzE6kQZ;;AyEplQQ;EAOI,2BAAA;AzEilQZ;;AyExlQQ;EAOI,8BAAA;AzEqlQZ;;AyE5lQQ;EAOI,yBAAA;AzEylQZ;;AyEhmQQ;EAOI,4BAAA;AzE6lQZ;;AyEpmQQ;EAOI,2BAAA;AzEimQZ;;AyExmQQ;EAOI,yBAAA;AzEqmQZ;;AyE5mQQ;EAOI,2BAAA;AzEymQZ;;AyEhnQQ;EAOI,4BAAA;AzE6mQZ;;AyEpnQQ;EAOI,6BAAA;AzEinQZ;;AyExnQQ;EAOI,gCAAA;AzEqnQZ;;AyE5nQQ;EAOI,qCAAA;AzEynQZ;;AyEhoQQ;EAOI,wCAAA;AzE6nQZ;;AyEpoQQ;EAOI,oCAAA;AzEioQZ;;AyExoQQ;EAOI,oCAAA;AzEqoQZ;;AyE5oQQ;EAOI,qCAAA;AzEyoQZ;;AyEhpQQ;EAOI,8BAAA;AzE6oQZ;;AyEppQQ;EAOI,8BAAA;AzEipQZ;;AyEtqQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AzEupQZ;;AyEpoQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AzE6pQZ;;AyEpqQQ;EAIQ,oBAAA;EAGJ,uEAAA;AzEkqQZ;;AyEzqQQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEuqQZ;;AyE9qQQ;EAIQ,oBAAA;EAGJ,kEAAA;AzE4qQZ;;AyEnrQQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEirQZ;;AyExrQQ;EAIQ,oBAAA;EAGJ,oEAAA;AzEsrQZ;;AyE7rQQ;EAIQ,oBAAA;EAGJ,mEAAA;AzE2rQZ;;AyElsQQ;EAIQ,oBAAA;EAGJ,kEAAA;AzEgsQZ;;AyEvsQQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEqsQZ;;AyE5sQQ;EAIQ,oBAAA;EAGJ,mEAAA;AzE0sQZ;;AyEjtQQ;EAIQ,oBAAA;EAGJ,wEAAA;AzE+sQZ;;AyEttQQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEotQZ;;AyE3tQQ;EAIQ,oBAAA;EAGJ,oCAAA;AzEytQZ;;AyEhuQQ;EAIQ,oBAAA;EAGJ,0CAAA;AzE8tQZ;;AyEruQQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEmuQZ;;AyE1uQQ;EAIQ,oBAAA;EAGJ,0CAAA;AzEwuQZ;;AyE/uQQ;EAIQ,oBAAA;EAGJ,0CAAA;AzE6uQZ;;AyEpvQQ;EAIQ,oBAAA;EAGJ,yBAAA;AzEkvQZ;;AyEnwQQ;EACE,uBAAA;AzEswQV;;AyEvwQQ;EACE,sBAAA;AzE0wQV;;AyE3wQQ;EACE,uBAAA;AzE8wQV;;AyE/wQQ;EACE,oBAAA;AzEkxQV;;AyEzwQQ;EAOI,iDAAA;AzEswQZ;;AyE7wQQ;EAOI,mDAAA;AzE0wQZ;;AyEjxQQ;EAOI,iDAAA;AzE8wQZ;;AyErxQQ;EAOI,8CAAA;AzEkxQZ;;AyEzxQQ;EAOI,iDAAA;AzEsxQZ;;AyE7xQQ;EAOI,gDAAA;AzE0xQZ;;AyEjyQQ;EAOI,+CAAA;AzE8xQZ;;AyEryQQ;EAOI,8CAAA;AzEkyQZ;;AyEnzQQ;EACE,sBAAA;AzEszQV;;AyElzQU;EACE,sBAAA;AzEqzQZ;;AyE3zQQ;EACE,uBAAA;AzE8zQV;;AyE1zQU;EACE,uBAAA;AzE6zQZ;;AyEn0QQ;EACE,sBAAA;AzEs0QV;;AyEl0QU;EACE,sBAAA;AzEq0QZ;;AyE30QQ;EACE,uBAAA;AzE80QV;;AyE10QU;EACE,uBAAA;AzE60QZ;;AyEn1QQ;EACE,oBAAA;AzEs1QV;;AyEl1QU;EACE,oBAAA;AzEq1QZ;;AyEj1QQ;EAOI,yCAAA;AzE80QZ;;AyEz0QU;EAOI,yCAAA;AzEs0Qd;;AyEz1QQ;EAOI,wCAAA;AzEs1QZ;;AyEj1QU;EAOI,wCAAA;AzE80Qd;;AyEj2QQ;EAOI,yCAAA;AzE81QZ;;AyEz1QU;EAOI,yCAAA;AzEs1Qd;;AyEz2QQ;EAIQ,8BAAA;EAGJ,+FAAA;AzEu2QZ;;AyE92QQ;EAIQ,8BAAA;EAGJ,iGAAA;AzE42QZ;;AyEn3QQ;EAIQ,8BAAA;EAGJ,+FAAA;AzEi3QZ;;AyEx3QQ;EAIQ,8BAAA;EAGJ,4FAAA;AzEs3QZ;;AyE73QQ;EAIQ,8BAAA;EAGJ,+FAAA;AzE23QZ;;AyEl4QQ;EAIQ,8BAAA;EAGJ,8FAAA;AzEg4QZ;;AyEv4QQ;EAIQ,8BAAA;EAGJ,6FAAA;AzEq4QZ;;AyE54QQ;EAIQ,8BAAA;EAGJ,4FAAA;AzE04QZ;;AyEj5QQ;EAIQ,8BAAA;EAGJ,qGAAA;AzE+4QZ;;AyEh6QQ;EACE,8BAAA;AzEm6QV;;AyE/5QU;EACE,8BAAA;AzEk6QZ;;AyEx6QQ;EACE,gCAAA;AzE26QV;;AyEv6QU;EACE,gCAAA;AzE06QZ;;AyEh7QQ;EACE,iCAAA;AzEm7QV;;AyE/6QU;EACE,iCAAA;AzEk7QZ;;AyEx7QQ;EACE,gCAAA;AzE27QV;;AyEv7QU;EACE,gCAAA;AzE07QZ;;AyEh8QQ;EACE,iCAAA;AzEm8QV;;AyE/7QU;EACE,iCAAA;AzEk8QZ;;AyEx8QQ;EACE,8BAAA;AzE28QV;;AyEv8QU;EACE,8BAAA;AzE08QZ;;AyEt8QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEo8QZ;;AyE38QQ;EAIQ,kBAAA;EAGJ,gFAAA;AzEy8QZ;;AyEh9QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzE88QZ;;AyEr9QQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEm9QZ;;AyE19QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEw9QZ;;AyE/9QQ;EAIQ,kBAAA;EAGJ,6EAAA;AzE69QZ;;AyEp+QQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEk+QZ;;AyEz+QQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEu+QZ;;AyE9+QQ;EAIQ,kBAAA;EAGJ,4EAAA;AzE4+QZ;;AyEn/QQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEi/QZ;;AyEx/QQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEs/QZ;;AyE7/QQ;EAIQ,kBAAA;EAGJ,wCAAA;AzE2/QZ;;AyElgRQ;EAIQ,kBAAA;EAGJ,mFAAA;AzEggRZ;;AyEvgRQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEqgRZ;;AyEthRQ;EACE,oBAAA;AzEyhRV;;AyE1hRQ;EACE,qBAAA;AzE6hRV;;AyE9hRQ;EACE,oBAAA;AzEiiRV;;AyEliRQ;EACE,qBAAA;AzEqiRV;;AyEtiRQ;EACE,kBAAA;AzEyiRV;;AyEhiRQ;EAOI,wDAAA;AzE6hRZ;;AyEpiRQ;EAOI,0DAAA;AzEiiRZ;;AyExiRQ;EAOI,wDAAA;AzEqiRZ;;AyE5iRQ;EAOI,qDAAA;AzEyiRZ;;AyEhjRQ;EAOI,wDAAA;AzE6iRZ;;AyEpjRQ;EAOI,uDAAA;AzEijRZ;;AyExjRQ;EAOI,sDAAA;AzEqjRZ;;AyE5jRQ;EAOI,qDAAA;AzEyjRZ;;AyEhkRQ;EAOI,+CAAA;AzE6jRZ;;AyEpkRQ;EAOI,2BAAA;AzEikRZ;;AyExkRQ;EAOI,4BAAA;AzEqkRZ;;AyE5kRQ;EAOI,4BAAA;AzEykRZ;;AyEhlRQ;EAOI,+BAAA;AzE6kRZ;;AyEplRQ;EAOI,+BAAA;AzEilRZ;;AyExlRQ;EAOI,iDAAA;AzEqlRZ;;AyE5lRQ;EAOI,2BAAA;AzEylRZ;;AyEhmRQ;EAOI,oDAAA;AzE6lRZ;;AyEpmRQ;EAOI,iDAAA;AzEimRZ;;AyExmRQ;EAOI,oDAAA;AzEqmRZ;;AyE5mRQ;EAOI,oDAAA;AzEymRZ;;AyEhnRQ;EAOI,qDAAA;AzE6mRZ;;AyEpnRQ;EAOI,6BAAA;AzEinRZ;;AyExnRQ;EAOI,sDAAA;AzEqnRZ;;AyE5nRQ;EAOI,0DAAA;EAAA,2DAAA;AzE0nRZ;;AyEjoRQ;EAOI,oCAAA;EAAA,qCAAA;AzE+nRZ;;AyEtoRQ;EAOI,6DAAA;EAAA,8DAAA;AzEooRZ;;AyE3oRQ;EAOI,0DAAA;EAAA,2DAAA;AzEyoRZ;;AyEhpRQ;EAOI,6DAAA;EAAA,8DAAA;AzE8oRZ;;AyErpRQ;EAOI,6DAAA;EAAA,8DAAA;AzEmpRZ;;AyE1pRQ;EAOI,8DAAA;EAAA,+DAAA;AzEwpRZ;;AyE/pRQ;EAOI,sCAAA;EAAA,uCAAA;AzE6pRZ;;AyEpqRQ;EAOI,+DAAA;EAAA,gEAAA;AzEkqRZ;;AyEzqRQ;EAOI,2DAAA;EAAA,8DAAA;AzEuqRZ;;AyE9qRQ;EAOI,qCAAA;EAAA,wCAAA;AzE4qRZ;;AyEnrRQ;EAOI,8DAAA;EAAA,iEAAA;AzEirRZ;;AyExrRQ;EAOI,2DAAA;EAAA,8DAAA;AzEsrRZ;;AyE7rRQ;EAOI,8DAAA;EAAA,iEAAA;AzE2rRZ;;AyElsRQ;EAOI,8DAAA;EAAA,iEAAA;AzEgsRZ;;AyEvsRQ;EAOI,+DAAA;EAAA,kEAAA;AzEqsRZ;;AyE5sRQ;EAOI,uCAAA;EAAA,0CAAA;AzE0sRZ;;AyEjtRQ;EAOI,gEAAA;EAAA,mEAAA;AzE+sRZ;;AyEttRQ;EAOI,8DAAA;EAAA,6DAAA;AzEotRZ;;AyE3tRQ;EAOI,wCAAA;EAAA,uCAAA;AzEytRZ;;AyEhuRQ;EAOI,iEAAA;EAAA,gEAAA;AzE8tRZ;;AyEruRQ;EAOI,8DAAA;EAAA,6DAAA;AzEmuRZ;;AyE1uRQ;EAOI,iEAAA;EAAA,gEAAA;AzEwuRZ;;AyE/uRQ;EAOI,iEAAA;EAAA,gEAAA;AzE6uRZ;;AyEpvRQ;EAOI,kEAAA;EAAA,iEAAA;AzEkvRZ;;AyEzvRQ;EAOI,0CAAA;EAAA,yCAAA;AzEuvRZ;;AyE9vRQ;EAOI,mEAAA;EAAA,kEAAA;AzE4vRZ;;AyEnwRQ;EAOI,6DAAA;EAAA,0DAAA;AzEiwRZ;;AyExwRQ;EAOI,uCAAA;EAAA,oCAAA;AzEswRZ;;AyE7wRQ;EAOI,gEAAA;EAAA,6DAAA;AzE2wRZ;;AyElxRQ;EAOI,6DAAA;EAAA,0DAAA;AzEgxRZ;;AyEvxRQ;EAOI,gEAAA;EAAA,6DAAA;AzEqxRZ;;AyE5xRQ;EAOI,gEAAA;EAAA,6DAAA;AzE0xRZ;;AyEjyRQ;EAOI,iEAAA;EAAA,8DAAA;AzE+xRZ;;AyEtyRQ;EAOI,yCAAA;EAAA,sCAAA;AzEoyRZ;;AyE3yRQ;EAOI,kEAAA;EAAA,+DAAA;AzEyyRZ;;AyEhzRQ;EAOI,8BAAA;AzE6yRZ;;AyEpzRQ;EAOI,6BAAA;AzEizRZ;;AyExzRQ;EAOI,sBAAA;AzEqzRZ;;AyE5zRQ;EAOI,qBAAA;AzEyzRZ;;AyEh0RQ;EAOI,qBAAA;AzE6zRZ;;AyEp0RQ;EAOI,qBAAA;AzEi0RZ;;AyEx0RQ;EAOI,qBAAA;AzEq0RZ;;Ae/0RI;E0DGI;IAOI,sBAAA;EzE00RV;EyEj1RM;IAOI,uBAAA;EzE60RV;EyEp1RM;IAOI,sBAAA;EzEg1RV;EyEv1RM;IAOI,8BAAA;EzEm1RV;EyE11RM;IAOI,4BAAA;EzEs1RV;EyE71RM;IAOI,2BAAA;EzEy1RV;EyEh2RM;IAOI,iCAAA;EzE41RV;EyEn2RM;IAOI,2BAAA;EzE+1RV;EyEt2RM;IAOI,0BAAA;EzEk2RV;EyEz2RM;IAOI,gCAAA;EzEq2RV;EyE52RM;IAOI,yBAAA;EzEw2RV;EyE/2RM;IAOI,wBAAA;EzE22RV;EyEl3RM;IAOI,+BAAA;EzE82RV;EyEr3RM;IAOI,yBAAA;EzEi3RV;EyEx3RM;IAOI,6BAAA;EzEo3RV;EyE33RM;IAOI,8BAAA;EzEu3RV;EyE93RM;IAOI,wBAAA;EzE03RV;EyEj4RM;IAOI,+BAAA;EzE63RV;EyEp4RM;IAOI,wBAAA;EzEg4RV;EyEv4RM;IAOI,yBAAA;EzEm4RV;EyE14RM;IAOI,8BAAA;EzEs4RV;EyE74RM;IAOI,iCAAA;EzEy4RV;EyEh5RM;IAOI,sCAAA;EzE44RV;EyEn5RM;IAOI,yCAAA;EzE+4RV;EyEt5RM;IAOI,uBAAA;EzEk5RV;EyEz5RM;IAOI,uBAAA;EzEq5RV;EyE55RM;IAOI,yBAAA;EzEw5RV;EyE/5RM;IAOI,yBAAA;EzE25RV;EyEl6RM;IAOI,0BAAA;EzE85RV;EyEr6RM;IAOI,4BAAA;EzEi6RV;EyEx6RM;IAOI,kCAAA;EzEo6RV;EyE36RM;IAOI,sCAAA;EzEu6RV;EyE96RM;IAOI,oCAAA;EzE06RV;EyEj7RM;IAOI,kCAAA;EzE66RV;EyEp7RM;IAOI,yCAAA;EzEg7RV;EyEv7RM;IAOI,wCAAA;EzEm7RV;EyE17RM;IAOI,wCAAA;EzEs7RV;EyE77RM;IAOI,kCAAA;EzEy7RV;EyEh8RM;IAOI,gCAAA;EzE47RV;EyEn8RM;IAOI,8BAAA;EzE+7RV;EyEt8RM;IAOI,gCAAA;EzEk8RV;EyEz8RM;IAOI,+BAAA;EzEq8RV;EyE58RM;IAOI,oCAAA;EzEw8RV;EyE/8RM;IAOI,kCAAA;EzE28RV;EyEl9RM;IAOI,gCAAA;EzE88RV;EyEr9RM;IAOI,uCAAA;EzEi9RV;EyEx9RM;IAOI,sCAAA;EzEo9RV;EyE39RM;IAOI,iCAAA;EzEu9RV;EyE99RM;IAOI,2BAAA;EzE09RV;EyEj+RM;IAOI,iCAAA;EzE69RV;EyEp+RM;IAOI,+BAAA;EzEg+RV;EyEv+RM;IAOI,6BAAA;EzEm+RV;EyE1+RM;IAOI,+BAAA;EzEs+RV;EyE7+RM;IAOI,8BAAA;EzEy+RV;EyEh/RM;IAOI,oBAAA;EzE4+RV;EyEn/RM;IAOI,mBAAA;EzE++RV;EyEt/RM;IAOI,mBAAA;EzEk/RV;EyEz/RM;IAOI,mBAAA;EzEq/RV;EyE5/RM;IAOI,mBAAA;EzEw/RV;EyE//RM;IAOI,mBAAA;EzE2/RV;EyElgSM;IAOI,mBAAA;EzE8/RV;EyErgSM;IAOI,mBAAA;EzEigSV;EyExgSM;IAOI,oBAAA;EzEogSV;EyE3gSM;IAOI,0BAAA;EzEugSV;EyE9gSM;IAOI,yBAAA;EzE0gSV;EyEjhSM;IAOI,uBAAA;EzE6gSV;EyEphSM;IAOI,yBAAA;EzEghSV;EyEvhSM;IAOI,uBAAA;EzEmhSV;EyE1hSM;IAOI,uBAAA;EzEshSV;EyE7hSM;IAOI,0BAAA;IAAA,yBAAA;EzE0hSV;EyEjiSM;IAOI,gCAAA;IAAA,+BAAA;EzE8hSV;EyEriSM;IAOI,+BAAA;IAAA,8BAAA;EzEkiSV;EyEziSM;IAOI,6BAAA;IAAA,4BAAA;EzEsiSV;EyE7iSM;IAOI,+BAAA;IAAA,8BAAA;EzE0iSV;EyEjjSM;IAOI,6BAAA;IAAA,4BAAA;EzE8iSV;EyErjSM;IAOI,6BAAA;IAAA,4BAAA;EzEkjSV;EyEzjSM;IAOI,wBAAA;IAAA,2BAAA;EzEsjSV;EyE7jSM;IAOI,8BAAA;IAAA,iCAAA;EzE0jSV;EyEjkSM;IAOI,6BAAA;IAAA,gCAAA;EzE8jSV;EyErkSM;IAOI,2BAAA;IAAA,8BAAA;EzEkkSV;EyEzkSM;IAOI,6BAAA;IAAA,gCAAA;EzEskSV;EyE7kSM;IAOI,2BAAA;IAAA,8BAAA;EzE0kSV;EyEjlSM;IAOI,2BAAA;IAAA,8BAAA;EzE8kSV;EyErlSM;IAOI,wBAAA;EzEilSV;EyExlSM;IAOI,8BAAA;EzEolSV;EyE3lSM;IAOI,6BAAA;EzEulSV;EyE9lSM;IAOI,2BAAA;EzE0lSV;EyEjmSM;IAOI,6BAAA;EzE6lSV;EyEpmSM;IAOI,2BAAA;EzEgmSV;EyEvmSM;IAOI,2BAAA;EzEmmSV;EyE1mSM;IAOI,0BAAA;EzEsmSV;EyE7mSM;IAOI,gCAAA;EzEymSV;EyEhnSM;IAOI,+BAAA;EzE4mSV;EyEnnSM;IAOI,6BAAA;EzE+mSV;EyEtnSM;IAOI,+BAAA;EzEknSV;EyEznSM;IAOI,6BAAA;EzEqnSV;EyE5nSM;IAOI,6BAAA;EzEwnSV;EyE/nSM;IAOI,2BAAA;EzE2nSV;EyEloSM;IAOI,iCAAA;EzE8nSV;EyEroSM;IAOI,gCAAA;EzEioSV;EyExoSM;IAOI,8BAAA;EzEooSV;EyE3oSM;IAOI,gCAAA;EzEuoSV;EyE9oSM;IAOI,8BAAA;EzE0oSV;EyEjpSM;IAOI,8BAAA;EzE6oSV;EyEppSM;IAOI,yBAAA;EzEgpSV;EyEvpSM;IAOI,+BAAA;EzEmpSV;EyE1pSM;IAOI,8BAAA;EzEspSV;EyE7pSM;IAOI,4BAAA;EzEypSV;EyEhqSM;IAOI,8BAAA;EzE4pSV;EyEnqSM;IAOI,4BAAA;EzE+pSV;EyEtqSM;IAOI,4BAAA;EzEkqSV;EyEzqSM;IAOI,qBAAA;EzEqqSV;EyE5qSM;IAOI,2BAAA;EzEwqSV;EyE/qSM;IAOI,0BAAA;EzE2qSV;EyElrSM;IAOI,wBAAA;EzE8qSV;EyErrSM;IAOI,0BAAA;EzEirSV;EyExrSM;IAOI,wBAAA;EzEorSV;EyE3rSM;IAOI,2BAAA;IAAA,0BAAA;EzEwrSV;EyE/rSM;IAOI,iCAAA;IAAA,gCAAA;EzE4rSV;EyEnsSM;IAOI,gCAAA;IAAA,+BAAA;EzEgsSV;EyEvsSM;IAOI,8BAAA;IAAA,6BAAA;EzEosSV;EyE3sSM;IAOI,gCAAA;IAAA,+BAAA;EzEwsSV;EyE/sSM;IAOI,8BAAA;IAAA,6BAAA;EzE4sSV;EyEntSM;IAOI,yBAAA;IAAA,4BAAA;EzEgtSV;EyEvtSM;IAOI,+BAAA;IAAA,kCAAA;EzEotSV;EyE3tSM;IAOI,8BAAA;IAAA,iCAAA;EzEwtSV;EyE/tSM;IAOI,4BAAA;IAAA,+BAAA;EzE4tSV;EyEnuSM;IAOI,8BAAA;IAAA,iCAAA;EzEguSV;EyEvuSM;IAOI,4BAAA;IAAA,+BAAA;EzEouSV;EyE3uSM;IAOI,yBAAA;EzEuuSV;EyE9uSM;IAOI,+BAAA;EzE0uSV;EyEjvSM;IAOI,8BAAA;EzE6uSV;EyEpvSM;IAOI,4BAAA;EzEgvSV;EyEvvSM;IAOI,8BAAA;EzEmvSV;EyE1vSM;IAOI,4BAAA;EzEsvSV;EyE7vSM;IAOI,2BAAA;EzEyvSV;EyEhwSM;IAOI,iCAAA;EzE4vSV;EyEnwSM;IAOI,gCAAA;EzE+vSV;EyEtwSM;IAOI,8BAAA;EzEkwSV;EyEzwSM;IAOI,gCAAA;EzEqwSV;EyE5wSM;IAOI,8BAAA;EzEwwSV;EyE/wSM;IAOI,4BAAA;EzE2wSV;EyElxSM;IAOI,kCAAA;EzE8wSV;EyErxSM;IAOI,iCAAA;EzEixSV;EyExxSM;IAOI,+BAAA;EzEoxSV;EyE3xSM;IAOI,iCAAA;EzEuxSV;EyE9xSM;IAOI,+BAAA;EzE0xSV;EyEjySM;IAOI,0BAAA;EzE6xSV;EyEpySM;IAOI,gCAAA;EzEgySV;EyEvySM;IAOI,+BAAA;EzEmySV;EyE1ySM;IAOI,6BAAA;EzEsySV;EyE7ySM;IAOI,+BAAA;EzEyySV;EyEhzSM;IAOI,6BAAA;EzE4ySV;EyEnzSM;IAOI,iBAAA;EzE+ySV;EyEtzSM;IAOI,uBAAA;EzEkzSV;EyEzzSM;IAOI,sBAAA;EzEqzSV;EyE5zSM;IAOI,oBAAA;EzEwzSV;EyE/zSM;IAOI,sBAAA;EzE2zSV;EyEl0SM;IAOI,oBAAA;EzE8zSV;EyEr0SM;IAOI,qBAAA;EzEi0SV;EyEx0SM;IAOI,2BAAA;EzEo0SV;EyE30SM;IAOI,0BAAA;EzEu0SV;EyE90SM;IAOI,wBAAA;EzE00SV;EyEj1SM;IAOI,0BAAA;EzE60SV;EyEp1SM;IAOI,wBAAA;EzEg1SV;EyEv1SM;IAOI,wBAAA;EzEm1SV;EyE11SM;IAOI,8BAAA;EzEs1SV;EyE71SM;IAOI,6BAAA;EzEy1SV;EyEh2SM;IAOI,2BAAA;EzE41SV;EyEn2SM;IAOI,6BAAA;EzE+1SV;EyEt2SM;IAOI,2BAAA;EzEk2SV;EyEz2SM;IAOI,2BAAA;EzEq2SV;EyE52SM;IAOI,4BAAA;EzEw2SV;EyE/2SM;IAOI,6BAAA;EzE22SV;AACF;Aet3SI;E0DGI;IAOI,sBAAA;EzEg3SV;EyEv3SM;IAOI,uBAAA;EzEm3SV;EyE13SM;IAOI,sBAAA;EzEs3SV;EyE73SM;IAOI,8BAAA;EzEy3SV;EyEh4SM;IAOI,4BAAA;EzE43SV;EyEn4SM;IAOI,2BAAA;EzE+3SV;EyEt4SM;IAOI,iCAAA;EzEk4SV;EyEz4SM;IAOI,2BAAA;EzEq4SV;EyE54SM;IAOI,0BAAA;EzEw4SV;EyE/4SM;IAOI,gCAAA;EzE24SV;EyEl5SM;IAOI,yBAAA;EzE84SV;EyEr5SM;IAOI,wBAAA;EzEi5SV;EyEx5SM;IAOI,+BAAA;EzEo5SV;EyE35SM;IAOI,yBAAA;EzEu5SV;EyE95SM;IAOI,6BAAA;EzE05SV;EyEj6SM;IAOI,8BAAA;EzE65SV;EyEp6SM;IAOI,wBAAA;EzEg6SV;EyEv6SM;IAOI,+BAAA;EzEm6SV;EyE16SM;IAOI,wBAAA;EzEs6SV;EyE76SM;IAOI,yBAAA;EzEy6SV;EyEh7SM;IAOI,8BAAA;EzE46SV;EyEn7SM;IAOI,iCAAA;EzE+6SV;EyEt7SM;IAOI,sCAAA;EzEk7SV;EyEz7SM;IAOI,yCAAA;EzEq7SV;EyE57SM;IAOI,uBAAA;EzEw7SV;EyE/7SM;IAOI,uBAAA;EzE27SV;EyEl8SM;IAOI,yBAAA;EzE87SV;EyEr8SM;IAOI,yBAAA;EzEi8SV;EyEx8SM;IAOI,0BAAA;EzEo8SV;EyE38SM;IAOI,4BAAA;EzEu8SV;EyE98SM;IAOI,kCAAA;EzE08SV;EyEj9SM;IAOI,sCAAA;EzE68SV;EyEp9SM;IAOI,oCAAA;EzEg9SV;EyEv9SM;IAOI,kCAAA;EzEm9SV;EyE19SM;IAOI,yCAAA;EzEs9SV;EyE79SM;IAOI,wCAAA;EzEy9SV;EyEh+SM;IAOI,wCAAA;EzE49SV;EyEn+SM;IAOI,kCAAA;EzE+9SV;EyEt+SM;IAOI,gCAAA;EzEk+SV;EyEz+SM;IAOI,8BAAA;EzEq+SV;EyE5+SM;IAOI,gCAAA;EzEw+SV;EyE/+SM;IAOI,+BAAA;EzE2+SV;EyEl/SM;IAOI,oCAAA;EzE8+SV;EyEr/SM;IAOI,kCAAA;EzEi/SV;EyEx/SM;IAOI,gCAAA;EzEo/SV;EyE3/SM;IAOI,uCAAA;EzEu/SV;EyE9/SM;IAOI,sCAAA;EzE0/SV;EyEjgTM;IAOI,iCAAA;EzE6/SV;EyEpgTM;IAOI,2BAAA;EzEggTV;EyEvgTM;IAOI,iCAAA;EzEmgTV;EyE1gTM;IAOI,+BAAA;EzEsgTV;EyE7gTM;IAOI,6BAAA;EzEygTV;EyEhhTM;IAOI,+BAAA;EzE4gTV;EyEnhTM;IAOI,8BAAA;EzE+gTV;EyEthTM;IAOI,oBAAA;EzEkhTV;EyEzhTM;IAOI,mBAAA;EzEqhTV;EyE5hTM;IAOI,mBAAA;EzEwhTV;EyE/hTM;IAOI,mBAAA;EzE2hTV;EyEliTM;IAOI,mBAAA;EzE8hTV;EyEriTM;IAOI,mBAAA;EzEiiTV;EyExiTM;IAOI,mBAAA;EzEoiTV;EyE3iTM;IAOI,mBAAA;EzEuiTV;EyE9iTM;IAOI,oBAAA;EzE0iTV;EyEjjTM;IAOI,0BAAA;EzE6iTV;EyEpjTM;IAOI,yBAAA;EzEgjTV;EyEvjTM;IAOI,uBAAA;EzEmjTV;EyE1jTM;IAOI,yBAAA;EzEsjTV;EyE7jTM;IAOI,uBAAA;EzEyjTV;EyEhkTM;IAOI,uBAAA;EzE4jTV;EyEnkTM;IAOI,0BAAA;IAAA,yBAAA;EzEgkTV;EyEvkTM;IAOI,gCAAA;IAAA,+BAAA;EzEokTV;EyE3kTM;IAOI,+BAAA;IAAA,8BAAA;EzEwkTV;EyE/kTM;IAOI,6BAAA;IAAA,4BAAA;EzE4kTV;EyEnlTM;IAOI,+BAAA;IAAA,8BAAA;EzEglTV;EyEvlTM;IAOI,6BAAA;IAAA,4BAAA;EzEolTV;EyE3lTM;IAOI,6BAAA;IAAA,4BAAA;EzEwlTV;EyE/lTM;IAOI,wBAAA;IAAA,2BAAA;EzE4lTV;EyEnmTM;IAOI,8BAAA;IAAA,iCAAA;EzEgmTV;EyEvmTM;IAOI,6BAAA;IAAA,gCAAA;EzEomTV;EyE3mTM;IAOI,2BAAA;IAAA,8BAAA;EzEwmTV;EyE/mTM;IAOI,6BAAA;IAAA,gCAAA;EzE4mTV;EyEnnTM;IAOI,2BAAA;IAAA,8BAAA;EzEgnTV;EyEvnTM;IAOI,2BAAA;IAAA,8BAAA;EzEonTV;EyE3nTM;IAOI,wBAAA;EzEunTV;EyE9nTM;IAOI,8BAAA;EzE0nTV;EyEjoTM;IAOI,6BAAA;EzE6nTV;EyEpoTM;IAOI,2BAAA;EzEgoTV;EyEvoTM;IAOI,6BAAA;EzEmoTV;EyE1oTM;IAOI,2BAAA;EzEsoTV;EyE7oTM;IAOI,2BAAA;EzEyoTV;EyEhpTM;IAOI,0BAAA;EzE4oTV;EyEnpTM;IAOI,gCAAA;EzE+oTV;EyEtpTM;IAOI,+BAAA;EzEkpTV;EyEzpTM;IAOI,6BAAA;EzEqpTV;EyE5pTM;IAOI,+BAAA;EzEwpTV;EyE/pTM;IAOI,6BAAA;EzE2pTV;EyElqTM;IAOI,6BAAA;EzE8pTV;EyErqTM;IAOI,2BAAA;EzEiqTV;EyExqTM;IAOI,iCAAA;EzEoqTV;EyE3qTM;IAOI,gCAAA;EzEuqTV;EyE9qTM;IAOI,8BAAA;EzE0qTV;EyEjrTM;IAOI,gCAAA;EzE6qTV;EyEprTM;IAOI,8BAAA;EzEgrTV;EyEvrTM;IAOI,8BAAA;EzEmrTV;EyE1rTM;IAOI,yBAAA;EzEsrTV;EyE7rTM;IAOI,+BAAA;EzEyrTV;EyEhsTM;IAOI,8BAAA;EzE4rTV;EyEnsTM;IAOI,4BAAA;EzE+rTV;EyEtsTM;IAOI,8BAAA;EzEksTV;EyEzsTM;IAOI,4BAAA;EzEqsTV;EyE5sTM;IAOI,4BAAA;EzEwsTV;EyE/sTM;IAOI,qBAAA;EzE2sTV;EyEltTM;IAOI,2BAAA;EzE8sTV;EyErtTM;IAOI,0BAAA;EzEitTV;EyExtTM;IAOI,wBAAA;EzEotTV;EyE3tTM;IAOI,0BAAA;EzEutTV;EyE9tTM;IAOI,wBAAA;EzE0tTV;EyEjuTM;IAOI,2BAAA;IAAA,0BAAA;EzE8tTV;EyEruTM;IAOI,iCAAA;IAAA,gCAAA;EzEkuTV;EyEzuTM;IAOI,gCAAA;IAAA,+BAAA;EzEsuTV;EyE7uTM;IAOI,8BAAA;IAAA,6BAAA;EzE0uTV;EyEjvTM;IAOI,gCAAA;IAAA,+BAAA;EzE8uTV;EyErvTM;IAOI,8BAAA;IAAA,6BAAA;EzEkvTV;EyEzvTM;IAOI,yBAAA;IAAA,4BAAA;EzEsvTV;EyE7vTM;IAOI,+BAAA;IAAA,kCAAA;EzE0vTV;EyEjwTM;IAOI,8BAAA;IAAA,iCAAA;EzE8vTV;EyErwTM;IAOI,4BAAA;IAAA,+BAAA;EzEkwTV;EyEzwTM;IAOI,8BAAA;IAAA,iCAAA;EzEswTV;EyE7wTM;IAOI,4BAAA;IAAA,+BAAA;EzE0wTV;EyEjxTM;IAOI,yBAAA;EzE6wTV;EyEpxTM;IAOI,+BAAA;EzEgxTV;EyEvxTM;IAOI,8BAAA;EzEmxTV;EyE1xTM;IAOI,4BAAA;EzEsxTV;EyE7xTM;IAOI,8BAAA;EzEyxTV;EyEhyTM;IAOI,4BAAA;EzE4xTV;EyEnyTM;IAOI,2BAAA;EzE+xTV;EyEtyTM;IAOI,iCAAA;EzEkyTV;EyEzyTM;IAOI,gCAAA;EzEqyTV;EyE5yTM;IAOI,8BAAA;EzEwyTV;EyE/yTM;IAOI,gCAAA;EzE2yTV;EyElzTM;IAOI,8BAAA;EzE8yTV;EyErzTM;IAOI,4BAAA;EzEizTV;EyExzTM;IAOI,kCAAA;EzEozTV;EyE3zTM;IAOI,iCAAA;EzEuzTV;EyE9zTM;IAOI,+BAAA;EzE0zTV;EyEj0TM;IAOI,iCAAA;EzE6zTV;EyEp0TM;IAOI,+BAAA;EzEg0TV;EyEv0TM;IAOI,0BAAA;EzEm0TV;EyE10TM;IAOI,gCAAA;EzEs0TV;EyE70TM;IAOI,+BAAA;EzEy0TV;EyEh1TM;IAOI,6BAAA;EzE40TV;EyEn1TM;IAOI,+BAAA;EzE+0TV;EyEt1TM;IAOI,6BAAA;EzEk1TV;EyEz1TM;IAOI,iBAAA;EzEq1TV;EyE51TM;IAOI,uBAAA;EzEw1TV;EyE/1TM;IAOI,sBAAA;EzE21TV;EyEl2TM;IAOI,oBAAA;EzE81TV;EyEr2TM;IAOI,sBAAA;EzEi2TV;EyEx2TM;IAOI,oBAAA;EzEo2TV;EyE32TM;IAOI,qBAAA;EzEu2TV;EyE92TM;IAOI,2BAAA;EzE02TV;EyEj3TM;IAOI,0BAAA;EzE62TV;EyEp3TM;IAOI,wBAAA;EzEg3TV;EyEv3TM;IAOI,0BAAA;EzEm3TV;EyE13TM;IAOI,wBAAA;EzEs3TV;EyE73TM;IAOI,wBAAA;EzEy3TV;EyEh4TM;IAOI,8BAAA;EzE43TV;EyEn4TM;IAOI,6BAAA;EzE+3TV;EyEt4TM;IAOI,2BAAA;EzEk4TV;EyEz4TM;IAOI,6BAAA;EzEq4TV;EyE54TM;IAOI,2BAAA;EzEw4TV;EyE/4TM;IAOI,2BAAA;EzE24TV;EyEl5TM;IAOI,4BAAA;EzE84TV;EyEr5TM;IAOI,6BAAA;EzEi5TV;AACF;Ae55TI;E0DGI;IAOI,sBAAA;EzEs5TV;EyE75TM;IAOI,uBAAA;EzEy5TV;EyEh6TM;IAOI,sBAAA;EzE45TV;EyEn6TM;IAOI,8BAAA;EzE+5TV;EyEt6TM;IAOI,4BAAA;EzEk6TV;EyEz6TM;IAOI,2BAAA;EzEq6TV;EyE56TM;IAOI,iCAAA;EzEw6TV;EyE/6TM;IAOI,2BAAA;EzE26TV;EyEl7TM;IAOI,0BAAA;EzE86TV;EyEr7TM;IAOI,gCAAA;EzEi7TV;EyEx7TM;IAOI,yBAAA;EzEo7TV;EyE37TM;IAOI,wBAAA;EzEu7TV;EyE97TM;IAOI,+BAAA;EzE07TV;EyEj8TM;IAOI,yBAAA;EzE67TV;EyEp8TM;IAOI,6BAAA;EzEg8TV;EyEv8TM;IAOI,8BAAA;EzEm8TV;EyE18TM;IAOI,wBAAA;EzEs8TV;EyE78TM;IAOI,+BAAA;EzEy8TV;EyEh9TM;IAOI,wBAAA;EzE48TV;EyEn9TM;IAOI,yBAAA;EzE+8TV;EyEt9TM;IAOI,8BAAA;EzEk9TV;EyEz9TM;IAOI,iCAAA;EzEq9TV;EyE59TM;IAOI,sCAAA;EzEw9TV;EyE/9TM;IAOI,yCAAA;EzE29TV;EyEl+TM;IAOI,uBAAA;EzE89TV;EyEr+TM;IAOI,uBAAA;EzEi+TV;EyEx+TM;IAOI,yBAAA;EzEo+TV;EyE3+TM;IAOI,yBAAA;EzEu+TV;EyE9+TM;IAOI,0BAAA;EzE0+TV;EyEj/TM;IAOI,4BAAA;EzE6+TV;EyEp/TM;IAOI,kCAAA;EzEg/TV;EyEv/TM;IAOI,sCAAA;EzEm/TV;EyE1/TM;IAOI,oCAAA;EzEs/TV;EyE7/TM;IAOI,kCAAA;EzEy/TV;EyEhgUM;IAOI,yCAAA;EzE4/TV;EyEngUM;IAOI,wCAAA;EzE+/TV;EyEtgUM;IAOI,wCAAA;EzEkgUV;EyEzgUM;IAOI,kCAAA;EzEqgUV;EyE5gUM;IAOI,gCAAA;EzEwgUV;EyE/gUM;IAOI,8BAAA;EzE2gUV;EyElhUM;IAOI,gCAAA;EzE8gUV;EyErhUM;IAOI,+BAAA;EzEihUV;EyExhUM;IAOI,oCAAA;EzEohUV;EyE3hUM;IAOI,kCAAA;EzEuhUV;EyE9hUM;IAOI,gCAAA;EzE0hUV;EyEjiUM;IAOI,uCAAA;EzE6hUV;EyEpiUM;IAOI,sCAAA;EzEgiUV;EyEviUM;IAOI,iCAAA;EzEmiUV;EyE1iUM;IAOI,2BAAA;EzEsiUV;EyE7iUM;IAOI,iCAAA;EzEyiUV;EyEhjUM;IAOI,+BAAA;EzE4iUV;EyEnjUM;IAOI,6BAAA;EzE+iUV;EyEtjUM;IAOI,+BAAA;EzEkjUV;EyEzjUM;IAOI,8BAAA;EzEqjUV;EyE5jUM;IAOI,oBAAA;EzEwjUV;EyE/jUM;IAOI,mBAAA;EzE2jUV;EyElkUM;IAOI,mBAAA;EzE8jUV;EyErkUM;IAOI,mBAAA;EzEikUV;EyExkUM;IAOI,mBAAA;EzEokUV;EyE3kUM;IAOI,mBAAA;EzEukUV;EyE9kUM;IAOI,mBAAA;EzE0kUV;EyEjlUM;IAOI,mBAAA;EzE6kUV;EyEplUM;IAOI,oBAAA;EzEglUV;EyEvlUM;IAOI,0BAAA;EzEmlUV;EyE1lUM;IAOI,yBAAA;EzEslUV;EyE7lUM;IAOI,uBAAA;EzEylUV;EyEhmUM;IAOI,yBAAA;EzE4lUV;EyEnmUM;IAOI,uBAAA;EzE+lUV;EyEtmUM;IAOI,uBAAA;EzEkmUV;EyEzmUM;IAOI,0BAAA;IAAA,yBAAA;EzEsmUV;EyE7mUM;IAOI,gCAAA;IAAA,+BAAA;EzE0mUV;EyEjnUM;IAOI,+BAAA;IAAA,8BAAA;EzE8mUV;EyErnUM;IAOI,6BAAA;IAAA,4BAAA;EzEknUV;EyEznUM;IAOI,+BAAA;IAAA,8BAAA;EzEsnUV;EyE7nUM;IAOI,6BAAA;IAAA,4BAAA;EzE0nUV;EyEjoUM;IAOI,6BAAA;IAAA,4BAAA;EzE8nUV;EyEroUM;IAOI,wBAAA;IAAA,2BAAA;EzEkoUV;EyEzoUM;IAOI,8BAAA;IAAA,iCAAA;EzEsoUV;EyE7oUM;IAOI,6BAAA;IAAA,gCAAA;EzE0oUV;EyEjpUM;IAOI,2BAAA;IAAA,8BAAA;EzE8oUV;EyErpUM;IAOI,6BAAA;IAAA,gCAAA;EzEkpUV;EyEzpUM;IAOI,2BAAA;IAAA,8BAAA;EzEspUV;EyE7pUM;IAOI,2BAAA;IAAA,8BAAA;EzE0pUV;EyEjqUM;IAOI,wBAAA;EzE6pUV;EyEpqUM;IAOI,8BAAA;EzEgqUV;EyEvqUM;IAOI,6BAAA;EzEmqUV;EyE1qUM;IAOI,2BAAA;EzEsqUV;EyE7qUM;IAOI,6BAAA;EzEyqUV;EyEhrUM;IAOI,2BAAA;EzE4qUV;EyEnrUM;IAOI,2BAAA;EzE+qUV;EyEtrUM;IAOI,0BAAA;EzEkrUV;EyEzrUM;IAOI,gCAAA;EzEqrUV;EyE5rUM;IAOI,+BAAA;EzEwrUV;EyE/rUM;IAOI,6BAAA;EzE2rUV;EyElsUM;IAOI,+BAAA;EzE8rUV;EyErsUM;IAOI,6BAAA;EzEisUV;EyExsUM;IAOI,6BAAA;EzEosUV;EyE3sUM;IAOI,2BAAA;EzEusUV;EyE9sUM;IAOI,iCAAA;EzE0sUV;EyEjtUM;IAOI,gCAAA;EzE6sUV;EyEptUM;IAOI,8BAAA;EzEgtUV;EyEvtUM;IAOI,gCAAA;EzEmtUV;EyE1tUM;IAOI,8BAAA;EzEstUV;EyE7tUM;IAOI,8BAAA;EzEytUV;EyEhuUM;IAOI,yBAAA;EzE4tUV;EyEnuUM;IAOI,+BAAA;EzE+tUV;EyEtuUM;IAOI,8BAAA;EzEkuUV;EyEzuUM;IAOI,4BAAA;EzEquUV;EyE5uUM;IAOI,8BAAA;EzEwuUV;EyE/uUM;IAOI,4BAAA;EzE2uUV;EyElvUM;IAOI,4BAAA;EzE8uUV;EyErvUM;IAOI,qBAAA;EzEivUV;EyExvUM;IAOI,2BAAA;EzEovUV;EyE3vUM;IAOI,0BAAA;EzEuvUV;EyE9vUM;IAOI,wBAAA;EzE0vUV;EyEjwUM;IAOI,0BAAA;EzE6vUV;EyEpwUM;IAOI,wBAAA;EzEgwUV;EyEvwUM;IAOI,2BAAA;IAAA,0BAAA;EzEowUV;EyE3wUM;IAOI,iCAAA;IAAA,gCAAA;EzEwwUV;EyE/wUM;IAOI,gCAAA;IAAA,+BAAA;EzE4wUV;EyEnxUM;IAOI,8BAAA;IAAA,6BAAA;EzEgxUV;EyEvxUM;IAOI,gCAAA;IAAA,+BAAA;EzEoxUV;EyE3xUM;IAOI,8BAAA;IAAA,6BAAA;EzEwxUV;EyE/xUM;IAOI,yBAAA;IAAA,4BAAA;EzE4xUV;EyEnyUM;IAOI,+BAAA;IAAA,kCAAA;EzEgyUV;EyEvyUM;IAOI,8BAAA;IAAA,iCAAA;EzEoyUV;EyE3yUM;IAOI,4BAAA;IAAA,+BAAA;EzEwyUV;EyE/yUM;IAOI,8BAAA;IAAA,iCAAA;EzE4yUV;EyEnzUM;IAOI,4BAAA;IAAA,+BAAA;EzEgzUV;EyEvzUM;IAOI,yBAAA;EzEmzUV;EyE1zUM;IAOI,+BAAA;EzEszUV;EyE7zUM;IAOI,8BAAA;EzEyzUV;EyEh0UM;IAOI,4BAAA;EzE4zUV;EyEn0UM;IAOI,8BAAA;EzE+zUV;EyEt0UM;IAOI,4BAAA;EzEk0UV;EyEz0UM;IAOI,2BAAA;EzEq0UV;EyE50UM;IAOI,iCAAA;EzEw0UV;EyE/0UM;IAOI,gCAAA;EzE20UV;EyEl1UM;IAOI,8BAAA;EzE80UV;EyEr1UM;IAOI,gCAAA;EzEi1UV;EyEx1UM;IAOI,8BAAA;EzEo1UV;EyE31UM;IAOI,4BAAA;EzEu1UV;EyE91UM;IAOI,kCAAA;EzE01UV;EyEj2UM;IAOI,iCAAA;EzE61UV;EyEp2UM;IAOI,+BAAA;EzEg2UV;EyEv2UM;IAOI,iCAAA;EzEm2UV;EyE12UM;IAOI,+BAAA;EzEs2UV;EyE72UM;IAOI,0BAAA;EzEy2UV;EyEh3UM;IAOI,gCAAA;EzE42UV;EyEn3UM;IAOI,+BAAA;EzE+2UV;EyEt3UM;IAOI,6BAAA;EzEk3UV;EyEz3UM;IAOI,+BAAA;EzEq3UV;EyE53UM;IAOI,6BAAA;EzEw3UV;EyE/3UM;IAOI,iBAAA;EzE23UV;EyEl4UM;IAOI,uBAAA;EzE83UV;EyEr4UM;IAOI,sBAAA;EzEi4UV;EyEx4UM;IAOI,oBAAA;EzEo4UV;EyE34UM;IAOI,sBAAA;EzEu4UV;EyE94UM;IAOI,oBAAA;EzE04UV;EyEj5UM;IAOI,qBAAA;EzE64UV;EyEp5UM;IAOI,2BAAA;EzEg5UV;EyEv5UM;IAOI,0BAAA;EzEm5UV;EyE15UM;IAOI,wBAAA;EzEs5UV;EyE75UM;IAOI,0BAAA;EzEy5UV;EyEh6UM;IAOI,wBAAA;EzE45UV;EyEn6UM;IAOI,wBAAA;EzE+5UV;EyEt6UM;IAOI,8BAAA;EzEk6UV;EyEz6UM;IAOI,6BAAA;EzEq6UV;EyE56UM;IAOI,2BAAA;EzEw6UV;EyE/6UM;IAOI,6BAAA;EzE26UV;EyEl7UM;IAOI,2BAAA;EzE86UV;EyEr7UM;IAOI,2BAAA;EzEi7UV;EyEx7UM;IAOI,4BAAA;EzEo7UV;EyE37UM;IAOI,6BAAA;EzEu7UV;AACF;Ael8UI;E0DGI;IAOI,sBAAA;EzE47UV;EyEn8UM;IAOI,uBAAA;EzE+7UV;EyEt8UM;IAOI,sBAAA;EzEk8UV;EyEz8UM;IAOI,8BAAA;EzEq8UV;EyE58UM;IAOI,4BAAA;EzEw8UV;EyE/8UM;IAOI,2BAAA;EzE28UV;EyEl9UM;IAOI,iCAAA;EzE88UV;EyEr9UM;IAOI,2BAAA;EzEi9UV;EyEx9UM;IAOI,0BAAA;EzEo9UV;EyE39UM;IAOI,gCAAA;EzEu9UV;EyE99UM;IAOI,yBAAA;EzE09UV;EyEj+UM;IAOI,wBAAA;EzE69UV;EyEp+UM;IAOI,+BAAA;EzEg+UV;EyEv+UM;IAOI,yBAAA;EzEm+UV;EyE1+UM;IAOI,6BAAA;EzEs+UV;EyE7+UM;IAOI,8BAAA;EzEy+UV;EyEh/UM;IAOI,wBAAA;EzE4+UV;EyEn/UM;IAOI,+BAAA;EzE++UV;EyEt/UM;IAOI,wBAAA;EzEk/UV;EyEz/UM;IAOI,yBAAA;EzEq/UV;EyE5/UM;IAOI,8BAAA;EzEw/UV;EyE//UM;IAOI,iCAAA;EzE2/UV;EyElgVM;IAOI,sCAAA;EzE8/UV;EyErgVM;IAOI,yCAAA;EzEigVV;EyExgVM;IAOI,uBAAA;EzEogVV;EyE3gVM;IAOI,uBAAA;EzEugVV;EyE9gVM;IAOI,yBAAA;EzE0gVV;EyEjhVM;IAOI,yBAAA;EzE6gVV;EyEphVM;IAOI,0BAAA;EzEghVV;EyEvhVM;IAOI,4BAAA;EzEmhVV;EyE1hVM;IAOI,kCAAA;EzEshVV;EyE7hVM;IAOI,sCAAA;EzEyhVV;EyEhiVM;IAOI,oCAAA;EzE4hVV;EyEniVM;IAOI,kCAAA;EzE+hVV;EyEtiVM;IAOI,yCAAA;EzEkiVV;EyEziVM;IAOI,wCAAA;EzEqiVV;EyE5iVM;IAOI,wCAAA;EzEwiVV;EyE/iVM;IAOI,kCAAA;EzE2iVV;EyEljVM;IAOI,gCAAA;EzE8iVV;EyErjVM;IAOI,8BAAA;EzEijVV;EyExjVM;IAOI,gCAAA;EzEojVV;EyE3jVM;IAOI,+BAAA;EzEujVV;EyE9jVM;IAOI,oCAAA;EzE0jVV;EyEjkVM;IAOI,kCAAA;EzE6jVV;EyEpkVM;IAOI,gCAAA;EzEgkVV;EyEvkVM;IAOI,uCAAA;EzEmkVV;EyE1kVM;IAOI,sCAAA;EzEskVV;EyE7kVM;IAOI,iCAAA;EzEykVV;EyEhlVM;IAOI,2BAAA;EzE4kVV;EyEnlVM;IAOI,iCAAA;EzE+kVV;EyEtlVM;IAOI,+BAAA;EzEklVV;EyEzlVM;IAOI,6BAAA;EzEqlVV;EyE5lVM;IAOI,+BAAA;EzEwlVV;EyE/lVM;IAOI,8BAAA;EzE2lVV;EyElmVM;IAOI,oBAAA;EzE8lVV;EyErmVM;IAOI,mBAAA;EzEimVV;EyExmVM;IAOI,mBAAA;EzEomVV;EyE3mVM;IAOI,mBAAA;EzEumVV;EyE9mVM;IAOI,mBAAA;EzE0mVV;EyEjnVM;IAOI,mBAAA;EzE6mVV;EyEpnVM;IAOI,mBAAA;EzEgnVV;EyEvnVM;IAOI,mBAAA;EzEmnVV;EyE1nVM;IAOI,oBAAA;EzEsnVV;EyE7nVM;IAOI,0BAAA;EzEynVV;EyEhoVM;IAOI,yBAAA;EzE4nVV;EyEnoVM;IAOI,uBAAA;EzE+nVV;EyEtoVM;IAOI,yBAAA;EzEkoVV;EyEzoVM;IAOI,uBAAA;EzEqoVV;EyE5oVM;IAOI,uBAAA;EzEwoVV;EyE/oVM;IAOI,0BAAA;IAAA,yBAAA;EzE4oVV;EyEnpVM;IAOI,gCAAA;IAAA,+BAAA;EzEgpVV;EyEvpVM;IAOI,+BAAA;IAAA,8BAAA;EzEopVV;EyE3pVM;IAOI,6BAAA;IAAA,4BAAA;EzEwpVV;EyE/pVM;IAOI,+BAAA;IAAA,8BAAA;EzE4pVV;EyEnqVM;IAOI,6BAAA;IAAA,4BAAA;EzEgqVV;EyEvqVM;IAOI,6BAAA;IAAA,4BAAA;EzEoqVV;EyE3qVM;IAOI,wBAAA;IAAA,2BAAA;EzEwqVV;EyE/qVM;IAOI,8BAAA;IAAA,iCAAA;EzE4qVV;EyEnrVM;IAOI,6BAAA;IAAA,gCAAA;EzEgrVV;EyEvrVM;IAOI,2BAAA;IAAA,8BAAA;EzEorVV;EyE3rVM;IAOI,6BAAA;IAAA,gCAAA;EzEwrVV;EyE/rVM;IAOI,2BAAA;IAAA,8BAAA;EzE4rVV;EyEnsVM;IAOI,2BAAA;IAAA,8BAAA;EzEgsVV;EyEvsVM;IAOI,wBAAA;EzEmsVV;EyE1sVM;IAOI,8BAAA;EzEssVV;EyE7sVM;IAOI,6BAAA;EzEysVV;EyEhtVM;IAOI,2BAAA;EzE4sVV;EyEntVM;IAOI,6BAAA;EzE+sVV;EyEttVM;IAOI,2BAAA;EzEktVV;EyEztVM;IAOI,2BAAA;EzEqtVV;EyE5tVM;IAOI,0BAAA;EzEwtVV;EyE/tVM;IAOI,gCAAA;EzE2tVV;EyEluVM;IAOI,+BAAA;EzE8tVV;EyEruVM;IAOI,6BAAA;EzEiuVV;EyExuVM;IAOI,+BAAA;EzEouVV;EyE3uVM;IAOI,6BAAA;EzEuuVV;EyE9uVM;IAOI,6BAAA;EzE0uVV;EyEjvVM;IAOI,2BAAA;EzE6uVV;EyEpvVM;IAOI,iCAAA;EzEgvVV;EyEvvVM;IAOI,gCAAA;EzEmvVV;EyE1vVM;IAOI,8BAAA;EzEsvVV;EyE7vVM;IAOI,gCAAA;EzEyvVV;EyEhwVM;IAOI,8BAAA;EzE4vVV;EyEnwVM;IAOI,8BAAA;EzE+vVV;EyEtwVM;IAOI,yBAAA;EzEkwVV;EyEzwVM;IAOI,+BAAA;EzEqwVV;EyE5wVM;IAOI,8BAAA;EzEwwVV;EyE/wVM;IAOI,4BAAA;EzE2wVV;EyElxVM;IAOI,8BAAA;EzE8wVV;EyErxVM;IAOI,4BAAA;EzEixVV;EyExxVM;IAOI,4BAAA;EzEoxVV;EyE3xVM;IAOI,qBAAA;EzEuxVV;EyE9xVM;IAOI,2BAAA;EzE0xVV;EyEjyVM;IAOI,0BAAA;EzE6xVV;EyEpyVM;IAOI,wBAAA;EzEgyVV;EyEvyVM;IAOI,0BAAA;EzEmyVV;EyE1yVM;IAOI,wBAAA;EzEsyVV;EyE7yVM;IAOI,2BAAA;IAAA,0BAAA;EzE0yVV;EyEjzVM;IAOI,iCAAA;IAAA,gCAAA;EzE8yVV;EyErzVM;IAOI,gCAAA;IAAA,+BAAA;EzEkzVV;EyEzzVM;IAOI,8BAAA;IAAA,6BAAA;EzEszVV;EyE7zVM;IAOI,gCAAA;IAAA,+BAAA;EzE0zVV;EyEj0VM;IAOI,8BAAA;IAAA,6BAAA;EzE8zVV;EyEr0VM;IAOI,yBAAA;IAAA,4BAAA;EzEk0VV;EyEz0VM;IAOI,+BAAA;IAAA,kCAAA;EzEs0VV;EyE70VM;IAOI,8BAAA;IAAA,iCAAA;EzE00VV;EyEj1VM;IAOI,4BAAA;IAAA,+BAAA;EzE80VV;EyEr1VM;IAOI,8BAAA;IAAA,iCAAA;EzEk1VV;EyEz1VM;IAOI,4BAAA;IAAA,+BAAA;EzEs1VV;EyE71VM;IAOI,yBAAA;EzEy1VV;EyEh2VM;IAOI,+BAAA;EzE41VV;EyEn2VM;IAOI,8BAAA;EzE+1VV;EyEt2VM;IAOI,4BAAA;EzEk2VV;EyEz2VM;IAOI,8BAAA;EzEq2VV;EyE52VM;IAOI,4BAAA;EzEw2VV;EyE/2VM;IAOI,2BAAA;EzE22VV;EyEl3VM;IAOI,iCAAA;EzE82VV;EyEr3VM;IAOI,gCAAA;EzEi3VV;EyEx3VM;IAOI,8BAAA;EzEo3VV;EyE33VM;IAOI,gCAAA;EzEu3VV;EyE93VM;IAOI,8BAAA;EzE03VV;EyEj4VM;IAOI,4BAAA;EzE63VV;EyEp4VM;IAOI,kCAAA;EzEg4VV;EyEv4VM;IAOI,iCAAA;EzEm4VV;EyE14VM;IAOI,+BAAA;EzEs4VV;EyE74VM;IAOI,iCAAA;EzEy4VV;EyEh5VM;IAOI,+BAAA;EzE44VV;EyEn5VM;IAOI,0BAAA;EzE+4VV;EyEt5VM;IAOI,gCAAA;EzEk5VV;EyEz5VM;IAOI,+BAAA;EzEq5VV;EyE55VM;IAOI,6BAAA;EzEw5VV;EyE/5VM;IAOI,+BAAA;EzE25VV;EyEl6VM;IAOI,6BAAA;EzE85VV;EyEr6VM;IAOI,iBAAA;EzEi6VV;EyEx6VM;IAOI,uBAAA;EzEo6VV;EyE36VM;IAOI,sBAAA;EzEu6VV;EyE96VM;IAOI,oBAAA;EzE06VV;EyEj7VM;IAOI,sBAAA;EzE66VV;EyEp7VM;IAOI,oBAAA;EzEg7VV;EyEv7VM;IAOI,qBAAA;EzEm7VV;EyE17VM;IAOI,2BAAA;EzEs7VV;EyE77VM;IAOI,0BAAA;EzEy7VV;EyEh8VM;IAOI,wBAAA;EzE47VV;EyEn8VM;IAOI,0BAAA;EzE+7VV;EyEt8VM;IAOI,wBAAA;EzEk8VV;EyEz8VM;IAOI,wBAAA;EzEq8VV;EyE58VM;IAOI,8BAAA;EzEw8VV;EyE/8VM;IAOI,6BAAA;EzE28VV;EyEl9VM;IAOI,2BAAA;EzE88VV;EyEr9VM;IAOI,6BAAA;EzEi9VV;EyEx9VM;IAOI,2BAAA;EzEo9VV;EyE39VM;IAOI,2BAAA;EzEu9VV;EyE99VM;IAOI,4BAAA;EzE09VV;EyEj+VM;IAOI,6BAAA;EzE69VV;AACF;Aex+VI;E0DGI;IAOI,sBAAA;EzEk+VV;EyEz+VM;IAOI,uBAAA;EzEq+VV;EyE5+VM;IAOI,sBAAA;EzEw+VV;EyE/+VM;IAOI,8BAAA;EzE2+VV;EyEl/VM;IAOI,4BAAA;EzE8+VV;EyEr/VM;IAOI,2BAAA;EzEi/VV;EyEx/VM;IAOI,iCAAA;EzEo/VV;EyE3/VM;IAOI,2BAAA;EzEu/VV;EyE9/VM;IAOI,0BAAA;EzE0/VV;EyEjgWM;IAOI,gCAAA;EzE6/VV;EyEpgWM;IAOI,yBAAA;EzEggWV;EyEvgWM;IAOI,wBAAA;EzEmgWV;EyE1gWM;IAOI,+BAAA;EzEsgWV;EyE7gWM;IAOI,yBAAA;EzEygWV;EyEhhWM;IAOI,6BAAA;EzE4gWV;EyEnhWM;IAOI,8BAAA;EzE+gWV;EyEthWM;IAOI,wBAAA;EzEkhWV;EyEzhWM;IAOI,+BAAA;EzEqhWV;EyE5hWM;IAOI,wBAAA;EzEwhWV;EyE/hWM;IAOI,yBAAA;EzE2hWV;EyEliWM;IAOI,8BAAA;EzE8hWV;EyEriWM;IAOI,iCAAA;EzEiiWV;EyExiWM;IAOI,sCAAA;EzEoiWV;EyE3iWM;IAOI,yCAAA;EzEuiWV;EyE9iWM;IAOI,uBAAA;EzE0iWV;EyEjjWM;IAOI,uBAAA;EzE6iWV;EyEpjWM;IAOI,yBAAA;EzEgjWV;EyEvjWM;IAOI,yBAAA;EzEmjWV;EyE1jWM;IAOI,0BAAA;EzEsjWV;EyE7jWM;IAOI,4BAAA;EzEyjWV;EyEhkWM;IAOI,kCAAA;EzE4jWV;EyEnkWM;IAOI,sCAAA;EzE+jWV;EyEtkWM;IAOI,oCAAA;EzEkkWV;EyEzkWM;IAOI,kCAAA;EzEqkWV;EyE5kWM;IAOI,yCAAA;EzEwkWV;EyE/kWM;IAOI,wCAAA;EzE2kWV;EyEllWM;IAOI,wCAAA;EzE8kWV;EyErlWM;IAOI,kCAAA;EzEilWV;EyExlWM;IAOI,gCAAA;EzEolWV;EyE3lWM;IAOI,8BAAA;EzEulWV;EyE9lWM;IAOI,gCAAA;EzE0lWV;EyEjmWM;IAOI,+BAAA;EzE6lWV;EyEpmWM;IAOI,oCAAA;EzEgmWV;EyEvmWM;IAOI,kCAAA;EzEmmWV;EyE1mWM;IAOI,gCAAA;EzEsmWV;EyE7mWM;IAOI,uCAAA;EzEymWV;EyEhnWM;IAOI,sCAAA;EzE4mWV;EyEnnWM;IAOI,iCAAA;EzE+mWV;EyEtnWM;IAOI,2BAAA;EzEknWV;EyEznWM;IAOI,iCAAA;EzEqnWV;EyE5nWM;IAOI,+BAAA;EzEwnWV;EyE/nWM;IAOI,6BAAA;EzE2nWV;EyEloWM;IAOI,+BAAA;EzE8nWV;EyEroWM;IAOI,8BAAA;EzEioWV;EyExoWM;IAOI,oBAAA;EzEooWV;EyE3oWM;IAOI,mBAAA;EzEuoWV;EyE9oWM;IAOI,mBAAA;EzE0oWV;EyEjpWM;IAOI,mBAAA;EzE6oWV;EyEppWM;IAOI,mBAAA;EzEgpWV;EyEvpWM;IAOI,mBAAA;EzEmpWV;EyE1pWM;IAOI,mBAAA;EzEspWV;EyE7pWM;IAOI,mBAAA;EzEypWV;EyEhqWM;IAOI,oBAAA;EzE4pWV;EyEnqWM;IAOI,0BAAA;EzE+pWV;EyEtqWM;IAOI,yBAAA;EzEkqWV;EyEzqWM;IAOI,uBAAA;EzEqqWV;EyE5qWM;IAOI,yBAAA;EzEwqWV;EyE/qWM;IAOI,uBAAA;EzE2qWV;EyElrWM;IAOI,uBAAA;EzE8qWV;EyErrWM;IAOI,0BAAA;IAAA,yBAAA;EzEkrWV;EyEzrWM;IAOI,gCAAA;IAAA,+BAAA;EzEsrWV;EyE7rWM;IAOI,+BAAA;IAAA,8BAAA;EzE0rWV;EyEjsWM;IAOI,6BAAA;IAAA,4BAAA;EzE8rWV;EyErsWM;IAOI,+BAAA;IAAA,8BAAA;EzEksWV;EyEzsWM;IAOI,6BAAA;IAAA,4BAAA;EzEssWV;EyE7sWM;IAOI,6BAAA;IAAA,4BAAA;EzE0sWV;EyEjtWM;IAOI,wBAAA;IAAA,2BAAA;EzE8sWV;EyErtWM;IAOI,8BAAA;IAAA,iCAAA;EzEktWV;EyEztWM;IAOI,6BAAA;IAAA,gCAAA;EzEstWV;EyE7tWM;IAOI,2BAAA;IAAA,8BAAA;EzE0tWV;EyEjuWM;IAOI,6BAAA;IAAA,gCAAA;EzE8tWV;EyEruWM;IAOI,2BAAA;IAAA,8BAAA;EzEkuWV;EyEzuWM;IAOI,2BAAA;IAAA,8BAAA;EzEsuWV;EyE7uWM;IAOI,wBAAA;EzEyuWV;EyEhvWM;IAOI,8BAAA;EzE4uWV;EyEnvWM;IAOI,6BAAA;EzE+uWV;EyEtvWM;IAOI,2BAAA;EzEkvWV;EyEzvWM;IAOI,6BAAA;EzEqvWV;EyE5vWM;IAOI,2BAAA;EzEwvWV;EyE/vWM;IAOI,2BAAA;EzE2vWV;EyElwWM;IAOI,0BAAA;EzE8vWV;EyErwWM;IAOI,gCAAA;EzEiwWV;EyExwWM;IAOI,+BAAA;EzEowWV;EyE3wWM;IAOI,6BAAA;EzEuwWV;EyE9wWM;IAOI,+BAAA;EzE0wWV;EyEjxWM;IAOI,6BAAA;EzE6wWV;EyEpxWM;IAOI,6BAAA;EzEgxWV;EyEvxWM;IAOI,2BAAA;EzEmxWV;EyE1xWM;IAOI,iCAAA;EzEsxWV;EyE7xWM;IAOI,gCAAA;EzEyxWV;EyEhyWM;IAOI,8BAAA;EzE4xWV;EyEnyWM;IAOI,gCAAA;EzE+xWV;EyEtyWM;IAOI,8BAAA;EzEkyWV;EyEzyWM;IAOI,8BAAA;EzEqyWV;EyE5yWM;IAOI,yBAAA;EzEwyWV;EyE/yWM;IAOI,+BAAA;EzE2yWV;EyElzWM;IAOI,8BAAA;EzE8yWV;EyErzWM;IAOI,4BAAA;EzEizWV;EyExzWM;IAOI,8BAAA;EzEozWV;EyE3zWM;IAOI,4BAAA;EzEuzWV;EyE9zWM;IAOI,4BAAA;EzE0zWV;EyEj0WM;IAOI,qBAAA;EzE6zWV;EyEp0WM;IAOI,2BAAA;EzEg0WV;EyEv0WM;IAOI,0BAAA;EzEm0WV;EyE10WM;IAOI,wBAAA;EzEs0WV;EyE70WM;IAOI,0BAAA;EzEy0WV;EyEh1WM;IAOI,wBAAA;EzE40WV;EyEn1WM;IAOI,2BAAA;IAAA,0BAAA;EzEg1WV;EyEv1WM;IAOI,iCAAA;IAAA,gCAAA;EzEo1WV;EyE31WM;IAOI,gCAAA;IAAA,+BAAA;EzEw1WV;EyE/1WM;IAOI,8BAAA;IAAA,6BAAA;EzE41WV;EyEn2WM;IAOI,gCAAA;IAAA,+BAAA;EzEg2WV;EyEv2WM;IAOI,8BAAA;IAAA,6BAAA;EzEo2WV;EyE32WM;IAOI,yBAAA;IAAA,4BAAA;EzEw2WV;EyE/2WM;IAOI,+BAAA;IAAA,kCAAA;EzE42WV;EyEn3WM;IAOI,8BAAA;IAAA,iCAAA;EzEg3WV;EyEv3WM;IAOI,4BAAA;IAAA,+BAAA;EzEo3WV;EyE33WM;IAOI,8BAAA;IAAA,iCAAA;EzEw3WV;EyE/3WM;IAOI,4BAAA;IAAA,+BAAA;EzE43WV;EyEn4WM;IAOI,yBAAA;EzE+3WV;EyEt4WM;IAOI,+BAAA;EzEk4WV;EyEz4WM;IAOI,8BAAA;EzEq4WV;EyE54WM;IAOI,4BAAA;EzEw4WV;EyE/4WM;IAOI,8BAAA;EzE24WV;EyEl5WM;IAOI,4BAAA;EzE84WV;EyEr5WM;IAOI,2BAAA;EzEi5WV;EyEx5WM;IAOI,iCAAA;EzEo5WV;EyE35WM;IAOI,gCAAA;EzEu5WV;EyE95WM;IAOI,8BAAA;EzE05WV;EyEj6WM;IAOI,gCAAA;EzE65WV;EyEp6WM;IAOI,8BAAA;EzEg6WV;EyEv6WM;IAOI,4BAAA;EzEm6WV;EyE16WM;IAOI,kCAAA;EzEs6WV;EyE76WM;IAOI,iCAAA;EzEy6WV;EyEh7WM;IAOI,+BAAA;EzE46WV;EyEn7WM;IAOI,iCAAA;EzE+6WV;EyEt7WM;IAOI,+BAAA;EzEk7WV;EyEz7WM;IAOI,0BAAA;EzEq7WV;EyE57WM;IAOI,gCAAA;EzEw7WV;EyE/7WM;IAOI,+BAAA;EzE27WV;EyEl8WM;IAOI,6BAAA;EzE87WV;EyEr8WM;IAOI,+BAAA;EzEi8WV;EyEx8WM;IAOI,6BAAA;EzEo8WV;EyE38WM;IAOI,iBAAA;EzEu8WV;EyE98WM;IAOI,uBAAA;EzE08WV;EyEj9WM;IAOI,sBAAA;EzE68WV;EyEp9WM;IAOI,oBAAA;EzEg9WV;EyEv9WM;IAOI,sBAAA;EzEm9WV;EyE19WM;IAOI,oBAAA;EzEs9WV;EyE79WM;IAOI,qBAAA;EzEy9WV;EyEh+WM;IAOI,2BAAA;EzE49WV;EyEn+WM;IAOI,0BAAA;EzE+9WV;EyEt+WM;IAOI,wBAAA;EzEk+WV;EyEz+WM;IAOI,0BAAA;EzEq+WV;EyE5+WM;IAOI,wBAAA;EzEw+WV;EyE/+WM;IAOI,wBAAA;EzE2+WV;EyEl/WM;IAOI,8BAAA;EzE8+WV;EyEr/WM;IAOI,6BAAA;EzEi/WV;EyEx/WM;IAOI,2BAAA;EzEo/WV;EyE3/WM;IAOI,6BAAA;EzEu/WV;EyE9/WM;IAOI,2BAAA;EzE0/WV;EyEjgXM;IAOI,2BAAA;EzE6/WV;EyEpgXM;IAOI,4BAAA;EzEggXV;EyEvgXM;IAOI,6BAAA;EzEmgXV;AACF;A0E1jXA;ED+CQ;IAOI,4BAAA;EzEwgXV;EyE/gXM;IAOI,0BAAA;EzE2gXV;EyElhXM;IAOI,6BAAA;EzE8gXV;EyErhXM;IAOI,4BAAA;EzEihXV;AACF;A0ErjXA;ED4BQ;IAOI,0BAAA;EzEshXV;EyE7hXM;IAOI,gCAAA;EzEyhXV;EyEhiXM;IAOI,yBAAA;EzE4hXV;EyEniXM;IAOI,wBAAA;EzE+hXV;EyEtiXM;IAOI,+BAAA;EzEkiXV;EyEziXM;IAOI,yBAAA;EzEqiXV;EyE5iXM;IAOI,6BAAA;EzEwiXV;EyE/iXM;IAOI,8BAAA;EzE2iXV;EyEljXM;IAOI,wBAAA;EzE8iXV;EyErjXM;IAOI,+BAAA;EzEijXV;EyExjXM;IAOI,wBAAA;EzEojXV;AACF;A2E9nXA;;;;EAAA;AAaA;EACE,mBAAA;EACA,8BATqB;EAUrB,sHANyB;A3E8nX3B;A2ErnXA;;;EAGE,qBAAA;EACA,yCAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;A3EunXF;;A2EllTE;EAAuB,gBAliEH;A3EwnXtB;;A2EtlTE;EAAuB,gBAliEH;A3E4nXtB;;A2E1lTE;EAAuB,gBAliEH;A3EgoXtB;;A2E9lTE;EAAuB,gBAliEH;A3EooXtB;;A2ElmTE;EAAuB,gBAliEH;A3EwoXtB;;A2EtmTE;EAAuB,gBAliEH;A3E4oXtB;;A2E1mTE;EAAuB,gBAliEH;A3EgpXtB;;A2E9mTE;EAAuB,gBAliEH;A3EopXtB;;A2ElnTE;EAAuB,gBAliEH;A3EwpXtB;;A2EtnTE;EAAuB,gBAliEH;A3E4pXtB;;A2E1nTE;EAAuB,gBAliEH;A3EgqXtB;;A2E9nTE;EAAuB,gBAliEH;A3EoqXtB;;A2EloTE;EAAuB,gBAliEH;A3EwqXtB;;A2EtoTE;EAAuB,gBAliEH;A3E4qXtB;;A2E1oTE;EAAuB,gBAliEH;A3EgrXtB;;A2E9oTE;EAAuB,gBAliEH;A3EorXtB;;A2ElpTE;EAAuB,gBAliEH;A3EwrXtB;;A2EtpTE;EAAuB,gBAliEH;A3E4rXtB;;A2E1pTE;EAAuB,gBAliEH;A3EgsXtB;;A2E9pTE;EAAuB,gBAliEH;A3EosXtB;;A2ElqTE;EAAuB,gBAliEH;A3EwsXtB;;A2EtqTE;EAAuB,gBAliEH;A3E4sXtB;;A2E1qTE;EAAuB,gBAliEH;A3EgtXtB;;A2E9qTE;EAAuB,gBAliEH;A3EotXtB;;A2ElrTE;EAAuB,gBAliEH;A3EwtXtB;;A2EtrTE;EAAuB,gBAliEH;A3E4tXtB;;A2E1rTE;EAAuB,gBAliEH;A3EguXtB;;A2E9rTE;EAAuB,gBAliEH;A3EouXtB;;A2ElsTE;EAAuB,gBAliEH;A3EwuXtB;;A2EtsTE;EAAuB,gBAliEH;A3E4uXtB;;A2E1sTE;EAAuB,gBAliEH;A3EgvXtB;;A2E9sTE;EAAuB,gBAliEH;A3EovXtB;;A2EltTE;EAAuB,gBAliEH;A3EwvXtB;;A2EttTE;EAAuB,gBAliEH;A3E4vXtB;;A2E1tTE;EAAuB,gBAliEH;A3EgwXtB;;A2E9tTE;EAAuB,gBAliEH;A3EowXtB;;A2EluTE;EAAuB,gBAliEH;A3EwwXtB;;A2EtuTE;EAAuB,gBAliEH;A3E4wXtB;;A2E1uTE;EAAuB,gBAliEH;A3EgxXtB;;A2E9uTE;EAAuB,gBAliEH;A3EoxXtB;;A2ElvTE;EAAuB,gBAliEH;A3EwxXtB;;A2EtvTE;EAAuB,gBAliEH;A3E4xXtB;;A2E1vTE;EAAuB,gBAliEH;A3EgyXtB;;A2E9vTE;EAAuB,gBAliEH;A3EoyXtB;;A2ElwTE;EAAuB,gBAliEH;A3EwyXtB;;A2EtwTE;EAAuB,gBAliEH;A3E4yXtB;;A2E1wTE;EAAuB,gBAliEH;A3EgzXtB;;A2E9wTE;EAAuB,gBAliEH;A3EozXtB;;A2ElxTE;EAAuB,gBAliEH;A3EwzXtB;;A2EtxTE;EAAuB,gBAliEH;A3E4zXtB;;A2E1xTE;EAAuB,gBAliEH;A3Eg0XtB;;A2E9xTE;EAAuB,gBAliEH;A3Eo0XtB;;A2ElyTE;EAAuB,gBAliEH;A3Ew0XtB;;A2EtyTE;EAAuB,gBAliEH;A3E40XtB;;A2E1yTE;EAAuB,gBAliEH;A3Eg1XtB;;A2E9yTE;EAAuB,gBAliEH;A3Eo1XtB;;A2ElzTE;EAAuB,gBAliEH;A3Ew1XtB;;A2EtzTE;EAAuB,gBAliEH;A3E41XtB;;A2E1zTE;EAAuB,gBAliEH;A3Eg2XtB;;A2E9zTE;EAAuB,gBAliEH;A3Eo2XtB;;A2El0TE;EAAuB,gBAliEH;A3Ew2XtB;;A2Et0TE;EAAuB,gBAliEH;A3E42XtB;;A2E10TE;EAAuB,gBAliEH;A3Eg3XtB;;A2E90TE;EAAuB,gBAliEH;A3Eo3XtB;;A2El1TE;EAAuB,gBAliEH;A3Ew3XtB;;A2Et1TE;EAAuB,gBAliEH;A3E43XtB;;A2E11TE;EAAuB,gBAliEH;A3Eg4XtB;;A2E91TE;EAAuB,gBAliEH;A3Eo4XtB;;A2El2TE;EAAuB,gBAliEH;A3Ew4XtB;;A2Et2TE;EAAuB,gBAliEH;A3E44XtB;;A2E12TE;EAAuB,gBAliEH;A3Eg5XtB;;A2E92TE;EAAuB,gBAliEH;A3Eo5XtB;;A2El3TE;EAAuB,gBAliEH;A3Ew5XtB;;A2Et3TE;EAAuB,gBAliEH;A3E45XtB;;A2E13TE;EAAuB,gBAliEH;A3Eg6XtB;;A2E93TE;EAAuB,gBAliEH;A3Eo6XtB;;A2El4TE;EAAuB,gBAliEH;A3Ew6XtB;;A2Et4TE;EAAuB,gBAliEH;A3E46XtB;;A2E14TE;EAAuB,gBAliEH;A3Eg7XtB;;A2E94TE;EAAuB,gBAliEH;A3Eo7XtB;;A2El5TE;EAAuB,gBAliEH;A3Ew7XtB;;A2Et5TE;EAAuB,gBAliEH;A3E47XtB;;A2E15TE;EAAuB,gBAliEH;A3Eg8XtB;;A2E95TE;EAAuB,gBAliEH;A3Eo8XtB;;A2El6TE;EAAuB,gBAliEH;A3Ew8XtB;;A2Et6TE;EAAuB,gBAliEH;A3E48XtB;;A2E16TE;EAAuB,gBAliEH;A3Eg9XtB;;A2E96TE;EAAuB,gBAliEH;A3Eo9XtB;;A2El7TE;EAAuB,gBAliEH;A3Ew9XtB;;A2Et7TE;EAAuB,gBAliEH;A3E49XtB;;A2E17TE;EAAuB,gBAliEH;A3Eg+XtB;;A2E97TE;EAAuB,gBAliEH;A3Eo+XtB;;A2El8TE;EAAuB,gBAliEH;A3Ew+XtB;;A2Et8TE;EAAuB,gBAliEH;A3E4+XtB;;A2E18TE;EAAuB,gBAliEH;A3Eg/XtB;;A2E98TE;EAAuB,gBAliEH;A3Eo/XtB;;A2El9TE;EAAuB,gBAliEH;A3Ew/XtB;;A2Et9TE;EAAuB,gBAliEH;A3E4/XtB;;A2E19TE;EAAuB,gBAliEH;A3EggYtB;;A2E99TE;EAAuB,gBAliEH;A3EogYtB;;A2El+TE;EAAuB,gBAliEH;A3EwgYtB;;A2Et+TE;EAAuB,gBAliEH;A3E4gYtB;;A2E1+TE;EAAuB,gBAliEH;A3EghYtB;;A2E9+TE;EAAuB,gBAliEH;A3EohYtB;;A2El/TE;EAAuB,gBAliEH;A3EwhYtB;;A2Et/TE;EAAuB,gBAliEH;A3E4hYtB;;A2E1/TE;EAAuB,gBAliEH;A3EgiYtB;;A2E9/TE;EAAuB,gBAliEH;A3EoiYtB;;A2ElgUE;EAAuB,gBAliEH;A3EwiYtB;;A2EtgUE;EAAuB,gBAliEH;A3E4iYtB;;A2E1gUE;EAAuB,gBAliEH;A3EgjYtB;;A2E9gUE;EAAuB,gBAliEH;A3EojYtB;;A2ElhUE;EAAuB,gBAliEH;A3EwjYtB;;A2EthUE;EAAuB,gBAliEH;A3E4jYtB;;A2E1hUE;EAAuB,gBAliEH;A3EgkYtB;;A2E9hUE;EAAuB,gBAliEH;A3EokYtB;;A2EliUE;EAAuB,gBAliEH;A3EwkYtB;;A2EtiUE;EAAuB,gBAliEH;A3E4kYtB;;A2E1iUE;EAAuB,gBAliEH;A3EglYtB;;A2E9iUE;EAAuB,gBAliEH;A3EolYtB;;A2EljUE;EAAuB,gBAliEH;A3EwlYtB;;A2EtjUE;EAAuB,gBAliEH;A3E4lYtB;;A2E1jUE;EAAuB,gBAliEH;A3EgmYtB;;A2E9jUE;EAAuB,gBAliEH;A3EomYtB;;A2ElkUE;EAAuB,gBAliEH;A3EwmYtB;;A2EtkUE;EAAuB,gBAliEH;A3E4mYtB;;A2E1kUE;EAAuB,gBAliEH;A3EgnYtB;;A2E9kUE;EAAuB,gBAliEH;A3EonYtB;;A2EllUE;EAAuB,gBAliEH;A3EwnYtB;;A2EtlUE;EAAuB,gBAliEH;A3E4nYtB;;A2E1lUE;EAAuB,gBAliEH;A3EgoYtB;;A2E9lUE;EAAuB,gBAliEH;A3EooYtB;;A2ElmUE;EAAuB,gBAliEH;A3EwoYtB;;A2EtmUE;EAAuB,gBAliEH;A3E4oYtB;;A2E1mUE;EAAuB,gBAliEH;A3EgpYtB;;A2E9mUE;EAAuB,gBAliEH;A3EopYtB;;A2ElnUE;EAAuB,gBAliEH;A3EwpYtB;;A2EtnUE;EAAuB,gBAliEH;A3E4pYtB;;A2E1nUE;EAAuB,gBAliEH;A3EgqYtB;;A2E9nUE;EAAuB,gBAliEH;A3EoqYtB;;A2EloUE;EAAuB,gBAliEH;A3EwqYtB;;A2EtoUE;EAAuB,gBAliEH;A3E4qYtB;;A2E1oUE;EAAuB,gBAliEH;A3EgrYtB;;A2E9oUE;EAAuB,gBAliEH;A3EorYtB;;A2ElpUE;EAAuB,gBAliEH;A3EwrYtB;;A2EtpUE;EAAuB,gBAliEH;A3E4rYtB;;A2E1pUE;EAAuB,gBAliEH;A3EgsYtB;;A2E9pUE;EAAuB,gBAliEH;A3EosYtB;;A2ElqUE;EAAuB,gBAliEH;A3EwsYtB;;A2EtqUE;EAAuB,gBAliEH;A3E4sYtB;;A2E1qUE;EAAuB,gBAliEH;A3EgtYtB;;A2E9qUE;EAAuB,gBAliEH;A3EotYtB;;A2ElrUE;EAAuB,gBAliEH;A3EwtYtB;;A2EtrUE;EAAuB,gBAliEH;A3E4tYtB;;A2E1rUE;EAAuB,gBAliEH;A3EguYtB;;A2E9rUE;EAAuB,gBAliEH;A3EouYtB;;A2ElsUE;EAAuB,gBAliEH;A3EwuYtB;;A2EtsUE;EAAuB,gBAliEH;A3E4uYtB;;A2E1sUE;EAAuB,gBAliEH;A3EgvYtB;;A2E9sUE;EAAuB,gBAliEH;A3EovYtB;;A2EltUE;EAAuB,gBAliEH;A3EwvYtB;;A2EttUE;EAAuB,gBAliEH;A3E4vYtB;;A2E1tUE;EAAuB,gBAliEH;A3EgwYtB;;A2E9tUE;EAAuB,gBAliEH;A3EowYtB;;A2EluUE;EAAuB,gBAliEH;A3EwwYtB;;A2EtuUE;EAAuB,gBAliEH;A3E4wYtB;;A2E1uUE;EAAuB,gBAliEH;A3EgxYtB;;A2E9uUE;EAAuB,gBAliEH;A3EoxYtB;;A2ElvUE;EAAuB,gBAliEH;A3EwxYtB;;A2EtvUE;EAAuB,gBAliEH;A3E4xYtB;;A2E1vUE;EAAuB,gBAliEH;A3EgyYtB;;A2E9vUE;EAAuB,gBAliEH;A3EoyYtB;;A2ElwUE;EAAuB,gBAliEH;A3EwyYtB;;A2EtwUE;EAAuB,gBAliEH;A3E4yYtB;;A2E1wUE;EAAuB,gBAliEH;A3EgzYtB;;A2E9wUE;EAAuB,gBAliEH;A3EozYtB;;A2ElxUE;EAAuB,gBAliEH;A3EwzYtB;;A2EtxUE;EAAuB,gBAliEH;A3E4zYtB;;A2E1xUE;EAAuB,gBAliEH;A3Eg0YtB;;A2E9xUE;EAAuB,gBAliEH;A3Eo0YtB;;A2ElyUE;EAAuB,gBAliEH;A3Ew0YtB;;A2EtyUE;EAAuB,gBAliEH;A3E40YtB;;A2E1yUE;EAAuB,gBAliEH;A3Eg1YtB;;A2E9yUE;EAAuB,gBAliEH;A3Eo1YtB;;A2ElzUE;EAAuB,gBAliEH;A3Ew1YtB;;A2EtzUE;EAAuB,gBAliEH;A3E41YtB;;A2E1zUE;EAAuB,gBAliEH;A3Eg2YtB;;A2E9zUE;EAAuB,gBAliEH;A3Eo2YtB;;A2El0UE;EAAuB,gBAliEH;A3Ew2YtB;;A2Et0UE;EAAuB,gBAliEH;A3E42YtB;;A2E10UE;EAAuB,gBAliEH;A3Eg3YtB;;A2E90UE;EAAuB,gBAliEH;A3Eo3YtB;;A2El1UE;EAAuB,gBAliEH;A3Ew3YtB;;A2Et1UE;EAAuB,gBAliEH;A3E43YtB;;A2E11UE;EAAuB,gBAliEH;A3Eg4YtB;;A2E91UE;EAAuB,gBAliEH;A3Eo4YtB;;A2El2UE;EAAuB,gBAliEH;A3Ew4YtB;;A2Et2UE;EAAuB,gBAliEH;A3E44YtB;;A2E12UE;EAAuB,gBAliEH;A3Eg5YtB;;A2E92UE;EAAuB,gBAliEH;A3Eo5YtB;;A2El3UE;EAAuB,gBAliEH;A3Ew5YtB;;A2Et3UE;EAAuB,gBAliEH;A3E45YtB;;A2E13UE;EAAuB,gBAliEH;A3Eg6YtB;;A2E93UE;EAAuB,gBAliEH;A3Eo6YtB;;A2El4UE;EAAuB,gBAliEH;A3Ew6YtB;;A2Et4UE;EAAuB,gBAliEH;A3E46YtB;;A2E14UE;EAAuB,gBAliEH;A3Eg7YtB;;A2E94UE;EAAuB,gBAliEH;A3Eo7YtB;;A2El5UE;EAAuB,gBAliEH;A3Ew7YtB;;A2Et5UE;EAAuB,gBAliEH;A3E47YtB;;A2E15UE;EAAuB,gBAliEH;A3Eg8YtB;;A2E95UE;EAAuB,gBAliEH;A3Eo8YtB;;A2El6UE;EAAuB,gBAliEH;A3Ew8YtB;;A2Et6UE;EAAuB,gBAliEH;A3E48YtB;;A2E16UE;EAAuB,gBAliEH;A3Eg9YtB;;A2E96UE;EAAuB,gBAliEH;A3Eo9YtB;;A2El7UE;EAAuB,gBAliEH;A3Ew9YtB;;A2Et7UE;EAAuB,gBAliEH;A3E49YtB;;A2E17UE;EAAuB,gBAliEH;A3Eg+YtB;;A2E97UE;EAAuB,gBAliEH;A3Eo+YtB;;A2El8UE;EAAuB,gBAliEH;A3Ew+YtB;;A2Et8UE;EAAuB,gBAliEH;A3E4+YtB;;A2E18UE;EAAuB,gBAliEH;A3Eg/YtB;;A2E98UE;EAAuB,gBAliEH;A3Eo/YtB;;A2El9UE;EAAuB,gBAliEH;A3Ew/YtB;;A2Et9UE;EAAuB,gBAliEH;A3E4/YtB;;A2E19UE;EAAuB,gBAliEH;A3EggZtB;;A2E99UE;EAAuB,gBAliEH;A3EogZtB;;A2El+UE;EAAuB,gBAliEH;A3EwgZtB;;A2Et+UE;EAAuB,gBAliEH;A3E4gZtB;;A2E1+UE;EAAuB,gBAliEH;A3EghZtB;;A2E9+UE;EAAuB,gBAliEH;A3EohZtB;;A2El/UE;EAAuB,gBAliEH;A3EwhZtB;;A2Et/UE;EAAuB,gBAliEH;A3E4hZtB;;A2E1/UE;EAAuB,gBAliEH;A3EgiZtB;;A2E9/UE;EAAuB,gBAliEH;A3EoiZtB;;A2ElgVE;EAAuB,gBAliEH;A3EwiZtB;;A2EtgVE;EAAuB,gBAliEH;A3E4iZtB;;A2E1gVE;EAAuB,gBAliEH;A3EgjZtB;;A2E9gVE;EAAuB,gBAliEH;A3EojZtB;;A2ElhVE;EAAuB,gBAliEH;A3EwjZtB;;A2EthVE;EAAuB,gBAliEH;A3E4jZtB;;A2E1hVE;EAAuB,gBAliEH;A3EgkZtB;;A2E9hVE;EAAuB,gBAliEH;A3EokZtB;;A2EliVE;EAAuB,gBAliEH;A3EwkZtB;;A2EtiVE;EAAuB,gBAliEH;A3E4kZtB;;A2E1iVE;EAAuB,gBAliEH;A3EglZtB;;A2E9iVE;EAAuB,gBAliEH;A3EolZtB;;A2EljVE;EAAuB,gBAliEH;A3EwlZtB;;A2EtjVE;EAAuB,gBAliEH;A3E4lZtB;;A2E1jVE;EAAuB,gBAliEH;A3EgmZtB;;A2E9jVE;EAAuB,gBAliEH;A3EomZtB;;A2ElkVE;EAAuB,gBAliEH;A3EwmZtB;;A2EtkVE;EAAuB,gBAliEH;A3E4mZtB;;A2E1kVE;EAAuB,gBAliEH;A3EgnZtB;;A2E9kVE;EAAuB,gBAliEH;A3EonZtB;;A2EllVE;EAAuB,gBAliEH;A3EwnZtB;;A2EtlVE;EAAuB,gBAliEH;A3E4nZtB;;A2E1lVE;EAAuB,gBAliEH;A3EgoZtB;;A2E9lVE;EAAuB,gBAliEH;A3EooZtB;;A2ElmVE;EAAuB,gBAliEH;A3EwoZtB;;A2EtmVE;EAAuB,gBAliEH;A3E4oZtB;;A2E1mVE;EAAuB,gBAliEH;A3EgpZtB;;A2E9mVE;EAAuB,gBAliEH;A3EopZtB;;A2ElnVE;EAAuB,gBAliEH;A3EwpZtB;;A2EtnVE;EAAuB,gBAliEH;A3E4pZtB;;A2E1nVE;EAAuB,gBAliEH;A3EgqZtB;;A2E9nVE;EAAuB,gBAliEH;A3EoqZtB;;A2EloVE;EAAuB,gBAliEH;A3EwqZtB;;A2EtoVE;EAAuB,gBAliEH;A3E4qZtB;;A2E1oVE;EAAuB,gBAliEH;A3EgrZtB;;A2E9oVE;EAAuB,gBAliEH;A3EorZtB;;A2ElpVE;EAAuB,gBAliEH;A3EwrZtB;;A2EtpVE;EAAuB,gBAliEH;A3E4rZtB;;A2E1pVE;EAAuB,gBAliEH;A3EgsZtB;;A2E9pVE;EAAuB,gBAliEH;A3EosZtB;;A2ElqVE;EAAuB,gBAliEH;A3EwsZtB;;A2EtqVE;EAAuB,gBAliEH;A3E4sZtB;;A2E1qVE;EAAuB,gBAliEH;A3EgtZtB;;A2E9qVE;EAAuB,gBAliEH;A3EotZtB;;A2ElrVE;EAAuB,gBAliEH;A3EwtZtB;;A2EtrVE;EAAuB,gBAliEH;A3E4tZtB;;A2E1rVE;EAAuB,gBAliEH;A3EguZtB;;A2E9rVE;EAAuB,gBAliEH;A3EouZtB;;A2ElsVE;EAAuB,gBAliEH;A3EwuZtB;;A2EtsVE;EAAuB,gBAliEH;A3E4uZtB;;A2E1sVE;EAAuB,gBAliEH;A3EgvZtB;;A2E9sVE;EAAuB,gBAliEH;A3EovZtB;;A2EltVE;EAAuB,gBAliEH;A3EwvZtB;;A2EttVE;EAAuB,gBAliEH;A3E4vZtB;;A2E1tVE;EAAuB,gBAliEH;A3EgwZtB;;A2E9tVE;EAAuB,gBAliEH;A3EowZtB;;A2EluVE;EAAuB,gBAliEH;A3EwwZtB;;A2EtuVE;EAAuB,gBAliEH;A3E4wZtB;;A2E1uVE;EAAuB,gBAliEH;A3EgxZtB;;A2E9uVE;EAAuB,gBAliEH;A3EoxZtB;;A2ElvVE;EAAuB,gBAliEH;A3EwxZtB;;A2EtvVE;EAAuB,gBAliEH;A3E4xZtB;;A2E1vVE;EAAuB,gBAliEH;A3EgyZtB;;A2E9vVE;EAAuB,gBAliEH;A3EoyZtB;;A2ElwVE;EAAuB,gBAliEH;A3EwyZtB;;A2EtwVE;EAAuB,gBAliEH;A3E4yZtB;;A2E1wVE;EAAuB,gBAliEH;A3EgzZtB;;A2E9wVE;EAAuB,gBAliEH;A3EozZtB;;A2ElxVE;EAAuB,gBAliEH;A3EwzZtB;;A2EtxVE;EAAuB,gBAliEH;A3E4zZtB;;A2E1xVE;EAAuB,gBAliEH;A3Eg0ZtB;;A2E9xVE;EAAuB,gBAliEH;A3Eo0ZtB;;A2ElyVE;EAAuB,gBAliEH;A3Ew0ZtB;;A2EtyVE;EAAuB,gBAliEH;A3E40ZtB;;A2E1yVE;EAAuB,gBAliEH;A3Eg1ZtB;;A2E9yVE;EAAuB,gBAliEH;A3Eo1ZtB;;A2ElzVE;EAAuB,gBAliEH;A3Ew1ZtB;;A2EtzVE;EAAuB,gBAliEH;A3E41ZtB;;A2E1zVE;EAAuB,gBAliEH;A3Eg2ZtB;;A2E9zVE;EAAuB,gBAliEH;A3Eo2ZtB;;A2El0VE;EAAuB,gBAliEH;A3Ew2ZtB;;A2Et0VE;EAAuB,gBAliEH;A3E42ZtB;;A2E10VE;EAAuB,gBAliEH;A3Eg3ZtB;;A2E90VE;EAAuB,gBAliEH;A3Eo3ZtB;;A2El1VE;EAAuB,gBAliEH;A3Ew3ZtB;;A2Et1VE;EAAuB,gBAliEH;A3E43ZtB;;A2E11VE;EAAuB,gBAliEH;A3Eg4ZtB;;A2E91VE;EAAuB,gBAliEH;A3Eo4ZtB;;A2El2VE;EAAuB,gBAliEH;A3Ew4ZtB;;A2Et2VE;EAAuB,gBAliEH;A3E44ZtB;;A2E12VE;EAAuB,gBAliEH;A3Eg5ZtB;;A2E92VE;EAAuB,gBAliEH;A3Eo5ZtB;;A2El3VE;EAAuB,gBAliEH;A3Ew5ZtB;;A2Et3VE;EAAuB,gBAliEH;A3E45ZtB;;A2E13VE;EAAuB,gBAliEH;A3Eg6ZtB;;A2E93VE;EAAuB,gBAliEH;A3Eo6ZtB;;A2El4VE;EAAuB,gBAliEH;A3Ew6ZtB;;A2Et4VE;EAAuB,gBAliEH;A3E46ZtB;;A2E14VE;EAAuB,gBAliEH;A3Eg7ZtB;;A2E94VE;EAAuB,gBAliEH;A3Eo7ZtB;;A2El5VE;EAAuB,gBAliEH;A3Ew7ZtB;;A2Et5VE;EAAuB,gBAliEH;A3E47ZtB;;A2E15VE;EAAuB,gBAliEH;A3Eg8ZtB;;A2E95VE;EAAuB,gBAliEH;A3Eo8ZtB;;A2El6VE;EAAuB,gBAliEH;A3Ew8ZtB;;A2Et6VE;EAAuB,gBAliEH;A3E48ZtB;;A2E16VE;EAAuB,gBAliEH;A3Eg9ZtB;;A2E96VE;EAAuB,gBAliEH;A3Eo9ZtB;;A2El7VE;EAAuB,gBAliEH;A3Ew9ZtB;;A2Et7VE;EAAuB,gBAliEH;A3E49ZtB;;A2E17VE;EAAuB,gBAliEH;A3Eg+ZtB;;A2E97VE;EAAuB,gBAliEH;A3Eo+ZtB;;A2El8VE;EAAuB,gBAliEH;A3Ew+ZtB;;A2Et8VE;EAAuB,gBAliEH;A3E4+ZtB;;A2E18VE;EAAuB,gBAliEH;A3Eg/ZtB;;A2E98VE;EAAuB,gBAliEH;A3Eo/ZtB;;A2El9VE;EAAuB,gBAliEH;A3Ew/ZtB;;A2Et9VE;EAAuB,gBAliEH;A3E4/ZtB;;A2E19VE;EAAuB,gBAliEH;A3EggatB;;A2E99VE;EAAuB,gBAliEH;A3EogatB;;A2El+VE;EAAuB,gBAliEH;A3EwgatB;;A2Et+VE;EAAuB,gBAliEH;A3E4gatB;;A2E1+VE;EAAuB,gBAliEH;A3EghatB;;A2E9+VE;EAAuB,gBAliEH;A3EohatB;;A2El/VE;EAAuB,gBAliEH;A3EwhatB;;A2Et/VE;EAAuB,gBAliEH;A3E4hatB;;A2E1/VE;EAAuB,gBAliEH;A3EgiatB;;A2E9/VE;EAAuB,gBAliEH;A3EoiatB;;A2ElgWE;EAAuB,gBAliEH;A3EwiatB;;A2EtgWE;EAAuB,gBAliEH;A3E4iatB;;A2E1gWE;EAAuB,gBAliEH;A3EgjatB;;A2E9gWE;EAAuB,gBAliEH;A3EojatB;;A2ElhWE;EAAuB,gBAliEH;A3EwjatB;;A2EthWE;EAAuB,gBAliEH;A3E4jatB;;A2E1hWE;EAAuB,gBAliEH;A3EgkatB;;A2E9hWE;EAAuB,gBAliEH;A3EokatB;;A2EliWE;EAAuB,gBAliEH;A3EwkatB;;A2EtiWE;EAAuB,gBAliEH;A3E4katB;;A2E1iWE;EAAuB,gBAliEH;A3EglatB;;A2E9iWE;EAAuB,gBAliEH;A3EolatB;;A2EljWE;EAAuB,gBAliEH;A3EwlatB;;A2EtjWE;EAAuB,gBAliEH;A3E4latB;;A2E1jWE;EAAuB,gBAliEH;A3EgmatB;;A2E9jWE;EAAuB,gBAliEH;A3EomatB;;A2ElkWE;EAAuB,gBAliEH;A3EwmatB;;A2EtkWE;EAAuB,gBAliEH;A3E4matB;;A2E1kWE;EAAuB,gBAliEH;A3EgnatB;;A2E9kWE;EAAuB,gBAliEH;A3EonatB;;A2EllWE;EAAuB,gBAliEH;A3EwnatB;;A2EtlWE;EAAuB,gBAliEH;A3E4natB;;A2E1lWE;EAAuB,gBAliEH;A3EgoatB;;A2E9lWE;EAAuB,gBAliEH;A3EooatB;;A2ElmWE;EAAuB,gBAliEH;A3EwoatB;;A2EtmWE;EAAuB,gBAliEH;A3E4oatB;;A2E1mWE;EAAuB,gBAliEH;A3EgpatB;;A2E9mWE;EAAuB,gBAliEH;A3EopatB;;A2ElnWE;EAAuB,gBAliEH;A3EwpatB;;A2EtnWE;EAAuB,gBAliEH;A3E4patB;;A2E1nWE;EAAuB,gBAliEH;A3EgqatB;;A2E9nWE;EAAuB,gBAliEH;A3EoqatB;;A2EloWE;EAAuB,gBAliEH;A3EwqatB;;A2EtoWE;EAAuB,gBAliEH;A3E4qatB;;A2E1oWE;EAAuB,gBAliEH;A3EgratB;;A2E9oWE;EAAuB,gBAliEH;A3EoratB;;A2ElpWE;EAAuB,gBAliEH;A3EwratB;;A2EtpWE;EAAuB,gBAliEH;A3E4ratB;;A2E1pWE;EAAuB,gBAliEH;A3EgsatB;;A2E9pWE;EAAuB,gBAliEH;A3EosatB;;A2ElqWE;EAAuB,gBAliEH;A3EwsatB;;A2EtqWE;EAAuB,gBAliEH;A3E4satB;;A2E1qWE;EAAuB,gBAliEH;A3EgtatB;;A2E9qWE;EAAuB,gBAliEH;A3EotatB;;A2ElrWE;EAAuB,gBAliEH;A3EwtatB;;A2EtrWE;EAAuB,gBAliEH;A3E4tatB;;A2E1rWE;EAAuB,gBAliEH;A3EguatB;;A2E9rWE;EAAuB,gBAliEH;A3EouatB;;A2ElsWE;EAAuB,gBAliEH;A3EwuatB;;A2EtsWE;EAAuB,gBAliEH;A3E4uatB;;A2E1sWE;EAAuB,gBAliEH;A3EgvatB;;A2E9sWE;EAAuB,gBAliEH;A3EovatB;;A2EltWE;EAAuB,gBAliEH;A3EwvatB;;A2EttWE;EAAuB,gBAliEH;A3E4vatB;;A2E1tWE;EAAuB,gBAliEH;A3EgwatB;;A2E9tWE;EAAuB,gBAliEH;A3EowatB;;A2EluWE;EAAuB,gBAliEH;A3EwwatB;;A2EtuWE;EAAuB,gBAliEH;A3E4watB;;A2E1uWE;EAAuB,gBAliEH;A3EgxatB;;A2E9uWE;EAAuB,gBAliEH;A3EoxatB;;A2ElvWE;EAAuB,gBAliEH;A3EwxatB;;A2EtvWE;EAAuB,gBAliEH;A3E4xatB;;A2E1vWE;EAAuB,gBAliEH;A3EgyatB;;A2E9vWE;EAAuB,gBAliEH;A3EoyatB;;A2ElwWE;EAAuB,gBAliEH;A3EwyatB;;A2EtwWE;EAAuB,gBAliEH;A3E4yatB;;A2E1wWE;EAAuB,gBAliEH;A3EgzatB;;A2E9wWE;EAAuB,gBAliEH;A3EozatB;;A2ElxWE;EAAuB,gBAliEH;A3EwzatB;;A2EtxWE;EAAuB,gBAliEH;A3E4zatB;;A2E1xWE;EAAuB,gBAliEH;A3Eg0atB;;A2E9xWE;EAAuB,gBAliEH;A3Eo0atB;;A2ElyWE;EAAuB,gBAliEH;A3Ew0atB;;A2EtyWE;EAAuB,gBAliEH;A3E40atB;;A2E1yWE;EAAuB,gBAliEH;A3Eg1atB;;A2E9yWE;EAAuB,gBAliEH;A3Eo1atB;;A2ElzWE;EAAuB,gBAliEH;A3Ew1atB;;A2EtzWE;EAAuB,gBAliEH;A3E41atB;;A2E1zWE;EAAuB,gBAliEH;A3Eg2atB;;A2E9zWE;EAAuB,gBAliEH;A3Eo2atB;;A2El0WE;EAAuB,gBAliEH;A3Ew2atB;;A2Et0WE;EAAuB,gBAliEH;A3E42atB;;A2E10WE;EAAuB,gBAliEH;A3Eg3atB;;A2E90WE;EAAuB,gBAliEH;A3Eo3atB;;A2El1WE;EAAuB,gBAliEH;A3Ew3atB;;A2Et1WE;EAAuB,gBAliEH;A3E43atB;;A2E11WE;EAAuB,gBAliEH;A3Eg4atB;;A2E91WE;EAAuB,gBAliEH;A3Eo4atB;;A2El2WE;EAAuB,gBAliEH;A3Ew4atB;;A2Et2WE;EAAuB,gBAliEH;A3E44atB;;A2E12WE;EAAuB,gBAliEH;A3Eg5atB;;A2E92WE;EAAuB,gBAliEH;A3Eo5atB;;A2El3WE;EAAuB,gBAliEH;A3Ew5atB;;A2Et3WE;EAAuB,gBAliEH;A3E45atB;;A2E13WE;EAAuB,gBAliEH;A3Eg6atB;;A2E93WE;EAAuB,gBAliEH;A3Eo6atB;;A2El4WE;EAAuB,gBAliEH;A3Ew6atB;;A2Et4WE;EAAuB,gBAliEH;A3E46atB;;A2E14WE;EAAuB,gBAliEH;A3Eg7atB;;A2E94WE;EAAuB,gBAliEH;A3Eo7atB;;A2El5WE;EAAuB,gBAliEH;A3Ew7atB;;A2Et5WE;EAAuB,gBAliEH;A3E47atB;;A2E15WE;EAAuB,gBAliEH;A3Eg8atB;;A2E95WE;EAAuB,gBAliEH;A3Eo8atB;;A2El6WE;EAAuB,gBAliEH;A3Ew8atB;;A2Et6WE;EAAuB,gBAliEH;A3E48atB;;A2E16WE;EAAuB,gBAliEH;A3Eg9atB;;A2E96WE;EAAuB,gBAliEH;A3Eo9atB;;A2El7WE;EAAuB,gBAliEH;A3Ew9atB;;A2Et7WE;EAAuB,gBAliEH;A3E49atB;;A2E17WE;EAAuB,gBAliEH;A3Eg+atB;;A2E97WE;EAAuB,gBAliEH;A3Eo+atB;;A2El8WE;EAAuB,gBAliEH;A3Ew+atB;;A2Et8WE;EAAuB,gBAliEH;A3E4+atB;;A2E18WE;EAAuB,gBAliEH;A3Eg/atB;;A2E98WE;EAAuB,gBAliEH;A3Eo/atB;;A2El9WE;EAAuB,gBAliEH;A3Ew/atB;;A2Et9WE;EAAuB,gBAliEH;A3E4/atB;;A2E19WE;EAAuB,gBAliEH;A3EggbtB;;A2E99WE;EAAuB,gBAliEH;A3EogbtB;;A2El+WE;EAAuB,gBAliEH;A3EwgbtB;;A2Et+WE;EAAuB,gBAliEH;A3E4gbtB;;A2E1+WE;EAAuB,gBAliEH;A3EghbtB;;A2E9+WE;EAAuB,gBAliEH;A3EohbtB;;A2El/WE;EAAuB,gBAliEH;A3EwhbtB;;A2Et/WE;EAAuB,gBAliEH;A3E4hbtB;;A2E1/WE;EAAuB,gBAliEH;A3EgibtB;;A2E9/WE;EAAuB,gBAliEH;A3EoibtB;;A2ElgXE;EAAuB,gBAliEH;A3EwibtB;;A2EtgXE;EAAuB,gBAliEH;A3E4ibtB;;A2E1gXE;EAAuB,gBAliEH;A3EgjbtB;;A2E9gXE;EAAuB,gBAliEH;A3EojbtB;;A2ElhXE;EAAuB,gBAliEH;A3EwjbtB;;A2EthXE;EAAuB,gBAliEH;A3E4jbtB;;A2E1hXE;EAAuB,gBAliEH;A3EgkbtB;;A2E9hXE;EAAuB,gBAliEH;A3EokbtB;;A2EliXE;EAAuB,gBAliEH;A3EwkbtB;;A2EtiXE;EAAuB,gBAliEH;A3E4kbtB;;A2E1iXE;EAAuB,gBAliEH;A3EglbtB;;A2E9iXE;EAAuB,gBAliEH;A3EolbtB;;A2EljXE;EAAuB,gBAliEH;A3EwlbtB;;A2EtjXE;EAAuB,gBAliEH;A3E4lbtB;;A2E1jXE;EAAuB,gBAliEH;A3EgmbtB;;A2E9jXE;EAAuB,gBAliEH;A3EombtB;;A2ElkXE;EAAuB,gBAliEH;A3EwmbtB;;A2EtkXE;EAAuB,gBAliEH;A3E4mbtB;;A2E1kXE;EAAuB,gBAliEH;A3EgnbtB;;A2E9kXE;EAAuB,gBAliEH;A3EonbtB;;A2EllXE;EAAuB,gBAliEH;A3EwnbtB;;A2EtlXE;EAAuB,gBAliEH;A3E4nbtB;;A2E1lXE;EAAuB,gBAliEH;A3EgobtB;;A2E9lXE;EAAuB,gBAliEH;A3EoobtB;;A2ElmXE;EAAuB,gBAliEH;A3EwobtB;;A2EtmXE;EAAuB,gBAliEH;A3E4obtB;;A2E1mXE;EAAuB,gBAliEH;A3EgpbtB;;A2E9mXE;EAAuB,gBAliEH;A3EopbtB;;A2ElnXE;EAAuB,gBAliEH;A3EwpbtB;;A2EtnXE;EAAuB,gBAliEH;A3E4pbtB;;A2E1nXE;EAAuB,gBAliEH;A3EgqbtB;;A2E9nXE;EAAuB,gBAliEH;A3EoqbtB;;A2EloXE;EAAuB,gBAliEH;A3EwqbtB;;A2EtoXE;EAAuB,gBAliEH;A3E4qbtB;;A2E1oXE;EAAuB,gBAliEH;A3EgrbtB;;A2E9oXE;EAAuB,gBAliEH;A3EorbtB;;A2ElpXE;EAAuB,gBAliEH;A3EwrbtB;;A2EtpXE;EAAuB,gBAliEH;A3E4rbtB;;A2E1pXE;EAAuB,gBAliEH;A3EgsbtB;;A2E9pXE;EAAuB,gBAliEH;A3EosbtB;;A2ElqXE;EAAuB,gBAliEH;A3EwsbtB;;A2EtqXE;EAAuB,gBAliEH;A3E4sbtB;;A2E1qXE;EAAuB,gBAliEH;A3EgtbtB;;A2E9qXE;EAAuB,gBAliEH;A3EotbtB;;A2ElrXE;EAAuB,gBAliEH;A3EwtbtB;;A2EtrXE;EAAuB,gBAliEH;A3E4tbtB;;A2E1rXE;EAAuB,gBAliEH;A3EgubtB;;A2E9rXE;EAAuB,gBAliEH;A3EoubtB;;A2ElsXE;EAAuB,gBAliEH;A3EwubtB;;A2EtsXE;EAAuB,gBAliEH;A3E4ubtB;;A2E1sXE;EAAuB,gBAliEH;A3EgvbtB;;A2E9sXE;EAAuB,gBAliEH;A3EovbtB;;A2EltXE;EAAuB,gBAliEH;A3EwvbtB;;A2EttXE;EAAuB,gBAliEH;A3E4vbtB;;A2E1tXE;EAAuB,gBAliEH;A3EgwbtB;;A2E9tXE;EAAuB,gBAliEH;A3EowbtB;;A2EluXE;EAAuB,gBAliEH;A3EwwbtB;;A2EtuXE;EAAuB,gBAliEH;A3E4wbtB;;A2E1uXE;EAAuB,gBAliEH;A3EgxbtB;;A2E9uXE;EAAuB,gBAliEH;A3EoxbtB;;A2ElvXE;EAAuB,gBAliEH;A3EwxbtB;;A2EtvXE;EAAuB,gBAliEH;A3E4xbtB;;A2E1vXE;EAAuB,gBAliEH;A3EgybtB;;A2E9vXE;EAAuB,gBAliEH;A3EoybtB;;A2ElwXE;EAAuB,gBAliEH;A3EwybtB;;A2EtwXE;EAAuB,gBAliEH;A3E4ybtB;;A2E1wXE;EAAuB,gBAliEH;A3EgzbtB;;A2E9wXE;EAAuB,gBAliEH;A3EozbtB;;A2ElxXE;EAAuB,gBAliEH;A3EwzbtB;;A2EtxXE;EAAuB,gBAliEH;A3E4zbtB;;A2E1xXE;EAAuB,gBAliEH;A3Eg0btB;;A2E9xXE;EAAuB,gBAliEH;A3Eo0btB;;A2ElyXE;EAAuB,gBAliEH;A3Ew0btB;;A2EtyXE;EAAuB,gBAliEH;A3E40btB;;A2E1yXE;EAAuB,gBAliEH;A3Eg1btB;;A2E9yXE;EAAuB,gBAliEH;A3Eo1btB;;A2ElzXE;EAAuB,gBAliEH;A3Ew1btB;;A2EtzXE;EAAuB,gBAliEH;A3E41btB;;A2E1zXE;EAAuB,gBAliEH;A3Eg2btB;;A2E9zXE;EAAuB,gBAliEH;A3Eo2btB;;A2El0XE;EAAuB,gBAliEH;A3Ew2btB;;A2Et0XE;EAAuB,gBAliEH;A3E42btB;;A2E10XE;EAAuB,gBAliEH;A3Eg3btB;;A2E90XE;EAAuB,gBAliEH;A3Eo3btB;;A2El1XE;EAAuB,gBAliEH;A3Ew3btB;;A2Et1XE;EAAuB,gBAliEH;A3E43btB;;A2E11XE;EAAuB,gBAliEH;A3Eg4btB;;A2E91XE;EAAuB,gBAliEH;A3Eo4btB;;A2El2XE;EAAuB,gBAliEH;A3Ew4btB;;A2Et2XE;EAAuB,gBAliEH;A3E44btB;;A2E12XE;EAAuB,gBAliEH;A3Eg5btB;;A2E92XE;EAAuB,gBAliEH;A3Eo5btB;;A2El3XE;EAAuB,gBAliEH;A3Ew5btB;;A2Et3XE;EAAuB,gBAliEH;A3E45btB;;A2E13XE;EAAuB,gBAliEH;A3Eg6btB;;A2E93XE;EAAuB,gBAliEH;A3Eo6btB;;A2El4XE;EAAuB,gBAliEH;A3Ew6btB;;A2Et4XE;EAAuB,gBAliEH;A3E46btB;;A2E14XE;EAAuB,gBAliEH;A3Eg7btB;;A2E94XE;EAAuB,gBAliEH;A3Eo7btB;;A2El5XE;EAAuB,gBAliEH;A3Ew7btB;;A2Et5XE;EAAuB,gBAliEH;A3E47btB;;A2E15XE;EAAuB,gBAliEH;A3Eg8btB;;A2E95XE;EAAuB,gBAliEH;A3Eo8btB;;A2El6XE;EAAuB,gBAliEH;A3Ew8btB;;A2Et6XE;EAAuB,gBAliEH;A3E48btB;;A2E16XE;EAAuB,gBAliEH;A3Eg9btB;;A2E96XE;EAAuB,gBAliEH;A3Eo9btB;;A2El7XE;EAAuB,gBAliEH;A3Ew9btB;;A2Et7XE;EAAuB,gBAliEH;A3E49btB;;A2E17XE;EAAuB,gBAliEH;A3Eg+btB;;A2E97XE;EAAuB,gBAliEH;A3Eo+btB;;A2El8XE;EAAuB,gBAliEH;A3Ew+btB;;A2Et8XE;EAAuB,gBAliEH;A3E4+btB;;A2E18XE;EAAuB,gBAliEH;A3Eg/btB;;A2E98XE;EAAuB,gBAliEH;A3Eo/btB;;A2El9XE;EAAuB,gBAliEH;A3Ew/btB;;A2Et9XE;EAAuB,gBAliEH;A3E4/btB;;A2E19XE;EAAuB,gBAliEH;A3EggctB;;A2E99XE;EAAuB,gBAliEH;A3EogctB;;A2El+XE;EAAuB,gBAliEH;A3EwgctB;;A2Et+XE;EAAuB,gBAliEH;A3E4gctB;;A2E1+XE;EAAuB,gBAliEH;A3EghctB;;A2E9+XE;EAAuB,gBAliEH;A3EohctB;;A2El/XE;EAAuB,gBAliEH;A3EwhctB;;A2Et/XE;EAAuB,gBAliEH;A3E4hctB;;A2E1/XE;EAAuB,gBAliEH;A3EgictB;;A2E9/XE;EAAuB,gBAliEH;A3EoictB;;A2ElgYE;EAAuB,gBAliEH;A3EwictB;;A2EtgYE;EAAuB,gBAliEH;A3E4ictB;;A2E1gYE;EAAuB,gBAliEH;A3EgjctB;;A2E9gYE;EAAuB,gBAliEH;A3EojctB;;A2ElhYE;EAAuB,gBAliEH;A3EwjctB;;A2EthYE;EAAuB,gBAliEH;A3E4jctB;;A2E1hYE;EAAuB,gBAliEH;A3EgkctB;;A2E9hYE;EAAuB,gBAliEH;A3EokctB;;A2EliYE;EAAuB,gBAliEH;A3EwkctB;;A2EtiYE;EAAuB,gBAliEH;A3E4kctB;;A2E1iYE;EAAuB,gBAliEH;A3EglctB;;A2E9iYE;EAAuB,gBAliEH;A3EolctB;;A2EljYE;EAAuB,gBAliEH;A3EwlctB;;A2EtjYE;EAAuB,gBAliEH;A3E4lctB;;A2E1jYE;EAAuB,gBAliEH;A3EgmctB;;A2E9jYE;EAAuB,gBAliEH;A3EomctB;;A2ElkYE;EAAuB,gBAliEH;A3EwmctB;;A2EtkYE;EAAuB,gBAliEH;A3E4mctB;;A2E1kYE;EAAuB,gBAliEH;A3EgnctB;;A2E9kYE;EAAuB,gBAliEH;A3EonctB;;A2EllYE;EAAuB,gBAliEH;A3EwnctB;;A2EtlYE;EAAuB,gBAliEH;A3E4nctB;;A2E1lYE;EAAuB,gBAliEH;A3EgoctB;;A2E9lYE;EAAuB,gBAliEH;A3EooctB;;A2ElmYE;EAAuB,gBAliEH;A3EwoctB;;A2EtmYE;EAAuB,gBAliEH;A3E4octB;;A2E1mYE;EAAuB,gBAliEH;A3EgpctB;;A2E9mYE;EAAuB,gBAliEH;A3EopctB;;A2ElnYE;EAAuB,gBAliEH;A3EwpctB;;A2EtnYE;EAAuB,gBAliEH;A3E4pctB;;A2E1nYE;EAAuB,gBAliEH;A3EgqctB;;A2E9nYE;EAAuB,gBAliEH;A3EoqctB;;A2EloYE;EAAuB,gBAliEH;A3EwqctB;;A2EtoYE;EAAuB,gBAliEH;A3E4qctB;;A2E1oYE;EAAuB,gBAliEH;A3EgrctB;;A2E9oYE;EAAuB,gBAliEH;A3EorctB;;A2ElpYE;EAAuB,gBAliEH;A3EwrctB;;A2EtpYE;EAAuB,gBAliEH;A3E4rctB;;A2E1pYE;EAAuB,gBAliEH;A3EgsctB;;A2E9pYE;EAAuB,gBAliEH;A3EosctB;;A2ElqYE;EAAuB,gBAliEH;A3EwsctB;;A2EtqYE;EAAuB,gBAliEH;A3E4sctB;;A2E1qYE;EAAuB,gBAliEH;A3EgtctB;;A2E9qYE;EAAuB,gBAliEH;A3EotctB;;A2ElrYE;EAAuB,gBAliEH;A3EwtctB;;A2EtrYE;EAAuB,gBAliEH;A3E4tctB;;A2E1rYE;EAAuB,gBAliEH;A3EguctB;;A2E9rYE;EAAuB,gBAliEH;A3EouctB;;A2ElsYE;EAAuB,gBAliEH;A3EwuctB;;A2EtsYE;EAAuB,gBAliEH;A3E4uctB;;A2E1sYE;EAAuB,gBAliEH;A3EgvctB;;A2E9sYE;EAAuB,gBAliEH;A3EovctB;;A2EltYE;EAAuB,gBAliEH;A3EwvctB;;A2EttYE;EAAuB,gBAliEH;A3E4vctB;;A2E1tYE;EAAuB,gBAliEH;A3EgwctB;;A2E9tYE;EAAuB,gBAliEH;A3EowctB;;A2EluYE;EAAuB,gBAliEH;A3EwwctB;;A2EtuYE;EAAuB,gBAliEH;A3E4wctB;;A2E1uYE;EAAuB,gBAliEH;A3EgxctB;;A2E9uYE;EAAuB,gBAliEH;A3EoxctB;;A2ElvYE;EAAuB,gBAliEH;A3EwxctB;;A2EtvYE;EAAuB,gBAliEH;A3E4xctB;;A2E1vYE;EAAuB,gBAliEH;A3EgyctB;;A2E9vYE;EAAuB,gBAliEH;A3EoyctB;;A2ElwYE;EAAuB,gBAliEH;A3EwyctB;;A2EtwYE;EAAuB,gBAliEH;A3E4yctB;;A2E1wYE;EAAuB,gBAliEH;A3EgzctB;;A2E9wYE;EAAuB,gBAliEH;A3EozctB;;A2ElxYE;EAAuB,gBAliEH;A3EwzctB;;A2EtxYE;EAAuB,gBAliEH;A3E4zctB;;A2E1xYE;EAAuB,gBAliEH;A3Eg0ctB;;A2E9xYE;EAAuB,gBAliEH;A3Eo0ctB;;A2ElyYE;EAAuB,gBAliEH;A3Ew0ctB;;A2EtyYE;EAAuB,gBAliEH;A3E40ctB;;A2E1yYE;EAAuB,gBAliEH;A3Eg1ctB;;A2E9yYE;EAAuB,gBAliEH;A3Eo1ctB;;A2ElzYE;EAAuB,gBAliEH;A3Ew1ctB;;A2EtzYE;EAAuB,gBAliEH;A3E41ctB;;A2E1zYE;EAAuB,gBAliEH;A3Eg2ctB;;A2E9zYE;EAAuB,gBAliEH;A3Eo2ctB;;A2El0YE;EAAuB,gBAliEH;A3Ew2ctB;;A2Et0YE;EAAuB,gBAliEH;A3E42ctB;;A2E10YE;EAAuB,gBAliEH;A3Eg3ctB;;A2E90YE;EAAuB,gBAliEH;A3Eo3ctB;;A2El1YE;EAAuB,gBAliEH;A3Ew3ctB;;A2Et1YE;EAAuB,gBAliEH;A3E43ctB;;A2E11YE;EAAuB,gBAliEH;A3Eg4ctB;;A2E91YE;EAAuB,gBAliEH;A3Eo4ctB;;A2El2YE;EAAuB,gBAliEH;A3Ew4ctB;;A2Et2YE;EAAuB,gBAliEH;A3E44ctB;;A2E12YE;EAAuB,gBAliEH;A3Eg5ctB;;A2E92YE;EAAuB,gBAliEH;A3Eo5ctB;;A2El3YE;EAAuB,gBAliEH;A3Ew5ctB;;A2Et3YE;EAAuB,gBAliEH;A3E45ctB;;A2E13YE;EAAuB,gBAliEH;A3Eg6ctB;;A2E93YE;EAAuB,gBAliEH;A3Eo6ctB;;A2El4YE;EAAuB,gBAliEH;A3Ew6ctB;;A2Et4YE;EAAuB,gBAliEH;A3E46ctB;;A2E14YE;EAAuB,gBAliEH;A3Eg7ctB;;A2E94YE;EAAuB,gBAliEH;A3Eo7ctB;;A2El5YE;EAAuB,gBAliEH;A3Ew7ctB;;A2Et5YE;EAAuB,gBAliEH;A3E47ctB;;A2E15YE;EAAuB,gBAliEH;A3Eg8ctB;;A2E95YE;EAAuB,gBAliEH;A3Eo8ctB;;A2El6YE;EAAuB,gBAliEH;A3Ew8ctB;;A2Et6YE;EAAuB,gBAliEH;A3E48ctB;;A2E16YE;EAAuB,gBAliEH;A3Eg9ctB;;A2E96YE;EAAuB,gBAliEH;A3Eo9ctB;;A2El7YE;EAAuB,gBAliEH;A3Ew9ctB;;A2Et7YE;EAAuB,gBAliEH;A3E49ctB;;A2E17YE;EAAuB,gBAliEH;A3Eg+ctB;;A2E97YE;EAAuB,gBAliEH;A3Eo+ctB;;A2El8YE;EAAuB,gBAliEH;A3Ew+ctB;;A2Et8YE;EAAuB,gBAliEH;A3E4+ctB;;A2E18YE;EAAuB,gBAliEH;A3Eg/ctB;;A2E98YE;EAAuB,gBAliEH;A3Eo/ctB;;A2El9YE;EAAuB,gBAliEH;A3Ew/ctB;;A2Et9YE;EAAuB,gBAliEH;A3E4/ctB;;A2E19YE;EAAuB,gBAliEH;A3EggdtB;;A2E99YE;EAAuB,gBAliEH;A3EogdtB;;A2El+YE;EAAuB,gBAliEH;A3EwgdtB;;A2Et+YE;EAAuB,gBAliEH;A3E4gdtB;;A2E1+YE;EAAuB,gBAliEH;A3EghdtB;;A2E9+YE;EAAuB,gBAliEH;A3EohdtB;;A2El/YE;EAAuB,gBAliEH;A3EwhdtB;;A2Et/YE;EAAuB,gBAliEH;A3E4hdtB;;A2E1/YE;EAAuB,gBAliEH;A3EgidtB;;A2E9/YE;EAAuB,gBAliEH;A3EoidtB;;A2ElgZE;EAAuB,gBAliEH;A3EwidtB;;A2EtgZE;EAAuB,gBAliEH;A3E4idtB;;A2E1gZE;EAAuB,gBAliEH;A3EgjdtB;;A2E9gZE;EAAuB,gBAliEH;A3EojdtB;;A2ElhZE;EAAuB,gBAliEH;A3EwjdtB;;A2EthZE;EAAuB,gBAliEH;A3E4jdtB;;A2E1hZE;EAAuB,gBAliEH;A3EgkdtB;;A2E9hZE;EAAuB,gBAliEH;A3EokdtB;;A2EliZE;EAAuB,gBAliEH;A3EwkdtB;;A2EtiZE;EAAuB,gBAliEH;A3E4kdtB;;A2E1iZE;EAAuB,gBAliEH;A3EgldtB;;A2E9iZE;EAAuB,gBAliEH;A3EoldtB;;A2EljZE;EAAuB,gBAliEH;A3EwldtB;;A2EtjZE;EAAuB,gBAliEH;A3E4ldtB;;A2E1jZE;EAAuB,gBAliEH;A3EgmdtB;;A2E9jZE;EAAuB,gBAliEH;A3EomdtB;;A2ElkZE;EAAuB,gBAliEH;A3EwmdtB;;A2EtkZE;EAAuB,gBAliEH;A3E4mdtB;;A2E1kZE;EAAuB,gBAliEH;A3EgndtB;;A2E9kZE;EAAuB,gBAliEH;A3EondtB;;A2EllZE;EAAuB,gBAliEH;A3EwndtB;;A2EtlZE;EAAuB,gBAliEH;A3E4ndtB;;A2E1lZE;EAAuB,gBAliEH;A3EgodtB;;A2E9lZE;EAAuB,gBAliEH;A3EoodtB;;A2ElmZE;EAAuB,gBAliEH;A3EwodtB;;A2EtmZE;EAAuB,gBAliEH;A3E4odtB;;A2E1mZE;EAAuB,gBAliEH;A3EgpdtB;;A2E9mZE;EAAuB,gBAliEH;A3EopdtB;;A2ElnZE;EAAuB,gBAliEH;A3EwpdtB;;A2EtnZE;EAAuB,gBAliEH;A3E4pdtB;;A2E1nZE;EAAuB,gBAliEH;A3EgqdtB;;A2E9nZE;EAAuB,gBAliEH;A3EoqdtB;;A2EloZE;EAAuB,gBAliEH;A3EwqdtB;;A2EtoZE;EAAuB,gBAliEH;A3E4qdtB;;A2E1oZE;EAAuB,gBAliEH;A3EgrdtB;;A2E9oZE;EAAuB,gBAliEH;A3EordtB;;A2ElpZE;EAAuB,gBAliEH;A3EwrdtB;;A2EtpZE;EAAuB,gBAliEH;A3E4rdtB;;A2E1pZE;EAAuB,gBAliEH;A3EgsdtB;;A2E9pZE;EAAuB,gBAliEH;A3EosdtB;;A2ElqZE;EAAuB,gBAliEH;A3EwsdtB;;A2EtqZE;EAAuB,gBAliEH;A3E4sdtB;;A2E1qZE;EAAuB,gBAliEH;A3EgtdtB;;A2E9qZE;EAAuB,gBAliEH;A3EotdtB;;A2ElrZE;EAAuB,gBAliEH;A3EwtdtB;;A2EtrZE;EAAuB,gBAliEH;A3E4tdtB;;A2E1rZE;EAAuB,gBAliEH;A3EgudtB;;A2E9rZE;EAAuB,gBAliEH;A3EoudtB;;A2ElsZE;EAAuB,gBAliEH;A3EwudtB;;A2EtsZE;EAAuB,gBAliEH;A3E4udtB;;A2E1sZE;EAAuB,gBAliEH;A3EgvdtB;;A2E9sZE;EAAuB,gBAliEH;A3EovdtB;;A2EltZE;EAAuB,gBAliEH;A3EwvdtB;;A2EttZE;EAAuB,gBAliEH;A3E4vdtB;;A2E1tZE;EAAuB,gBAliEH;A3EgwdtB;;A2E9tZE;EAAuB,gBAliEH;A3EowdtB;;A2EluZE;EAAuB,gBAliEH;A3EwwdtB;;A2EtuZE;EAAuB,gBAliEH;A3E4wdtB;;A2E1uZE;EAAuB,gBAliEH;A3EgxdtB;;A2E9uZE;EAAuB,gBAliEH;A3EoxdtB;;A2ElvZE;EAAuB,gBAliEH;A3EwxdtB;;A2EtvZE;EAAuB,gBAliEH;A3E4xdtB;;A2E1vZE;EAAuB,gBAliEH;A3EgydtB;;A2E9vZE;EAAuB,gBAliEH;A3EoydtB;;A2ElwZE;EAAuB,gBAliEH;A3EwydtB;;A2EtwZE;EAAuB,gBAliEH;A3E4ydtB;;A2E1wZE;EAAuB,gBAliEH;A3EgzdtB;;A2E9wZE;EAAuB,gBAliEH;A3EozdtB;;A2ElxZE;EAAuB,gBAliEH;A3EwzdtB;;A2EtxZE;EAAuB,gBAliEH;A3E4zdtB;;A2E1xZE;EAAuB,gBAliEH;A3Eg0dtB;;A2E9xZE;EAAuB,gBAliEH;A3Eo0dtB;;A2ElyZE;EAAuB,gBAliEH;A3Ew0dtB;;A2EtyZE;EAAuB,gBAliEH;A3E40dtB;;A2E1yZE;EAAuB,gBAliEH;A3Eg1dtB;;A2E9yZE;EAAuB,gBAliEH;A3Eo1dtB;;A2ElzZE;EAAuB,gBAliEH;A3Ew1dtB;;A2EtzZE;EAAuB,gBAliEH;A3E41dtB;;A2E1zZE;EAAuB,gBAliEH;A3Eg2dtB;;A2E9zZE;EAAuB,gBAliEH;A3Eo2dtB;;A2El0ZE;EAAuB,gBAliEH;A3Ew2dtB;;A2Et0ZE;EAAuB,gBAliEH;A3E42dtB;;A2E10ZE;EAAuB,gBAliEH;A3Eg3dtB;;A2E90ZE;EAAuB,gBAliEH;A3Eo3dtB;;A2El1ZE;EAAuB,gBAliEH;A3Ew3dtB;;A2Et1ZE;EAAuB,gBAliEH;A3E43dtB;;A2E11ZE;EAAuB,gBAliEH;A3Eg4dtB;;A2E91ZE;EAAuB,gBAliEH;A3Eo4dtB;;A2El2ZE;EAAuB,gBAliEH;A3Ew4dtB;;A2Et2ZE;EAAuB,gBAliEH;A3E44dtB;;A2E12ZE;EAAuB,gBAliEH;A3Eg5dtB;;A2E92ZE;EAAuB,gBAliEH;A3Eo5dtB;;A2El3ZE;EAAuB,gBAliEH;A3Ew5dtB;;A2Et3ZE;EAAuB,gBAliEH;A3E45dtB;;A2E13ZE;EAAuB,gBAliEH;A3Eg6dtB;;A2E93ZE;EAAuB,gBAliEH;A3Eo6dtB;;A2El4ZE;EAAuB,gBAliEH;A3Ew6dtB;;A2Et4ZE;EAAuB,gBAliEH;A3E46dtB;;A2E14ZE;EAAuB,gBAliEH;A3Eg7dtB;;A2E94ZE;EAAuB,gBAliEH;A3Eo7dtB;;A2El5ZE;EAAuB,gBAliEH;A3Ew7dtB;;A2Et5ZE;EAAuB,gBAliEH;A3E47dtB;;A2E15ZE;EAAuB,gBAliEH;A3Eg8dtB;;A2E95ZE;EAAuB,gBAliEH;A3Eo8dtB;;A2El6ZE;EAAuB,gBAliEH;A3Ew8dtB;;A2Et6ZE;EAAuB,gBAliEH;A3E48dtB;;A2E16ZE;EAAuB,gBAliEH;A3Eg9dtB;;A2E96ZE;EAAuB,gBAliEH;A3Eo9dtB;;A2El7ZE;EAAuB,gBAliEH;A3Ew9dtB;;A2Et7ZE;EAAuB,gBAliEH;A3E49dtB;;A2E17ZE;EAAuB,gBAliEH;A3Eg+dtB;;A2E97ZE;EAAuB,gBAliEH;A3Eo+dtB;;A2El8ZE;EAAuB,gBAliEH;A3Ew+dtB;;A2Et8ZE;EAAuB,gBAliEH;A3E4+dtB;;A2E18ZE;EAAuB,gBAliEH;A3Eg/dtB;;A2E98ZE;EAAuB,gBAliEH;A3Eo/dtB;;A2El9ZE;EAAuB,gBAliEH;A3Ew/dtB;;A2Et9ZE;EAAuB,gBAliEH;A3E4/dtB;;A2E19ZE;EAAuB,gBAliEH;A3EggetB;;A2E99ZE;EAAuB,gBAliEH;A3EogetB;;A2El+ZE;EAAuB,gBAliEH;A3EwgetB;;A2Et+ZE;EAAuB,gBAliEH;A3E4getB;;A2E1+ZE;EAAuB,gBAliEH;A3EghetB;;A2E9+ZE;EAAuB,gBAliEH;A3EohetB;;A2El/ZE;EAAuB,gBAliEH;A3EwhetB;;A2Et/ZE;EAAuB,gBAliEH;A3E4hetB;;A2E1/ZE;EAAuB,gBAliEH;A3EgietB;;A2E9/ZE;EAAuB,gBAliEH;A3EoietB;;A2ElgaE;EAAuB,gBAliEH;A3EwietB;;A2EtgaE;EAAuB,gBAliEH;A3E4ietB;;A2E1gaE;EAAuB,gBAliEH;A3EgjetB;;A2E9gaE;EAAuB,gBAliEH;A3EojetB;;A2ElhaE;EAAuB,gBAliEH;A3EwjetB;;A2EthaE;EAAuB,gBAliEH;A3E4jetB;;A2E1haE;EAAuB,gBAliEH;A3EgketB;;A2E9haE;EAAuB,gBAliEH;A3EoketB;;A2EliaE;EAAuB,gBAliEH;A3EwketB;;A2EtiaE;EAAuB,gBAliEH;A3E4ketB;;A2E1iaE;EAAuB,gBAliEH;A3EgletB;;A2E9iaE;EAAuB,gBAliEH;A3EoletB;;A2EljaE;EAAuB,gBAliEH;A3EwletB;;A2EtjaE;EAAuB,gBAliEH;A3E4letB;;A2E1jaE;EAAuB,gBAliEH;A3EgmetB;;A2E9jaE;EAAuB,gBAliEH;A3EometB;;A2ElkaE;EAAuB,gBAliEH;A3EwmetB;;A2EtkaE;EAAuB,gBAliEH;A3E4metB;;A2E1kaE;EAAuB,gBAliEH;A3EgnetB;;A2E9kaE;EAAuB,gBAliEH;A3EonetB;;A2EllaE;EAAuB,gBAliEH;A3EwnetB;;A2EtlaE;EAAuB,gBAliEH;A3E4netB;;A2E1laE;EAAuB,gBAliEH;A3EgoetB;;A2E9laE;EAAuB,gBAliEH;A3EooetB;;A2ElmaE;EAAuB,gBAliEH;A3EwoetB;;A2EtmaE;EAAuB,gBAliEH;A3E4oetB;;A2E1maE;EAAuB,gBAliEH;A3EgpetB;;A2E9maE;EAAuB,gBAliEH;A3EopetB;;A2ElnaE;EAAuB,gBAliEH;A3EwpetB;;A2EtnaE;EAAuB,gBAliEH;A3E4petB;;A2E1naE;EAAuB,gBAliEH;A3EgqetB;;A2E9naE;EAAuB,gBAliEH;A3EoqetB;;A2EloaE;EAAuB,gBAliEH;A3EwqetB;;A2EtoaE;EAAuB,gBAliEH;A3E4qetB;;A2E1oaE;EAAuB,gBAliEH;A3EgretB;;A2E9oaE;EAAuB,gBAliEH;A3EoretB;;A2ElpaE;EAAuB,gBAliEH;A3EwretB;;A2EtpaE;EAAuB,gBAliEH;A3E4retB;;A2E1paE;EAAuB,gBAliEH;A3EgsetB;;A2E9paE;EAAuB,gBAliEH;A3EosetB;;A2ElqaE;EAAuB,gBAliEH;A3EwsetB;;A2EtqaE;EAAuB,gBAliEH;A3E4setB;;A2E1qaE;EAAuB,gBAliEH;A3EgtetB;;A2E9qaE;EAAuB,gBAliEH;A3EotetB;;A2ElraE;EAAuB,gBAliEH;A3EwtetB;;A2EtraE;EAAuB,gBAliEH;A3E4tetB;;A2E1raE;EAAuB,gBAliEH;A3EguetB;;A2E9raE;EAAuB,gBAliEH;A3EouetB;;A2ElsaE;EAAuB,gBAliEH;A3EwuetB;;A2EtsaE;EAAuB,gBAliEH;A3E4uetB;;A2E1saE;EAAuB,gBAliEH;A3EgvetB;;A2E9saE;EAAuB,gBAliEH;A3EovetB;;A2EltaE;EAAuB,gBAliEH;A3EwvetB;;A2EttaE;EAAuB,gBAliEH;A3E4vetB;;A2E1taE;EAAuB,gBAliEH;A3EgwetB;;A2E9taE;EAAuB,gBAliEH;A3EowetB;;A2EluaE;EAAuB,gBAliEH;A3EwwetB;;A2EtuaE;EAAuB,gBAliEH;A3E4wetB;;A2E1uaE;EAAuB,gBAliEH;A3EgxetB;;A2E9uaE;EAAuB,gBAliEH;A3EoxetB;;A2ElvaE;EAAuB,gBAliEH;A3EwxetB;;A2EtvaE;EAAuB,gBAliEH;A3E4xetB;;A2E1vaE;EAAuB,gBAliEH;A3EgyetB;;A2E9vaE;EAAuB,gBAliEH;A3EoyetB;;A2ElwaE;EAAuB,gBAliEH;A3EwyetB;;A2EtwaE;EAAuB,gBAliEH;A3E4yetB;;A2E1waE;EAAuB,gBAliEH;A3EgzetB;;A2E9waE;EAAuB,gBAliEH;A3EozetB;;A2ElxaE;EAAuB,gBAliEH;A3EwzetB;;A2EtxaE;EAAuB,gBAliEH;A3E4zetB;;A2E1xaE;EAAuB,gBAliEH;A3Eg0etB;;A2E9xaE;EAAuB,gBAliEH;A3Eo0etB;;A2ElyaE;EAAuB,gBAliEH;A3Ew0etB;;A2EtyaE;EAAuB,gBAliEH;A3E40etB;;A2E1yaE;EAAuB,gBAliEH;A3Eg1etB;;A2E9yaE;EAAuB,gBAliEH;A3Eo1etB;;A2ElzaE;EAAuB,gBAliEH;A3Ew1etB;;A2EtzaE;EAAuB,gBAliEH;A3E41etB;;A2E1zaE;EAAuB,gBAliEH;A3Eg2etB;;A2E9zaE;EAAuB,gBAliEH;A3Eo2etB;;A2El0aE;EAAuB,gBAliEH;A3Ew2etB;;A2Et0aE;EAAuB,gBAliEH;A3E42etB;;A2E10aE;EAAuB,gBAliEH;A3Eg3etB;;A2E90aE;EAAuB,gBAliEH;A3Eo3etB;;A2El1aE;EAAuB,gBAliEH;A3Ew3etB;;A2Et1aE;EAAuB,gBAliEH;A3E43etB;;A2E11aE;EAAuB,gBAliEH;A3Eg4etB;;A2E91aE;EAAuB,gBAliEH;A3Eo4etB;;A2El2aE;EAAuB,gBAliEH;A3Ew4etB;;A2Et2aE;EAAuB,gBAliEH;A3E44etB;;A2E12aE;EAAuB,gBAliEH;A3Eg5etB;;A2E92aE;EAAuB,gBAliEH;A3Eo5etB;;A2El3aE;EAAuB,gBAliEH;A3Ew5etB;;A2Et3aE;EAAuB,gBAliEH;A3E45etB;;A2E13aE;EAAuB,gBAliEH;A3Eg6etB;;A2E93aE;EAAuB,gBAliEH;A3Eo6etB;;A2El4aE;EAAuB,gBAliEH;A3Ew6etB;;A2Et4aE;EAAuB,gBAliEH;A3E46etB;;A2E14aE;EAAuB,gBAliEH;A3Eg7etB;;A2E94aE;EAAuB,gBAliEH;A3Eo7etB;;A2El5aE;EAAuB,gBAliEH;A3Ew7etB;;A2Et5aE;EAAuB,gBAliEH;A3E47etB;;A2E15aE;EAAuB,gBAliEH;A3Eg8etB;;A2E95aE;EAAuB,gBAliEH;A3Eo8etB;;A2El6aE;EAAuB,gBAliEH;A3Ew8etB;;A2Et6aE;EAAuB,gBAliEH;A3E48etB;;A2E16aE;EAAuB,gBAliEH;A3Eg9etB;;A2E96aE;EAAuB,gBAliEH;A3Eo9etB;;A2El7aE;EAAuB,gBAliEH;A3Ew9etB;;A2Et7aE;EAAuB,gBAliEH;A3E49etB;;A2E17aE;EAAuB,gBAliEH;A3Eg+etB;;A2E97aE;EAAuB,gBAliEH;A3Eo+etB;;A2El8aE;EAAuB,gBAliEH;A3Ew+etB;;A2Et8aE;EAAuB,gBAliEH;A3E4+etB;;A2E18aE;EAAuB,gBAliEH;A3Eg/etB;;A2E98aE;EAAuB,gBAliEH;A3Eo/etB;;A2El9aE;EAAuB,gBAliEH;A3Ew/etB;;A2Et9aE;EAAuB,gBAliEH;A3E4/etB;;A2E19aE;EAAuB,gBAliEH;A3EggftB;;A2E99aE;EAAuB,gBAliEH;A3EogftB;;A2El+aE;EAAuB,gBAliEH;A3EwgftB;;A2Et+aE;EAAuB,gBAliEH;A3E4gftB;;A2E1+aE;EAAuB,gBAliEH;A3EghftB;;A2E9+aE;EAAuB,gBAliEH;A3EohftB;;A2El/aE;EAAuB,gBAliEH;A3EwhftB;;A2Et/aE;EAAuB,gBAliEH;A3E4hftB;;A2E1/aE;EAAuB,gBAliEH;A3EgiftB;;A2E9/aE;EAAuB,gBAliEH;A3EoiftB;;A2ElgbE;EAAuB,gBAliEH;A3EwiftB;;A2EtgbE;EAAuB,gBAliEH;A3E4iftB;;A2E1gbE;EAAuB,gBAliEH;A3EgjftB;;A2E9gbE;EAAuB,gBAliEH;A3EojftB;;A2ElhbE;EAAuB,gBAliEH;A3EwjftB;;A2EthbE;EAAuB,gBAliEH;A3E4jftB;;A2E1hbE;EAAuB,gBAliEH;A3EgkftB;;A2E9hbE;EAAuB,gBAliEH;A3EokftB;;A2ElibE;EAAuB,gBAliEH;A3EwkftB;;A2EtibE;EAAuB,gBAliEH;A3E4kftB;;A2E1ibE;EAAuB,gBAliEH;A3EglftB;;A2E9ibE;EAAuB,gBAliEH;A3EolftB;;A2EljbE;EAAuB,gBAliEH;A3EwlftB;;A2EtjbE;EAAuB,gBAliEH;A3E4lftB;;A2E1jbE;EAAuB,gBAliEH;A3EgmftB;;A2E9jbE;EAAuB,gBAliEH;A3EomftB;;A2ElkbE;EAAuB,gBAliEH;A3EwmftB;;A2EtkbE;EAAuB,gBAliEH;A3E4mftB;;A2E1kbE;EAAuB,gBAliEH;A3EgnftB;;A2E9kbE;EAAuB,gBAliEH;A3EonftB;;A2EllbE;EAAuB,gBAliEH;A3EwnftB;;A2EtlbE;EAAuB,gBAliEH;A3E4nftB;;A2E1lbE;EAAuB,gBAliEH;A3EgoftB;;A2E9lbE;EAAuB,gBAliEH;A3EooftB;;A2ElmbE;EAAuB,gBAliEH;A3EwoftB;;A2EtmbE;EAAuB,gBAliEH;A3E4oftB;;A2E1mbE;EAAuB,gBAliEH;A3EgpftB;;A2E9mbE;EAAuB,gBAliEH;A3EopftB;;A2ElnbE;EAAuB,gBAliEH;A3EwpftB;;A2EtnbE;EAAuB,gBAliEH;A3E4pftB;;A2E1nbE;EAAuB,gBAliEH;A3EgqftB;;A2E9nbE;EAAuB,gBAliEH;A3EoqftB;;A2ElobE;EAAuB,gBAliEH;A3EwqftB;;A2EtobE;EAAuB,gBAliEH;A3E4qftB;;A2E1obE;EAAuB,gBAliEH;A3EgrftB;;A2E9obE;EAAuB,gBAliEH;A3EorftB;;A2ElpbE;EAAuB,gBAliEH;A3EwrftB;;A2EtpbE;EAAuB,gBAliEH;A3E4rftB;;A2E1pbE;EAAuB,gBAliEH;A3EgsftB;;A2E9pbE;EAAuB,gBAliEH;A3EosftB;;A2ElqbE;EAAuB,gBAliEH;A3EwsftB;;A2EtqbE;EAAuB,gBAliEH;A3E4sftB;;A2E1qbE;EAAuB,gBAliEH;A3EgtftB;;A2E9qbE;EAAuB,gBAliEH;A3EotftB;;A2ElrbE;EAAuB,gBAliEH;A3EwtftB;;A2EtrbE;EAAuB,gBAliEH;A3E4tftB;;A2E1rbE;EAAuB,gBAliEH;A3EguftB;;A2E9rbE;EAAuB,gBAliEH;A3EouftB;;A2ElsbE;EAAuB,gBAliEH;A3EwuftB;;A2EtsbE;EAAuB,gBAliEH;A3E4uftB;;A2E1sbE;EAAuB,gBAliEH;A3EgvftB;;A2E9sbE;EAAuB,gBAliEH;A3EovftB;;A2EltbE;EAAuB,gBAliEH;A3EwvftB;;A2EttbE;EAAuB,gBAliEH;A3E4vftB;;A2E1tbE;EAAuB,gBAliEH;A3EgwftB;;A2E9tbE;EAAuB,gBAliEH;A3EowftB;;A2ElubE;EAAuB,gBAliEH;A3EwwftB;;A2EtubE;EAAuB,gBAliEH;A3E4wftB;;A2E1ubE;EAAuB,gBAliEH;A3EgxftB;;A2E9ubE;EAAuB,gBAliEH;A3EoxftB;;A2ElvbE;EAAuB,gBAliEH;A3EwxftB;;A2EtvbE;EAAuB,gBAliEH;A3E4xftB;;A2E1vbE;EAAuB,gBAliEH;A3EgyftB;;A2E9vbE;EAAuB,gBAliEH;A3EoyftB;;A2ElwbE;EAAuB,gBAliEH;A3EwyftB;;A2EtwbE;EAAuB,gBAliEH;A3E4yftB;;A2E1wbE;EAAuB,gBAliEH;A3EgzftB;;A2E9wbE;EAAuB,gBAliEH;A3EozftB;;A2ElxbE;EAAuB,gBAliEH;A3EwzftB;;A2EtxbE;EAAuB,gBAliEH;A3E4zftB;;A2E1xbE;EAAuB,gBAliEH;A3Eg0ftB;;A2E9xbE;EAAuB,gBAliEH;A3Eo0ftB;;A2ElybE;EAAuB,gBAliEH;A3Ew0ftB;;A2EtybE;EAAuB,gBAliEH;A3E40ftB;;A2E1ybE;EAAuB,gBAliEH;A3Eg1ftB;;A2E9ybE;EAAuB,gBAliEH;A3Eo1ftB;;A2ElzbE;EAAuB,gBAliEH;A3Ew1ftB;;A2EtzbE;EAAuB,gBAliEH;A3E41ftB;;A2E1zbE;EAAuB,gBAliEH;A3Eg2ftB;;A2E9zbE;EAAuB,gBAliEH;A3Eo2ftB;;A2El0bE;EAAuB,gBAliEH;A3Ew2ftB;;A2Et0bE;EAAuB,gBAliEH;A3E42ftB;;A2E10bE;EAAuB,gBAliEH;A3Eg3ftB;;A2E90bE;EAAuB,gBAliEH;A3Eo3ftB;;A2El1bE;EAAuB,gBAliEH;A3Ew3ftB;;A2Et1bE;EAAuB,gBAliEH;A3E43ftB;;A2E11bE;EAAuB,gBAliEH;A3Eg4ftB;;A2E91bE;EAAuB,gBAliEH;A3Eo4ftB;;A2El2bE;EAAuB,gBAliEH;A3Ew4ftB;;A2Et2bE;EAAuB,gBAliEH;A3E44ftB;;A2E12bE;EAAuB,gBAliEH;A3Eg5ftB;;A2E92bE;EAAuB,gBAliEH;A3Eo5ftB;;A2El3bE;EAAuB,gBAliEH;A3Ew5ftB;;A2Et3bE;EAAuB,gBAliEH;A3E45ftB;;A2E13bE;EAAuB,gBAliEH;A3Eg6ftB;;A2E93bE;EAAuB,gBAliEH;A3Eo6ftB;;A2El4bE;EAAuB,gBAliEH;A3Ew6ftB;;A2Et4bE;EAAuB,gBAliEH;A3E46ftB;;A2E14bE;EAAuB,gBAliEH;A3Eg7ftB;;A2E94bE;EAAuB,gBAliEH;A3Eo7ftB;;A2El5bE;EAAuB,gBAliEH;A3Ew7ftB;;A2Et5bE;EAAuB,gBAliEH;A3E47ftB;;A2E15bE;EAAuB,gBAliEH;A3Eg8ftB;;A2E95bE;EAAuB,gBAliEH;A3Eo8ftB;;A2El6bE;EAAuB,gBAliEH;A3Ew8ftB;;A2Et6bE;EAAuB,gBAliEH;A3E48ftB;;A2E16bE;EAAuB,gBAliEH;A3Eg9ftB;;A2E96bE;EAAuB,gBAliEH;A3Eo9ftB;;A2El7bE;EAAuB,gBAliEH;A3Ew9ftB;;A2Et7bE;EAAuB,gBAliEH;A3E49ftB;;A2E17bE;EAAuB,gBAliEH;A3Eg+ftB;;A2E97bE;EAAuB,gBAliEH;A3Eo+ftB;;A2El8bE;EAAuB,gBAliEH;A3Ew+ftB;;A2Et8bE;EAAuB,gBAliEH;A3E4+ftB;;A2E18bE;EAAuB,gBAliEH;A3Eg/ftB;;A2E98bE;EAAuB,gBAliEH;A3Eo/ftB;;A2El9bE;EAAuB,gBAliEH;A3Ew/ftB;;A2Et9bE;EAAuB,gBAliEH;A3E4/ftB;;A2E19bE;EAAuB,gBAliEH;A3EgggBtB;;A2E99bE;EAAuB,gBAliEH;A3EoggBtB;;A2El+bE;EAAuB,gBAliEH;A3EwggBtB;;A2Et+bE;EAAuB,gBAliEH;A3E4ggBtB;;A2E1+bE;EAAuB,gBAliEH;A3EghgBtB;;A2E9+bE;EAAuB,gBAliEH;A3EohgBtB;;A2El/bE;EAAuB,gBAliEH;A3EwhgBtB;;A2Et/bE;EAAuB,gBAliEH;A3E4hgBtB;;A2E1/bE;EAAuB,gBAliEH;A3EgigBtB;;A2E9/bE;EAAuB,gBAliEH;A3EoigBtB;;A2ElgcE;EAAuB,gBAliEH;A3EwigBtB;;A2EtgcE;EAAuB,gBAliEH;A3E4igBtB;;A2E1gcE;EAAuB,gBAliEH;A3EgjgBtB;;A2E9gcE;EAAuB,gBAliEH;A3EojgBtB;;A2ElhcE;EAAuB,gBAliEH;A3EwjgBtB;;A2EthcE;EAAuB,gBAliEH;A3E4jgBtB;;A2E1hcE;EAAuB,gBAliEH;A3EgkgBtB;;A2E9hcE;EAAuB,gBAliEH;A3EokgBtB;;A2ElicE;EAAuB,gBAliEH;A3EwkgBtB;;A2EticE;EAAuB,gBAliEH;A3E4kgBtB;;A2E1icE;EAAuB,gBAliEH;A3EglgBtB;;A2E9icE;EAAuB,gBAliEH;A3EolgBtB;;A2EljcE;EAAuB,gBAliEH;A3EwlgBtB;;A2EtjcE;EAAuB,gBAliEH;A3E4lgBtB;;A2E1jcE;EAAuB,gBAliEH;A3EgmgBtB;;A2E9jcE;EAAuB,gBAliEH;A3EomgBtB;;A2ElkcE;EAAuB,gBAliEH;A3EwmgBtB;;A2EtkcE;EAAuB,gBAliEH;A3E4mgBtB;;A2E1kcE;EAAuB,gBAliEH;A3EgngBtB;;A2E9kcE;EAAuB,gBAliEH;A3EongBtB;;A2EllcE;EAAuB,gBAliEH;A3EwngBtB;;A2EtlcE;EAAuB,gBAliEH;A3E4ngBtB;;A2E1lcE;EAAuB,gBAliEH;A3EgogBtB;;A2E9lcE;EAAuB,gBAliEH;A3EoogBtB;;A2ElmcE;EAAuB,gBAliEH;A3EwogBtB;;A2EtmcE;EAAuB,gBAliEH;A3E4ogBtB;;A2E1mcE;EAAuB,gBAliEH;A3EgpgBtB;;A2E9mcE;EAAuB,gBAliEH;A3EopgBtB;;A2ElncE;EAAuB,gBAliEH;A3EwpgBtB;;A2EtncE;EAAuB,gBAliEH;A3E4pgBtB;;A2E1ncE;EAAuB,gBAliEH;A3EgqgBtB;;A2E9ncE;EAAuB,gBAliEH;A3EoqgBtB;;A2ElocE;EAAuB,gBAliEH;A3EwqgBtB;;A2EtocE;EAAuB,gBAliEH;A3E4qgBtB;;A2E1ocE;EAAuB,gBAliEH;A3EgrgBtB;;A2E9ocE;EAAuB,gBAliEH;A3EorgBtB;;A2ElpcE;EAAuB,gBAliEH;A3EwrgBtB;;A2EtpcE;EAAuB,gBAliEH;A3E4rgBtB;;A2E1pcE;EAAuB,gBAliEH;A3EgsgBtB;;A2E9pcE;EAAuB,gBAliEH;A3EosgBtB;;A2ElqcE;EAAuB,gBAliEH;A3EwsgBtB;;A2EtqcE;EAAuB,gBAliEH;A3E4sgBtB;;A2E1qcE;EAAuB,gBAliEH;A3EgtgBtB;;A2E9qcE;EAAuB,gBAliEH;A3EotgBtB;;A2ElrcE;EAAuB,gBAliEH;A3EwtgBtB;;A2EtrcE;EAAuB,gBAliEH;A3E4tgBtB;;A2E1rcE;EAAuB,gBAliEH;A3EgugBtB;;A2E9rcE;EAAuB,gBAliEH;A3EougBtB;;A2ElscE;EAAuB,gBAliEH;A3EwugBtB;;A2EtscE;EAAuB,gBAliEH;A3E4ugBtB;;A2E1scE;EAAuB,gBAliEH;A3EgvgBtB;;A2E9scE;EAAuB,gBAliEH;A3EovgBtB;;A2EltcE;EAAuB,gBAliEH;A3EwvgBtB;;A2EttcE;EAAuB,gBAliEH;A3E4vgBtB;;A2E1tcE;EAAuB,gBAliEH;A3EgwgBtB;;A2E9tcE;EAAuB,gBAliEH;A3EowgBtB;;A2ElucE;EAAuB,gBAliEH;A3EwwgBtB;;A2EtucE;EAAuB,gBAliEH;A3E4wgBtB;;A2E1ucE;EAAuB,gBAliEH;A3EgxgBtB;;A2E9ucE;EAAuB,gBAliEH;A3EoxgBtB;;A2ElvcE;EAAuB,gBAliEH;A3EwxgBtB;;A2EtvcE;EAAuB,gBAliEH;A3E4xgBtB;;A2E1vcE;EAAuB,gBAliEH;A3EgygBtB;;A2E9vcE;EAAuB,gBAliEH;A3EoygBtB;;A2ElwcE;EAAuB,gBAliEH;A3EwygBtB;;A2EtwcE;EAAuB,gBAliEH;A3E4ygBtB;;A2E1wcE;EAAuB,gBAliEH;A3EgzgBtB;;A2E9wcE;EAAuB,gBAliEH;A3EozgBtB;;A2ElxcE;EAAuB,gBAliEH;A3EwzgBtB;;A2EtxcE;EAAuB,gBAliEH;A3E4zgBtB;;A2E1xcE;EAAuB,gBAliEH;A3Eg0gBtB;;A2E9xcE;EAAuB,gBAliEH;A3Eo0gBtB;;A2ElycE;EAAuB,gBAliEH;A3Ew0gBtB;;A2EtycE;EAAuB,gBAliEH;A3E40gBtB;;A2E1ycE;EAAuB,gBAliEH;A3Eg1gBtB;;A2E9ycE;EAAuB,gBAliEH;A3Eo1gBtB;;A2ElzcE;EAAuB,gBAliEH;A3Ew1gBtB;;A2EtzcE;EAAuB,gBAliEH;A3E41gBtB;;A2E1zcE;EAAuB,gBAliEH;A3Eg2gBtB;;A2E9zcE;EAAuB,gBAliEH;A3Eo2gBtB;;A2El0cE;EAAuB,gBAliEH;A3Ew2gBtB;;A2Et0cE;EAAuB,gBAliEH;A3E42gBtB;;A2E10cE;EAAuB,gBAliEH;A3Eg3gBtB;;A2E90cE;EAAuB,gBAliEH;A3Eo3gBtB;;A2El1cE;EAAuB,gBAliEH;A3Ew3gBtB;;A2Et1cE;EAAuB,gBAliEH;A3E43gBtB;;A2E11cE;EAAuB,gBAliEH;A3Eg4gBtB;;A2E91cE;EAAuB,gBAliEH;A3Eo4gBtB;;A2El2cE;EAAuB,gBAliEH;A3Ew4gBtB;;A2Et2cE;EAAuB,gBAliEH;A3E44gBtB;;A2E12cE;EAAuB,gBAliEH;A3Eg5gBtB;;A2E92cE;EAAuB,gBAliEH;A3Eo5gBtB;;A2El3cE;EAAuB,gBAliEH;A3Ew5gBtB;;A2Et3cE;EAAuB,gBAliEH;A3E45gBtB;;A2E13cE;EAAuB,gBAliEH;A3Eg6gBtB;;A2E93cE;EAAuB,gBAliEH;A3Eo6gBtB;;A2El4cE;EAAuB,gBAliEH;A3Ew6gBtB;;A2Et4cE;EAAuB,gBAliEH;A3E46gBtB;;A2E14cE;EAAuB,gBAliEH;A3Eg7gBtB;;A2E94cE;EAAuB,gBAliEH;A3Eo7gBtB;;A2El5cE;EAAuB,gBAliEH;A3Ew7gBtB;;A2Et5cE;EAAuB,gBAliEH;A3E47gBtB;;A2E15cE;EAAuB,gBAliEH;A3Eg8gBtB;;A2E95cE;EAAuB,gBAliEH;A3Eo8gBtB;;A2El6cE;EAAuB,gBAliEH;A3Ew8gBtB;;A2Et6cE;EAAuB,gBAliEH;A3E48gBtB;;A2E16cE;EAAuB,gBAliEH;A3Eg9gBtB;;A2E96cE;EAAuB,gBAliEH;A3Eo9gBtB;;A2El7cE;EAAuB,gBAliEH;A3Ew9gBtB;;A2Et7cE;EAAuB,gBAliEH;A3E49gBtB;;A2E17cE;EAAuB,gBAliEH;A3Eg+gBtB;;A2E97cE;EAAuB,gBAliEH;A3Eo+gBtB;;A2El8cE;EAAuB,gBAliEH;A3Ew+gBtB;;A2Et8cE;EAAuB,gBAliEH;A3E4+gBtB;;A2E18cE;EAAuB,gBAliEH;A3Eg/gBtB;;A2E98cE;EAAuB,gBAliEH;A3Eo/gBtB;;A2El9cE;EAAuB,gBAliEH;A3Ew/gBtB;;A2Et9cE;EAAuB,gBAliEH;A3E4/gBtB;;A2E19cE;EAAuB,gBAliEH;A3EgghBtB;;A2E99cE;EAAuB,gBAliEH;A3EoghBtB;;A2El+cE;EAAuB,gBAliEH;A3EwghBtB;;A2Et+cE;EAAuB,gBAliEH;A3E4ghBtB;;A2E1+cE;EAAuB,gBAliEH;A3EghhBtB;;A2E9+cE;EAAuB,gBAliEH;A3EohhBtB;;A2El/cE;EAAuB,gBAliEH;A3EwhhBtB;;A2Et/cE;EAAuB,gBAliEH;A3E4hhBtB;;A2E1/cE;EAAuB,gBAliEH;A3EgihBtB;;A2E9/cE;EAAuB,gBAliEH;A3EoihBtB;;A2ElgdE;EAAuB,gBAliEH;A3EwihBtB;;A2EtgdE;EAAuB,gBAliEH;A3E4ihBtB;;A2E1gdE;EAAuB,gBAliEH;A3EgjhBtB;;A2E9gdE;EAAuB,gBAliEH;A3EojhBtB;;A2ElhdE;EAAuB,gBAliEH;A3EwjhBtB;;A2EthdE;EAAuB,gBAliEH;A3E4jhBtB;;A2E1hdE;EAAuB,gBAliEH;A3EgkhBtB;;A2E9hdE;EAAuB,gBAliEH;A3EokhBtB;;A2ElidE;EAAuB,gBAliEH;A3EwkhBtB;;A2EtidE;EAAuB,gBAliEH;A3E4khBtB;;A2E1idE;EAAuB,gBAliEH;A3EglhBtB;;A2E9idE;EAAuB,gBAliEH;A3EolhBtB;;A2EljdE;EAAuB,gBAliEH;A3EwlhBtB;;A2EtjdE;EAAuB,gBAliEH;A3E4lhBtB;;A2E1jdE;EAAuB,gBAliEH;A3EgmhBtB;;A2E9jdE;EAAuB,gBAliEH;A3EomhBtB;;A2ElkdE;EAAuB,gBAliEH;A3EwmhBtB;;A2EtkdE;EAAuB,gBAliEH;A3E4mhBtB;;A2E1kdE;EAAuB,gBAliEH;A3EgnhBtB;;A2E9kdE;EAAuB,gBAliEH;A3EonhBtB;;A2ElldE;EAAuB,gBAliEH;A3EwnhBtB;;A2EtldE;EAAuB,gBAliEH;A3E4nhBtB;;A2E1ldE;EAAuB,gBAliEH;A3EgohBtB;;A2E9ldE;EAAuB,gBAliEH;A3EoohBtB;;A2ElmdE;EAAuB,gBAliEH;A3EwohBtB;;A2EtmdE;EAAuB,gBAliEH;A3E4ohBtB;;A2E1mdE;EAAuB,gBAliEH;A3EgphBtB;;A2E9mdE;EAAuB,gBAliEH;A3EophBtB;;A2ElndE;EAAuB,gBAliEH;A3EwphBtB;;A2EtndE;EAAuB,gBAliEH;A3E4phBtB;;A2E1ndE;EAAuB,gBAliEH;A3EgqhBtB;;A2E9ndE;EAAuB,gBAliEH;A3EoqhBtB;;A2ElodE;EAAuB,gBAliEH;A3EwqhBtB;;A2EtodE;EAAuB,gBAliEH;A3E4qhBtB;;A2E1odE;EAAuB,gBAliEH;A3EgrhBtB;;A2E9odE;EAAuB,gBAliEH;A3EorhBtB;;A2ElpdE;EAAuB,gBAliEH;A3EwrhBtB;;A2EtpdE;EAAuB,gBAliEH;A3E4rhBtB;;A2E1pdE;EAAuB,gBAliEH;A3EgshBtB;;A2E9pdE;EAAuB,gBAliEH;A3EoshBtB;;A2ElqdE;EAAuB,gBAliEH;A3EwshBtB;;A2EtqdE;EAAuB,gBAliEH;A3E4shBtB;;A2E1qdE;EAAuB,gBAliEH;A3EgthBtB;;A2E9qdE;EAAuB,gBAliEH;A3EothBtB;;A2ElrdE;EAAuB,gBAliEH;A3EwthBtB;;A2EtrdE;EAAuB,gBAliEH;A3E4thBtB;;A2E1rdE;EAAuB,gBAliEH;A3EguhBtB;;A2E9rdE;EAAuB,gBAliEH;A3EouhBtB;;A2ElsdE;EAAuB,gBAliEH;A3EwuhBtB;;A2EtsdE;EAAuB,gBAliEH;A3E4uhBtB;;A2E1sdE;EAAuB,gBAliEH;A3EgvhBtB;;A2E9sdE;EAAuB,gBAliEH;A3EovhBtB;;A2EltdE;EAAuB,gBAliEH;A3EwvhBtB;;A2EttdE;EAAuB,gBAliEH;A3E4vhBtB;;A2E1tdE;EAAuB,gBAliEH;A3EgwhBtB;;A2E9tdE;EAAuB,gBAliEH;A3EowhBtB;;A2EludE;EAAuB,gBAliEH;A3EwwhBtB;;A2EtudE;EAAuB,gBAliEH;A3E4whBtB;;A2E1udE;EAAuB,gBAliEH;A3EgxhBtB;;A2E9udE;EAAuB,gBAliEH;A3EoxhBtB;;A2ElvdE;EAAuB,gBAliEH;A3EwxhBtB;;A2EtvdE;EAAuB,gBAliEH;A3E4xhBtB;;A2E1vdE;EAAuB,gBAliEH;A3EgyhBtB;;A2E9vdE;EAAuB,gBAliEH;A3EoyhBtB;;A2ElwdE;EAAuB,gBAliEH;A3EwyhBtB;;A2EtwdE;EAAuB,gBAliEH;A3E4yhBtB;;A2E1wdE;EAAuB,gBAliEH;A3EgzhBtB;;A2E9wdE;EAAuB,gBAliEH;A3EozhBtB;;A2ElxdE;EAAuB,gBAliEH;A3EwzhBtB;;A2EtxdE;EAAuB,gBAliEH;A3E4zhBtB;;A2E1xdE;EAAuB,gBAliEH;A3Eg0hBtB;;A2E9xdE;EAAuB,gBAliEH;A3Eo0hBtB;;A2ElydE;EAAuB,gBAliEH;A3Ew0hBtB;;A2EtydE;EAAuB,gBAliEH;A3E40hBtB;;A2E1ydE;EAAuB,gBAliEH;A3Eg1hBtB;;A2E9ydE;EAAuB,gBAliEH;A3Eo1hBtB;;A2ElzdE;EAAuB,gBAliEH;A3Ew1hBtB;;A2EtzdE;EAAuB,gBAliEH;A3E41hBtB;;A2E1zdE;EAAuB,gBAliEH;A3Eg2hBtB;;A2E9zdE;EAAuB,gBAliEH;A3Eo2hBtB;;A2El0dE;EAAuB,gBAliEH;A3Ew2hBtB;;A2Et0dE;EAAuB,gBAliEH;A3E42hBtB;;A2E10dE;EAAuB,gBAliEH;A3Eg3hBtB;;A2E90dE;EAAuB,gBAliEH;A3Eo3hBtB;;A2El1dE;EAAuB,gBAliEH;A3Ew3hBtB;;A2Et1dE;EAAuB,gBAliEH;A3E43hBtB;;A2E11dE;EAAuB,gBAliEH;A3Eg4hBtB;;A2E91dE;EAAuB,gBAliEH;A3Eo4hBtB;;A2El2dE;EAAuB,gBAliEH;A3Ew4hBtB;;A2Et2dE;EAAuB,gBAliEH;A3E44hBtB;;A2E12dE;EAAuB,gBAliEH;A3Eg5hBtB;;A2E92dE;EAAuB,gBAliEH;A3Eo5hBtB;;A2El3dE;EAAuB,gBAliEH;A3Ew5hBtB;;A2Et3dE;EAAuB,gBAliEH;A3E45hBtB;;A2E13dE;EAAuB,gBAliEH;A3Eg6hBtB;;A2E93dE;EAAuB,gBAliEH;A3Eo6hBtB;;A2El4dE;EAAuB,gBAliEH;A3Ew6hBtB;;A2Et4dE;EAAuB,gBAliEH;A3E46hBtB;;A2E14dE;EAAuB,gBAliEH;A3Eg7hBtB;;A2E94dE;EAAuB,gBAliEH;A3Eo7hBtB;;A2El5dE;EAAuB,gBAliEH;A3Ew7hBtB;;A2Et5dE;EAAuB,gBAliEH;A3E47hBtB;;A2E15dE;EAAuB,gBAliEH;A3Eg8hBtB;;A2E95dE;EAAuB,gBAliEH;A3Eo8hBtB;;A2El6dE;EAAuB,gBAliEH;A3Ew8hBtB;;A2Et6dE;EAAuB,gBAliEH;A3E48hBtB;;A2E16dE;EAAuB,gBAliEH;A3Eg9hBtB;;A2E96dE;EAAuB,gBAliEH;A3Eo9hBtB;;A2El7dE;EAAuB,gBAliEH;A3Ew9hBtB;;A2Et7dE;EAAuB,gBAliEH;A3E49hBtB;;A2E17dE;EAAuB,gBAliEH;A3Eg+hBtB;;A2E97dE;EAAuB,gBAliEH;A3Eo+hBtB;;A2El8dE;EAAuB,gBAliEH;A3Ew+hBtB;;A2Et8dE;EAAuB,gBAliEH;A3E4+hBtB;;A2E18dE;EAAuB,gBAliEH;A3Eg/hBtB;;A2E98dE;EAAuB,gBAliEH;A3Eo/hBtB;;A2El9dE;EAAuB,gBAliEH;A3Ew/hBtB;;A2Et9dE;EAAuB,gBAliEH;A3E4/hBtB;;A2E19dE;EAAuB,gBAliEH;A3EggiBtB;;A2E99dE;EAAuB,gBAliEH;A3EogiBtB;;A2El+dE;EAAuB,gBAliEH;A3EwgiBtB;;A2Et+dE;EAAuB,gBAliEH;A3E4giBtB;;A2E1+dE;EAAuB,gBAliEH;A3EghiBtB;;A2E9+dE;EAAuB,gBAliEH;A3EohiBtB;;A2El/dE;EAAuB,gBAliEH;A3EwhiBtB;;A2Et/dE;EAAuB,gBAliEH;A3E4hiBtB;;A2E1/dE;EAAuB,gBAliEH;A3EgiiBtB;;A2E9/dE;EAAuB,gBAliEH;A3EoiiBtB;;A2ElgeE;EAAuB,gBAliEH;A3EwiiBtB;;A2EtgeE;EAAuB,gBAliEH;A3E4iiBtB;;A2E1geE;EAAuB,gBAliEH;A3EgjiBtB;;A2E9geE;EAAuB,gBAliEH;A3EojiBtB;;A2ElheE;EAAuB,gBAliEH;A3EwjiBtB;;A2EtheE;EAAuB,gBAliEH;A3E4jiBtB;;A2E1heE;EAAuB,gBAliEH;A3EgkiBtB;;A2E9heE;EAAuB,gBAliEH;A3EokiBtB;;A2ElieE;EAAuB,gBAliEH;A3EwkiBtB;;A2EtieE;EAAuB,gBAliEH;A3E4kiBtB;;A2E1ieE;EAAuB,gBAliEH;A3EgliBtB;;A2E9ieE;EAAuB,gBAliEH;A3EoliBtB;;A2EljeE;EAAuB,gBAliEH;A3EwliBtB;;A2EtjeE;EAAuB,gBAliEH;A3E4liBtB;;A2E1jeE;EAAuB,gBAliEH;A3EgmiBtB;;A2E9jeE;EAAuB,gBAliEH;A3EomiBtB;;A2ElkeE;EAAuB,gBAliEH;A3EwmiBtB;;A2EtkeE;EAAuB,gBAliEH;A3E4miBtB;;A2E1keE;EAAuB,gBAliEH;A3EgniBtB;;A2E9keE;EAAuB,gBAliEH;A3EoniBtB;;A2ElleE;EAAuB,gBAliEH;A3EwniBtB;;A2EtleE;EAAuB,gBAliEH;A3E4niBtB;;A2E1leE;EAAuB,gBAliEH;A3EgoiBtB;;A2E9leE;EAAuB,gBAliEH;A3EooiBtB;;A2ElmeE;EAAuB,gBAliEH;A3EwoiBtB;;A2EtmeE;EAAuB,gBAliEH;A3E4oiBtB;;A2E1meE;EAAuB,gBAliEH;A3EgpiBtB;;A2E9meE;EAAuB,gBAliEH;A3EopiBtB;;A2ElneE;EAAuB,gBAliEH;A3EwpiBtB;;A2EtneE;EAAuB,gBAliEH;A3E4piBtB;;A2E1neE;EAAuB,gBAliEH;A3EgqiBtB;;A2E9neE;EAAuB,gBAliEH;A3EoqiBtB;;A2EloeE;EAAuB,gBAliEH;A3EwqiBtB;;A2EtoeE;EAAuB,gBAliEH;A3E4qiBtB;;A2E1oeE;EAAuB,gBAliEH;A3EgriBtB;;A2E9oeE;EAAuB,gBAliEH;A3EoriBtB;;A2ElpeE;EAAuB,gBAliEH;A3EwriBtB;;A2EtpeE;EAAuB,gBAliEH;A3E4riBtB;;A2E1peE;EAAuB,gBAliEH;A3EgsiBtB;;A2E9peE;EAAuB,gBAliEH;A3EosiBtB;;A2ElqeE;EAAuB,gBAliEH;A3EwsiBtB;;A2EtqeE;EAAuB,gBAliEH;A3E4siBtB;;A2E1qeE;EAAuB,gBAliEH;A3EgtiBtB;;A2E9qeE;EAAuB,gBAliEH;A3EotiBtB;;A2ElreE;EAAuB,gBAliEH;A3EwtiBtB;;A2EtreE;EAAuB,gBAliEH;A3E4tiBtB;;A2E1reE;EAAuB,gBAliEH;A3EguiBtB;;A2E9reE;EAAuB,gBAliEH;A3EouiBtB;;A2ElseE;EAAuB,gBAliEH;A3EwuiBtB;;A2EtseE;EAAuB,gBAliEH;A3E4uiBtB;;A2E1seE;EAAuB,gBAliEH;A3EgviBtB;;A2E9seE;EAAuB,gBAliEH;A3EoviBtB;;A2ElteE;EAAuB,gBAliEH;A3EwviBtB;;A2EtteE;EAAuB,gBAliEH;A3E4viBtB;;A2E1teE;EAAuB,gBAliEH;A3EgwiBtB;;A2E9teE;EAAuB,gBAliEH;A3EowiBtB;;A2ElueE;EAAuB,gBAliEH;A3EwwiBtB;;A2EtueE;EAAuB,gBAliEH;A3E4wiBtB;;A2E1ueE;EAAuB,gBAliEH;A3EgxiBtB;;A2E9ueE;EAAuB,gBAliEH;A3EoxiBtB;;A2ElveE;EAAuB,gBAliEH;A3EwxiBtB;;A2EtveE;EAAuB,gBAliEH;A3E4xiBtB;;A2E1veE;EAAuB,gBAliEH;A3EgyiBtB;;A2E9veE;EAAuB,gBAliEH;A3EoyiBtB;;A2ElweE;EAAuB,gBAliEH;A3EwyiBtB;;A2EtweE;EAAuB,gBAliEH;A3E4yiBtB;;A2E1weE;EAAuB,gBAliEH;A3EgziBtB;;A2E9weE;EAAuB,gBAliEH;A3EoziBtB;;A2ElxeE;EAAuB,gBAliEH;A3EwziBtB;;A2EtxeE;EAAuB,gBAliEH;A3E4ziBtB;;A2E1xeE;EAAuB,gBAliEH;A3Eg0iBtB;;A2E9xeE;EAAuB,gBAliEH;A3Eo0iBtB;;A2ElyeE;EAAuB,gBAliEH;A3Ew0iBtB;;A2EtyeE;EAAuB,gBAliEH;A3E40iBtB;;A2E1yeE;EAAuB,gBAliEH;A3Eg1iBtB;;A2E9yeE;EAAuB,gBAliEH;A3Eo1iBtB;;A2ElzeE;EAAuB,gBAliEH;A3Ew1iBtB;;A2EtzeE;EAAuB,gBAliEH;A3E41iBtB;;A2E1zeE;EAAuB,gBAliEH;A3Eg2iBtB;;A2E9zeE;EAAuB,gBAliEH;A3Eo2iBtB;;A2El0eE;EAAuB,gBAliEH;A3Ew2iBtB;;A2Et0eE;EAAuB,gBAliEH;A3E42iBtB;;A2E10eE;EAAuB,gBAliEH;A3Eg3iBtB;;A2E90eE;EAAuB,gBAliEH;A3Eo3iBtB;;A2El1eE;EAAuB,gBAliEH;A3Ew3iBtB;;A2Et1eE;EAAuB,gBAliEH;A3E43iBtB;;A2E11eE;EAAuB,gBAliEH;A3Eg4iBtB;;A2E91eE;EAAuB,gBAliEH;A3Eo4iBtB;;A2El2eE;EAAuB,gBAliEH;A3Ew4iBtB;;A2Et2eE;EAAuB,gBAliEH;A3E44iBtB;;A2E12eE;EAAuB,gBAliEH;A3Eg5iBtB;;A2E92eE;EAAuB,gBAliEH;A3Eo5iBtB;;A2El3eE;EAAuB,gBAliEH;A3Ew5iBtB;;A2Et3eE;EAAuB,gBAliEH;A3E45iBtB;;A2E13eE;EAAuB,gBAliEH;A3Eg6iBtB;;A2E93eE;EAAuB,gBAliEH;A3Eo6iBtB;;A2El4eE;EAAuB,gBAliEH;A3Ew6iBtB;;A2Et4eE;EAAuB,gBAliEH;A3E46iBtB;;A2E14eE;EAAuB,gBAliEH;A3Eg7iBtB;;A2E94eE;EAAuB,gBAliEH;A3Eo7iBtB;;A2El5eE;EAAuB,gBAliEH;A3Ew7iBtB;;A2Et5eE;EAAuB,gBAliEH;A3E47iBtB;;A2E15eE;EAAuB,gBAliEH;A3Eg8iBtB;;A2E95eE;EAAuB,gBAliEH;A3Eo8iBtB;;A2El6eE;EAAuB,gBAliEH;A3Ew8iBtB;;A2Et6eE;EAAuB,gBAliEH;A3E48iBtB;;A2E16eE;EAAuB,gBAliEH;A3Eg9iBtB;;A2E96eE;EAAuB,gBAliEH;A3Eo9iBtB;;A2El7eE;EAAuB,gBAliEH;A3Ew9iBtB;;A2Et7eE;EAAuB,gBAliEH;A3E49iBtB;;A2E17eE;EAAuB,gBAliEH;A3Eg+iBtB;;A2E97eE;EAAuB,gBAliEH;A3Eo+iBtB;;A2El8eE;EAAuB,gBAliEH;A3Ew+iBtB;;A2Et8eE;EAAuB,gBAliEH;A3E4+iBtB;;A2E18eE;EAAuB,gBAliEH;A3Eg/iBtB;;A2E98eE;EAAuB,gBAliEH;A3Eo/iBtB;;A2El9eE;EAAuB,gBAliEH;A3Ew/iBtB;;A2Et9eE;EAAuB,gBAliEH;A3E4/iBtB;;A2E19eE;EAAuB,gBAliEH;A3EggjBtB;;A2E99eE;EAAuB,gBAliEH;A3EogjBtB;;A2El+eE;EAAuB,gBAliEH;A3EwgjBtB;;A2Et+eE;EAAuB,gBAliEH;A3E4gjBtB;;A2E1+eE;EAAuB,gBAliEH;A3EghjBtB;;A2E9+eE;EAAuB,gBAliEH;A3EohjBtB;;A2El/eE;EAAuB,gBAliEH;A3EwhjBtB;;A2Et/eE;EAAuB,gBAliEH;A3E4hjBtB;;A2E1/eE;EAAuB,gBAliEH;A3EgijBtB;;A2E9/eE;EAAuB,gBAliEH;A3EoijBtB;;A2ElgfE;EAAuB,gBAliEH;A3EwijBtB;;A2EtgfE;EAAuB,gBAliEH;A3E4ijBtB;;A2E1gfE;EAAuB,gBAliEH;A3EgjjBtB;;A2E9gfE;EAAuB,gBAliEH;A3EojjBtB;;A2ElhfE;EAAuB,gBAliEH;A3EwjjBtB;;A2EthfE;EAAuB,gBAliEH;A3E4jjBtB;;A2E1hfE;EAAuB,gBAliEH;A3EgkjBtB;;A2E9hfE;EAAuB,gBAliEH;A3EokjBtB;;A2ElifE;EAAuB,gBAliEH;A3EwkjBtB;;A2EtifE;EAAuB,gBAliEH;A3E4kjBtB;;A2E1ifE;EAAuB,gBAliEH;A3EgljBtB;;A2E9ifE;EAAuB,gBAliEH;A3EoljBtB;;A2EljfE;EAAuB,gBAliEH;A3EwljBtB;;A2EtjfE;EAAuB,gBAliEH;A3E4ljBtB;;A2E1jfE;EAAuB,gBAliEH;A3EgmjBtB;;A2E9jfE;EAAuB,gBAliEH;A3EomjBtB;;A2ElkfE;EAAuB,gBAliEH;A3EwmjBtB;;A2EtkfE;EAAuB,gBAliEH;A3E4mjBtB;;A2E1kfE;EAAuB,gBAliEH;A3EgnjBtB;;A2E9kfE;EAAuB,gBAliEH;A3EonjBtB;;A2EllfE;EAAuB,gBAliEH;A3EwnjBtB;;A2EtlfE;EAAuB,gBAliEH;A3E4njBtB;;A2E1lfE;EAAuB,gBAliEH;A3EgojBtB;;A2E9lfE;EAAuB,gBAliEH;A3EoojBtB;;A2ElmfE;EAAuB,gBAliEH;A3EwojBtB;;A2EtmfE;EAAuB,gBAliEH;A3E4ojBtB;;A2E1mfE;EAAuB,gBAliEH;A3EgpjBtB;;A2E9mfE;EAAuB,gBAliEH;A3EopjBtB;;A2ElnfE;EAAuB,gBAliEH;A3EwpjBtB;;A2EtnfE;EAAuB,gBAliEH;A3E4pjBtB;;A2E1nfE;EAAuB,gBAliEH;A3EgqjBtB;;A2E9nfE;EAAuB,gBAliEH;A3EoqjBtB;;A2ElofE;EAAuB,gBAliEH;A3EwqjBtB;;A2EtofE;EAAuB,gBAliEH;A3E4qjBtB;;A2E1ofE;EAAuB,gBAliEH;A3EgrjBtB;;A2E9ofE;EAAuB,gBAliEH;A3EorjBtB;;A2ElpfE;EAAuB,gBAliEH;A3EwrjBtB;;A2EtpfE;EAAuB,gBAliEH;A3E4rjBtB;;A2E1pfE;EAAuB,gBAliEH;A3EgsjBtB;;A2E9pfE;EAAuB,gBAliEH;A3EosjBtB;;A2ElqfE;EAAuB,gBAliEH;A3EwsjBtB;;A2EtqfE;EAAuB,gBAliEH;A3E4sjBtB;;A2E1qfE;EAAuB,gBAliEH;A3EgtjBtB;;A2E9qfE;EAAuB,gBAliEH;A3EotjBtB;;A2ElrfE;EAAuB,gBAliEH;A3EwtjBtB;;A2EtrfE;EAAuB,gBAliEH;A3E4tjBtB;;A2E1rfE;EAAuB,gBAliEH;A3EgujBtB;;A2E9rfE;EAAuB,gBAliEH;A3EoujBtB;;A2ElsfE;EAAuB,gBAliEH;A3EwujBtB;;A2EtsfE;EAAuB,gBAliEH;A3E4ujBtB;;A2E1sfE;EAAuB,gBAliEH;A3EgvjBtB;;A2E9sfE;EAAuB,gBAliEH;A3EovjBtB;;A2EltfE;EAAuB,gBAliEH;A3EwvjBtB;;A2EttfE;EAAuB,gBAliEH;A3E4vjBtB;;A2E1tfE;EAAuB,gBAliEH;A3EgwjBtB;;A2E9tfE;EAAuB,gBAliEH;A3EowjBtB;;A2ElufE;EAAuB,gBAliEH;A3EwwjBtB;;A2EtufE;EAAuB,gBAliEH;A3E4wjBtB;;A2E1ufE;EAAuB,gBAliEH;A3EgxjBtB;;A2E9ufE;EAAuB,gBAliEH;A3EoxjBtB;;A2ElvfE;EAAuB,gBAliEH;A3EwxjBtB;;A2EtvfE;EAAuB,gBAliEH;A3E4xjBtB;;A2E1vfE;EAAuB,gBAliEH;A3EgyjBtB;;A2E9vfE;EAAuB,gBAliEH;A3EoyjBtB;;A2ElwfE;EAAuB,gBAliEH;A3EwyjBtB;;A2EtwfE;EAAuB,gBAliEH;A3E4yjBtB;;A2E1wfE;EAAuB,gBAliEH;A3EgzjBtB;;A2E9wfE;EAAuB,gBAliEH;A3EozjBtB;;A2ElxfE;EAAuB,gBAliEH;A3EwzjBtB;;A2EtxfE;EAAuB,gBAliEH;A3E4zjBtB;;A2E1xfE;EAAuB,gBAliEH;A3Eg0jBtB;;A2E9xfE;EAAuB,gBAliEH;A3Eo0jBtB;;A2ElyfE;EAAuB,gBAliEH;A3Ew0jBtB;;A2EtyfE;EAAuB,gBAliEH;A3E40jBtB;;A2E1yfE;EAAuB,gBAliEH;A3Eg1jBtB;;A2E9yfE;EAAuB,gBAliEH;A3Eo1jBtB;;A2ElzfE;EAAuB,gBAliEH;A3Ew1jBtB;;A2EtzfE;EAAuB,gBAliEH;A3E41jBtB;;A2E1zfE;EAAuB,gBAliEH;A3Eg2jBtB;;A2E9zfE;EAAuB,gBAliEH;A3Eo2jBtB;;A2El0fE;EAAuB,gBAliEH;A3Ew2jBtB;;A2Et0fE;EAAuB,gBAliEH;A3E42jBtB;;A2E10fE;EAAuB,gBAliEH;A3Eg3jBtB;;A2E90fE;EAAuB,gBAliEH;A3Eo3jBtB;;A2El1fE;EAAuB,gBAliEH;A3Ew3jBtB;;A2Et1fE;EAAuB,gBAliEH;A3E43jBtB;;A2E11fE;EAAuB,gBAliEH;A3Eg4jBtB;;A2E91fE;EAAuB,gBAliEH;A3Eo4jBtB;;A2El2fE;EAAuB,gBAliEH;A3Ew4jBtB;;A2Et2fE;EAAuB,gBAliEH;A3E44jBtB;;A2E12fE;EAAuB,gBAliEH;A3Eg5jBtB;;A2E92fE;EAAuB,gBAliEH;A3Eo5jBtB;;A2El3fE;EAAuB,gBAliEH;A3Ew5jBtB;;A2Et3fE;EAAuB,gBAliEH;A3E45jBtB;;A2E13fE;EAAuB,gBAliEH;A3Eg6jBtB;;A2E93fE;EAAuB,gBAliEH;A3Eo6jBtB;;A2El4fE;EAAuB,gBAliEH;A3Ew6jBtB;;A2Et4fE;EAAuB,gBAliEH;A3E46jBtB;;A2E14fE;EAAuB,gBAliEH;A3Eg7jBtB;;A2E94fE;EAAuB,gBAliEH;A3Eo7jBtB;;A2El5fE;EAAuB,gBAliEH;A3Ew7jBtB;;A2Et5fE;EAAuB,gBAliEH;A3E47jBtB;;A2E15fE;EAAuB,gBAliEH;A3Eg8jBtB;;A2E95fE;EAAuB,gBAliEH;A3Eo8jBtB;;A2El6fE;EAAuB,gBAliEH;A3Ew8jBtB;;A2Et6fE;EAAuB,gBAliEH;A3E48jBtB;;A2E16fE;EAAuB,gBAliEH;A3Eg9jBtB;;A2E96fE;EAAuB,gBAliEH;A3Eo9jBtB;;A2El7fE;EAAuB,gBAliEH;A3Ew9jBtB;;A2Et7fE;EAAuB,gBAliEH;A3E49jBtB;;A2E17fE;EAAuB,gBAliEH;A3Eg+jBtB;;A2E97fE;EAAuB,gBAliEH;A3Eo+jBtB;;A2El8fE;EAAuB,gBAliEH;A3Ew+jBtB;;A2Et8fE;EAAuB,gBAliEH;A3E4+jBtB;;A2E18fE;EAAuB,gBAliEH;A3Eg/jBtB;;A2E98fE;EAAuB,gBAliEH;A3Eo/jBtB;;A2El9fE;EAAuB,gBAliEH;A3Ew/jBtB;;A2Et9fE;EAAuB,gBAliEH;A3E4/jBtB;;A2E19fE;EAAuB,gBAliEH;A3EggkBtB;;A2E99fE;EAAuB,gBAliEH;A3EogkBtB;;A2El+fE;EAAuB,gBAliEH;A3EwgkBtB;;A2Et+fE;EAAuB,gBAliEH;A3E4gkBtB;;A2E1+fE;EAAuB,gBAliEH;A3EghkBtB;;A2E9+fE;EAAuB,gBAliEH;A3EohkBtB;;A2El/fE;EAAuB,gBAliEH;A3EwhkBtB;;A2Et/fE;EAAuB,gBAliEH;A3E4hkBtB;;A2E1/fE;EAAuB,gBAliEH;A3EgikBtB;;A2E9/fE;EAAuB,gBAliEH;A3EoikBtB;;A2ElggBE;EAAuB,gBAliEH;A3EwikBtB;;A2EtggBE;EAAuB,gBAliEH;A3E4ikBtB;;A2E1ggBE;EAAuB,gBAliEH;A3EgjkBtB;;A2E9ggBE;EAAuB,gBAliEH;A3EojkBtB;;A2ElhgBE;EAAuB,gBAliEH;A3EwjkBtB;;A2EthgBE;EAAuB,gBAliEH;A3E4jkBtB;;A2E1hgBE;EAAuB,gBAliEH;A3EgkkBtB;;A2E9hgBE;EAAuB,gBAliEH;A3EokkBtB;;A2EligBE;EAAuB,gBAliEH;A3EwkkBtB;;A2EtigBE;EAAuB,gBAliEH;A3E4kkBtB;;A2E1igBE;EAAuB,gBAliEH;A3EglkBtB;;A2E9igBE;EAAuB,gBAliEH;A3EolkBtB;;A2EljgBE;EAAuB,gBAliEH;A3EwlkBtB;;A2EtjgBE;EAAuB,gBAliEH;A3E4lkBtB;;A2E1jgBE;EAAuB,gBAliEH;A3EgmkBtB;;A2E9jgBE;EAAuB,gBAliEH;A3EomkBtB;;A2ElkgBE;EAAuB,gBAliEH;A3EwmkBtB;;A2EtkgBE;EAAuB,gBAliEH;A3E4mkBtB;;A2E1kgBE;EAAuB,gBAliEH;A3EgnkBtB;;A2E9kgBE;EAAuB,gBAliEH;A3EonkBtB;;A2EllgBE;EAAuB,gBAliEH;A3EwnkBtB;;A2EtlgBE;EAAuB,gBAliEH;A3E4nkBtB;;A2E1lgBE;EAAuB,gBAliEH;A3EgokBtB;;A2E9lgBE;EAAuB,gBAliEH;A3EookBtB;;A2ElmgBE;EAAuB,gBAliEH;A3EwokBtB;;A2EtmgBE;EAAuB,gBAliEH;A3E4okBtB;;A2E1mgBE;EAAuB,gBAliEH;A3EgpkBtB;;A2E9mgBE;EAAuB,gBAliEH;A3EopkBtB;;A2ElngBE;EAAuB,gBAliEH;A3EwpkBtB;;A2EtngBE;EAAuB,gBAliEH;A3E4pkBtB;;A2E1ngBE;EAAuB,gBAliEH;A3EgqkBtB;;A2E9ngBE;EAAuB,gBAliEH;A3EoqkBtB;;A2ElogBE;EAAuB,gBAliEH;A3EwqkBtB;;A2EtogBE;EAAuB,gBAliEH;A3E4qkBtB;;A2E1ogBE;EAAuB,gBAliEH;A3EgrkBtB;;A2E9ogBE;EAAuB,gBAliEH;A3EorkBtB;;A2ElpgBE;EAAuB,gBAliEH;A3EwrkBtB;;A2EtpgBE;EAAuB,gBAliEH;A3E4rkBtB;;A2E1pgBE;EAAuB,gBAliEH;A3EgskBtB;;A2E9pgBE;EAAuB,gBAliEH;A3EoskBtB;;A2ElqgBE;EAAuB,gBAliEH;A3EwskBtB;;A2EtqgBE;EAAuB,gBAliEH;A3E4skBtB;;A2E1qgBE;EAAuB,gBAliEH;A3EgtkBtB;;A2E9qgBE;EAAuB,gBAliEH;A3EotkBtB;;A2ElrgBE;EAAuB,gBAliEH;A3EwtkBtB;;A2EtrgBE;EAAuB,gBAliEH;A3E4tkBtB;;A2E1rgBE;EAAuB,gBAliEH;A3EgukBtB;;A2E9rgBE;EAAuB,gBAliEH;A3EoukBtB;;A2ElsgBE;EAAuB,gBAliEH;A3EwukBtB;;A2EtsgBE;EAAuB,gBAliEH;A3E4ukBtB;;A2E1sgBE;EAAuB,gBAliEH;A3EgvkBtB;;A2E9sgBE;EAAuB,gBAliEH;A3EovkBtB;;A2EltgBE;EAAuB,gBAliEH;A3EwvkBtB;;A2EttgBE;EAAuB,gBAliEH;A3E4vkBtB;;A2E1tgBE;EAAuB,gBAliEH;A3EgwkBtB;;A2E9tgBE;EAAuB,gBAliEH;A3EowkBtB;;A2ElugBE;EAAuB,gBAliEH;A3EwwkBtB;;A2EtugBE;EAAuB,gBAliEH;A3E4wkBtB;;A2E1ugBE;EAAuB,gBAliEH;A3EgxkBtB;;A2E9ugBE;EAAuB,gBAliEH;A3EoxkBtB;;A2ElvgBE;EAAuB,gBAliEH;A3EwxkBtB;;A2EtvgBE;EAAuB,gBAliEH;A3E4xkBtB;;A2E1vgBE;EAAuB,gBAliEH;A3EgykBtB;;A2E9vgBE;EAAuB,gBAliEH;A3EoykBtB;;A2ElwgBE;EAAuB,gBAliEH;A3EwykBtB;;A2EtwgBE;EAAuB,gBAliEH;A3E4ykBtB;;A2E1wgBE;EAAuB,gBAliEH;A3EgzkBtB;;A2E9wgBE;EAAuB,gBAliEH;A3EozkBtB;;A2ElxgBE;EAAuB,gBAliEH;A3EwzkBtB;;A2EtxgBE;EAAuB,gBAliEH;A3E4zkBtB;;A2E1xgBE;EAAuB,gBAliEH;A3Eg0kBtB;;A2E9xgBE;EAAuB,gBAliEH;A3Eo0kBtB;;A2ElygBE;EAAuB,gBAliEH;A3Ew0kBtB;;A2EtygBE;EAAuB,gBAliEH;A3E40kBtB;;A2E1ygBE;EAAuB,gBAliEH;A3Eg1kBtB;;A2E9ygBE;EAAuB,gBAliEH;A3Eo1kBtB;;A2ElzgBE;EAAuB,gBAliEH;A3Ew1kBtB;;A2EtzgBE;EAAuB,gBAliEH;A3E41kBtB;;A2E1zgBE;EAAuB,gBAliEH;A3Eg2kBtB;;A2E9zgBE;EAAuB,gBAliEH;A3Eo2kBtB;;A2El0gBE;EAAuB,gBAliEH;A3Ew2kBtB;;A2Et0gBE;EAAuB,gBAliEH;A3E42kBtB;;A2E10gBE;EAAuB,gBAliEH;A3Eg3kBtB;;A2E90gBE;EAAuB,gBAliEH;A3Eo3kBtB;;A2El1gBE;EAAuB,gBAliEH;A3Ew3kBtB;;A2Et1gBE;EAAuB,gBAliEH;A3E43kBtB;;A2E11gBE;EAAuB,gBAliEH;A3Eg4kBtB;;A2E91gBE;EAAuB,gBAliEH;A3Eo4kBtB;;A2El2gBE;EAAuB,gBAliEH;A3Ew4kBtB;;A2Et2gBE;EAAuB,gBAliEH;A3E44kBtB;;A2E12gBE;EAAuB,gBAliEH;A3Eg5kBtB;;A2E92gBE;EAAuB,gBAliEH;A3Eo5kBtB;;A2El3gBE;EAAuB,gBAliEH;A3Ew5kBtB;;A2Et3gBE;EAAuB,gBAliEH;A3E45kBtB;;A2E13gBE;EAAuB,gBAliEH;A3Eg6kBtB;;A2E93gBE;EAAuB,gBAliEH;A3Eo6kBtB;;A2El4gBE;EAAuB,gBAliEH;A3Ew6kBtB;;A2Et4gBE;EAAuB,gBAliEH;A3E46kBtB;;A2E14gBE;EAAuB,gBAliEH;A3Eg7kBtB;;A2E94gBE;EAAuB,gBAliEH;A3Eo7kBtB;;A2El5gBE;EAAuB,gBAliEH;A3Ew7kBtB;;A2Et5gBE;EAAuB,gBAliEH;A3E47kBtB;;A2E15gBE;EAAuB,gBAliEH;A3Eg8kBtB;;A2E95gBE;EAAuB,gBAliEH;A3Eo8kBtB;;A2El6gBE;EAAuB,gBAliEH;A3Ew8kBtB;;A2Et6gBE;EAAuB,gBAliEH;A3E48kBtB;;A2E16gBE;EAAuB,gBAliEH;A3Eg9kBtB;;A2E96gBE;EAAuB,gBAliEH;A3Eo9kBtB;;A2El7gBE;EAAuB,gBAliEH;A3Ew9kBtB;;A2Et7gBE;EAAuB,gBAliEH;A3E49kBtB;;A2E17gBE;EAAuB,gBAliEH;A3Eg+kBtB;;A2E97gBE;EAAuB,gBAliEH;A3Eo+kBtB;;A2El8gBE;EAAuB,gBAliEH;A3Ew+kBtB;;A2Et8gBE;EAAuB,gBAliEH;A3E4+kBtB;;A2E18gBE;EAAuB,gBAliEH;A3Eg/kBtB;;A2E98gBE;EAAuB,gBAliEH;A3Eo/kBtB;;A2El9gBE;EAAuB,gBAliEH;A3Ew/kBtB;;A2Et9gBE;EAAuB,gBAliEH;A3E4/kBtB;;A2E19gBE;EAAuB,gBAliEH;A3EgglBtB;;A2E99gBE;EAAuB,gBAliEH;A3EoglBtB;;A2El+gBE;EAAuB,gBAliEH;A3EwglBtB;;A2Et+gBE;EAAuB,gBAliEH;A3E4glBtB;;A2E1+gBE;EAAuB,gBAliEH;A3EghlBtB;;A2E9+gBE;EAAuB,gBAliEH;A3EohlBtB;;A2El/gBE;EAAuB,gBAliEH;A3EwhlBtB;;A2Et/gBE;EAAuB,gBAliEH;A3E4hlBtB;;A2E1/gBE;EAAuB,gBAliEH;A3EgilBtB;;A2E9/gBE;EAAuB,gBAliEH;A3EoilBtB;;A2ElghBE;EAAuB,gBAliEH;A3EwilBtB;;A2EtghBE;EAAuB,gBAliEH;A3E4ilBtB;;A2E1ghBE;EAAuB,gBAliEH;A3EgjlBtB;;A2E9ghBE;EAAuB,gBAliEH;A3EojlBtB;;A2ElhhBE;EAAuB,gBAliEH;A3EwjlBtB;;A2EthhBE;EAAuB,gBAliEH;A3E4jlBtB;;A2E1hhBE;EAAuB,gBAliEH;A3EgklBtB;;A2E9hhBE;EAAuB,gBAliEH;A3EoklBtB;;A2ElihBE;EAAuB,gBAliEH;A3EwklBtB;;A2EtihBE;EAAuB,gBAliEH;A3E4klBtB;;A2E1ihBE;EAAuB,gBAliEH;A3EgllBtB;;A2E9ihBE;EAAuB,gBAliEH;A3EollBtB;;A2EljhBE;EAAuB,gBAliEH;A3EwllBtB;;A2EtjhBE;EAAuB,gBAliEH;A3E4llBtB;;A2E1jhBE;EAAuB,gBAliEH;A3EgmlBtB;;A2E9jhBE;EAAuB,gBAliEH;A3EomlBtB;;A2ElkhBE;EAAuB,gBAliEH;A3EwmlBtB;;A2EtkhBE;EAAuB,gBAliEH;A3E4mlBtB;;A2E1khBE;EAAuB,gBAliEH;A3EgnlBtB;;A2E9khBE;EAAuB,gBAliEH;A3EonlBtB;;A2EllhBE;EAAuB,gBAliEH;A3EwnlBtB;;A2EtlhBE;EAAuB,gBAliEH;A3E4nlBtB;;A2E1lhBE;EAAuB,gBAliEH;A3EgolBtB;;A2E9lhBE;EAAuB,gBAliEH;A3EoolBtB;;A2ElmhBE;EAAuB,gBAliEH;A3EwolBtB;;A2EtmhBE;EAAuB,gBAliEH;A3E4olBtB;;A2E1mhBE;EAAuB,gBAliEH;A3EgplBtB;;A2E9mhBE;EAAuB,gBAliEH;A3EoplBtB;;A2ElnhBE;EAAuB,gBAliEH;A3EwplBtB;;A2EtnhBE;EAAuB,gBAliEH;A3E4plBtB;;A2E1nhBE;EAAuB,gBAliEH;A3EgqlBtB;;A2E9nhBE;EAAuB,gBAliEH;A3EoqlBtB;;A2ElohBE;EAAuB,gBAliEH;A3EwqlBtB;;A2EtohBE;EAAuB,gBAliEH;A3E4qlBtB;;A2E1ohBE;EAAuB,gBAliEH;A3EgrlBtB;;A2E9ohBE;EAAuB,gBAliEH;A3EorlBtB;;A2ElphBE;EAAuB,gBAliEH;A3EwrlBtB;;A2EtphBE;EAAuB,gBAliEH;A3E4rlBtB;;A2E1phBE;EAAuB,gBAliEH;A3EgslBtB;;A2E9phBE;EAAuB,gBAliEH;A3EoslBtB;;A2ElqhBE;EAAuB,gBAliEH;A3EwslBtB;;A2EtqhBE;EAAuB,gBAliEH;A3E4slBtB;;A2E1qhBE;EAAuB,gBAliEH;A3EgtlBtB;;A2E9qhBE;EAAuB,gBAliEH;A3EotlBtB;;A2ElrhBE;EAAuB,gBAliEH;A3EwtlBtB;;A2EtrhBE;EAAuB,gBAliEH;A3E4tlBtB;;A2E1rhBE;EAAuB,gBAliEH;A3EgulBtB;;A2E9rhBE;EAAuB,gBAliEH;A3EoulBtB;;A2ElshBE;EAAuB,gBAliEH;A3EwulBtB;;A2EtshBE;EAAuB,gBAliEH;A3E4ulBtB;;A2E1shBE;EAAuB,gBAliEH;A3EgvlBtB;;A2E9shBE;EAAuB,gBAliEH;A3EovlBtB;;A2ElthBE;EAAuB,gBAliEH;A3EwvlBtB;;A2EtthBE;EAAuB,gBAliEH;A3E4vlBtB;;A2E1thBE;EAAuB,gBAliEH;A3EgwlBtB;;A2E9thBE;EAAuB,gBAliEH;A3EowlBtB;;A2EluhBE;EAAuB,gBAliEH;A3EwwlBtB;;A2EtuhBE;EAAuB,gBAliEH;A3E4wlBtB;;A2E1uhBE;EAAuB,gBAliEH;A3EgxlBtB;;A2E9uhBE;EAAuB,gBAliEH;A3EoxlBtB;;A2ElvhBE;EAAuB,gBAliEH;A3EwxlBtB;;A2EtvhBE;EAAuB,gBAliEH;A3E4xlBtB;;A2E1vhBE;EAAuB,gBAliEH;A3EgylBtB;;A2E9vhBE;EAAuB,gBAliEH;A3EoylBtB;;A2ElwhBE;EAAuB,gBAliEH;A3EwylBtB;;A2EtwhBE;EAAuB,gBAliEH;A3E4ylBtB;;A2E1whBE;EAAuB,gBAliEH;A3EgzlBtB;;A2E9whBE;EAAuB,gBAliEH;A3EozlBtB;;A2ElxhBE;EAAuB,gBAliEH;A3EwzlBtB;;A2EtxhBE;EAAuB,gBAliEH;A3E4zlBtB;;A2E1xhBE;EAAuB,gBAliEH;A3Eg0lBtB;;A2E9xhBE;EAAuB,gBAliEH;A3Eo0lBtB;;A2ElyhBE;EAAuB,gBAliEH;A3Ew0lBtB;;A2EtyhBE;EAAuB,gBAliEH;A3E40lBtB;;A2E1yhBE;EAAuB,gBAliEH;A3Eg1lBtB;;A2E9yhBE;EAAuB,gBAliEH;A3Eo1lBtB;;A2ElzhBE;EAAuB,gBAliEH;A3Ew1lBtB;;A2EtzhBE;EAAuB,gBAliEH;A3E41lBtB;;A2E1zhBE;EAAuB,gBAliEH;A3Eg2lBtB;;A2E9zhBE;EAAuB,gBAliEH;A3Eo2lBtB;;A2El0hBE;EAAuB,gBAliEH;A3Ew2lBtB;;A2Et0hBE;EAAuB,gBAliEH;A3E42lBtB;;A2E10hBE;EAAuB,gBAliEH;A3Eg3lBtB;;A2E90hBE;EAAuB,gBAliEH;A3Eo3lBtB;;A2El1hBE;EAAuB,gBAliEH;A3Ew3lBtB;;A2Et1hBE;EAAuB,gBAliEH;A3E43lBtB;;A2E11hBE;EAAuB,gBAliEH;A3Eg4lBtB;;A2E91hBE;EAAuB,gBAliEH;A3Eo4lBtB;;A2El2hBE;EAAuB,gBAliEH;A3Ew4lBtB;;A2Et2hBE;EAAuB,gBAliEH;A3E44lBtB;;A2E12hBE;EAAuB,gBAliEH;A3Eg5lBtB;;A2E92hBE;EAAuB,gBAliEH;A3Eo5lBtB;;A2El3hBE;EAAuB,gBAliEH;A3Ew5lBtB;;A2Et3hBE;EAAuB,gBAliEH;A3E45lBtB;;A2E13hBE;EAAuB,gBAliEH;A3Eg6lBtB;;A2E93hBE;EAAuB,gBAliEH;A3Eo6lBtB;;A2El4hBE;EAAuB,gBAliEH;A3Ew6lBtB;;A2Et4hBE;EAAuB,gBAliEH;A3E46lBtB;;A2E14hBE;EAAuB,gBAliEH;A3Eg7lBtB;;A2E94hBE;EAAuB,gBAliEH;A3Eo7lBtB;;A2El5hBE;EAAuB,gBAliEH;A3Ew7lBtB;;A2Et5hBE;EAAuB,gBAliEH;A3E47lBtB;;A2E15hBE;EAAuB,gBAliEH;A3Eg8lBtB;;A2E95hBE;EAAuB,gBAliEH;A3Eo8lBtB;;A2El6hBE;EAAuB,gBAliEH;A3Ew8lBtB;;A2Et6hBE;EAAuB,gBAliEH;A3E48lBtB;;A2E16hBE;EAAuB,gBAliEH;A3Eg9lBtB;;A2E96hBE;EAAuB,gBAliEH;A3Eo9lBtB;;A2El7hBE;EAAuB,gBAliEH;A3Ew9lBtB;;A2Et7hBE;EAAuB,gBAliEH;A3E49lBtB;;A2E17hBE;EAAuB,gBAliEH;A3Eg+lBtB;;A2E97hBE;EAAuB,gBAliEH;A3Eo+lBtB;;A2El8hBE;EAAuB,gBAliEH;A3Ew+lBtB;;A2Et8hBE;EAAuB,gBAliEH;A3E4+lBtB;;A2E18hBE;EAAuB,gBAliEH;A3Eg/lBtB;;A2E98hBE;EAAuB,gBAliEH;A3Eo/lBtB;;A2El9hBE;EAAuB,gBAliEH;A3Ew/lBtB;;A2Et9hBE;EAAuB,gBAliEH;A3E4/lBtB;;A2E19hBE;EAAuB,gBAliEH;A3EggmBtB;;A2E99hBE;EAAuB,gBAliEH;A3EogmBtB;;A2El+hBE;EAAuB,gBAliEH;A3EwgmBtB;;A2Et+hBE;EAAuB,gBAliEH;A3E4gmBtB;;A2E1+hBE;EAAuB,gBAliEH;A3EghmBtB;;A2E9+hBE;EAAuB,gBAliEH;A3EohmBtB;;A2El/hBE;EAAuB,gBAliEH;A3EwhmBtB;;A2Et/hBE;EAAuB,gBAliEH;A3E4hmBtB;;A2E1/hBE;EAAuB,gBAliEH;A3EgimBtB;;A2E9/hBE;EAAuB,gBAliEH;A3EoimBtB;;A2ElgiBE;EAAuB,gBAliEH;A3EwimBtB;;A2EtgiBE;EAAuB,gBAliEH;A3E4imBtB;;A2E1giBE;EAAuB,gBAliEH;A3EgjmBtB;;A2E9giBE;EAAuB,gBAliEH;A3EojmBtB;;A2ElhiBE;EAAuB,gBAliEH;A3EwjmBtB;;A2EthiBE;EAAuB,gBAliEH;A3E4jmBtB;;A2E1hiBE;EAAuB,gBAliEH;A3EgkmBtB;;A2E9hiBE;EAAuB,gBAliEH;A3EokmBtB;;A2EliiBE;EAAuB,gBAliEH;A3EwkmBtB;;A2EtiiBE;EAAuB,gBAliEH;A3E4kmBtB;;A2E1iiBE;EAAuB,gBAliEH;A3EglmBtB;;A2E9iiBE;EAAuB,gBAliEH;A3EolmBtB;;A2EljiBE;EAAuB,gBAliEH;A3EwlmBtB;;A2EtjiBE;EAAuB,gBAliEH;A3E4lmBtB;;A2E1jiBE;EAAuB,gBAliEH;A3EgmmBtB;;A2E9jiBE;EAAuB,gBAliEH;A3EommBtB;;A2ElkiBE;EAAuB,gBAliEH;A3EwmmBtB;;A2EtkiBE;EAAuB,gBAliEH;A3E4mmBtB;;A2E1kiBE;EAAuB,gBAliEH;A3EgnmBtB;;A2E9kiBE;EAAuB,gBAliEH;A3EonmBtB;;A2ElliBE;EAAuB,gBAliEH;A3EwnmBtB;;A2EtliBE;EAAuB,gBAliEH;A3E4nmBtB;;A2E1liBE;EAAuB,gBAliEH;A3EgomBtB;;A2E9liBE;EAAuB,gBAliEH;A3EoomBtB;;A2ElmiBE;EAAuB,gBAliEH;A3EwomBtB;;A2EtmiBE;EAAuB,gBAliEH;A3E4omBtB;;A2E1miBE;EAAuB,gBAliEH;A3EgpmBtB;;A2E9miBE;EAAuB,gBAliEH;A3EopmBtB;;A2ElniBE;EAAuB,gBAliEH;A3EwpmBtB;;A2EtniBE;EAAuB,gBAliEH;A3E4pmBtB;;A2E1niBE;EAAuB,gBAliEH;A3EgqmBtB;;A2E9niBE;EAAuB,gBAliEH;A3EoqmBtB;;A2EloiBE;EAAuB,gBAliEH;A3EwqmBtB;;A2EtoiBE;EAAuB,gBAliEH;A3E4qmBtB;;A2E1oiBE;EAAuB,gBAliEH;A3EgrmBtB;;A2E9oiBE;EAAuB,gBAliEH;A3EormBtB;;A2ElpiBE;EAAuB,gBAliEH;A3EwrmBtB;;A2EtpiBE;EAAuB,gBAliEH;A3E4rmBtB;;A2E1piBE;EAAuB,gBAliEH;A3EgsmBtB;;A2E9piBE;EAAuB,gBAliEH;A3EosmBtB;;A2ElqiBE;EAAuB,gBAliEH;A3EwsmBtB;;A2EtqiBE;EAAuB,gBAliEH;A3E4smBtB;;A2E1qiBE;EAAuB,gBAliEH;A3EgtmBtB;;A2E9qiBE;EAAuB,gBAliEH;A3EotmBtB;;A2ElriBE;EAAuB,gBAliEH;A3EwtmBtB;;A2EtriBE;EAAuB,gBAliEH;A3E4tmBtB;;A2E1riBE;EAAuB,gBAliEH;A3EgumBtB;;A2E9riBE;EAAuB,gBAliEH;A3EoumBtB;;A2ElsiBE;EAAuB,gBAliEH;A3EwumBtB;;A2EtsiBE;EAAuB,gBAliEH;A3E4umBtB;;A2E1siBE;EAAuB,gBAliEH;A3EgvmBtB;;A2E9siBE;EAAuB,gBAliEH;A3EovmBtB;;A2EltiBE;EAAuB,gBAliEH;A3EwvmBtB;;A2EttiBE;EAAuB,gBAliEH;A3E4vmBtB;;A2E1tiBE;EAAuB,gBAliEH;A3EgwmBtB;;A2E9tiBE;EAAuB,gBAliEH;A3EowmBtB;;A2EluiBE;EAAuB,gBAliEH;A3EwwmBtB;;A2EtuiBE;EAAuB,gBAliEH;A3E4wmBtB;;A2E1uiBE;EAAuB,gBAliEH;A3EgxmBtB;;A2E9uiBE;EAAuB,gBAliEH;A3EoxmBtB;;A2ElviBE;EAAuB,gBAliEH;A3EwxmBtB;;A2EtviBE;EAAuB,gBAliEH;A3E4xmBtB;;A2E1viBE;EAAuB,gBAliEH;A3EgymBtB;;A2E9viBE;EAAuB,gBAliEH;A3EoymBtB;;A2ElwiBE;EAAuB,gBAliEH;A3EwymBtB;;A2EtwiBE;EAAuB,gBAliEH;A3E4ymBtB;;A2E1wiBE;EAAuB,gBAliEH;A3EgzmBtB;;A2E9wiBE;EAAuB,gBAliEH;A3EozmBtB;;A2ElxiBE;EAAuB,gBAliEH;A3EwzmBtB;;A2EtxiBE;EAAuB,gBAliEH;A3E4zmBtB;;A2E1xiBE;EAAuB,gBAliEH;A3Eg0mBtB;;A2E9xiBE;EAAuB,gBAliEH;A3Eo0mBtB;;A2ElyiBE;EAAuB,gBAliEH;A3Ew0mBtB;;A2EtyiBE;EAAuB,gBAliEH;A3E40mBtB;;A2E1yiBE;EAAuB,gBAliEH;A3Eg1mBtB;;A2E9yiBE;EAAuB,gBAliEH;A3Eo1mBtB;;A2ElziBE;EAAuB,gBAliEH;A3Ew1mBtB;;A2EtziBE;EAAuB,gBAliEH;A3E41mBtB;;A2E1ziBE;EAAuB,gBAliEH;A3Eg2mBtB;;A2E9ziBE;EAAuB,gBAliEH;A3Eo2mBtB;;A2El0iBE;EAAuB,gBAliEH;A3Ew2mBtB;;A2Et0iBE;EAAuB,gBAliEH;A3E42mBtB;;A2E10iBE;EAAuB,gBAliEH;A3Eg3mBtB;;A2E90iBE;EAAuB,gBAliEH;A3Eo3mBtB;;A2El1iBE;EAAuB,gBAliEH;A3Ew3mBtB;;A2Et1iBE;EAAuB,gBAliEH;A3E43mBtB;;A2E11iBE;EAAuB,gBAliEH;A3Eg4mBtB;;A2E91iBE;EAAuB,gBAliEH;A3Eo4mBtB;;A2El2iBE;EAAuB,gBAliEH;A3Ew4mBtB;;A2Et2iBE;EAAuB,gBAliEH;A3E44mBtB;;A2E12iBE;EAAuB,gBAliEH;A3Eg5mBtB;;A2E92iBE;EAAuB,gBAliEH;A3Eo5mBtB;;A2El3iBE;EAAuB,gBAliEH;A3Ew5mBtB;;A2Et3iBE;EAAuB,gBAliEH;A3E45mBtB;;A2E13iBE;EAAuB,gBAliEH;A3Eg6mBtB;;A2E93iBE;EAAuB,gBAliEH;A3Eo6mBtB;;A2El4iBE;EAAuB,gBAliEH;A3Ew6mBtB;;A2Et4iBE;EAAuB,gBAliEH;A3E46mBtB;;A2E14iBE;EAAuB,gBAliEH;A3Eg7mBtB;;A2E94iBE;EAAuB,gBAliEH;A3Eo7mBtB;;A2El5iBE;EAAuB,gBAliEH;A3Ew7mBtB;;A2Et5iBE;EAAuB,gBAliEH;A3E47mBtB;;A2E15iBE;EAAuB,gBAliEH;A3Eg8mBtB;;A2E95iBE;EAAuB,gBAliEH;A3Eo8mBtB;;A2El6iBE;EAAuB,gBAliEH;A3Ew8mBtB;;A2Et6iBE;EAAuB,gBAliEH;A3E48mBtB;;A2E16iBE;EAAuB,gBAliEH;A3Eg9mBtB;;A2E96iBE;EAAuB,gBAliEH;A3Eo9mBtB;;A2El7iBE;EAAuB,gBAliEH;A3Ew9mBtB;;A2Et7iBE;EAAuB,gBAliEH;A3E49mBtB;;A2E17iBE;EAAuB,gBAliEH;A3Eg+mBtB;;A2E97iBE;EAAuB,gBAliEH;A3Eo+mBtB;;A2El8iBE;EAAuB,gBAliEH;A3Ew+mBtB;;A2Et8iBE;EAAuB,gBAliEH;A3E4+mBtB;;A2E18iBE;EAAuB,gBAliEH;A3Eg/mBtB;;A2E98iBE;EAAuB,gBAliEH;A3Eo/mBtB;;A2El9iBE;EAAuB,gBAliEH;A3Ew/mBtB;;A2Et9iBE;EAAuB,gBAliEH;A3E4/mBtB;;A2E19iBE;EAAuB,gBAliEH;A3EggnBtB;;A2E99iBE;EAAuB,gBAliEH;A3EognBtB;;A2El+iBE;EAAuB,gBAliEH;A3EwgnBtB;;A2Et+iBE;EAAuB,gBAliEH;A3E4gnBtB;;A2E1+iBE;EAAuB,gBAliEH;A3EghnBtB;;A2E9+iBE;EAAuB,gBAliEH;A3EohnBtB;;A2El/iBE;EAAuB,gBAliEH;A3EwhnBtB;;A2Et/iBE;EAAuB,gBAliEH;A3E4hnBtB;;A2E1/iBE;EAAuB,gBAliEH;A3EginBtB;;A2E9/iBE;EAAuB,gBAliEH;A3EoinBtB;;A2ElgjBE;EAAuB,gBAliEH;A3EwinBtB;;A2EtgjBE;EAAuB,gBAliEH;A3E4inBtB;;A2E1gjBE;EAAuB,gBAliEH;A3EgjnBtB;;A2E9gjBE;EAAuB,gBAliEH;A3EojnBtB;;A2ElhjBE;EAAuB,gBAliEH;A3EwjnBtB;;A2EthjBE;EAAuB,gBAliEH;A3E4jnBtB;;A2E1hjBE;EAAuB,gBAliEH;A3EgknBtB;;A2E9hjBE;EAAuB,gBAliEH;A3EoknBtB;;A2ElijBE;EAAuB,gBAliEH;A3EwknBtB;;A2EtijBE;EAAuB,gBAliEH;A3E4knBtB;;A2E1ijBE;EAAuB,gBAliEH;A3EglnBtB;;A2E9ijBE;EAAuB,gBAliEH;A3EolnBtB;;A2EljjBE;EAAuB,gBAliEH;A3EwlnBtB;;A2EtjjBE;EAAuB,gBAliEH;A3E4lnBtB;;A2E1jjBE;EAAuB,gBAliEH;A3EgmnBtB;;A2E9jjBE;EAAuB,gBAliEH;A3EomnBtB;;A2ElkjBE;EAAuB,gBAliEH;A3EwmnBtB;;A2EtkjBE;EAAuB,gBAliEH;A3E4mnBtB;;A2E1kjBE;EAAuB,YAliEH;A3EgnnBtB;;A2E9kjBE;EAAuB,YAliEH;A3EonnBtB;;A2ElljBE;EAAuB,YAliEH;A3EwnnBtB;;A2EtljBE;EAAuB,YAliEH;A3E4nnBtB;;A2E1ljBE;EAAuB,gBAliEH;A3EgonBtB;;A2E9ljBE;EAAuB,YAliEH;A3EoonBtB;;A2ElmjBE;EAAuB,YAliEH;A3EwonBtB;;A2EtmjBE;EAAuB,YAliEH;A3E4onBtB;;A2E1mjBE;EAAuB,YAliEH;A3EgpnBtB;;A2E9mjBE;EAAuB,YAliEH;A3EopnBtB;;A2ElnjBE;EAAuB,YAliEH;A3EwpnBtB;;A2EtnjBE;EAAuB,YAliEH;A3E4pnBtB;;A2E1njBE;EAAuB,YAliEH;A3EgqnBtB;;A2E9njBE;EAAuB,YAliEH;A3EoqnBtB;;A2ElojBE;EAAuB,YAliEH;A3EwqnBtB;;A2EtojBE;EAAuB,YAliEH;A3E4qnBtB;;A2E1ojBE;EAAuB,YAliEH;A3EgrnBtB;;A2E9ojBE;EAAuB,YAliEH;A3EornBtB;;A2ElpjBE;EAAuB,YAliEH;A3EwrnBtB;;A2EtpjBE;EAAuB,YAliEH;A3E4rnBtB;;A2E1pjBE;EAAuB,YAliEH;A3EgsnBtB;;A2E9pjBE;EAAuB,YAliEH;A3EosnBtB;;A2ElqjBE;EAAuB,YAliEH;A3EwsnBtB;;A2EtqjBE;EAAuB,YAliEH;A3E4snBtB;;A2E1qjBE;EAAuB,YAliEH;A3EgtnBtB;;A2E9qjBE;EAAuB,YAliEH;A3EotnBtB;;A2ElrjBE;EAAuB,YAliEH;A3EwtnBtB;;A2EtrjBE;EAAuB,YAliEH;A3E4tnBtB;;A2E1rjBE;EAAuB,YAliEH;A3EgunBtB;;A2E9rjBE;EAAuB,YAliEH;A3EounBtB;;A2ElsjBE;EAAuB,YAliEH;A3EwunBtB;;A2EtsjBE;EAAuB,YAliEH;A3E4unBtB;;AApwnBA,sBAAA;AACA;EACC,kBAAA;EACA,qBAAA;EACA,+BAAA,EAAA,8CAAA;AAuwnBD;;AApwnBA,iBAAA;AACA;EACC,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EAEA,oDAAA;EACA,kBAAA;EACA,UAAA;AAswnBD;;AAnwnBA,oEAAA;AACA;EACC,mBAAA;AAswnBD;;AAnwnBA;EACC,+BAAA;AAswnBD;;AAnwnBA;EACC,6BAAA;AAswnBD;;AAnwnBA;EACC,eAAA;AAswnBD;;AAnwnBA;EACC,sBAAA;AAswnBD;;AAlwnBA;EACC,sBAAA;AAqwnBD;;AAlwnBA;EACC,sBAAA;AAqwnBD;;AAlwnBA;EACC,sBAAA;AAqwnBD;;AAlwnBA;EACC,sBAAA;AAqwnBD;;AAlwnBA;EACC,sBAAA;AAqwnBD;;AAnwnBA,gBAAA;AAEA,eAAA;AAEA;EACC,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;AAownBD;;AAjwnBA;EACC,WAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,qBAAA;EACA,eAAA;AAownBD;;AAjwnBA;EACC,sBAAA;EACA,YAAA;AAownBD;;AAjwnBA;EACC,yBAAA;EACA,YAAA;AAownBD;;AAjwnBA;EACC,6BAAA;AAownBD;;AAjwnBA;EACC,YAAA;AAownBD;;AAjwnBA;EACC,cAAA;AAownBD;;AAjwnBA,kBAAA;AAEA,cAAA;AAGA;EACC,+BAAA;AAiwnBD;;AA9vnBA;EACC,+BAAA;AAiwnBD;;AA9vnBA;EACC,+BAAA;AAiwnBD;;AA9vnBA;EACC,+BAAA;AAiwnBD;;AA9vnBA;EACC,sBAAA;AAiwnBD;;AA9vnBA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;AAiwnBD;;AA9vnBA;EACC,yBAAA;EACA,qBAAA;AAiwnBD;;AA9vnBA;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;AAiwnBD;;AA9vnBA;EACC,yBAAA;AAiwnBD;;AA7vnBA;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;AAgwnBD;;AA7vnBA;EACC,yBAAA;AAgwnBD;;AA5vnBA;EACC,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;AA+vnBD;;AA5vnBA;EACC,WAAA;EACA,UAAA;EACA,eAAA;EAEA,+BAAA;AA8vnBD;;AA1vnBA;EACC,WAAA;EACA,UAAA;EACA,eAAA;EAEA,+BAAA;AA4vnBD;;AAzvnBA;EACC,+BAAA;AA4vnBD;;AAzvnBA,mCAAA;AACA;EACC,WAAA;EACA,cAAA;EACA,WAAA;AA4vnBD;;AAzvnBA;EACC,YAAA;EACA,aAAA;AA4vnBD;;AAzvnBA;EACC,aAAA;AA4vnBD;;AAzvnBA,+IAAA;AACA;EACC;IACC,WAAA;IACA,aAAA;EA4vnBA;EAzvnBD;IACC,aAAA;EA2vnBA;EAxvnBD;IACC,sBAAA;IACA,eAAA;IACA,QAAA;IACA,SAAA;IACA,aAAA;EA0vnBA;EAvvnBD;IACC,YAAA;IACA,gBAAA;IACA,gCAAA;EAyvnBA;EAtvnBD;IACC,yBAAA;EAwvnBA;EArvnBD;IACC,YAAA;IACA,cAAA;EAuvnBA;AACF;AApvnBA,qBAAA;AAEA,cAAA;AACA;EACC,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAqvnBD;;AAlvnBA;EACC,mBAAA;EACA,iDAAA;EACA,yCAAA;AAqvnBD;;AAlvnBA;EACC;IAAM,SAAA;IAAW,UAAA;EAuvnBhB;EAtvnBD;IAAI,YAAA;IAAc,UAAA;EA0vnBjB;AACF;AAxvnBA;EACC;IAAM,SAAA;IAAW,UAAA;EA4vnBhB;EA3vnBD;IAAI,YAAA;IAAc,UAAA;EA+vnBjB;AACF;AA7vnBA;EACC;IAAM,YAAA;IAAc,UAAA;EAiwnBnB;EAhwnBD;IAAI,SAAA;IAAW,UAAA;EAownBd;AACF;AAlwnBA;EACC;IAAM,YAAA;IAAc,UAAA;EAswnBnB;EArwnBD;IAAI,SAAA;IAAW,UAAA;EAywnBd;AACF;AAxwnBA,qBAAA;AAEA,YAAA;AACA;EACC,+BAAA;AAywnBD;;AAtwnBA;EACC,yBAAA;AAywnBD;;AAtwnBA;EACC,yBAAA;AAywnBD;;AAtwnBA;EACC,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;AAywnBD;;AArwnBA;EACC,qBAAA;AAwwnBD;;AAtwnBA,mBAAA;AAEA,oBAAA;AAEA;EACC,aAAA;AAuwnBD;;AAnwnBA;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;AAswnBD;;AApwnBA,2BAAA;AAEA,iBAAA;AAEA;EACC,aAAA;EACA,+BAAA;EACA,cAAA;AAqwnBD;;AAlwnBA;EACC,YAAA;AAqwnBD;;AAlwnBA;EACC,4BAAA;EACA,yBAAA;EACA,YAAA;AAqwnBD;;AAlwnBA;EACC,4BAAA;AAqwnBD;;AAnwnBA,sBAAA;AAEA;EACC,4BAAA;EACA,kBAAA;AAqwnBD;;AAlwnBA,wBAAA;AAEA,kBAAA;AAEA;EACC,aAAA;EACA,+BAAA;EACA,cAAA;AAmwnBD;;AA/vnBA;EACC,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,+BAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AAkwnBD;;AA/vnBA;EACC,+BAAA;EACA,qBAAA;AAkwnBD;;AA/vnBA,yBAAA;AAEA,cAAA;AAEA;EACC,aAAA;EACA,+BAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AAgwnBD;;AA7vnBA;EACC,UAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;EACA,YAAA;EACA,WAAA;AAgwnBD;;AA7vnBA;EACC,cAAA;AAgwnBD;;AA7vnBA;EACC,UAAA;AAgwnBD;;AA7vnBA;EACC,oDAAA;EACA,mBAAA;AAgwnBD;;AA7vnBA;EACC,mBAAA;EACA,oDAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;AAgwnBD;;AA7vnBA;EACC,iBAAA;AAgwnBD;;AA7vnBA;EACC,YAAA;AAgwnBD;;AA5vnBA;EACC,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;AA+vnBD;;AA5vnBA;EACC,YAAA;EACA,eAAA;AA+vnBD;;AA5vnBA;EACC,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;AA+vnBD;;AA5vnBA;EACC,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;AA+vnBD;;AA3vnBA,qBAAA;AAEA,WAAA;AACA;EACC,aAAA;EACA,aAAA;EACA,sBAAA;AA6vnBD;;AA1vnBA;EACC,UAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,yBAAA;AA6vnBD;;AA1vnBA;EACC,iBAAA;AA6vnBD;;AA3vnBA,kBAAA;AAEA,cAAA;AACA;EACC,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,+BAAA;AA6vnBD;;AA1vnBA;EACC,eAAA;EACA,kBAAA;EACA,qBAAA;AA6vnBD;;AA1vnBA;EACC,uBAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;AA6vnBD;;AA1vnBA;EACC,kBAAA;EACA,qBAAA;AA6vnBD;;AA1vnBA,qBAAA;AAEA,mBAAA;AAEA;EACC,WAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,aAAA;AA2vnBD;;AAxvnBA,kBAAA;AAEA,sBAAA;AAEA;EACC,YAAA;EACA,+BAAA;AAyvnBD;;AAtvnBA;EAEC,+BAAA;AAwvnBD;;AArvnBA,6BAAA;AAKA;EACC,eAAA;EACG,UAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAovnBJ;;AAjvnBA;EAEC,cAAA;EACA,YAAA;EACA,WAAA;EACA,qDAAA;EACA,cAAA;EAEA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAkvnBD;AAjvnBC;EACE,qBAAA;EACA,iBAAA;AAmvnBH;;AA7unBC;EACE,4CAAA;AAgvnBH;AA9unBE;EACE,qBAAA;AAgvnBJ;AAjvnBE;EACE,qBAAA;AAmvnBJ;AApvnBE;EACE,qBAAA;AAsvnBJ;AAvvnBE;EACE,qBAAA;AAyvnBJ;AA1vnBE;EACE,mBAAA;AA4vnBJ;AA7vnBE;EACE,qBAAA;AA+vnBJ;;AA1vnBE;EACD;IACE,eAAA;IACA,UAAA;EA6vnBD;EA3vnBD;IACE,iBAAA;IACA,YAAA;EA6vnBD;AACF","sourcesContent":["/* Globals */\n@import 'font-faces';\n@import \"~bootstrap/scss/bootstrap\";\n$bootstrap-icons-font-dir: \"~bootstrap-icons/font/fonts\";\n@import \"~bootstrap-icons/font/bootstrap-icons.scss\";\n\n\n\n\n\n/* Tooltip container */\n.tooltip {\n\tposition: relative;\n\tdisplay: inline-block;\n\tborder-bottom: 0px dotted black; /* If you want dots under the hoverable text */\n}\n\n/* Tooltip text */\n.tooltip .tooltiptext {\n\tvisibility: hidden;\n\twidth: 120px;\n\tbackground-color: black;\n\tcolor: #fff;\n\ttext-align: center;\n\tpadding: 5px 0;\n\tborder-radius: 6px;\n\n\t/* Position the tooltip text - see examples below! */\n\tposition: absolute;\n\tz-index: 1;\n}\n\n/* Show the tooltip text when you mouse over the tooltip container */\n.tooltip:hover .tooltiptext {\n\tvisibility: visible;\n}\n\n.custom_main_font {\n\tfont-family: 'fira_sansregular';\n}\n\n#buy_now_button {\n\tfont-family: 'sea-dogregular';\n}\n\n#buy_now_button:hover {\n\tcursor:pointer;\n}\n\n#about_container {\n\tfont-family: \"Poppins\";\n\n}\n\n#showcase_container {\n\tfont-family: \"Poppins\";\n}\n\n#outlets_container {\n\tfont-family: \"Poppins\";\n}\n\n#contactus_container {\n\tfont-family: \"Poppins\";\n}\n\n#customer_support_container {\n\tfont-family: \"Poppins\";\n}\n\n#navmenu {\n\tfont-family: \"Poppins\";\n}\n/* End Globals */\n\n/* top Navbar */\n\n.topnav {\n\toverflow: hidden;\n\tbackground-color: #333;\n\tmargin-bottom:5px;\n\tfont-family: 'fira_sansregular';\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n.topnav a {\n\tfloat: left;\n\tcolor: #f2f2f2;\n\ttext-align: center;\n\tpadding: 16px 14px 16px 16px;\n\ttext-decoration: none;\n\tfont-size: 17px;\n}\n\n.topnav a:hover {\n\tbackground-color: #ddd;\n\tcolor: black;\n}\n\n.topnav a.active {\n\tbackground-color: #4CAF50;\n\tcolor: white;\n}\n\n#firm_title {\n\tfont-family: \"sea-dogregular\";\n}\n\n#firm_main_logo {\n\theight: 40px;\n}\n\n.pp-blue {\n\tcolor: #076691;\n}\n\n/*End Top Navbar */\n\n/* Form Page */\n\n\n.loginInput::-webkit-input-placeholder {\n\tfont-family: 'fira_sansregular';\n}\n\n.loginInput:-ms-input-placeholder {\n\tfont-family: 'fira_sansregular';\n}\n\n.loginInput:-moz-placeholder {\n\tfont-family: 'fira_sansregular';\n}\n\n.loginInput::-moz-placeholder {\n\tfont-family: 'fira_sansregular';\n}\n\n* {\n\tbox-sizing: border-box;\n}\n\ninput[type=text], select, textarea {\n\twidth: 100%;\n\tpadding: 12px;\n\tborder: 1px solid #ccc;\n\tborder-radius: 4px;\n\tresize: vertical;\n\tfont-family: 'fira_sansregular';\n}\n\nlabel {\n\tpadding: 12px 12px 12px 0;\n\tdisplay: inline-block;\n}\n\ninput[type=submit] {\n\tbackground-color: #4CAF50;\n\tcolor: white;\n\tpadding: 12px 20px;\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tfloat: right;\n\tmargin: 5px;\n\tfont-family: 'fira_sansregular';\n}\n\ninput[type=submit]:hover {\n\tbackground-color: #45a049;\n\n}\n\ninput[type=button] {\n\tbackground-color: #4CAF50;\n\tcolor: white;\n\tpadding: 12px 20px;\n\tborder: none;\n\tborder-radius: 4px;\n\tcursor: pointer;\n\tfloat: right;\n\tmargin: 5px;\n\tfont-family: 'fira_sansregular';\n}\n\ninput[type=button]:hover {\n\tbackground-color: #45a049;\n\n}\n\n.custom_container {\n\tborder-radius: 5px;\n\tmax-width:500px;\n\tbackground-color: #f2f2f2;\n\tpadding: 20px;\n\tmargin: 20px;\n\tmargin:auto;\n\tfont-family: 'fira_sansregular';\n}\n\n.col-25 {\n\tfloat: left;\n\twidth: 25%;\n\tmargin-top: 6px;\n\n\tfont-family: 'fira_sansregular';\n\n}\n\n.col-75 {\n\tfloat: left;\n\twidth: 75%;\n\tmargin-top: 6px;\n\n\tfont-family: 'fira_sansregular';\n}\n\n.col-75 select {\n\tfont-family: 'fira_sansregular';\n}\n\n/* Clear floats after the columns */\n.row:after {\n\tcontent: \"\";\n\tdisplay: table;\n\tclear: both;\n}\n\n#menu_items_toggle_button {\n\tfloat: right;\n\tdisplay: none;\n}\n\n#menu_item_expanded_list {\n\tdisplay: none;\n}\n\n/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */\n@media screen and (max-width: 770px) {\n\t.col-25, .col-75, input[type=submit] {\n\t\twidth: 100%;\n\t\tmargin-top: 0;\n\t}\n\n\t.menu_items {\n\t\tdisplay: none;\n\t}\n\n\t#menu_item_expanded_list {\n\t\tbackground-color: #333;\n\t\tposition: fixed;\n\t\ttop: 0px;\n\t\tleft: 0px;\n\t\tdisplay: none;\n\t}\n\n\t#menu_item_expanded_list a {\n\t\twidth: 100vw;\n\t\ttext-align: left;\n\t\tborder-bottom: 1px solid #f2f2f2;\n\t}\n\n\t#menu_item_expanded_list a:hover {\n\t\tbackground-color: #f2f2f2;\n\t}\n\n\t#menu_items_toggle_button {\n\t\tfloat: right;\n\t\tdisplay: block;\n\t}\n}\n\n/* End of Form Page */\n\n/* Snack Bar */\n#snackbar {\n\tfont-family: 'fira_sansregular';\n\tvisibility: hidden;\n\tmin-width: 250px;\n\tmargin-left: -125px;\n\tbackground-color: #333;\n\tcolor: #fff;\n\ttext-align: center;\n\tborder-radius: 2px;\n\tpadding: 16px;\n\tposition: fixed;\n\tz-index: 1;\n\tleft: 50%;\n\tbottom: 30px;\n\tfont-size: 17px;\n}\n\n#snackbar.show {\n\tvisibility: visible;\n\t-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n\tanimation: fadein 0.5s, fadeout 0.5s 2.5s;\n}\n\n@-webkit-keyframes fadein {\n\tfrom {bottom: 0; opacity: 0;} \n\tto {bottom: 30px; opacity: 1;}\n}\n\n@keyframes fadein {\n\tfrom {bottom: 0; opacity: 0;}\n\tto {bottom: 30px; opacity: 1;}\n}\n\n@-webkit-keyframes fadeout {\n\tfrom {bottom: 30px; opacity: 1;} \n\tto {bottom: 0; opacity: 0;}\n}\n\n@keyframes fadeout {\n\tfrom {bottom: 30px; opacity: 1;}\n\tto {bottom: 0; opacity: 0;}\n}\n/* End of Snack Bar */\n\n/* Commons */\n.custom_font {\n\tfont-family: 'fira_sansregular';\n}\n\n.background_color_green {\n\tbackground-color: #4CAF50;\n}\n\n.background_color_violet {\n\tbackground-color: #9900e6;\n}\n\n.step_card {\n\twidth:200px;\n\theight: 250px;\n\tpadding: 2px;\n\tmargin: 3px;\n\tdisplay: inline-block;\n\n}\n\n.no_bullets_list {\n\tlist-style-type:none;\n}\n/* End of commons */\n\n/* Contact Us Page */\n\n.contact_us_main_container {\n\tpadding: 20px;\n\n}\n\n.button {\n\tbackground-color: #008CBA;\n\tborder: none;\n\tborder-radius: 8px;\n\tcolor: white;\n\tpadding: 15px 32px;\n\ttext-align: center;\n\ttext-decoration: none;\n\tdisplay: inline-block;\n\tfont-size: 16px;\n\tmargin: 4px 2px;\n\tcursor: pointer;\n\tfont-family: 'fira_sansregular';\n}\n/* End of Contact Us Page */\n\n/* Pricing Page */\n\n.pricing_container {\n\tpadding:20px;\n\tfont-family: 'fira_sansregular';\n\toverflow: auto;\n}\n\n#pricing_table {\n\tmargin:auto;\n}\n\n#pricing_table th {\n\tpadding: 10px 10px 10px 10px;\n\tbackground-color:#ff6666;\n\tcolor:white;\n}\n\n#pricing_table td {\n\tpadding: 10px 10px 10px 10px;\n}\n/* Visitor Container */\n\n.visitor_container {\n\tpadding: 10px 10px 10px 10px;\n\tmargin-bottom:  5px;\n}\n\n/* End of Pricing Page */\n\n/* Services Page */\n\n.services_main_div {\n\tpadding:20px;\n\tfont-family: 'fira_sansregular';\n\toverflow: auto;\n\n}\n\n.service_item {\n\tborder: solid 1px;\n\tborder-radius:5px;\n\twidth:250px;\n\theight:400px;\n\ttext-align:center;\n\tbox-shadow: 5px 2px 2px #000000;\n\tbackground-color:white;\n\tdisplay: inline-block;\n\toverflow:hidden;\n\tpadding:25px;\n\tmargin:5px;\n}\n\n.service_item:hover {\n\tbox-shadow: 5px 5px 5px #000000;\n\tdisplay: inline-block;\n}\n\n/* End of services page */\n\n/* Blog page */\n\n.blog_main_div {\n\tpadding:20px;\n\tfont-family: 'fira_sansregular';\n}\n\n.blog_display_area {\n\tborder: solid 1px;\n\tborder-radius:5px;\n\twidth:100%;\n\tbackground-color:white;\n\tdisplay: inline-block;\n\tpadding:25px;\n\tmargin-top:20px;\n\tmargin-bottom:20px;\n\toverflow: hidden;\n}\n\n.title_area {\n\tborder: solid 1px;\n\tborder-radius: 5px;\n\twidth: 100%;\n\theight: 200px;\n\tbackground-color: white;\n\tpadding: 5px;\n}\n\n.blog_title_item {\n\twidth: 22%;\n\tborder: solid 1px;\n\tpadding: 5px;\n\tbox-shadow: 5px 2px 2px #000000;\n\tdisplay: inline-block;\n\tmargin: 6px;;\n}\n\n.meta_data_area {\n\tborder: solid 0px;\n\tpadding: 2px;\n\tmargin:2px;\n}\n\n.scroll {\n\toverflow: auto;\n}\n\n.scroll::-webkit-scrollbar {\n\twidth: 5px;\n}\n\n.scroll::-webkit-scrollbar-track {\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); \n\tborder-radius: 10px;\n}\n\n.scroll::-webkit-scrollbar-thumb {\n\tborder-radius: 10px;\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); \n}\n\ndate {\n\tborder: solid 0px;\n}\n\nview {\n\tborder: solid 0px;\n}\n\nview_count {\n\tborder: solid 0px;\n}\n\nlike {\n\tborder: solid 0px;\n}\n\nlike_count {\n\tborder: solid 0px;\n}\n\ncomment {\n\tborder: solid 0px;\n}\n\ncomment_count {\n\tborder: solid 0px;\n}\n\ninteraction {\n\tfloat:right;\n\n}\n\n.blog {\n\tborder: solid 1px;\n\twidth: 60%;\n\tmargin-left: 50px;\n\tdisplay:inline-block;\n}\n\nblog_title_image {\n\tpadding: 5px;\n\tmargin-top:5px;\n}\n\n.additional_blog_sections {\n\tborder: solid 1px;\n\tdisplay:inline-block;\n\twidth: 29%;\n\theight: 1000px;\n}\n\n.social_media_widget {\n\tborder: solid 1px;\n\twidth:40px;\n\ttext-align:center;\n\tmargin-top:2px;\n\tpadding:2px;\n\tmargin-bottom:2px;\n\tdisplay:inline-block;\n\topacity:0.8;\n\ttransform: translateY(-500px);\n}\n\n\n/* End of blog page */\n\n/*Dev Page*/\n#dev_main_container {\n\tpadding: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.dev_title_item {\n\twidth: 60%;\n\tborder: solid 1px;\n\tpadding: 5px;\n\tbox-shadow: 5px 2px 2px #000000;\n\tdisplay: inline-block;\n\tmargin: 6px;;\n\tbackground-color: #ffffff;\n}\n\n.dev_title_item p {\n\ttext-indent: 20px;\n}\n/*End of dev page*/\n\n/* Home Page */\n.home_main_container {\n\tborder-radius: 2px;\n\t/*background-color:  #2eb82e;*/\n\tpadding: 20px;\n\theight: 100vh;\n\toverflow:auto;\n\tmargin:auto;\n\tfont-family: 'fira_sansregular';\n}\n\n.steps_items {\n\t/*float:right;*/\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.home_main_anim {\n\t/*border: solid black;*/\n\theight:\t200px;\n\twidth: 500px;\n\tdisplay: inline-block;\n}\n\n.step_sub_block {\n\tposition: relative;\n\tdisplay: inline-block;\n\n}\n/* End of Home Page */\n\n/* Footer Section */\n\n.footer {\n\twidth: 100%;\n\tmargin-top: 2px;\n\tbackground-color: #333;\n\tcolor: white;\n\ttext-align: center;\n\tfont-family: 'fira_sansregular';\n\tpadding: 10px;\n}\n\n/* End of Footer */\n\n/* Subscription Form */\n\n.subscription_form {\n\tmargin:auto;\n\tfont-family: 'fira_sansregular';\n}\n\n.subscription_form[input] {\n\n\tfont-family: 'fira_sansregular';\n}\n\n/* End of Subscription Form */\n\n\n// loader\n\n#loader_wrapper {\n\tposition: fixed;\n    z-index: 1;\n    height: 100vh;\n    width: 100vw;\n    overflow: hidden;\n}\n\n.loading {\n\t// display: none;\n\tdisplay: block;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: linear-gradient(120deg, #7bc6cc, #be93c5);\n\tpadding: 4em 0;\n\n\tfont-size: 84px;\n\tfont-family: \"sea-dog\";\n\tfont-weight: 800;\n\ttext-align: center;\n\tspan {\n\t  display: inline-block;\n\t  margin: 0 -.05em;\n\t}\n}\n\n.loading02 {\n\t// z-index: 1;\n\tspan {\n\t  animation: loading02 1.2s infinite alternate;\n\t  @for $i from 1 through 6 {\n\t\t&:nth-child(#{$i+1}) {\n\t\t  animation-delay: #{$i*.2}s;\n\t\t}\n\t  }\n\t}\n  }\n  @keyframes loading02 {\n\t0% {\n\t  filter: blur(0);\n\t  opacity: 1;\n\t}\n\t100% {\n\t  filter: blur(5px);\n\t  opacity: .2;\n\t}\n  }","@font-face {\n\tfont-family: 'bebasNeueRegular';\n\tsrc: url('../assets/fonts/BebasNeue-Regular.woff2') format('woff2'),\n\turl('../assets/fonts/BebasNeue-Regular.woff') format('woff');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: 'robotoRegular';\n\tsrc: url('../assets/fonts/roboto-regular-webfont.woff2') format('woff2'),\n\turl('../assets/fonts/roboto-regular-webfont.woff') format('woff');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n@font-face {\n    font-family: 'sea-dogregular';\n    src: url('../assets/fonts/seadog-webfont.woff2') format('woff2'),\n         url('../assets/fonts/seadog-webfont.woff') format('woff'),\n\t\t url('../assets/fonts/seadog.ttf')  format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  \n  }\n\n\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url('../assets/fonts/poppins/pxiEyp8kv8JHgFVrJJbecmNE.woff2') format(\"woff2\");\n\tunicode-range: U+0900-097F, U+1CD0-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC,\n\tU+A830-A839, U+A8E0-A8FF;\n}\n/* latin-ext */\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url('../assets/fonts/poppins/pxiEyp8kv8JHgFVrJJnecmNE.woff2') format(\"woff2\");\n\tunicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF,\n\tU+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n\tfont-family: \"Poppins\";\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url('../assets/fonts/poppins/pxiEyp8kv8JHgFVrJJfecg.woff2') format(\"woff2\");\n\tunicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\n\tU+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191,\n\tU+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.8 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*!\n * Bootstrap Icons v1.13.1 (https://icons.getbootstrap.com/)\n * Copyright 2019-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/icons/blob/main/LICENSE)\n */\n\n$bootstrap-icons-font: \"bootstrap-icons\" !default;\n$bootstrap-icons-font-dir: \"./fonts\" !default;\n$bootstrap-icons-font-file: \"#{$bootstrap-icons-font-dir}/#{$bootstrap-icons-font}\" !default;\n$bootstrap-icons-font-hash: \"24e3eb84d0bcaf83d77f904c78ac1f47\" !default;\n$bootstrap-icons-font-src: url(\"#{$bootstrap-icons-font-file}.woff2?#{$bootstrap-icons-font-hash}\") format(\"woff2\"),\n                           url(\"#{$bootstrap-icons-font-file}.woff?#{$bootstrap-icons-font-hash}\") format(\"woff\") !default;\n\n@font-face {\n  font-display: block;\n  font-family: $bootstrap-icons-font;\n  src: $bootstrap-icons-font-src;\n}\n\n.bi::before,\n[class^=\"bi-\"]::before,\n[class*=\" bi-\"]::before {\n  display: inline-block;\n  font-family: $bootstrap-icons-font !important;\n  font-style: normal;\n  font-weight: normal !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n$bootstrap-icons-map: (\n  \"123\": \"\\f67f\",\n  \"alarm-fill\": \"\\f101\",\n  \"alarm\": \"\\f102\",\n  \"align-bottom\": \"\\f103\",\n  \"align-center\": \"\\f104\",\n  \"align-end\": \"\\f105\",\n  \"align-middle\": \"\\f106\",\n  \"align-start\": \"\\f107\",\n  \"align-top\": \"\\f108\",\n  \"alt\": \"\\f109\",\n  \"app-indicator\": \"\\f10a\",\n  \"app\": \"\\f10b\",\n  \"archive-fill\": \"\\f10c\",\n  \"archive\": \"\\f10d\",\n  \"arrow-90deg-down\": \"\\f10e\",\n  \"arrow-90deg-left\": \"\\f10f\",\n  \"arrow-90deg-right\": \"\\f110\",\n  \"arrow-90deg-up\": \"\\f111\",\n  \"arrow-bar-down\": \"\\f112\",\n  \"arrow-bar-left\": \"\\f113\",\n  \"arrow-bar-right\": \"\\f114\",\n  \"arrow-bar-up\": \"\\f115\",\n  \"arrow-clockwise\": \"\\f116\",\n  \"arrow-counterclockwise\": \"\\f117\",\n  \"arrow-down-circle-fill\": \"\\f118\",\n  \"arrow-down-circle\": \"\\f119\",\n  \"arrow-down-left-circle-fill\": \"\\f11a\",\n  \"arrow-down-left-circle\": \"\\f11b\",\n  \"arrow-down-left-square-fill\": \"\\f11c\",\n  \"arrow-down-left-square\": \"\\f11d\",\n  \"arrow-down-left\": \"\\f11e\",\n  \"arrow-down-right-circle-fill\": \"\\f11f\",\n  \"arrow-down-right-circle\": \"\\f120\",\n  \"arrow-down-right-square-fill\": \"\\f121\",\n  \"arrow-down-right-square\": \"\\f122\",\n  \"arrow-down-right\": \"\\f123\",\n  \"arrow-down-short\": \"\\f124\",\n  \"arrow-down-square-fill\": \"\\f125\",\n  \"arrow-down-square\": \"\\f126\",\n  \"arrow-down-up\": \"\\f127\",\n  \"arrow-down\": \"\\f128\",\n  \"arrow-left-circle-fill\": \"\\f129\",\n  \"arrow-left-circle\": \"\\f12a\",\n  \"arrow-left-right\": \"\\f12b\",\n  \"arrow-left-short\": \"\\f12c\",\n  \"arrow-left-square-fill\": \"\\f12d\",\n  \"arrow-left-square\": \"\\f12e\",\n  \"arrow-left\": \"\\f12f\",\n  \"arrow-repeat\": \"\\f130\",\n  \"arrow-return-left\": \"\\f131\",\n  \"arrow-return-right\": \"\\f132\",\n  \"arrow-right-circle-fill\": \"\\f133\",\n  \"arrow-right-circle\": \"\\f134\",\n  \"arrow-right-short\": \"\\f135\",\n  \"arrow-right-square-fill\": \"\\f136\",\n  \"arrow-right-square\": \"\\f137\",\n  \"arrow-right\": \"\\f138\",\n  \"arrow-up-circle-fill\": \"\\f139\",\n  \"arrow-up-circle\": \"\\f13a\",\n  \"arrow-up-left-circle-fill\": \"\\f13b\",\n  \"arrow-up-left-circle\": \"\\f13c\",\n  \"arrow-up-left-square-fill\": \"\\f13d\",\n  \"arrow-up-left-square\": \"\\f13e\",\n  \"arrow-up-left\": \"\\f13f\",\n  \"arrow-up-right-circle-fill\": \"\\f140\",\n  \"arrow-up-right-circle\": \"\\f141\",\n  \"arrow-up-right-square-fill\": \"\\f142\",\n  \"arrow-up-right-square\": \"\\f143\",\n  \"arrow-up-right\": \"\\f144\",\n  \"arrow-up-short\": \"\\f145\",\n  \"arrow-up-square-fill\": \"\\f146\",\n  \"arrow-up-square\": \"\\f147\",\n  \"arrow-up\": \"\\f148\",\n  \"arrows-angle-contract\": \"\\f149\",\n  \"arrows-angle-expand\": \"\\f14a\",\n  \"arrows-collapse\": \"\\f14b\",\n  \"arrows-expand\": \"\\f14c\",\n  \"arrows-fullscreen\": \"\\f14d\",\n  \"arrows-move\": \"\\f14e\",\n  \"aspect-ratio-fill\": \"\\f14f\",\n  \"aspect-ratio\": \"\\f150\",\n  \"asterisk\": \"\\f151\",\n  \"at\": \"\\f152\",\n  \"award-fill\": \"\\f153\",\n  \"award\": \"\\f154\",\n  \"back\": \"\\f155\",\n  \"backspace-fill\": \"\\f156\",\n  \"backspace-reverse-fill\": \"\\f157\",\n  \"backspace-reverse\": \"\\f158\",\n  \"backspace\": \"\\f159\",\n  \"badge-3d-fill\": \"\\f15a\",\n  \"badge-3d\": \"\\f15b\",\n  \"badge-4k-fill\": \"\\f15c\",\n  \"badge-4k\": \"\\f15d\",\n  \"badge-8k-fill\": \"\\f15e\",\n  \"badge-8k\": \"\\f15f\",\n  \"badge-ad-fill\": \"\\f160\",\n  \"badge-ad\": \"\\f161\",\n  \"badge-ar-fill\": \"\\f162\",\n  \"badge-ar\": \"\\f163\",\n  \"badge-cc-fill\": \"\\f164\",\n  \"badge-cc\": \"\\f165\",\n  \"badge-hd-fill\": \"\\f166\",\n  \"badge-hd\": \"\\f167\",\n  \"badge-tm-fill\": \"\\f168\",\n  \"badge-tm\": \"\\f169\",\n  \"badge-vo-fill\": \"\\f16a\",\n  \"badge-vo\": \"\\f16b\",\n  \"badge-vr-fill\": \"\\f16c\",\n  \"badge-vr\": \"\\f16d\",\n  \"badge-wc-fill\": \"\\f16e\",\n  \"badge-wc\": \"\\f16f\",\n  \"bag-check-fill\": \"\\f170\",\n  \"bag-check\": \"\\f171\",\n  \"bag-dash-fill\": \"\\f172\",\n  \"bag-dash\": \"\\f173\",\n  \"bag-fill\": \"\\f174\",\n  \"bag-plus-fill\": \"\\f175\",\n  \"bag-plus\": \"\\f176\",\n  \"bag-x-fill\": \"\\f177\",\n  \"bag-x\": \"\\f178\",\n  \"bag\": \"\\f179\",\n  \"bar-chart-fill\": \"\\f17a\",\n  \"bar-chart-line-fill\": \"\\f17b\",\n  \"bar-chart-line\": \"\\f17c\",\n  \"bar-chart-steps\": \"\\f17d\",\n  \"bar-chart\": \"\\f17e\",\n  \"basket-fill\": \"\\f17f\",\n  \"basket\": \"\\f180\",\n  \"basket2-fill\": \"\\f181\",\n  \"basket2\": \"\\f182\",\n  \"basket3-fill\": \"\\f183\",\n  \"basket3\": \"\\f184\",\n  \"battery-charging\": \"\\f185\",\n  \"battery-full\": \"\\f186\",\n  \"battery-half\": \"\\f187\",\n  \"battery\": \"\\f188\",\n  \"bell-fill\": \"\\f189\",\n  \"bell\": \"\\f18a\",\n  \"bezier\": \"\\f18b\",\n  \"bezier2\": \"\\f18c\",\n  \"bicycle\": \"\\f18d\",\n  \"binoculars-fill\": \"\\f18e\",\n  \"binoculars\": \"\\f18f\",\n  \"blockquote-left\": \"\\f190\",\n  \"blockquote-right\": \"\\f191\",\n  \"book-fill\": \"\\f192\",\n  \"book-half\": \"\\f193\",\n  \"book\": \"\\f194\",\n  \"bookmark-check-fill\": \"\\f195\",\n  \"bookmark-check\": \"\\f196\",\n  \"bookmark-dash-fill\": \"\\f197\",\n  \"bookmark-dash\": \"\\f198\",\n  \"bookmark-fill\": \"\\f199\",\n  \"bookmark-heart-fill\": \"\\f19a\",\n  \"bookmark-heart\": \"\\f19b\",\n  \"bookmark-plus-fill\": \"\\f19c\",\n  \"bookmark-plus\": \"\\f19d\",\n  \"bookmark-star-fill\": \"\\f19e\",\n  \"bookmark-star\": \"\\f19f\",\n  \"bookmark-x-fill\": \"\\f1a0\",\n  \"bookmark-x\": \"\\f1a1\",\n  \"bookmark\": \"\\f1a2\",\n  \"bookmarks-fill\": \"\\f1a3\",\n  \"bookmarks\": \"\\f1a4\",\n  \"bookshelf\": \"\\f1a5\",\n  \"bootstrap-fill\": \"\\f1a6\",\n  \"bootstrap-reboot\": \"\\f1a7\",\n  \"bootstrap\": \"\\f1a8\",\n  \"border-all\": \"\\f1a9\",\n  \"border-bottom\": \"\\f1aa\",\n  \"border-center\": \"\\f1ab\",\n  \"border-inner\": \"\\f1ac\",\n  \"border-left\": \"\\f1ad\",\n  \"border-middle\": \"\\f1ae\",\n  \"border-outer\": \"\\f1af\",\n  \"border-right\": \"\\f1b0\",\n  \"border-style\": \"\\f1b1\",\n  \"border-top\": \"\\f1b2\",\n  \"border-width\": \"\\f1b3\",\n  \"border\": \"\\f1b4\",\n  \"bounding-box-circles\": \"\\f1b5\",\n  \"bounding-box\": \"\\f1b6\",\n  \"box-arrow-down-left\": \"\\f1b7\",\n  \"box-arrow-down-right\": \"\\f1b8\",\n  \"box-arrow-down\": \"\\f1b9\",\n  \"box-arrow-in-down-left\": \"\\f1ba\",\n  \"box-arrow-in-down-right\": \"\\f1bb\",\n  \"box-arrow-in-down\": \"\\f1bc\",\n  \"box-arrow-in-left\": \"\\f1bd\",\n  \"box-arrow-in-right\": \"\\f1be\",\n  \"box-arrow-in-up-left\": \"\\f1bf\",\n  \"box-arrow-in-up-right\": \"\\f1c0\",\n  \"box-arrow-in-up\": \"\\f1c1\",\n  \"box-arrow-left\": \"\\f1c2\",\n  \"box-arrow-right\": \"\\f1c3\",\n  \"box-arrow-up-left\": \"\\f1c4\",\n  \"box-arrow-up-right\": \"\\f1c5\",\n  \"box-arrow-up\": \"\\f1c6\",\n  \"box-seam\": \"\\f1c7\",\n  \"box\": \"\\f1c8\",\n  \"braces\": \"\\f1c9\",\n  \"bricks\": \"\\f1ca\",\n  \"briefcase-fill\": \"\\f1cb\",\n  \"briefcase\": \"\\f1cc\",\n  \"brightness-alt-high-fill\": \"\\f1cd\",\n  \"brightness-alt-high\": \"\\f1ce\",\n  \"brightness-alt-low-fill\": \"\\f1cf\",\n  \"brightness-alt-low\": \"\\f1d0\",\n  \"brightness-high-fill\": \"\\f1d1\",\n  \"brightness-high\": \"\\f1d2\",\n  \"brightness-low-fill\": \"\\f1d3\",\n  \"brightness-low\": \"\\f1d4\",\n  \"broadcast-pin\": \"\\f1d5\",\n  \"broadcast\": \"\\f1d6\",\n  \"brush-fill\": \"\\f1d7\",\n  \"brush\": \"\\f1d8\",\n  \"bucket-fill\": \"\\f1d9\",\n  \"bucket\": \"\\f1da\",\n  \"bug-fill\": \"\\f1db\",\n  \"bug\": \"\\f1dc\",\n  \"building\": \"\\f1dd\",\n  \"bullseye\": \"\\f1de\",\n  \"calculator-fill\": \"\\f1df\",\n  \"calculator\": \"\\f1e0\",\n  \"calendar-check-fill\": \"\\f1e1\",\n  \"calendar-check\": \"\\f1e2\",\n  \"calendar-date-fill\": \"\\f1e3\",\n  \"calendar-date\": \"\\f1e4\",\n  \"calendar-day-fill\": \"\\f1e5\",\n  \"calendar-day\": \"\\f1e6\",\n  \"calendar-event-fill\": \"\\f1e7\",\n  \"calendar-event\": \"\\f1e8\",\n  \"calendar-fill\": \"\\f1e9\",\n  \"calendar-minus-fill\": \"\\f1ea\",\n  \"calendar-minus\": \"\\f1eb\",\n  \"calendar-month-fill\": \"\\f1ec\",\n  \"calendar-month\": \"\\f1ed\",\n  \"calendar-plus-fill\": \"\\f1ee\",\n  \"calendar-plus\": \"\\f1ef\",\n  \"calendar-range-fill\": \"\\f1f0\",\n  \"calendar-range\": \"\\f1f1\",\n  \"calendar-week-fill\": \"\\f1f2\",\n  \"calendar-week\": \"\\f1f3\",\n  \"calendar-x-fill\": \"\\f1f4\",\n  \"calendar-x\": \"\\f1f5\",\n  \"calendar\": \"\\f1f6\",\n  \"calendar2-check-fill\": \"\\f1f7\",\n  \"calendar2-check\": \"\\f1f8\",\n  \"calendar2-date-fill\": \"\\f1f9\",\n  \"calendar2-date\": \"\\f1fa\",\n  \"calendar2-day-fill\": \"\\f1fb\",\n  \"calendar2-day\": \"\\f1fc\",\n  \"calendar2-event-fill\": \"\\f1fd\",\n  \"calendar2-event\": \"\\f1fe\",\n  \"calendar2-fill\": \"\\f1ff\",\n  \"calendar2-minus-fill\": \"\\f200\",\n  \"calendar2-minus\": \"\\f201\",\n  \"calendar2-month-fill\": \"\\f202\",\n  \"calendar2-month\": \"\\f203\",\n  \"calendar2-plus-fill\": \"\\f204\",\n  \"calendar2-plus\": \"\\f205\",\n  \"calendar2-range-fill\": \"\\f206\",\n  \"calendar2-range\": \"\\f207\",\n  \"calendar2-week-fill\": \"\\f208\",\n  \"calendar2-week\": \"\\f209\",\n  \"calendar2-x-fill\": \"\\f20a\",\n  \"calendar2-x\": \"\\f20b\",\n  \"calendar2\": \"\\f20c\",\n  \"calendar3-event-fill\": \"\\f20d\",\n  \"calendar3-event\": \"\\f20e\",\n  \"calendar3-fill\": \"\\f20f\",\n  \"calendar3-range-fill\": \"\\f210\",\n  \"calendar3-range\": \"\\f211\",\n  \"calendar3-week-fill\": \"\\f212\",\n  \"calendar3-week\": \"\\f213\",\n  \"calendar3\": \"\\f214\",\n  \"calendar4-event\": \"\\f215\",\n  \"calendar4-range\": \"\\f216\",\n  \"calendar4-week\": \"\\f217\",\n  \"calendar4\": \"\\f218\",\n  \"camera-fill\": \"\\f219\",\n  \"camera-reels-fill\": \"\\f21a\",\n  \"camera-reels\": \"\\f21b\",\n  \"camera-video-fill\": \"\\f21c\",\n  \"camera-video-off-fill\": \"\\f21d\",\n  \"camera-video-off\": \"\\f21e\",\n  \"camera-video\": \"\\f21f\",\n  \"camera\": \"\\f220\",\n  \"camera2\": \"\\f221\",\n  \"capslock-fill\": \"\\f222\",\n  \"capslock\": \"\\f223\",\n  \"card-checklist\": \"\\f224\",\n  \"card-heading\": \"\\f225\",\n  \"card-image\": \"\\f226\",\n  \"card-list\": \"\\f227\",\n  \"card-text\": \"\\f228\",\n  \"caret-down-fill\": \"\\f229\",\n  \"caret-down-square-fill\": \"\\f22a\",\n  \"caret-down-square\": \"\\f22b\",\n  \"caret-down\": \"\\f22c\",\n  \"caret-left-fill\": \"\\f22d\",\n  \"caret-left-square-fill\": \"\\f22e\",\n  \"caret-left-square\": \"\\f22f\",\n  \"caret-left\": \"\\f230\",\n  \"caret-right-fill\": \"\\f231\",\n  \"caret-right-square-fill\": \"\\f232\",\n  \"caret-right-square\": \"\\f233\",\n  \"caret-right\": \"\\f234\",\n  \"caret-up-fill\": \"\\f235\",\n  \"caret-up-square-fill\": \"\\f236\",\n  \"caret-up-square\": \"\\f237\",\n  \"caret-up\": \"\\f238\",\n  \"cart-check-fill\": \"\\f239\",\n  \"cart-check\": \"\\f23a\",\n  \"cart-dash-fill\": \"\\f23b\",\n  \"cart-dash\": \"\\f23c\",\n  \"cart-fill\": \"\\f23d\",\n  \"cart-plus-fill\": \"\\f23e\",\n  \"cart-plus\": \"\\f23f\",\n  \"cart-x-fill\": \"\\f240\",\n  \"cart-x\": \"\\f241\",\n  \"cart\": \"\\f242\",\n  \"cart2\": \"\\f243\",\n  \"cart3\": \"\\f244\",\n  \"cart4\": \"\\f245\",\n  \"cash-stack\": \"\\f246\",\n  \"cash\": \"\\f247\",\n  \"cast\": \"\\f248\",\n  \"chat-dots-fill\": \"\\f249\",\n  \"chat-dots\": \"\\f24a\",\n  \"chat-fill\": \"\\f24b\",\n  \"chat-left-dots-fill\": \"\\f24c\",\n  \"chat-left-dots\": \"\\f24d\",\n  \"chat-left-fill\": \"\\f24e\",\n  \"chat-left-quote-fill\": \"\\f24f\",\n  \"chat-left-quote\": \"\\f250\",\n  \"chat-left-text-fill\": \"\\f251\",\n  \"chat-left-text\": \"\\f252\",\n  \"chat-left\": \"\\f253\",\n  \"chat-quote-fill\": \"\\f254\",\n  \"chat-quote\": \"\\f255\",\n  \"chat-right-dots-fill\": \"\\f256\",\n  \"chat-right-dots\": \"\\f257\",\n  \"chat-right-fill\": \"\\f258\",\n  \"chat-right-quote-fill\": \"\\f259\",\n  \"chat-right-quote\": \"\\f25a\",\n  \"chat-right-text-fill\": \"\\f25b\",\n  \"chat-right-text\": \"\\f25c\",\n  \"chat-right\": \"\\f25d\",\n  \"chat-square-dots-fill\": \"\\f25e\",\n  \"chat-square-dots\": \"\\f25f\",\n  \"chat-square-fill\": \"\\f260\",\n  \"chat-square-quote-fill\": \"\\f261\",\n  \"chat-square-quote\": \"\\f262\",\n  \"chat-square-text-fill\": \"\\f263\",\n  \"chat-square-text\": \"\\f264\",\n  \"chat-square\": \"\\f265\",\n  \"chat-text-fill\": \"\\f266\",\n  \"chat-text\": \"\\f267\",\n  \"chat\": \"\\f268\",\n  \"check-all\": \"\\f269\",\n  \"check-circle-fill\": \"\\f26a\",\n  \"check-circle\": \"\\f26b\",\n  \"check-square-fill\": \"\\f26c\",\n  \"check-square\": \"\\f26d\",\n  \"check\": \"\\f26e\",\n  \"check2-all\": \"\\f26f\",\n  \"check2-circle\": \"\\f270\",\n  \"check2-square\": \"\\f271\",\n  \"check2\": \"\\f272\",\n  \"chevron-bar-contract\": \"\\f273\",\n  \"chevron-bar-down\": \"\\f274\",\n  \"chevron-bar-expand\": \"\\f275\",\n  \"chevron-bar-left\": \"\\f276\",\n  \"chevron-bar-right\": \"\\f277\",\n  \"chevron-bar-up\": \"\\f278\",\n  \"chevron-compact-down\": \"\\f279\",\n  \"chevron-compact-left\": \"\\f27a\",\n  \"chevron-compact-right\": \"\\f27b\",\n  \"chevron-compact-up\": \"\\f27c\",\n  \"chevron-contract\": \"\\f27d\",\n  \"chevron-double-down\": \"\\f27e\",\n  \"chevron-double-left\": \"\\f27f\",\n  \"chevron-double-right\": \"\\f280\",\n  \"chevron-double-up\": \"\\f281\",\n  \"chevron-down\": \"\\f282\",\n  \"chevron-expand\": \"\\f283\",\n  \"chevron-left\": \"\\f284\",\n  \"chevron-right\": \"\\f285\",\n  \"chevron-up\": \"\\f286\",\n  \"circle-fill\": \"\\f287\",\n  \"circle-half\": \"\\f288\",\n  \"circle-square\": \"\\f289\",\n  \"circle\": \"\\f28a\",\n  \"clipboard-check\": \"\\f28b\",\n  \"clipboard-data\": \"\\f28c\",\n  \"clipboard-minus\": \"\\f28d\",\n  \"clipboard-plus\": \"\\f28e\",\n  \"clipboard-x\": \"\\f28f\",\n  \"clipboard\": \"\\f290\",\n  \"clock-fill\": \"\\f291\",\n  \"clock-history\": \"\\f292\",\n  \"clock\": \"\\f293\",\n  \"cloud-arrow-down-fill\": \"\\f294\",\n  \"cloud-arrow-down\": \"\\f295\",\n  \"cloud-arrow-up-fill\": \"\\f296\",\n  \"cloud-arrow-up\": \"\\f297\",\n  \"cloud-check-fill\": \"\\f298\",\n  \"cloud-check\": \"\\f299\",\n  \"cloud-download-fill\": \"\\f29a\",\n  \"cloud-download\": \"\\f29b\",\n  \"cloud-drizzle-fill\": \"\\f29c\",\n  \"cloud-drizzle\": \"\\f29d\",\n  \"cloud-fill\": \"\\f29e\",\n  \"cloud-fog-fill\": \"\\f29f\",\n  \"cloud-fog\": \"\\f2a0\",\n  \"cloud-fog2-fill\": \"\\f2a1\",\n  \"cloud-fog2\": \"\\f2a2\",\n  \"cloud-hail-fill\": \"\\f2a3\",\n  \"cloud-hail\": \"\\f2a4\",\n  \"cloud-haze-fill\": \"\\f2a6\",\n  \"cloud-haze\": \"\\f2a7\",\n  \"cloud-haze2-fill\": \"\\f2a8\",\n  \"cloud-lightning-fill\": \"\\f2a9\",\n  \"cloud-lightning-rain-fill\": \"\\f2aa\",\n  \"cloud-lightning-rain\": \"\\f2ab\",\n  \"cloud-lightning\": \"\\f2ac\",\n  \"cloud-minus-fill\": \"\\f2ad\",\n  \"cloud-minus\": \"\\f2ae\",\n  \"cloud-moon-fill\": \"\\f2af\",\n  \"cloud-moon\": \"\\f2b0\",\n  \"cloud-plus-fill\": \"\\f2b1\",\n  \"cloud-plus\": \"\\f2b2\",\n  \"cloud-rain-fill\": \"\\f2b3\",\n  \"cloud-rain-heavy-fill\": \"\\f2b4\",\n  \"cloud-rain-heavy\": \"\\f2b5\",\n  \"cloud-rain\": \"\\f2b6\",\n  \"cloud-slash-fill\": \"\\f2b7\",\n  \"cloud-slash\": \"\\f2b8\",\n  \"cloud-sleet-fill\": \"\\f2b9\",\n  \"cloud-sleet\": \"\\f2ba\",\n  \"cloud-snow-fill\": \"\\f2bb\",\n  \"cloud-snow\": \"\\f2bc\",\n  \"cloud-sun-fill\": \"\\f2bd\",\n  \"cloud-sun\": \"\\f2be\",\n  \"cloud-upload-fill\": \"\\f2bf\",\n  \"cloud-upload\": \"\\f2c0\",\n  \"cloud\": \"\\f2c1\",\n  \"clouds-fill\": \"\\f2c2\",\n  \"clouds\": \"\\f2c3\",\n  \"cloudy-fill\": \"\\f2c4\",\n  \"cloudy\": \"\\f2c5\",\n  \"code-slash\": \"\\f2c6\",\n  \"code-square\": \"\\f2c7\",\n  \"code\": \"\\f2c8\",\n  \"collection-fill\": \"\\f2c9\",\n  \"collection-play-fill\": \"\\f2ca\",\n  \"collection-play\": \"\\f2cb\",\n  \"collection\": \"\\f2cc\",\n  \"columns-gap\": \"\\f2cd\",\n  \"columns\": \"\\f2ce\",\n  \"command\": \"\\f2cf\",\n  \"compass-fill\": \"\\f2d0\",\n  \"compass\": \"\\f2d1\",\n  \"cone-striped\": \"\\f2d2\",\n  \"cone\": \"\\f2d3\",\n  \"controller\": \"\\f2d4\",\n  \"cpu-fill\": \"\\f2d5\",\n  \"cpu\": \"\\f2d6\",\n  \"credit-card-2-back-fill\": \"\\f2d7\",\n  \"credit-card-2-back\": \"\\f2d8\",\n  \"credit-card-2-front-fill\": \"\\f2d9\",\n  \"credit-card-2-front\": \"\\f2da\",\n  \"credit-card-fill\": \"\\f2db\",\n  \"credit-card\": \"\\f2dc\",\n  \"crop\": \"\\f2dd\",\n  \"cup-fill\": \"\\f2de\",\n  \"cup-straw\": \"\\f2df\",\n  \"cup\": \"\\f2e0\",\n  \"cursor-fill\": \"\\f2e1\",\n  \"cursor-text\": \"\\f2e2\",\n  \"cursor\": \"\\f2e3\",\n  \"dash-circle-dotted\": \"\\f2e4\",\n  \"dash-circle-fill\": \"\\f2e5\",\n  \"dash-circle\": \"\\f2e6\",\n  \"dash-square-dotted\": \"\\f2e7\",\n  \"dash-square-fill\": \"\\f2e8\",\n  \"dash-square\": \"\\f2e9\",\n  \"dash\": \"\\f2ea\",\n  \"diagram-2-fill\": \"\\f2eb\",\n  \"diagram-2\": \"\\f2ec\",\n  \"diagram-3-fill\": \"\\f2ed\",\n  \"diagram-3\": \"\\f2ee\",\n  \"diamond-fill\": \"\\f2ef\",\n  \"diamond-half\": \"\\f2f0\",\n  \"diamond\": \"\\f2f1\",\n  \"dice-1-fill\": \"\\f2f2\",\n  \"dice-1\": \"\\f2f3\",\n  \"dice-2-fill\": \"\\f2f4\",\n  \"dice-2\": \"\\f2f5\",\n  \"dice-3-fill\": \"\\f2f6\",\n  \"dice-3\": \"\\f2f7\",\n  \"dice-4-fill\": \"\\f2f8\",\n  \"dice-4\": \"\\f2f9\",\n  \"dice-5-fill\": \"\\f2fa\",\n  \"dice-5\": \"\\f2fb\",\n  \"dice-6-fill\": \"\\f2fc\",\n  \"dice-6\": \"\\f2fd\",\n  \"disc-fill\": \"\\f2fe\",\n  \"disc\": \"\\f2ff\",\n  \"discord\": \"\\f300\",\n  \"display-fill\": \"\\f301\",\n  \"display\": \"\\f302\",\n  \"distribute-horizontal\": \"\\f303\",\n  \"distribute-vertical\": \"\\f304\",\n  \"door-closed-fill\": \"\\f305\",\n  \"door-closed\": \"\\f306\",\n  \"door-open-fill\": \"\\f307\",\n  \"door-open\": \"\\f308\",\n  \"dot\": \"\\f309\",\n  \"download\": \"\\f30a\",\n  \"droplet-fill\": \"\\f30b\",\n  \"droplet-half\": \"\\f30c\",\n  \"droplet\": \"\\f30d\",\n  \"earbuds\": \"\\f30e\",\n  \"easel-fill\": \"\\f30f\",\n  \"easel\": \"\\f310\",\n  \"egg-fill\": \"\\f311\",\n  \"egg-fried\": \"\\f312\",\n  \"egg\": \"\\f313\",\n  \"eject-fill\": \"\\f314\",\n  \"eject\": \"\\f315\",\n  \"emoji-angry-fill\": \"\\f316\",\n  \"emoji-angry\": \"\\f317\",\n  \"emoji-dizzy-fill\": \"\\f318\",\n  \"emoji-dizzy\": \"\\f319\",\n  \"emoji-expressionless-fill\": \"\\f31a\",\n  \"emoji-expressionless\": \"\\f31b\",\n  \"emoji-frown-fill\": \"\\f31c\",\n  \"emoji-frown\": \"\\f31d\",\n  \"emoji-heart-eyes-fill\": \"\\f31e\",\n  \"emoji-heart-eyes\": \"\\f31f\",\n  \"emoji-laughing-fill\": \"\\f320\",\n  \"emoji-laughing\": \"\\f321\",\n  \"emoji-neutral-fill\": \"\\f322\",\n  \"emoji-neutral\": \"\\f323\",\n  \"emoji-smile-fill\": \"\\f324\",\n  \"emoji-smile-upside-down-fill\": \"\\f325\",\n  \"emoji-smile-upside-down\": \"\\f326\",\n  \"emoji-smile\": \"\\f327\",\n  \"emoji-sunglasses-fill\": \"\\f328\",\n  \"emoji-sunglasses\": \"\\f329\",\n  \"emoji-wink-fill\": \"\\f32a\",\n  \"emoji-wink\": \"\\f32b\",\n  \"envelope-fill\": \"\\f32c\",\n  \"envelope-open-fill\": \"\\f32d\",\n  \"envelope-open\": \"\\f32e\",\n  \"envelope\": \"\\f32f\",\n  \"eraser-fill\": \"\\f330\",\n  \"eraser\": \"\\f331\",\n  \"exclamation-circle-fill\": \"\\f332\",\n  \"exclamation-circle\": \"\\f333\",\n  \"exclamation-diamond-fill\": \"\\f334\",\n  \"exclamation-diamond\": \"\\f335\",\n  \"exclamation-octagon-fill\": \"\\f336\",\n  \"exclamation-octagon\": \"\\f337\",\n  \"exclamation-square-fill\": \"\\f338\",\n  \"exclamation-square\": \"\\f339\",\n  \"exclamation-triangle-fill\": \"\\f33a\",\n  \"exclamation-triangle\": \"\\f33b\",\n  \"exclamation\": \"\\f33c\",\n  \"exclude\": \"\\f33d\",\n  \"eye-fill\": \"\\f33e\",\n  \"eye-slash-fill\": \"\\f33f\",\n  \"eye-slash\": \"\\f340\",\n  \"eye\": \"\\f341\",\n  \"eyedropper\": \"\\f342\",\n  \"eyeglasses\": \"\\f343\",\n  \"facebook\": \"\\f344\",\n  \"file-arrow-down-fill\": \"\\f345\",\n  \"file-arrow-down\": \"\\f346\",\n  \"file-arrow-up-fill\": \"\\f347\",\n  \"file-arrow-up\": \"\\f348\",\n  \"file-bar-graph-fill\": \"\\f349\",\n  \"file-bar-graph\": \"\\f34a\",\n  \"file-binary-fill\": \"\\f34b\",\n  \"file-binary\": \"\\f34c\",\n  \"file-break-fill\": \"\\f34d\",\n  \"file-break\": \"\\f34e\",\n  \"file-check-fill\": \"\\f34f\",\n  \"file-check\": \"\\f350\",\n  \"file-code-fill\": \"\\f351\",\n  \"file-code\": \"\\f352\",\n  \"file-diff-fill\": \"\\f353\",\n  \"file-diff\": \"\\f354\",\n  \"file-earmark-arrow-down-fill\": \"\\f355\",\n  \"file-earmark-arrow-down\": \"\\f356\",\n  \"file-earmark-arrow-up-fill\": \"\\f357\",\n  \"file-earmark-arrow-up\": \"\\f358\",\n  \"file-earmark-bar-graph-fill\": \"\\f359\",\n  \"file-earmark-bar-graph\": \"\\f35a\",\n  \"file-earmark-binary-fill\": \"\\f35b\",\n  \"file-earmark-binary\": \"\\f35c\",\n  \"file-earmark-break-fill\": \"\\f35d\",\n  \"file-earmark-break\": \"\\f35e\",\n  \"file-earmark-check-fill\": \"\\f35f\",\n  \"file-earmark-check\": \"\\f360\",\n  \"file-earmark-code-fill\": \"\\f361\",\n  \"file-earmark-code\": \"\\f362\",\n  \"file-earmark-diff-fill\": \"\\f363\",\n  \"file-earmark-diff\": \"\\f364\",\n  \"file-earmark-easel-fill\": \"\\f365\",\n  \"file-earmark-easel\": \"\\f366\",\n  \"file-earmark-excel-fill\": \"\\f367\",\n  \"file-earmark-excel\": \"\\f368\",\n  \"file-earmark-fill\": \"\\f369\",\n  \"file-earmark-font-fill\": \"\\f36a\",\n  \"file-earmark-font\": \"\\f36b\",\n  \"file-earmark-image-fill\": \"\\f36c\",\n  \"file-earmark-image\": \"\\f36d\",\n  \"file-earmark-lock-fill\": \"\\f36e\",\n  \"file-earmark-lock\": \"\\f36f\",\n  \"file-earmark-lock2-fill\": \"\\f370\",\n  \"file-earmark-lock2\": \"\\f371\",\n  \"file-earmark-medical-fill\": \"\\f372\",\n  \"file-earmark-medical\": \"\\f373\",\n  \"file-earmark-minus-fill\": \"\\f374\",\n  \"file-earmark-minus\": \"\\f375\",\n  \"file-earmark-music-fill\": \"\\f376\",\n  \"file-earmark-music\": \"\\f377\",\n  \"file-earmark-person-fill\": \"\\f378\",\n  \"file-earmark-person\": \"\\f379\",\n  \"file-earmark-play-fill\": \"\\f37a\",\n  \"file-earmark-play\": \"\\f37b\",\n  \"file-earmark-plus-fill\": \"\\f37c\",\n  \"file-earmark-plus\": \"\\f37d\",\n  \"file-earmark-post-fill\": \"\\f37e\",\n  \"file-earmark-post\": \"\\f37f\",\n  \"file-earmark-ppt-fill\": \"\\f380\",\n  \"file-earmark-ppt\": \"\\f381\",\n  \"file-earmark-richtext-fill\": \"\\f382\",\n  \"file-earmark-richtext\": \"\\f383\",\n  \"file-earmark-ruled-fill\": \"\\f384\",\n  \"file-earmark-ruled\": \"\\f385\",\n  \"file-earmark-slides-fill\": \"\\f386\",\n  \"file-earmark-slides\": \"\\f387\",\n  \"file-earmark-spreadsheet-fill\": \"\\f388\",\n  \"file-earmark-spreadsheet\": \"\\f389\",\n  \"file-earmark-text-fill\": \"\\f38a\",\n  \"file-earmark-text\": \"\\f38b\",\n  \"file-earmark-word-fill\": \"\\f38c\",\n  \"file-earmark-word\": \"\\f38d\",\n  \"file-earmark-x-fill\": \"\\f38e\",\n  \"file-earmark-x\": \"\\f38f\",\n  \"file-earmark-zip-fill\": \"\\f390\",\n  \"file-earmark-zip\": \"\\f391\",\n  \"file-earmark\": \"\\f392\",\n  \"file-easel-fill\": \"\\f393\",\n  \"file-easel\": \"\\f394\",\n  \"file-excel-fill\": \"\\f395\",\n  \"file-excel\": \"\\f396\",\n  \"file-fill\": \"\\f397\",\n  \"file-font-fill\": \"\\f398\",\n  \"file-font\": \"\\f399\",\n  \"file-image-fill\": \"\\f39a\",\n  \"file-image\": \"\\f39b\",\n  \"file-lock-fill\": \"\\f39c\",\n  \"file-lock\": \"\\f39d\",\n  \"file-lock2-fill\": \"\\f39e\",\n  \"file-lock2\": \"\\f39f\",\n  \"file-medical-fill\": \"\\f3a0\",\n  \"file-medical\": \"\\f3a1\",\n  \"file-minus-fill\": \"\\f3a2\",\n  \"file-minus\": \"\\f3a3\",\n  \"file-music-fill\": \"\\f3a4\",\n  \"file-music\": \"\\f3a5\",\n  \"file-person-fill\": \"\\f3a6\",\n  \"file-person\": \"\\f3a7\",\n  \"file-play-fill\": \"\\f3a8\",\n  \"file-play\": \"\\f3a9\",\n  \"file-plus-fill\": \"\\f3aa\",\n  \"file-plus\": \"\\f3ab\",\n  \"file-post-fill\": \"\\f3ac\",\n  \"file-post\": \"\\f3ad\",\n  \"file-ppt-fill\": \"\\f3ae\",\n  \"file-ppt\": \"\\f3af\",\n  \"file-richtext-fill\": \"\\f3b0\",\n  \"file-richtext\": \"\\f3b1\",\n  \"file-ruled-fill\": \"\\f3b2\",\n  \"file-ruled\": \"\\f3b3\",\n  \"file-slides-fill\": \"\\f3b4\",\n  \"file-slides\": \"\\f3b5\",\n  \"file-spreadsheet-fill\": \"\\f3b6\",\n  \"file-spreadsheet\": \"\\f3b7\",\n  \"file-text-fill\": \"\\f3b8\",\n  \"file-text\": \"\\f3b9\",\n  \"file-word-fill\": \"\\f3ba\",\n  \"file-word\": \"\\f3bb\",\n  \"file-x-fill\": \"\\f3bc\",\n  \"file-x\": \"\\f3bd\",\n  \"file-zip-fill\": \"\\f3be\",\n  \"file-zip\": \"\\f3bf\",\n  \"file\": \"\\f3c0\",\n  \"files-alt\": \"\\f3c1\",\n  \"files\": \"\\f3c2\",\n  \"film\": \"\\f3c3\",\n  \"filter-circle-fill\": \"\\f3c4\",\n  \"filter-circle\": \"\\f3c5\",\n  \"filter-left\": \"\\f3c6\",\n  \"filter-right\": \"\\f3c7\",\n  \"filter-square-fill\": \"\\f3c8\",\n  \"filter-square\": \"\\f3c9\",\n  \"filter\": \"\\f3ca\",\n  \"flag-fill\": \"\\f3cb\",\n  \"flag\": \"\\f3cc\",\n  \"flower1\": \"\\f3cd\",\n  \"flower2\": \"\\f3ce\",\n  \"flower3\": \"\\f3cf\",\n  \"folder-check\": \"\\f3d0\",\n  \"folder-fill\": \"\\f3d1\",\n  \"folder-minus\": \"\\f3d2\",\n  \"folder-plus\": \"\\f3d3\",\n  \"folder-symlink-fill\": \"\\f3d4\",\n  \"folder-symlink\": \"\\f3d5\",\n  \"folder-x\": \"\\f3d6\",\n  \"folder\": \"\\f3d7\",\n  \"folder2-open\": \"\\f3d8\",\n  \"folder2\": \"\\f3d9\",\n  \"fonts\": \"\\f3da\",\n  \"forward-fill\": \"\\f3db\",\n  \"forward\": \"\\f3dc\",\n  \"front\": \"\\f3dd\",\n  \"fullscreen-exit\": \"\\f3de\",\n  \"fullscreen\": \"\\f3df\",\n  \"funnel-fill\": \"\\f3e0\",\n  \"funnel\": \"\\f3e1\",\n  \"gear-fill\": \"\\f3e2\",\n  \"gear-wide-connected\": \"\\f3e3\",\n  \"gear-wide\": \"\\f3e4\",\n  \"gear\": \"\\f3e5\",\n  \"gem\": \"\\f3e6\",\n  \"geo-alt-fill\": \"\\f3e7\",\n  \"geo-alt\": \"\\f3e8\",\n  \"geo-fill\": \"\\f3e9\",\n  \"geo\": \"\\f3ea\",\n  \"gift-fill\": \"\\f3eb\",\n  \"gift\": \"\\f3ec\",\n  \"github\": \"\\f3ed\",\n  \"globe\": \"\\f3ee\",\n  \"globe2\": \"\\f3ef\",\n  \"google\": \"\\f3f0\",\n  \"graph-down\": \"\\f3f1\",\n  \"graph-up\": \"\\f3f2\",\n  \"grid-1x2-fill\": \"\\f3f3\",\n  \"grid-1x2\": \"\\f3f4\",\n  \"grid-3x2-gap-fill\": \"\\f3f5\",\n  \"grid-3x2-gap\": \"\\f3f6\",\n  \"grid-3x2\": \"\\f3f7\",\n  \"grid-3x3-gap-fill\": \"\\f3f8\",\n  \"grid-3x3-gap\": \"\\f3f9\",\n  \"grid-3x3\": \"\\f3fa\",\n  \"grid-fill\": \"\\f3fb\",\n  \"grid\": \"\\f3fc\",\n  \"grip-horizontal\": \"\\f3fd\",\n  \"grip-vertical\": \"\\f3fe\",\n  \"hammer\": \"\\f3ff\",\n  \"hand-index-fill\": \"\\f400\",\n  \"hand-index-thumb-fill\": \"\\f401\",\n  \"hand-index-thumb\": \"\\f402\",\n  \"hand-index\": \"\\f403\",\n  \"hand-thumbs-down-fill\": \"\\f404\",\n  \"hand-thumbs-down\": \"\\f405\",\n  \"hand-thumbs-up-fill\": \"\\f406\",\n  \"hand-thumbs-up\": \"\\f407\",\n  \"handbag-fill\": \"\\f408\",\n  \"handbag\": \"\\f409\",\n  \"hash\": \"\\f40a\",\n  \"hdd-fill\": \"\\f40b\",\n  \"hdd-network-fill\": \"\\f40c\",\n  \"hdd-network\": \"\\f40d\",\n  \"hdd-rack-fill\": \"\\f40e\",\n  \"hdd-rack\": \"\\f40f\",\n  \"hdd-stack-fill\": \"\\f410\",\n  \"hdd-stack\": \"\\f411\",\n  \"hdd\": \"\\f412\",\n  \"headphones\": \"\\f413\",\n  \"headset\": \"\\f414\",\n  \"heart-fill\": \"\\f415\",\n  \"heart-half\": \"\\f416\",\n  \"heart\": \"\\f417\",\n  \"heptagon-fill\": \"\\f418\",\n  \"heptagon-half\": \"\\f419\",\n  \"heptagon\": \"\\f41a\",\n  \"hexagon-fill\": \"\\f41b\",\n  \"hexagon-half\": \"\\f41c\",\n  \"hexagon\": \"\\f41d\",\n  \"hourglass-bottom\": \"\\f41e\",\n  \"hourglass-split\": \"\\f41f\",\n  \"hourglass-top\": \"\\f420\",\n  \"hourglass\": \"\\f421\",\n  \"house-door-fill\": \"\\f422\",\n  \"house-door\": \"\\f423\",\n  \"house-fill\": \"\\f424\",\n  \"house\": \"\\f425\",\n  \"hr\": \"\\f426\",\n  \"hurricane\": \"\\f427\",\n  \"image-alt\": \"\\f428\",\n  \"image-fill\": \"\\f429\",\n  \"image\": \"\\f42a\",\n  \"images\": \"\\f42b\",\n  \"inbox-fill\": \"\\f42c\",\n  \"inbox\": \"\\f42d\",\n  \"inboxes-fill\": \"\\f42e\",\n  \"inboxes\": \"\\f42f\",\n  \"info-circle-fill\": \"\\f430\",\n  \"info-circle\": \"\\f431\",\n  \"info-square-fill\": \"\\f432\",\n  \"info-square\": \"\\f433\",\n  \"info\": \"\\f434\",\n  \"input-cursor-text\": \"\\f435\",\n  \"input-cursor\": \"\\f436\",\n  \"instagram\": \"\\f437\",\n  \"intersect\": \"\\f438\",\n  \"journal-album\": \"\\f439\",\n  \"journal-arrow-down\": \"\\f43a\",\n  \"journal-arrow-up\": \"\\f43b\",\n  \"journal-bookmark-fill\": \"\\f43c\",\n  \"journal-bookmark\": \"\\f43d\",\n  \"journal-check\": \"\\f43e\",\n  \"journal-code\": \"\\f43f\",\n  \"journal-medical\": \"\\f440\",\n  \"journal-minus\": \"\\f441\",\n  \"journal-plus\": \"\\f442\",\n  \"journal-richtext\": \"\\f443\",\n  \"journal-text\": \"\\f444\",\n  \"journal-x\": \"\\f445\",\n  \"journal\": \"\\f446\",\n  \"journals\": \"\\f447\",\n  \"joystick\": \"\\f448\",\n  \"justify-left\": \"\\f449\",\n  \"justify-right\": \"\\f44a\",\n  \"justify\": \"\\f44b\",\n  \"kanban-fill\": \"\\f44c\",\n  \"kanban\": \"\\f44d\",\n  \"key-fill\": \"\\f44e\",\n  \"key\": \"\\f44f\",\n  \"keyboard-fill\": \"\\f450\",\n  \"keyboard\": \"\\f451\",\n  \"ladder\": \"\\f452\",\n  \"lamp-fill\": \"\\f453\",\n  \"lamp\": \"\\f454\",\n  \"laptop-fill\": \"\\f455\",\n  \"laptop\": \"\\f456\",\n  \"layer-backward\": \"\\f457\",\n  \"layer-forward\": \"\\f458\",\n  \"layers-fill\": \"\\f459\",\n  \"layers-half\": \"\\f45a\",\n  \"layers\": \"\\f45b\",\n  \"layout-sidebar-inset-reverse\": \"\\f45c\",\n  \"layout-sidebar-inset\": \"\\f45d\",\n  \"layout-sidebar-reverse\": \"\\f45e\",\n  \"layout-sidebar\": \"\\f45f\",\n  \"layout-split\": \"\\f460\",\n  \"layout-text-sidebar-reverse\": \"\\f461\",\n  \"layout-text-sidebar\": \"\\f462\",\n  \"layout-text-window-reverse\": \"\\f463\",\n  \"layout-text-window\": \"\\f464\",\n  \"layout-three-columns\": \"\\f465\",\n  \"layout-wtf\": \"\\f466\",\n  \"life-preserver\": \"\\f467\",\n  \"lightbulb-fill\": \"\\f468\",\n  \"lightbulb-off-fill\": \"\\f469\",\n  \"lightbulb-off\": \"\\f46a\",\n  \"lightbulb\": \"\\f46b\",\n  \"lightning-charge-fill\": \"\\f46c\",\n  \"lightning-charge\": \"\\f46d\",\n  \"lightning-fill\": \"\\f46e\",\n  \"lightning\": \"\\f46f\",\n  \"link-45deg\": \"\\f470\",\n  \"link\": \"\\f471\",\n  \"linkedin\": \"\\f472\",\n  \"list-check\": \"\\f473\",\n  \"list-nested\": \"\\f474\",\n  \"list-ol\": \"\\f475\",\n  \"list-stars\": \"\\f476\",\n  \"list-task\": \"\\f477\",\n  \"list-ul\": \"\\f478\",\n  \"list\": \"\\f479\",\n  \"lock-fill\": \"\\f47a\",\n  \"lock\": \"\\f47b\",\n  \"mailbox\": \"\\f47c\",\n  \"mailbox2\": \"\\f47d\",\n  \"map-fill\": \"\\f47e\",\n  \"map\": \"\\f47f\",\n  \"markdown-fill\": \"\\f480\",\n  \"markdown\": \"\\f481\",\n  \"mask\": \"\\f482\",\n  \"megaphone-fill\": \"\\f483\",\n  \"megaphone\": \"\\f484\",\n  \"menu-app-fill\": \"\\f485\",\n  \"menu-app\": \"\\f486\",\n  \"menu-button-fill\": \"\\f487\",\n  \"menu-button-wide-fill\": \"\\f488\",\n  \"menu-button-wide\": \"\\f489\",\n  \"menu-button\": \"\\f48a\",\n  \"menu-down\": \"\\f48b\",\n  \"menu-up\": \"\\f48c\",\n  \"mic-fill\": \"\\f48d\",\n  \"mic-mute-fill\": \"\\f48e\",\n  \"mic-mute\": \"\\f48f\",\n  \"mic\": \"\\f490\",\n  \"minecart-loaded\": \"\\f491\",\n  \"minecart\": \"\\f492\",\n  \"moisture\": \"\\f493\",\n  \"moon-fill\": \"\\f494\",\n  \"moon-stars-fill\": \"\\f495\",\n  \"moon-stars\": \"\\f496\",\n  \"moon\": \"\\f497\",\n  \"mouse-fill\": \"\\f498\",\n  \"mouse\": \"\\f499\",\n  \"mouse2-fill\": \"\\f49a\",\n  \"mouse2\": \"\\f49b\",\n  \"mouse3-fill\": \"\\f49c\",\n  \"mouse3\": \"\\f49d\",\n  \"music-note-beamed\": \"\\f49e\",\n  \"music-note-list\": \"\\f49f\",\n  \"music-note\": \"\\f4a0\",\n  \"music-player-fill\": \"\\f4a1\",\n  \"music-player\": \"\\f4a2\",\n  \"newspaper\": \"\\f4a3\",\n  \"node-minus-fill\": \"\\f4a4\",\n  \"node-minus\": \"\\f4a5\",\n  \"node-plus-fill\": \"\\f4a6\",\n  \"node-plus\": \"\\f4a7\",\n  \"nut-fill\": \"\\f4a8\",\n  \"nut\": \"\\f4a9\",\n  \"octagon-fill\": \"\\f4aa\",\n  \"octagon-half\": \"\\f4ab\",\n  \"octagon\": \"\\f4ac\",\n  \"option\": \"\\f4ad\",\n  \"outlet\": \"\\f4ae\",\n  \"paint-bucket\": \"\\f4af\",\n  \"palette-fill\": \"\\f4b0\",\n  \"palette\": \"\\f4b1\",\n  \"palette2\": \"\\f4b2\",\n  \"paperclip\": \"\\f4b3\",\n  \"paragraph\": \"\\f4b4\",\n  \"patch-check-fill\": \"\\f4b5\",\n  \"patch-check\": \"\\f4b6\",\n  \"patch-exclamation-fill\": \"\\f4b7\",\n  \"patch-exclamation\": \"\\f4b8\",\n  \"patch-minus-fill\": \"\\f4b9\",\n  \"patch-minus\": \"\\f4ba\",\n  \"patch-plus-fill\": \"\\f4bb\",\n  \"patch-plus\": \"\\f4bc\",\n  \"patch-question-fill\": \"\\f4bd\",\n  \"patch-question\": \"\\f4be\",\n  \"pause-btn-fill\": \"\\f4bf\",\n  \"pause-btn\": \"\\f4c0\",\n  \"pause-circle-fill\": \"\\f4c1\",\n  \"pause-circle\": \"\\f4c2\",\n  \"pause-fill\": \"\\f4c3\",\n  \"pause\": \"\\f4c4\",\n  \"peace-fill\": \"\\f4c5\",\n  \"peace\": \"\\f4c6\",\n  \"pen-fill\": \"\\f4c7\",\n  \"pen\": \"\\f4c8\",\n  \"pencil-fill\": \"\\f4c9\",\n  \"pencil-square\": \"\\f4ca\",\n  \"pencil\": \"\\f4cb\",\n  \"pentagon-fill\": \"\\f4cc\",\n  \"pentagon-half\": \"\\f4cd\",\n  \"pentagon\": \"\\f4ce\",\n  \"people-fill\": \"\\f4cf\",\n  \"people\": \"\\f4d0\",\n  \"percent\": \"\\f4d1\",\n  \"person-badge-fill\": \"\\f4d2\",\n  \"person-badge\": \"\\f4d3\",\n  \"person-bounding-box\": \"\\f4d4\",\n  \"person-check-fill\": \"\\f4d5\",\n  \"person-check\": \"\\f4d6\",\n  \"person-circle\": \"\\f4d7\",\n  \"person-dash-fill\": \"\\f4d8\",\n  \"person-dash\": \"\\f4d9\",\n  \"person-fill\": \"\\f4da\",\n  \"person-lines-fill\": \"\\f4db\",\n  \"person-plus-fill\": \"\\f4dc\",\n  \"person-plus\": \"\\f4dd\",\n  \"person-square\": \"\\f4de\",\n  \"person-x-fill\": \"\\f4df\",\n  \"person-x\": \"\\f4e0\",\n  \"person\": \"\\f4e1\",\n  \"phone-fill\": \"\\f4e2\",\n  \"phone-landscape-fill\": \"\\f4e3\",\n  \"phone-landscape\": \"\\f4e4\",\n  \"phone-vibrate-fill\": \"\\f4e5\",\n  \"phone-vibrate\": \"\\f4e6\",\n  \"phone\": \"\\f4e7\",\n  \"pie-chart-fill\": \"\\f4e8\",\n  \"pie-chart\": \"\\f4e9\",\n  \"pin-angle-fill\": \"\\f4ea\",\n  \"pin-angle\": \"\\f4eb\",\n  \"pin-fill\": \"\\f4ec\",\n  \"pin\": \"\\f4ed\",\n  \"pip-fill\": \"\\f4ee\",\n  \"pip\": \"\\f4ef\",\n  \"play-btn-fill\": \"\\f4f0\",\n  \"play-btn\": \"\\f4f1\",\n  \"play-circle-fill\": \"\\f4f2\",\n  \"play-circle\": \"\\f4f3\",\n  \"play-fill\": \"\\f4f4\",\n  \"play\": \"\\f4f5\",\n  \"plug-fill\": \"\\f4f6\",\n  \"plug\": \"\\f4f7\",\n  \"plus-circle-dotted\": \"\\f4f8\",\n  \"plus-circle-fill\": \"\\f4f9\",\n  \"plus-circle\": \"\\f4fa\",\n  \"plus-square-dotted\": \"\\f4fb\",\n  \"plus-square-fill\": \"\\f4fc\",\n  \"plus-square\": \"\\f4fd\",\n  \"plus\": \"\\f4fe\",\n  \"power\": \"\\f4ff\",\n  \"printer-fill\": \"\\f500\",\n  \"printer\": \"\\f501\",\n  \"puzzle-fill\": \"\\f502\",\n  \"puzzle\": \"\\f503\",\n  \"question-circle-fill\": \"\\f504\",\n  \"question-circle\": \"\\f505\",\n  \"question-diamond-fill\": \"\\f506\",\n  \"question-diamond\": \"\\f507\",\n  \"question-octagon-fill\": \"\\f508\",\n  \"question-octagon\": \"\\f509\",\n  \"question-square-fill\": \"\\f50a\",\n  \"question-square\": \"\\f50b\",\n  \"question\": \"\\f50c\",\n  \"rainbow\": \"\\f50d\",\n  \"receipt-cutoff\": \"\\f50e\",\n  \"receipt\": \"\\f50f\",\n  \"reception-0\": \"\\f510\",\n  \"reception-1\": \"\\f511\",\n  \"reception-2\": \"\\f512\",\n  \"reception-3\": \"\\f513\",\n  \"reception-4\": \"\\f514\",\n  \"record-btn-fill\": \"\\f515\",\n  \"record-btn\": \"\\f516\",\n  \"record-circle-fill\": \"\\f517\",\n  \"record-circle\": \"\\f518\",\n  \"record-fill\": \"\\f519\",\n  \"record\": \"\\f51a\",\n  \"record2-fill\": \"\\f51b\",\n  \"record2\": \"\\f51c\",\n  \"reply-all-fill\": \"\\f51d\",\n  \"reply-all\": \"\\f51e\",\n  \"reply-fill\": \"\\f51f\",\n  \"reply\": \"\\f520\",\n  \"rss-fill\": \"\\f521\",\n  \"rss\": \"\\f522\",\n  \"rulers\": \"\\f523\",\n  \"save-fill\": \"\\f524\",\n  \"save\": \"\\f525\",\n  \"save2-fill\": \"\\f526\",\n  \"save2\": \"\\f527\",\n  \"scissors\": \"\\f528\",\n  \"screwdriver\": \"\\f529\",\n  \"search\": \"\\f52a\",\n  \"segmented-nav\": \"\\f52b\",\n  \"server\": \"\\f52c\",\n  \"share-fill\": \"\\f52d\",\n  \"share\": \"\\f52e\",\n  \"shield-check\": \"\\f52f\",\n  \"shield-exclamation\": \"\\f530\",\n  \"shield-fill-check\": \"\\f531\",\n  \"shield-fill-exclamation\": \"\\f532\",\n  \"shield-fill-minus\": \"\\f533\",\n  \"shield-fill-plus\": \"\\f534\",\n  \"shield-fill-x\": \"\\f535\",\n  \"shield-fill\": \"\\f536\",\n  \"shield-lock-fill\": \"\\f537\",\n  \"shield-lock\": \"\\f538\",\n  \"shield-minus\": \"\\f539\",\n  \"shield-plus\": \"\\f53a\",\n  \"shield-shaded\": \"\\f53b\",\n  \"shield-slash-fill\": \"\\f53c\",\n  \"shield-slash\": \"\\f53d\",\n  \"shield-x\": \"\\f53e\",\n  \"shield\": \"\\f53f\",\n  \"shift-fill\": \"\\f540\",\n  \"shift\": \"\\f541\",\n  \"shop-window\": \"\\f542\",\n  \"shop\": \"\\f543\",\n  \"shuffle\": \"\\f544\",\n  \"signpost-2-fill\": \"\\f545\",\n  \"signpost-2\": \"\\f546\",\n  \"signpost-fill\": \"\\f547\",\n  \"signpost-split-fill\": \"\\f548\",\n  \"signpost-split\": \"\\f549\",\n  \"signpost\": \"\\f54a\",\n  \"sim-fill\": \"\\f54b\",\n  \"sim\": \"\\f54c\",\n  \"skip-backward-btn-fill\": \"\\f54d\",\n  \"skip-backward-btn\": \"\\f54e\",\n  \"skip-backward-circle-fill\": \"\\f54f\",\n  \"skip-backward-circle\": \"\\f550\",\n  \"skip-backward-fill\": \"\\f551\",\n  \"skip-backward\": \"\\f552\",\n  \"skip-end-btn-fill\": \"\\f553\",\n  \"skip-end-btn\": \"\\f554\",\n  \"skip-end-circle-fill\": \"\\f555\",\n  \"skip-end-circle\": \"\\f556\",\n  \"skip-end-fill\": \"\\f557\",\n  \"skip-end\": \"\\f558\",\n  \"skip-forward-btn-fill\": \"\\f559\",\n  \"skip-forward-btn\": \"\\f55a\",\n  \"skip-forward-circle-fill\": \"\\f55b\",\n  \"skip-forward-circle\": \"\\f55c\",\n  \"skip-forward-fill\": \"\\f55d\",\n  \"skip-forward\": \"\\f55e\",\n  \"skip-start-btn-fill\": \"\\f55f\",\n  \"skip-start-btn\": \"\\f560\",\n  \"skip-start-circle-fill\": \"\\f561\",\n  \"skip-start-circle\": \"\\f562\",\n  \"skip-start-fill\": \"\\f563\",\n  \"skip-start\": \"\\f564\",\n  \"slack\": \"\\f565\",\n  \"slash-circle-fill\": \"\\f566\",\n  \"slash-circle\": \"\\f567\",\n  \"slash-square-fill\": \"\\f568\",\n  \"slash-square\": \"\\f569\",\n  \"slash\": \"\\f56a\",\n  \"sliders\": \"\\f56b\",\n  \"smartwatch\": \"\\f56c\",\n  \"snow\": \"\\f56d\",\n  \"snow2\": \"\\f56e\",\n  \"snow3\": \"\\f56f\",\n  \"sort-alpha-down-alt\": \"\\f570\",\n  \"sort-alpha-down\": \"\\f571\",\n  \"sort-alpha-up-alt\": \"\\f572\",\n  \"sort-alpha-up\": \"\\f573\",\n  \"sort-down-alt\": \"\\f574\",\n  \"sort-down\": \"\\f575\",\n  \"sort-numeric-down-alt\": \"\\f576\",\n  \"sort-numeric-down\": \"\\f577\",\n  \"sort-numeric-up-alt\": \"\\f578\",\n  \"sort-numeric-up\": \"\\f579\",\n  \"sort-up-alt\": \"\\f57a\",\n  \"sort-up\": \"\\f57b\",\n  \"soundwave\": \"\\f57c\",\n  \"speaker-fill\": \"\\f57d\",\n  \"speaker\": \"\\f57e\",\n  \"speedometer\": \"\\f57f\",\n  \"speedometer2\": \"\\f580\",\n  \"spellcheck\": \"\\f581\",\n  \"square-fill\": \"\\f582\",\n  \"square-half\": \"\\f583\",\n  \"square\": \"\\f584\",\n  \"stack\": \"\\f585\",\n  \"star-fill\": \"\\f586\",\n  \"star-half\": \"\\f587\",\n  \"star\": \"\\f588\",\n  \"stars\": \"\\f589\",\n  \"stickies-fill\": \"\\f58a\",\n  \"stickies\": \"\\f58b\",\n  \"sticky-fill\": \"\\f58c\",\n  \"sticky\": \"\\f58d\",\n  \"stop-btn-fill\": \"\\f58e\",\n  \"stop-btn\": \"\\f58f\",\n  \"stop-circle-fill\": \"\\f590\",\n  \"stop-circle\": \"\\f591\",\n  \"stop-fill\": \"\\f592\",\n  \"stop\": \"\\f593\",\n  \"stoplights-fill\": \"\\f594\",\n  \"stoplights\": \"\\f595\",\n  \"stopwatch-fill\": \"\\f596\",\n  \"stopwatch\": \"\\f597\",\n  \"subtract\": \"\\f598\",\n  \"suit-club-fill\": \"\\f599\",\n  \"suit-club\": \"\\f59a\",\n  \"suit-diamond-fill\": \"\\f59b\",\n  \"suit-diamond\": \"\\f59c\",\n  \"suit-heart-fill\": \"\\f59d\",\n  \"suit-heart\": \"\\f59e\",\n  \"suit-spade-fill\": \"\\f59f\",\n  \"suit-spade\": \"\\f5a0\",\n  \"sun-fill\": \"\\f5a1\",\n  \"sun\": \"\\f5a2\",\n  \"sunglasses\": \"\\f5a3\",\n  \"sunrise-fill\": \"\\f5a4\",\n  \"sunrise\": \"\\f5a5\",\n  \"sunset-fill\": \"\\f5a6\",\n  \"sunset\": \"\\f5a7\",\n  \"symmetry-horizontal\": \"\\f5a8\",\n  \"symmetry-vertical\": \"\\f5a9\",\n  \"table\": \"\\f5aa\",\n  \"tablet-fill\": \"\\f5ab\",\n  \"tablet-landscape-fill\": \"\\f5ac\",\n  \"tablet-landscape\": \"\\f5ad\",\n  \"tablet\": \"\\f5ae\",\n  \"tag-fill\": \"\\f5af\",\n  \"tag\": \"\\f5b0\",\n  \"tags-fill\": \"\\f5b1\",\n  \"tags\": \"\\f5b2\",\n  \"telegram\": \"\\f5b3\",\n  \"telephone-fill\": \"\\f5b4\",\n  \"telephone-forward-fill\": \"\\f5b5\",\n  \"telephone-forward\": \"\\f5b6\",\n  \"telephone-inbound-fill\": \"\\f5b7\",\n  \"telephone-inbound\": \"\\f5b8\",\n  \"telephone-minus-fill\": \"\\f5b9\",\n  \"telephone-minus\": \"\\f5ba\",\n  \"telephone-outbound-fill\": \"\\f5bb\",\n  \"telephone-outbound\": \"\\f5bc\",\n  \"telephone-plus-fill\": \"\\f5bd\",\n  \"telephone-plus\": \"\\f5be\",\n  \"telephone-x-fill\": \"\\f5bf\",\n  \"telephone-x\": \"\\f5c0\",\n  \"telephone\": \"\\f5c1\",\n  \"terminal-fill\": \"\\f5c2\",\n  \"terminal\": \"\\f5c3\",\n  \"text-center\": \"\\f5c4\",\n  \"text-indent-left\": \"\\f5c5\",\n  \"text-indent-right\": \"\\f5c6\",\n  \"text-left\": \"\\f5c7\",\n  \"text-paragraph\": \"\\f5c8\",\n  \"text-right\": \"\\f5c9\",\n  \"textarea-resize\": \"\\f5ca\",\n  \"textarea-t\": \"\\f5cb\",\n  \"textarea\": \"\\f5cc\",\n  \"thermometer-half\": \"\\f5cd\",\n  \"thermometer-high\": \"\\f5ce\",\n  \"thermometer-low\": \"\\f5cf\",\n  \"thermometer-snow\": \"\\f5d0\",\n  \"thermometer-sun\": \"\\f5d1\",\n  \"thermometer\": \"\\f5d2\",\n  \"three-dots-vertical\": \"\\f5d3\",\n  \"three-dots\": \"\\f5d4\",\n  \"toggle-off\": \"\\f5d5\",\n  \"toggle-on\": \"\\f5d6\",\n  \"toggle2-off\": \"\\f5d7\",\n  \"toggle2-on\": \"\\f5d8\",\n  \"toggles\": \"\\f5d9\",\n  \"toggles2\": \"\\f5da\",\n  \"tools\": \"\\f5db\",\n  \"tornado\": \"\\f5dc\",\n  \"trash-fill\": \"\\f5dd\",\n  \"trash\": \"\\f5de\",\n  \"trash2-fill\": \"\\f5df\",\n  \"trash2\": \"\\f5e0\",\n  \"tree-fill\": \"\\f5e1\",\n  \"tree\": \"\\f5e2\",\n  \"triangle-fill\": \"\\f5e3\",\n  \"triangle-half\": \"\\f5e4\",\n  \"triangle\": \"\\f5e5\",\n  \"trophy-fill\": \"\\f5e6\",\n  \"trophy\": \"\\f5e7\",\n  \"tropical-storm\": \"\\f5e8\",\n  \"truck-flatbed\": \"\\f5e9\",\n  \"truck\": \"\\f5ea\",\n  \"tsunami\": \"\\f5eb\",\n  \"tv-fill\": \"\\f5ec\",\n  \"tv\": \"\\f5ed\",\n  \"twitch\": \"\\f5ee\",\n  \"twitter\": \"\\f5ef\",\n  \"type-bold\": \"\\f5f0\",\n  \"type-h1\": \"\\f5f1\",\n  \"type-h2\": \"\\f5f2\",\n  \"type-h3\": \"\\f5f3\",\n  \"type-italic\": \"\\f5f4\",\n  \"type-strikethrough\": \"\\f5f5\",\n  \"type-underline\": \"\\f5f6\",\n  \"type\": \"\\f5f7\",\n  \"ui-checks-grid\": \"\\f5f8\",\n  \"ui-checks\": \"\\f5f9\",\n  \"ui-radios-grid\": \"\\f5fa\",\n  \"ui-radios\": \"\\f5fb\",\n  \"umbrella-fill\": \"\\f5fc\",\n  \"umbrella\": \"\\f5fd\",\n  \"union\": \"\\f5fe\",\n  \"unlock-fill\": \"\\f5ff\",\n  \"unlock\": \"\\f600\",\n  \"upc-scan\": \"\\f601\",\n  \"upc\": \"\\f602\",\n  \"upload\": \"\\f603\",\n  \"vector-pen\": \"\\f604\",\n  \"view-list\": \"\\f605\",\n  \"view-stacked\": \"\\f606\",\n  \"vinyl-fill\": \"\\f607\",\n  \"vinyl\": \"\\f608\",\n  \"voicemail\": \"\\f609\",\n  \"volume-down-fill\": \"\\f60a\",\n  \"volume-down\": \"\\f60b\",\n  \"volume-mute-fill\": \"\\f60c\",\n  \"volume-mute\": \"\\f60d\",\n  \"volume-off-fill\": \"\\f60e\",\n  \"volume-off\": \"\\f60f\",\n  \"volume-up-fill\": \"\\f610\",\n  \"volume-up\": \"\\f611\",\n  \"vr\": \"\\f612\",\n  \"wallet-fill\": \"\\f613\",\n  \"wallet\": \"\\f614\",\n  \"wallet2\": \"\\f615\",\n  \"watch\": \"\\f616\",\n  \"water\": \"\\f617\",\n  \"whatsapp\": \"\\f618\",\n  \"wifi-1\": \"\\f619\",\n  \"wifi-2\": \"\\f61a\",\n  \"wifi-off\": \"\\f61b\",\n  \"wifi\": \"\\f61c\",\n  \"wind\": \"\\f61d\",\n  \"window-dock\": \"\\f61e\",\n  \"window-sidebar\": \"\\f61f\",\n  \"window\": \"\\f620\",\n  \"wrench\": \"\\f621\",\n  \"x-circle-fill\": \"\\f622\",\n  \"x-circle\": \"\\f623\",\n  \"x-diamond-fill\": \"\\f624\",\n  \"x-diamond\": \"\\f625\",\n  \"x-octagon-fill\": \"\\f626\",\n  \"x-octagon\": \"\\f627\",\n  \"x-square-fill\": \"\\f628\",\n  \"x-square\": \"\\f629\",\n  \"x\": \"\\f62a\",\n  \"youtube\": \"\\f62b\",\n  \"zoom-in\": \"\\f62c\",\n  \"zoom-out\": \"\\f62d\",\n  \"bank\": \"\\f62e\",\n  \"bank2\": \"\\f62f\",\n  \"bell-slash-fill\": \"\\f630\",\n  \"bell-slash\": \"\\f631\",\n  \"cash-coin\": \"\\f632\",\n  \"check-lg\": \"\\f633\",\n  \"coin\": \"\\f634\",\n  \"currency-bitcoin\": \"\\f635\",\n  \"currency-dollar\": \"\\f636\",\n  \"currency-euro\": \"\\f637\",\n  \"currency-exchange\": \"\\f638\",\n  \"currency-pound\": \"\\f639\",\n  \"currency-yen\": \"\\f63a\",\n  \"dash-lg\": \"\\f63b\",\n  \"exclamation-lg\": \"\\f63c\",\n  \"file-earmark-pdf-fill\": \"\\f63d\",\n  \"file-earmark-pdf\": \"\\f63e\",\n  \"file-pdf-fill\": \"\\f63f\",\n  \"file-pdf\": \"\\f640\",\n  \"gender-ambiguous\": \"\\f641\",\n  \"gender-female\": \"\\f642\",\n  \"gender-male\": \"\\f643\",\n  \"gender-trans\": \"\\f644\",\n  \"headset-vr\": \"\\f645\",\n  \"info-lg\": \"\\f646\",\n  \"mastodon\": \"\\f647\",\n  \"messenger\": \"\\f648\",\n  \"piggy-bank-fill\": \"\\f649\",\n  \"piggy-bank\": \"\\f64a\",\n  \"pin-map-fill\": \"\\f64b\",\n  \"pin-map\": \"\\f64c\",\n  \"plus-lg\": \"\\f64d\",\n  \"question-lg\": \"\\f64e\",\n  \"recycle\": \"\\f64f\",\n  \"reddit\": \"\\f650\",\n  \"safe-fill\": \"\\f651\",\n  \"safe2-fill\": \"\\f652\",\n  \"safe2\": \"\\f653\",\n  \"sd-card-fill\": \"\\f654\",\n  \"sd-card\": \"\\f655\",\n  \"skype\": \"\\f656\",\n  \"slash-lg\": \"\\f657\",\n  \"translate\": \"\\f658\",\n  \"x-lg\": \"\\f659\",\n  \"safe\": \"\\f65a\",\n  \"apple\": \"\\f65b\",\n  \"microsoft\": \"\\f65d\",\n  \"windows\": \"\\f65e\",\n  \"behance\": \"\\f65c\",\n  \"dribbble\": \"\\f65f\",\n  \"line\": \"\\f660\",\n  \"medium\": \"\\f661\",\n  \"paypal\": \"\\f662\",\n  \"pinterest\": \"\\f663\",\n  \"signal\": \"\\f664\",\n  \"snapchat\": \"\\f665\",\n  \"spotify\": \"\\f666\",\n  \"stack-overflow\": \"\\f667\",\n  \"strava\": \"\\f668\",\n  \"wordpress\": \"\\f669\",\n  \"vimeo\": \"\\f66a\",\n  \"activity\": \"\\f66b\",\n  \"easel2-fill\": \"\\f66c\",\n  \"easel2\": \"\\f66d\",\n  \"easel3-fill\": \"\\f66e\",\n  \"easel3\": \"\\f66f\",\n  \"fan\": \"\\f670\",\n  \"fingerprint\": \"\\f671\",\n  \"graph-down-arrow\": \"\\f672\",\n  \"graph-up-arrow\": \"\\f673\",\n  \"hypnotize\": \"\\f674\",\n  \"magic\": \"\\f675\",\n  \"person-rolodex\": \"\\f676\",\n  \"person-video\": \"\\f677\",\n  \"person-video2\": \"\\f678\",\n  \"person-video3\": \"\\f679\",\n  \"person-workspace\": \"\\f67a\",\n  \"radioactive\": \"\\f67b\",\n  \"webcam-fill\": \"\\f67c\",\n  \"webcam\": \"\\f67d\",\n  \"yin-yang\": \"\\f67e\",\n  \"bandaid-fill\": \"\\f680\",\n  \"bandaid\": \"\\f681\",\n  \"bluetooth\": \"\\f682\",\n  \"body-text\": \"\\f683\",\n  \"boombox\": \"\\f684\",\n  \"boxes\": \"\\f685\",\n  \"dpad-fill\": \"\\f686\",\n  \"dpad\": \"\\f687\",\n  \"ear-fill\": \"\\f688\",\n  \"ear\": \"\\f689\",\n  \"envelope-check-fill\": \"\\f68b\",\n  \"envelope-check\": \"\\f68c\",\n  \"envelope-dash-fill\": \"\\f68e\",\n  \"envelope-dash\": \"\\f68f\",\n  \"envelope-exclamation-fill\": \"\\f691\",\n  \"envelope-exclamation\": \"\\f692\",\n  \"envelope-plus-fill\": \"\\f693\",\n  \"envelope-plus\": \"\\f694\",\n  \"envelope-slash-fill\": \"\\f696\",\n  \"envelope-slash\": \"\\f697\",\n  \"envelope-x-fill\": \"\\f699\",\n  \"envelope-x\": \"\\f69a\",\n  \"explicit-fill\": \"\\f69b\",\n  \"explicit\": \"\\f69c\",\n  \"git\": \"\\f69d\",\n  \"infinity\": \"\\f69e\",\n  \"list-columns-reverse\": \"\\f69f\",\n  \"list-columns\": \"\\f6a0\",\n  \"meta\": \"\\f6a1\",\n  \"nintendo-switch\": \"\\f6a4\",\n  \"pc-display-horizontal\": \"\\f6a5\",\n  \"pc-display\": \"\\f6a6\",\n  \"pc-horizontal\": \"\\f6a7\",\n  \"pc\": \"\\f6a8\",\n  \"playstation\": \"\\f6a9\",\n  \"plus-slash-minus\": \"\\f6aa\",\n  \"projector-fill\": \"\\f6ab\",\n  \"projector\": \"\\f6ac\",\n  \"qr-code-scan\": \"\\f6ad\",\n  \"qr-code\": \"\\f6ae\",\n  \"quora\": \"\\f6af\",\n  \"quote\": \"\\f6b0\",\n  \"robot\": \"\\f6b1\",\n  \"send-check-fill\": \"\\f6b2\",\n  \"send-check\": \"\\f6b3\",\n  \"send-dash-fill\": \"\\f6b4\",\n  \"send-dash\": \"\\f6b5\",\n  \"send-exclamation-fill\": \"\\f6b7\",\n  \"send-exclamation\": \"\\f6b8\",\n  \"send-fill\": \"\\f6b9\",\n  \"send-plus-fill\": \"\\f6ba\",\n  \"send-plus\": \"\\f6bb\",\n  \"send-slash-fill\": \"\\f6bc\",\n  \"send-slash\": \"\\f6bd\",\n  \"send-x-fill\": \"\\f6be\",\n  \"send-x\": \"\\f6bf\",\n  \"send\": \"\\f6c0\",\n  \"steam\": \"\\f6c1\",\n  \"terminal-dash\": \"\\f6c3\",\n  \"terminal-plus\": \"\\f6c4\",\n  \"terminal-split\": \"\\f6c5\",\n  \"ticket-detailed-fill\": \"\\f6c6\",\n  \"ticket-detailed\": \"\\f6c7\",\n  \"ticket-fill\": \"\\f6c8\",\n  \"ticket-perforated-fill\": \"\\f6c9\",\n  \"ticket-perforated\": \"\\f6ca\",\n  \"ticket\": \"\\f6cb\",\n  \"tiktok\": \"\\f6cc\",\n  \"window-dash\": \"\\f6cd\",\n  \"window-desktop\": \"\\f6ce\",\n  \"window-fullscreen\": \"\\f6cf\",\n  \"window-plus\": \"\\f6d0\",\n  \"window-split\": \"\\f6d1\",\n  \"window-stack\": \"\\f6d2\",\n  \"window-x\": \"\\f6d3\",\n  \"xbox\": \"\\f6d4\",\n  \"ethernet\": \"\\f6d5\",\n  \"hdmi-fill\": \"\\f6d6\",\n  \"hdmi\": \"\\f6d7\",\n  \"usb-c-fill\": \"\\f6d8\",\n  \"usb-c\": \"\\f6d9\",\n  \"usb-fill\": \"\\f6da\",\n  \"usb-plug-fill\": \"\\f6db\",\n  \"usb-plug\": \"\\f6dc\",\n  \"usb-symbol\": \"\\f6dd\",\n  \"usb\": \"\\f6de\",\n  \"boombox-fill\": \"\\f6df\",\n  \"displayport\": \"\\f6e1\",\n  \"gpu-card\": \"\\f6e2\",\n  \"memory\": \"\\f6e3\",\n  \"modem-fill\": \"\\f6e4\",\n  \"modem\": \"\\f6e5\",\n  \"motherboard-fill\": \"\\f6e6\",\n  \"motherboard\": \"\\f6e7\",\n  \"optical-audio-fill\": \"\\f6e8\",\n  \"optical-audio\": \"\\f6e9\",\n  \"pci-card\": \"\\f6ea\",\n  \"router-fill\": \"\\f6eb\",\n  \"router\": \"\\f6ec\",\n  \"thunderbolt-fill\": \"\\f6ef\",\n  \"thunderbolt\": \"\\f6f0\",\n  \"usb-drive-fill\": \"\\f6f1\",\n  \"usb-drive\": \"\\f6f2\",\n  \"usb-micro-fill\": \"\\f6f3\",\n  \"usb-micro\": \"\\f6f4\",\n  \"usb-mini-fill\": \"\\f6f5\",\n  \"usb-mini\": \"\\f6f6\",\n  \"cloud-haze2\": \"\\f6f7\",\n  \"device-hdd-fill\": \"\\f6f8\",\n  \"device-hdd\": \"\\f6f9\",\n  \"device-ssd-fill\": \"\\f6fa\",\n  \"device-ssd\": \"\\f6fb\",\n  \"displayport-fill\": \"\\f6fc\",\n  \"mortarboard-fill\": \"\\f6fd\",\n  \"mortarboard\": \"\\f6fe\",\n  \"terminal-x\": \"\\f6ff\",\n  \"arrow-through-heart-fill\": \"\\f700\",\n  \"arrow-through-heart\": \"\\f701\",\n  \"badge-sd-fill\": \"\\f702\",\n  \"badge-sd\": \"\\f703\",\n  \"bag-heart-fill\": \"\\f704\",\n  \"bag-heart\": \"\\f705\",\n  \"balloon-fill\": \"\\f706\",\n  \"balloon-heart-fill\": \"\\f707\",\n  \"balloon-heart\": \"\\f708\",\n  \"balloon\": \"\\f709\",\n  \"box2-fill\": \"\\f70a\",\n  \"box2-heart-fill\": \"\\f70b\",\n  \"box2-heart\": \"\\f70c\",\n  \"box2\": \"\\f70d\",\n  \"braces-asterisk\": \"\\f70e\",\n  \"calendar-heart-fill\": \"\\f70f\",\n  \"calendar-heart\": \"\\f710\",\n  \"calendar2-heart-fill\": \"\\f711\",\n  \"calendar2-heart\": \"\\f712\",\n  \"chat-heart-fill\": \"\\f713\",\n  \"chat-heart\": \"\\f714\",\n  \"chat-left-heart-fill\": \"\\f715\",\n  \"chat-left-heart\": \"\\f716\",\n  \"chat-right-heart-fill\": \"\\f717\",\n  \"chat-right-heart\": \"\\f718\",\n  \"chat-square-heart-fill\": \"\\f719\",\n  \"chat-square-heart\": \"\\f71a\",\n  \"clipboard-check-fill\": \"\\f71b\",\n  \"clipboard-data-fill\": \"\\f71c\",\n  \"clipboard-fill\": \"\\f71d\",\n  \"clipboard-heart-fill\": \"\\f71e\",\n  \"clipboard-heart\": \"\\f71f\",\n  \"clipboard-minus-fill\": \"\\f720\",\n  \"clipboard-plus-fill\": \"\\f721\",\n  \"clipboard-pulse\": \"\\f722\",\n  \"clipboard-x-fill\": \"\\f723\",\n  \"clipboard2-check-fill\": \"\\f724\",\n  \"clipboard2-check\": \"\\f725\",\n  \"clipboard2-data-fill\": \"\\f726\",\n  \"clipboard2-data\": \"\\f727\",\n  \"clipboard2-fill\": \"\\f728\",\n  \"clipboard2-heart-fill\": \"\\f729\",\n  \"clipboard2-heart\": \"\\f72a\",\n  \"clipboard2-minus-fill\": \"\\f72b\",\n  \"clipboard2-minus\": \"\\f72c\",\n  \"clipboard2-plus-fill\": \"\\f72d\",\n  \"clipboard2-plus\": \"\\f72e\",\n  \"clipboard2-pulse-fill\": \"\\f72f\",\n  \"clipboard2-pulse\": \"\\f730\",\n  \"clipboard2-x-fill\": \"\\f731\",\n  \"clipboard2-x\": \"\\f732\",\n  \"clipboard2\": \"\\f733\",\n  \"emoji-kiss-fill\": \"\\f734\",\n  \"emoji-kiss\": \"\\f735\",\n  \"envelope-heart-fill\": \"\\f736\",\n  \"envelope-heart\": \"\\f737\",\n  \"envelope-open-heart-fill\": \"\\f738\",\n  \"envelope-open-heart\": \"\\f739\",\n  \"envelope-paper-fill\": \"\\f73a\",\n  \"envelope-paper-heart-fill\": \"\\f73b\",\n  \"envelope-paper-heart\": \"\\f73c\",\n  \"envelope-paper\": \"\\f73d\",\n  \"filetype-aac\": \"\\f73e\",\n  \"filetype-ai\": \"\\f73f\",\n  \"filetype-bmp\": \"\\f740\",\n  \"filetype-cs\": \"\\f741\",\n  \"filetype-css\": \"\\f742\",\n  \"filetype-csv\": \"\\f743\",\n  \"filetype-doc\": \"\\f744\",\n  \"filetype-docx\": \"\\f745\",\n  \"filetype-exe\": \"\\f746\",\n  \"filetype-gif\": \"\\f747\",\n  \"filetype-heic\": \"\\f748\",\n  \"filetype-html\": \"\\f749\",\n  \"filetype-java\": \"\\f74a\",\n  \"filetype-jpg\": \"\\f74b\",\n  \"filetype-js\": \"\\f74c\",\n  \"filetype-jsx\": \"\\f74d\",\n  \"filetype-key\": \"\\f74e\",\n  \"filetype-m4p\": \"\\f74f\",\n  \"filetype-md\": \"\\f750\",\n  \"filetype-mdx\": \"\\f751\",\n  \"filetype-mov\": \"\\f752\",\n  \"filetype-mp3\": \"\\f753\",\n  \"filetype-mp4\": \"\\f754\",\n  \"filetype-otf\": \"\\f755\",\n  \"filetype-pdf\": \"\\f756\",\n  \"filetype-php\": \"\\f757\",\n  \"filetype-png\": \"\\f758\",\n  \"filetype-ppt\": \"\\f75a\",\n  \"filetype-psd\": \"\\f75b\",\n  \"filetype-py\": \"\\f75c\",\n  \"filetype-raw\": \"\\f75d\",\n  \"filetype-rb\": \"\\f75e\",\n  \"filetype-sass\": \"\\f75f\",\n  \"filetype-scss\": \"\\f760\",\n  \"filetype-sh\": \"\\f761\",\n  \"filetype-svg\": \"\\f762\",\n  \"filetype-tiff\": \"\\f763\",\n  \"filetype-tsx\": \"\\f764\",\n  \"filetype-ttf\": \"\\f765\",\n  \"filetype-txt\": \"\\f766\",\n  \"filetype-wav\": \"\\f767\",\n  \"filetype-woff\": \"\\f768\",\n  \"filetype-xls\": \"\\f76a\",\n  \"filetype-xml\": \"\\f76b\",\n  \"filetype-yml\": \"\\f76c\",\n  \"heart-arrow\": \"\\f76d\",\n  \"heart-pulse-fill\": \"\\f76e\",\n  \"heart-pulse\": \"\\f76f\",\n  \"heartbreak-fill\": \"\\f770\",\n  \"heartbreak\": \"\\f771\",\n  \"hearts\": \"\\f772\",\n  \"hospital-fill\": \"\\f773\",\n  \"hospital\": \"\\f774\",\n  \"house-heart-fill\": \"\\f775\",\n  \"house-heart\": \"\\f776\",\n  \"incognito\": \"\\f777\",\n  \"magnet-fill\": \"\\f778\",\n  \"magnet\": \"\\f779\",\n  \"person-heart\": \"\\f77a\",\n  \"person-hearts\": \"\\f77b\",\n  \"phone-flip\": \"\\f77c\",\n  \"plugin\": \"\\f77d\",\n  \"postage-fill\": \"\\f77e\",\n  \"postage-heart-fill\": \"\\f77f\",\n  \"postage-heart\": \"\\f780\",\n  \"postage\": \"\\f781\",\n  \"postcard-fill\": \"\\f782\",\n  \"postcard-heart-fill\": \"\\f783\",\n  \"postcard-heart\": \"\\f784\",\n  \"postcard\": \"\\f785\",\n  \"search-heart-fill\": \"\\f786\",\n  \"search-heart\": \"\\f787\",\n  \"sliders2-vertical\": \"\\f788\",\n  \"sliders2\": \"\\f789\",\n  \"trash3-fill\": \"\\f78a\",\n  \"trash3\": \"\\f78b\",\n  \"valentine\": \"\\f78c\",\n  \"valentine2\": \"\\f78d\",\n  \"wrench-adjustable-circle-fill\": \"\\f78e\",\n  \"wrench-adjustable-circle\": \"\\f78f\",\n  \"wrench-adjustable\": \"\\f790\",\n  \"filetype-json\": \"\\f791\",\n  \"filetype-pptx\": \"\\f792\",\n  \"filetype-xlsx\": \"\\f793\",\n  \"1-circle-fill\": \"\\f796\",\n  \"1-circle\": \"\\f797\",\n  \"1-square-fill\": \"\\f798\",\n  \"1-square\": \"\\f799\",\n  \"2-circle-fill\": \"\\f79c\",\n  \"2-circle\": \"\\f79d\",\n  \"2-square-fill\": \"\\f79e\",\n  \"2-square\": \"\\f79f\",\n  \"3-circle-fill\": \"\\f7a2\",\n  \"3-circle\": \"\\f7a3\",\n  \"3-square-fill\": \"\\f7a4\",\n  \"3-square\": \"\\f7a5\",\n  \"4-circle-fill\": \"\\f7a8\",\n  \"4-circle\": \"\\f7a9\",\n  \"4-square-fill\": \"\\f7aa\",\n  \"4-square\": \"\\f7ab\",\n  \"5-circle-fill\": \"\\f7ae\",\n  \"5-circle\": \"\\f7af\",\n  \"5-square-fill\": \"\\f7b0\",\n  \"5-square\": \"\\f7b1\",\n  \"6-circle-fill\": \"\\f7b4\",\n  \"6-circle\": \"\\f7b5\",\n  \"6-square-fill\": \"\\f7b6\",\n  \"6-square\": \"\\f7b7\",\n  \"7-circle-fill\": \"\\f7ba\",\n  \"7-circle\": \"\\f7bb\",\n  \"7-square-fill\": \"\\f7bc\",\n  \"7-square\": \"\\f7bd\",\n  \"8-circle-fill\": \"\\f7c0\",\n  \"8-circle\": \"\\f7c1\",\n  \"8-square-fill\": \"\\f7c2\",\n  \"8-square\": \"\\f7c3\",\n  \"9-circle-fill\": \"\\f7c6\",\n  \"9-circle\": \"\\f7c7\",\n  \"9-square-fill\": \"\\f7c8\",\n  \"9-square\": \"\\f7c9\",\n  \"airplane-engines-fill\": \"\\f7ca\",\n  \"airplane-engines\": \"\\f7cb\",\n  \"airplane-fill\": \"\\f7cc\",\n  \"airplane\": \"\\f7cd\",\n  \"alexa\": \"\\f7ce\",\n  \"alipay\": \"\\f7cf\",\n  \"android\": \"\\f7d0\",\n  \"android2\": \"\\f7d1\",\n  \"box-fill\": \"\\f7d2\",\n  \"box-seam-fill\": \"\\f7d3\",\n  \"browser-chrome\": \"\\f7d4\",\n  \"browser-edge\": \"\\f7d5\",\n  \"browser-firefox\": \"\\f7d6\",\n  \"browser-safari\": \"\\f7d7\",\n  \"c-circle-fill\": \"\\f7da\",\n  \"c-circle\": \"\\f7db\",\n  \"c-square-fill\": \"\\f7dc\",\n  \"c-square\": \"\\f7dd\",\n  \"capsule-pill\": \"\\f7de\",\n  \"capsule\": \"\\f7df\",\n  \"car-front-fill\": \"\\f7e0\",\n  \"car-front\": \"\\f7e1\",\n  \"cassette-fill\": \"\\f7e2\",\n  \"cassette\": \"\\f7e3\",\n  \"cc-circle-fill\": \"\\f7e6\",\n  \"cc-circle\": \"\\f7e7\",\n  \"cc-square-fill\": \"\\f7e8\",\n  \"cc-square\": \"\\f7e9\",\n  \"cup-hot-fill\": \"\\f7ea\",\n  \"cup-hot\": \"\\f7eb\",\n  \"currency-rupee\": \"\\f7ec\",\n  \"dropbox\": \"\\f7ed\",\n  \"escape\": \"\\f7ee\",\n  \"fast-forward-btn-fill\": \"\\f7ef\",\n  \"fast-forward-btn\": \"\\f7f0\",\n  \"fast-forward-circle-fill\": \"\\f7f1\",\n  \"fast-forward-circle\": \"\\f7f2\",\n  \"fast-forward-fill\": \"\\f7f3\",\n  \"fast-forward\": \"\\f7f4\",\n  \"filetype-sql\": \"\\f7f5\",\n  \"fire\": \"\\f7f6\",\n  \"google-play\": \"\\f7f7\",\n  \"h-circle-fill\": \"\\f7fa\",\n  \"h-circle\": \"\\f7fb\",\n  \"h-square-fill\": \"\\f7fc\",\n  \"h-square\": \"\\f7fd\",\n  \"indent\": \"\\f7fe\",\n  \"lungs-fill\": \"\\f7ff\",\n  \"lungs\": \"\\f800\",\n  \"microsoft-teams\": \"\\f801\",\n  \"p-circle-fill\": \"\\f804\",\n  \"p-circle\": \"\\f805\",\n  \"p-square-fill\": \"\\f806\",\n  \"p-square\": \"\\f807\",\n  \"pass-fill\": \"\\f808\",\n  \"pass\": \"\\f809\",\n  \"prescription\": \"\\f80a\",\n  \"prescription2\": \"\\f80b\",\n  \"r-circle-fill\": \"\\f80e\",\n  \"r-circle\": \"\\f80f\",\n  \"r-square-fill\": \"\\f810\",\n  \"r-square\": \"\\f811\",\n  \"repeat-1\": \"\\f812\",\n  \"repeat\": \"\\f813\",\n  \"rewind-btn-fill\": \"\\f814\",\n  \"rewind-btn\": \"\\f815\",\n  \"rewind-circle-fill\": \"\\f816\",\n  \"rewind-circle\": \"\\f817\",\n  \"rewind-fill\": \"\\f818\",\n  \"rewind\": \"\\f819\",\n  \"train-freight-front-fill\": \"\\f81a\",\n  \"train-freight-front\": \"\\f81b\",\n  \"train-front-fill\": \"\\f81c\",\n  \"train-front\": \"\\f81d\",\n  \"train-lightrail-front-fill\": \"\\f81e\",\n  \"train-lightrail-front\": \"\\f81f\",\n  \"truck-front-fill\": \"\\f820\",\n  \"truck-front\": \"\\f821\",\n  \"ubuntu\": \"\\f822\",\n  \"unindent\": \"\\f823\",\n  \"unity\": \"\\f824\",\n  \"universal-access-circle\": \"\\f825\",\n  \"universal-access\": \"\\f826\",\n  \"virus\": \"\\f827\",\n  \"virus2\": \"\\f828\",\n  \"wechat\": \"\\f829\",\n  \"yelp\": \"\\f82a\",\n  \"sign-stop-fill\": \"\\f82b\",\n  \"sign-stop-lights-fill\": \"\\f82c\",\n  \"sign-stop-lights\": \"\\f82d\",\n  \"sign-stop\": \"\\f82e\",\n  \"sign-turn-left-fill\": \"\\f82f\",\n  \"sign-turn-left\": \"\\f830\",\n  \"sign-turn-right-fill\": \"\\f831\",\n  \"sign-turn-right\": \"\\f832\",\n  \"sign-turn-slight-left-fill\": \"\\f833\",\n  \"sign-turn-slight-left\": \"\\f834\",\n  \"sign-turn-slight-right-fill\": \"\\f835\",\n  \"sign-turn-slight-right\": \"\\f836\",\n  \"sign-yield-fill\": \"\\f837\",\n  \"sign-yield\": \"\\f838\",\n  \"ev-station-fill\": \"\\f839\",\n  \"ev-station\": \"\\f83a\",\n  \"fuel-pump-diesel-fill\": \"\\f83b\",\n  \"fuel-pump-diesel\": \"\\f83c\",\n  \"fuel-pump-fill\": \"\\f83d\",\n  \"fuel-pump\": \"\\f83e\",\n  \"0-circle-fill\": \"\\f83f\",\n  \"0-circle\": \"\\f840\",\n  \"0-square-fill\": \"\\f841\",\n  \"0-square\": \"\\f842\",\n  \"rocket-fill\": \"\\f843\",\n  \"rocket-takeoff-fill\": \"\\f844\",\n  \"rocket-takeoff\": \"\\f845\",\n  \"rocket\": \"\\f846\",\n  \"stripe\": \"\\f847\",\n  \"subscript\": \"\\f848\",\n  \"superscript\": \"\\f849\",\n  \"trello\": \"\\f84a\",\n  \"envelope-at-fill\": \"\\f84b\",\n  \"envelope-at\": \"\\f84c\",\n  \"regex\": \"\\f84d\",\n  \"text-wrap\": \"\\f84e\",\n  \"sign-dead-end-fill\": \"\\f84f\",\n  \"sign-dead-end\": \"\\f850\",\n  \"sign-do-not-enter-fill\": \"\\f851\",\n  \"sign-do-not-enter\": \"\\f852\",\n  \"sign-intersection-fill\": \"\\f853\",\n  \"sign-intersection-side-fill\": \"\\f854\",\n  \"sign-intersection-side\": \"\\f855\",\n  \"sign-intersection-t-fill\": \"\\f856\",\n  \"sign-intersection-t\": \"\\f857\",\n  \"sign-intersection-y-fill\": \"\\f858\",\n  \"sign-intersection-y\": \"\\f859\",\n  \"sign-intersection\": \"\\f85a\",\n  \"sign-merge-left-fill\": \"\\f85b\",\n  \"sign-merge-left\": \"\\f85c\",\n  \"sign-merge-right-fill\": \"\\f85d\",\n  \"sign-merge-right\": \"\\f85e\",\n  \"sign-no-left-turn-fill\": \"\\f85f\",\n  \"sign-no-left-turn\": \"\\f860\",\n  \"sign-no-parking-fill\": \"\\f861\",\n  \"sign-no-parking\": \"\\f862\",\n  \"sign-no-right-turn-fill\": \"\\f863\",\n  \"sign-no-right-turn\": \"\\f864\",\n  \"sign-railroad-fill\": \"\\f865\",\n  \"sign-railroad\": \"\\f866\",\n  \"building-add\": \"\\f867\",\n  \"building-check\": \"\\f868\",\n  \"building-dash\": \"\\f869\",\n  \"building-down\": \"\\f86a\",\n  \"building-exclamation\": \"\\f86b\",\n  \"building-fill-add\": \"\\f86c\",\n  \"building-fill-check\": \"\\f86d\",\n  \"building-fill-dash\": \"\\f86e\",\n  \"building-fill-down\": \"\\f86f\",\n  \"building-fill-exclamation\": \"\\f870\",\n  \"building-fill-gear\": \"\\f871\",\n  \"building-fill-lock\": \"\\f872\",\n  \"building-fill-slash\": \"\\f873\",\n  \"building-fill-up\": \"\\f874\",\n  \"building-fill-x\": \"\\f875\",\n  \"building-fill\": \"\\f876\",\n  \"building-gear\": \"\\f877\",\n  \"building-lock\": \"\\f878\",\n  \"building-slash\": \"\\f879\",\n  \"building-up\": \"\\f87a\",\n  \"building-x\": \"\\f87b\",\n  \"buildings-fill\": \"\\f87c\",\n  \"buildings\": \"\\f87d\",\n  \"bus-front-fill\": \"\\f87e\",\n  \"bus-front\": \"\\f87f\",\n  \"ev-front-fill\": \"\\f880\",\n  \"ev-front\": \"\\f881\",\n  \"globe-americas\": \"\\f882\",\n  \"globe-asia-australia\": \"\\f883\",\n  \"globe-central-south-asia\": \"\\f884\",\n  \"globe-europe-africa\": \"\\f885\",\n  \"house-add-fill\": \"\\f886\",\n  \"house-add\": \"\\f887\",\n  \"house-check-fill\": \"\\f888\",\n  \"house-check\": \"\\f889\",\n  \"house-dash-fill\": \"\\f88a\",\n  \"house-dash\": \"\\f88b\",\n  \"house-down-fill\": \"\\f88c\",\n  \"house-down\": \"\\f88d\",\n  \"house-exclamation-fill\": \"\\f88e\",\n  \"house-exclamation\": \"\\f88f\",\n  \"house-gear-fill\": \"\\f890\",\n  \"house-gear\": \"\\f891\",\n  \"house-lock-fill\": \"\\f892\",\n  \"house-lock\": \"\\f893\",\n  \"house-slash-fill\": \"\\f894\",\n  \"house-slash\": \"\\f895\",\n  \"house-up-fill\": \"\\f896\",\n  \"house-up\": \"\\f897\",\n  \"house-x-fill\": \"\\f898\",\n  \"house-x\": \"\\f899\",\n  \"person-add\": \"\\f89a\",\n  \"person-down\": \"\\f89b\",\n  \"person-exclamation\": \"\\f89c\",\n  \"person-fill-add\": \"\\f89d\",\n  \"person-fill-check\": \"\\f89e\",\n  \"person-fill-dash\": \"\\f89f\",\n  \"person-fill-down\": \"\\f8a0\",\n  \"person-fill-exclamation\": \"\\f8a1\",\n  \"person-fill-gear\": \"\\f8a2\",\n  \"person-fill-lock\": \"\\f8a3\",\n  \"person-fill-slash\": \"\\f8a4\",\n  \"person-fill-up\": \"\\f8a5\",\n  \"person-fill-x\": \"\\f8a6\",\n  \"person-gear\": \"\\f8a7\",\n  \"person-lock\": \"\\f8a8\",\n  \"person-slash\": \"\\f8a9\",\n  \"person-up\": \"\\f8aa\",\n  \"scooter\": \"\\f8ab\",\n  \"taxi-front-fill\": \"\\f8ac\",\n  \"taxi-front\": \"\\f8ad\",\n  \"amd\": \"\\f8ae\",\n  \"database-add\": \"\\f8af\",\n  \"database-check\": \"\\f8b0\",\n  \"database-dash\": \"\\f8b1\",\n  \"database-down\": \"\\f8b2\",\n  \"database-exclamation\": \"\\f8b3\",\n  \"database-fill-add\": \"\\f8b4\",\n  \"database-fill-check\": \"\\f8b5\",\n  \"database-fill-dash\": \"\\f8b6\",\n  \"database-fill-down\": \"\\f8b7\",\n  \"database-fill-exclamation\": \"\\f8b8\",\n  \"database-fill-gear\": \"\\f8b9\",\n  \"database-fill-lock\": \"\\f8ba\",\n  \"database-fill-slash\": \"\\f8bb\",\n  \"database-fill-up\": \"\\f8bc\",\n  \"database-fill-x\": \"\\f8bd\",\n  \"database-fill\": \"\\f8be\",\n  \"database-gear\": \"\\f8bf\",\n  \"database-lock\": \"\\f8c0\",\n  \"database-slash\": \"\\f8c1\",\n  \"database-up\": \"\\f8c2\",\n  \"database-x\": \"\\f8c3\",\n  \"database\": \"\\f8c4\",\n  \"houses-fill\": \"\\f8c5\",\n  \"houses\": \"\\f8c6\",\n  \"nvidia\": \"\\f8c7\",\n  \"person-vcard-fill\": \"\\f8c8\",\n  \"person-vcard\": \"\\f8c9\",\n  \"sina-weibo\": \"\\f8ca\",\n  \"tencent-qq\": \"\\f8cb\",\n  \"wikipedia\": \"\\f8cc\",\n  \"alphabet-uppercase\": \"\\f2a5\",\n  \"alphabet\": \"\\f68a\",\n  \"amazon\": \"\\f68d\",\n  \"arrows-collapse-vertical\": \"\\f690\",\n  \"arrows-expand-vertical\": \"\\f695\",\n  \"arrows-vertical\": \"\\f698\",\n  \"arrows\": \"\\f6a2\",\n  \"ban-fill\": \"\\f6a3\",\n  \"ban\": \"\\f6b6\",\n  \"bing\": \"\\f6c2\",\n  \"cake\": \"\\f6e0\",\n  \"cake2\": \"\\f6ed\",\n  \"cookie\": \"\\f6ee\",\n  \"copy\": \"\\f759\",\n  \"crosshair\": \"\\f769\",\n  \"crosshair2\": \"\\f794\",\n  \"emoji-astonished-fill\": \"\\f795\",\n  \"emoji-astonished\": \"\\f79a\",\n  \"emoji-grimace-fill\": \"\\f79b\",\n  \"emoji-grimace\": \"\\f7a0\",\n  \"emoji-grin-fill\": \"\\f7a1\",\n  \"emoji-grin\": \"\\f7a6\",\n  \"emoji-surprise-fill\": \"\\f7a7\",\n  \"emoji-surprise\": \"\\f7ac\",\n  \"emoji-tear-fill\": \"\\f7ad\",\n  \"emoji-tear\": \"\\f7b2\",\n  \"envelope-arrow-down-fill\": \"\\f7b3\",\n  \"envelope-arrow-down\": \"\\f7b8\",\n  \"envelope-arrow-up-fill\": \"\\f7b9\",\n  \"envelope-arrow-up\": \"\\f7be\",\n  \"feather\": \"\\f7bf\",\n  \"feather2\": \"\\f7c4\",\n  \"floppy-fill\": \"\\f7c5\",\n  \"floppy\": \"\\f7d8\",\n  \"floppy2-fill\": \"\\f7d9\",\n  \"floppy2\": \"\\f7e4\",\n  \"gitlab\": \"\\f7e5\",\n  \"highlighter\": \"\\f7f8\",\n  \"marker-tip\": \"\\f802\",\n  \"nvme-fill\": \"\\f803\",\n  \"nvme\": \"\\f80c\",\n  \"opencollective\": \"\\f80d\",\n  \"pci-card-network\": \"\\f8cd\",\n  \"pci-card-sound\": \"\\f8ce\",\n  \"radar\": \"\\f8cf\",\n  \"send-arrow-down-fill\": \"\\f8d0\",\n  \"send-arrow-down\": \"\\f8d1\",\n  \"send-arrow-up-fill\": \"\\f8d2\",\n  \"send-arrow-up\": \"\\f8d3\",\n  \"sim-slash-fill\": \"\\f8d4\",\n  \"sim-slash\": \"\\f8d5\",\n  \"sourceforge\": \"\\f8d6\",\n  \"substack\": \"\\f8d7\",\n  \"threads-fill\": \"\\f8d8\",\n  \"threads\": \"\\f8d9\",\n  \"transparency\": \"\\f8da\",\n  \"twitter-x\": \"\\f8db\",\n  \"type-h4\": \"\\f8dc\",\n  \"type-h5\": \"\\f8dd\",\n  \"type-h6\": \"\\f8de\",\n  \"backpack-fill\": \"\\f8df\",\n  \"backpack\": \"\\f8e0\",\n  \"backpack2-fill\": \"\\f8e1\",\n  \"backpack2\": \"\\f8e2\",\n  \"backpack3-fill\": \"\\f8e3\",\n  \"backpack3\": \"\\f8e4\",\n  \"backpack4-fill\": \"\\f8e5\",\n  \"backpack4\": \"\\f8e6\",\n  \"brilliance\": \"\\f8e7\",\n  \"cake-fill\": \"\\f8e8\",\n  \"cake2-fill\": \"\\f8e9\",\n  \"duffle-fill\": \"\\f8ea\",\n  \"duffle\": \"\\f8eb\",\n  \"exposure\": \"\\f8ec\",\n  \"gender-neuter\": \"\\f8ed\",\n  \"highlights\": \"\\f8ee\",\n  \"luggage-fill\": \"\\f8ef\",\n  \"luggage\": \"\\f8f0\",\n  \"mailbox-flag\": \"\\f8f1\",\n  \"mailbox2-flag\": \"\\f8f2\",\n  \"noise-reduction\": \"\\f8f3\",\n  \"passport-fill\": \"\\f8f4\",\n  \"passport\": \"\\f8f5\",\n  \"person-arms-up\": \"\\f8f6\",\n  \"person-raised-hand\": \"\\f8f7\",\n  \"person-standing-dress\": \"\\f8f8\",\n  \"person-standing\": \"\\f8f9\",\n  \"person-walking\": \"\\f8fa\",\n  \"person-wheelchair\": \"\\f8fb\",\n  \"shadows\": \"\\f8fc\",\n  \"suitcase-fill\": \"\\f8fd\",\n  \"suitcase-lg-fill\": \"\\f8fe\",\n  \"suitcase-lg\": \"\\f8ff\",\n  \"suitcase\": \"\\f900\",\n  \"suitcase2-fill\": \"\\f901\",\n  \"suitcase2\": \"\\f902\",\n  \"vignette\": \"\\f903\",\n  \"bluesky\": \"\\f7f9\",\n  \"tux\": \"\\f904\",\n  \"beaker-fill\": \"\\f905\",\n  \"beaker\": \"\\f906\",\n  \"flask-fill\": \"\\f907\",\n  \"flask-florence-fill\": \"\\f908\",\n  \"flask-florence\": \"\\f909\",\n  \"flask\": \"\\f90a\",\n  \"leaf-fill\": \"\\f90b\",\n  \"leaf\": \"\\f90c\",\n  \"measuring-cup-fill\": \"\\f90d\",\n  \"measuring-cup\": \"\\f90e\",\n  \"unlock2-fill\": \"\\f90f\",\n  \"unlock2\": \"\\f910\",\n  \"battery-low\": \"\\f911\",\n  \"anthropic\": \"\\f912\",\n  \"apple-music\": \"\\f913\",\n  \"claude\": \"\\f914\",\n  \"openai\": \"\\f915\",\n  \"perplexity\": \"\\f916\",\n  \"css\": \"\\f917\",\n  \"javascript\": \"\\f918\",\n  \"typescript\": \"\\f919\",\n  \"fork-knife\": \"\\f91a\",\n  \"globe-americas-fill\": \"\\f91b\",\n  \"globe-asia-australia-fill\": \"\\f91c\",\n  \"globe-central-south-asia-fill\": \"\\f91d\",\n  \"globe-europe-africa-fill\": \"\\f91e\",\n);\n\n@each $icon, $codepoint in $bootstrap-icons-map {\n  .bi-#{$icon}::before { content: $codepoint; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
